import * as React from 'react';
import React__default, { forwardRef, useRef, useEffect, useMemo, useState, useCallback, createContext, useContext, useImperativeHandle } from 'react';
import styled, { css, useTheme, keyframes, createGlobalStyle } from 'styled-components';
import * as TablerIcons from '@tabler/icons-react';
import { ButtonBase, AccordionDetails, AccordionSummary, Breadcrumbs as Breadcrumbs$1, Badge as Badge$2, MenuItem as MenuItem$4, Menu as Menu$3, ButtonGroup as ButtonGroup$1, useTheme as useTheme$1, Checkbox as Checkbox$1, Box, CircularProgress as CircularProgress$1, Typography as Typography$1, Slider as Slider$1, Pagination as Pagination$3, Select as Select$1, TextField as TextField$2, InputAdornment, IconButton as IconButton$1, Popover, Tooltip as Tooltip$2, Autocomplete, Popper, Modal as Modal$1, Chip, Radio as Radio$1, Switch, Skeleton as Skeleton$2, Tabs, Tab as Tab$1, Drawer as Drawer$1, MenuList, ListItemText } from '@mui/material';
import { get, capitalize, uniqueId } from 'lodash-es';
import cloneDeep from 'lodash-es/cloneDeep';
import dayjs from 'dayjs';
export { default as dayjs } from 'dayjs';
import businessTime from 'dayjs-business-time';
import arraySupport from 'dayjs/plugin/arraySupport';
import calendar from 'dayjs/plugin/calendar';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import isoWeeksInYear from 'dayjs/plugin/isoWeeksInYear';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import isYesterday from 'dayjs/plugin/isYesterday';
import localeData from 'dayjs/plugin/localeData';
import objectSupport from 'dayjs/plugin/objectSupport';
import pluralGetSet from 'dayjs/plugin/pluralGetSet';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import toObject from 'dayjs/plugin/toObject';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import 'dayjs/locale/pt-br';
import Accordion$1 from '@mui/material/Accordion';
import cx from 'classnames';
import { useSnackbar } from 'notistack';
export { SnackbarProvider as ToastProvider } from 'notistack';
import EasyCropper from 'react-easy-crop';
import { useTable, useSortBy, useExpanded, usePagination, useRowSelect } from 'react-table';
import { format, parse, parseISO, isValid, isAfter } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { useNavigation, DayPickerProvider, NavigationProvider, isMatch, useInput, DayPicker } from 'react-day-picker';
import { IMaskInput, IMask } from 'react-imask';
import 'react-day-picker/dist/style.css';
import * as XLSX from 'xlsx';
import { utils, writeFile } from 'xlsx';
import { createTheme, ThemeProvider as ThemeProvider$1 } from '@mui/material/styles';
import { LocalizationProvider, TimePicker as TimePicker$1 } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-youtube';
import '@devmobiliza/videojs-vimeo/dist/videojs-vimeo.esm';
import { flexRender, useReactTable, getCoreRowModel, getExpandedRowModel, getPaginationRowModel } from '@tanstack/react-table';
import debounce from 'lodash.debounce';
import ReactQuill, { Quill } from 'react-quill';
import 'quill-mention';
import 'react-quill/dist/quill.snow.css';
import { Link } from 'react-router-dom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var _path$g;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1"
  })));
};

var _path$f;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgAddCircle = function SvgAddCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m4 11h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1"
  })));
};

var _path$e, _path2$8;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgCheckboxCheckedIcon = function SvgCheckboxCheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    color: "transparent",
    viewBox: "0 0 20 20"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 4a4 4 0 0 1 4-4h8a8 8 0 0 1 8 8v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5.333 10 3.333 3.333 6.667-6.666"
  })));
};

var _path$d;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgCheckboxIcon = function SvgCheckboxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentcolor",
    d: "M.5 4A3.5 3.5 0 0 1 4 .5h8A7.5 7.5 0 0 1 19.5 8v8a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 16z"
  })));
};

var _path$c;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgCloudDownload = function SvgCloudDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M17 13l-4.65 4.65c-.2.2-.51.2-.71 0L7 13h3V9h4v4z"
  })));
};

var _g$8, _defs$4;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgCsvIcon = function SvgCsvIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#csv-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2ED9B8",
    d: "M10.5 4.5A1.5 1.5 0 0 1 12 3h8.625v6H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97ECDC",
    d: "M20.625 3h8.625a1.5 1.5 0 0 1 1.5 1.5V9H20.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A38A",
    d: "M10.5 9h10.125v6H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2ED9B8",
    d: "M20.625 9H30.75v6H20.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#094338",
    d: "M10.5 15h10.125v6H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A38A",
    d: "M20.625 15H30.75v6H20.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#094338",
    d: "M10.5 21h20.25v4.5a1.5 1.5 0 0 1-1.5 1.5H12a1.5 1.5 0 0 1-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#csv-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 10.5,
    x: 0.375,
    y: 13.5,
    fill: "#21A38A",
    rx: 1.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.52 21.84c-.66 0-1.227-.132-1.701-.396a2.734 2.734 0 0 1-1.08-1.134c-.252-.492-.378-1.071-.378-1.737 0-.666.126-1.242.378-1.728a2.677 2.677 0 0 1 1.08-1.125c.474-.27 1.041-.405 1.701-.405.426 0 .828.066 1.206.198.384.132.699.321.945.567l-.378.918a2.73 2.73 0 0 0-.828-.495 2.52 2.52 0 0 0-.909-.162c-.642 0-1.131.195-1.467.585-.336.384-.504.933-.504 1.647s.168 1.266.504 1.656c.336.39.825.585 1.467.585.324 0 .627-.051.909-.153.282-.108.558-.276.828-.504l.378.918a2.58 2.58 0 0 1-.945.567c-.378.132-.78.198-1.206.198m5.212 0c-.498 0-.96-.063-1.386-.189a3.49 3.49 0 0 1-1.08-.531l.35-.909c.295.21.616.372.964.486a3.74 3.74 0 0 0 1.152.171c.474 0 .819-.078 1.035-.234a.745.745 0 0 0 .324-.621.59.59 0 0 0-.234-.495c-.15-.12-.411-.219-.783-.297l-.99-.207c-1.128-.24-1.692-.819-1.692-1.737 0-.396.105-.741.315-1.035.21-.294.5-.522.873-.684.372-.162.8-.243 1.287-.243.432 0 .837.066 1.215.198.378.126.693.306.945.54l-.351.864c-.498-.42-1.104-.63-1.818-.63-.414 0-.738.087-.972.261a.813.813 0 0 0-.351.684c0 .216.072.39.216.522.144.126.39.225.738.297l.98.207c.595.126 1.036.324 1.324.594.294.27.44.63.44 1.08 0 .378-.101.711-.305.999-.204.288-.495.513-.873.675-.372.156-.813.234-1.323.234m5.41-.09-2.826-6.345h1.233l2.097 4.869 2.097-4.869h1.188l-2.826 6.345z"
  })))), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "csv-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "csv-icon_svg__b",
    width: 27,
    height: 16.5,
    x: -1.125,
    y: 11.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5,
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3878_462227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3878_462227",
    result: "shape"
  })))));
};

var _path$b, _g$7, _path2$7;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgDefaultDownload = function SvgDefaultDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 58 58"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEADA",
    d: "m51.5 14-14-14h-31v58h45z"
  })), _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
    fill: "#CEC9AE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23h25a1 1 0 1 0 0-2h-25a1 1 0 1 0 0 2M16.5 15h10a1 1 0 1 0 0-2h-10a1 1 0 1 0 0 2M41.5 29h-25a1 1 0 1 0 0 2h25a1 1 0 1 0 0-2M41.5 37h-25a1 1 0 1 0 0 2h25a1 1 0 1 0 0-2M41.5 45h-25a1 1 0 1 0 0 2h25a1 1 0 1 0 0-2"
  }))), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CEC9AE",
    d: "M37.5 0v14h14z"
  })));
};

var _path$a, _path2$6, _g$6;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgImageDownload = function SvgImageDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fill: "#00384D",
    d: "M310.624 0H64v512h384V137.376zM320 54.624 393.376 128H320zM96 480V32h192v128h128v320z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#71C5EE",
    d: "M384 448H128V64h160v96h96z"
  })), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
    fill: "#00384D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 247.936,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 272-42.848 64.256 8.304 51.936L232 356l-24-36-64 96h224z"
  }))));
};

var _path$9, _path2$5, _path3$5, _path4$5, _g$5, _path5$5;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgPdfDownload = function SvgPdfDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E5E7",
    d: "M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0z"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M384 128h96L352 0v96c0 17.6 14.4 32 32 32"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "m480 224-96-96h96z"
  })), _path4$5 || (_path4$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F15642",
    d: "M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16z"
  })), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.744 303.152c0-4.224 3.328-8.832 8.688-8.832h29.552c16.64 0 31.616 11.136 31.616 32.48 0 20.224-14.976 31.488-31.616 31.488h-21.36v16.896c0 5.632-3.584 8.816-8.192 8.816-4.224 0-8.688-3.184-8.688-8.816zm16.88 7.28v31.872h21.36c8.576 0 15.36-7.568 15.36-15.504 0-8.944-6.784-16.368-15.36-16.368zM196.656 384c-4.224 0-8.832-2.304-8.832-7.92v-72.672c0-4.592 4.608-7.936 8.832-7.936h29.296c58.464 0 57.184 88.528 1.152 88.528zm8.064-72.912V368.4h21.232c34.544 0 36.08-57.312 0-57.312zM303.872 312.112v20.336h32.624c4.608 0 9.216 4.608 9.216 9.072 0 4.224-4.608 7.68-9.216 7.68h-32.624v26.864c0 4.48-3.184 7.92-7.664 7.92-5.632 0-9.072-3.44-9.072-7.92v-72.672c0-4.592 3.456-7.936 9.072-7.936h44.912c5.632 0 8.96 3.344 8.96 7.936 0 4.096-3.328 8.704-8.96 8.704h-37.248z"
  }))), _path5$5 || (_path5$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16"
  })));
};

var _rect$1, _g$4, _g2, _g3, _defs$3;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgTransferListIcon = function SvgTransferListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 169 138"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    width: 99.133,
    height: 110,
    x: 34.68,
    y: 10,
    fill: "#F8F6F8",
    rx: 12
  })), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#TransferListIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.959,
    height: 26.191,
    x: 24.25,
    y: 83.333,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.87,
    height: 20.952,
    x: 26.859,
    y: 85.952,
    fill: "#D1C7CE",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.856 97.634v-.262c0-1.624 2.453-1.703 2.453-3.706 0-1.493-1.057-2.213-2.727-2.213-1.956 0-3.3 1.205-3.13 2.868l1.24.89c-.197-1.597.625-2.357 1.786-2.357.861 0 1.252.38 1.252.956 0 1.323-2.256 1.454-2.256 3.444v.38zm.13 2.724v-1.86h-1.669v1.86z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.87,
    height: 3.929,
    x: 52.945,
    y: 89.88,
    fill: "#D1C7CE",
    rx: 1.964
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.609,
    height: 3.929,
    x: 52.945,
    y: 99.047,
    fill: "#EBE6E9",
    rx: 1.964
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#TransferListIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.959,
    height: 26.191,
    x: 52.289,
    y: 51.904,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.87,
    height: 20.952,
    x: 54.898,
    y: 54.524,
    fill: "#D1C7CE",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.895 66.205v-.262c0-1.624 2.453-1.702 2.453-3.706 0-1.493-1.057-2.213-2.727-2.213-1.956 0-3.3 1.205-3.13 2.868l1.24.89c-.197-1.597.625-2.357 1.786-2.357.861 0 1.252.38 1.252.956 0 1.323-2.256 1.454-2.256 3.444v.38zm.13 2.724v-1.86h-1.669v1.86z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.87,
    height: 3.929,
    x: 80.988,
    y: 58.452,
    fill: "#D1C7CE",
    rx: 1.964
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.609,
    height: 3.929,
    x: 80.988,
    y: 67.619,
    fill: "#EBE6E9",
    rx: 1.964
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#TransferListIcon_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.959,
    height: 26.191,
    x: 24.25,
    y: 20.476,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.87,
    height: 20.952,
    x: 26.859,
    y: 23.095,
    fill: "#D1C7CE",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.856 34.776v-.262c0-1.623 2.453-1.702 2.453-3.705 0-1.493-1.057-2.213-2.727-2.213-1.956 0-3.3 1.204-3.13 2.867l1.24.89c-.197-1.597.625-2.356 1.786-2.356.861 0 1.252.38 1.252.956 0 1.322-2.256 1.453-2.256 3.444v.38zm.13 2.724v-1.86h-1.669v1.86z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.87,
    height: 3.929,
    x: 52.945,
    y: 27.024,
    fill: "#D1C7CE",
    rx: 1.964
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.609,
    height: 3.929,
    x: 52.945,
    y: 36.191,
    fill: "#EBE6E9",
    rx: 1.964
  }))), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "TransferListIcon_svg__a",
    width: 139.959,
    height: 74.19,
    x: 0.25,
    y: 63.333,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2240_59345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2240_59345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "TransferListIcon_svg__b",
    width: 139.959,
    height: 74.19,
    x: 28.289,
    y: 31.904,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2240_59345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2240_59345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "TransferListIcon_svg__c",
    width: 139.959,
    height: 74.19,
    x: 0.25,
    y: 0.476,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2240_59345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2240_59345",
    result: "shape"
  })))));
};

var _g$3, _defs$2;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgTxtIcon = function SvgTxtIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#txt-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8AC1FE",
    d: "M10.5 4.5A1.5 1.5 0 0 1 12 3h17.25a1.5 1.5 0 0 1 1.5 1.5V9H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DA0FE",
    d: "M10.5 9h20.25v6H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00244C",
    d: "M10.5 15h10.125v6H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#015FCB",
    d: "M20.625 15H30.75v6H20.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00244C",
    d: "M10.5 21h20.25v4.5a1.5 1.5 0 0 1-1.5 1.5H12a1.5 1.5 0 0 1-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#txt-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 10.5,
    x: 0.375,
    y: 13.5,
    fill: "#015FCB",
    rx: 1.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.098 21.75v-5.382H1.92v-.963h5.508v.963H5.25v5.382zm3.313 0 2.42-3.231-2.33-3.114h1.34l1.648 2.277 1.647-2.277h1.35l-2.331 3.114 2.412 3.231h-1.35l-1.728-2.376-1.72 2.376zm8.324 0v-5.382h-2.178v-.963h5.508v.963h-2.178v5.382z"
  })))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "txt-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "txt-icon_svg__b",
    width: 27,
    height: 16.5,
    x: -1.125,
    y: 11.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5,
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3878_462251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3878_462251",
    result: "shape"
  })))));
};

var _path$8, _path2$4, _path3$4, _path4$4, _path5$4, _path6$4;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgWordDownload = function SvgWordDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d92d4",
    d: "M42.256 6H15.744C14.781 6 14 6.781 14 7.744v7.259h30V7.744C44 6.781 43.219 6 42.256 6"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2150a9",
    d: "M14 33.054v7.202c0 .963.781 1.744 1.743 1.744h26.513c.963 0 1.744-.781 1.744-1.744v-7.202z"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d83d4",
    d: "M14 15.003h30v9.002H14z"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e70c9",
    d: "M14 24.005h30v9.05H14z"
  })), _path5$4 || (_path5$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00488d",
    d: "M22.319 34H5.681A1.682 1.682 0 0 1 4 32.319V15.681C4 14.753 4.753 14 5.681 14h16.638c.928 0 1.681.753 1.681 1.681v16.638c0 .928-.753 1.681-1.681 1.681"
  })), _path6$4 || (_path6$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.403 19-1.546 7.264L15.144 19h-2.187l-1.767 7.489L9.597 19H7.641l2.344 10h2.352l1.713-7.689L15.764 29h2.251l2.344-10z"
  })));
};

var _g$2;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgXlsxIcon = function SvgXlsxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xlsx-icon_svg__clip0_3878_462202)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2ED9B8",
    d: "M10.5 4.5A1.5 1.5 0 0 1 12 3h8.625v6H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97ECDC",
    d: "M20.625 3h8.625a1.5 1.5 0 0 1 1.5 1.5V9H20.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A38A",
    d: "M10.5 9h10.125v6H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2ED9B8",
    d: "M20.625 9H30.75v6H20.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#094338",
    d: "M10.5 15h10.125v6H10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A38A",
    d: "M20.625 15H30.75v6H20.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#094338",
    d: "M10.5 21h20.25v4.5a1.5 1.5 0 0 1-1.5 1.5H12a1.5 1.5 0 0 1-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#xlsx-icon_svg__filter0_d_3878_462202)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10.5,
    x: 0.375,
    y: 13.5,
    fill: "#21A38A",
    rx: 1.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1.821 21.75 2.421-3.231-2.331-3.114h1.341l1.647 2.277 1.647-2.277h1.35l-2.331 3.114 2.412 3.231h-1.35l-1.728-2.376L3.18 21.75zm6.794 0v-6.345h1.152v5.364h3.042v.981zm7.109.09c-.498 0-.96-.063-1.386-.189a3.49 3.49 0 0 1-1.08-.531l.35-.909c.295.21.616.372.964.486.354.114.738.171 1.152.171.474 0 .819-.078 1.035-.234a.745.745 0 0 0 .324-.621.59.59 0 0 0-.234-.495c-.15-.12-.411-.219-.783-.297l-.99-.207c-1.128-.24-1.692-.819-1.692-1.737 0-.396.105-.741.315-1.035.21-.294.5-.522.873-.684.372-.162.8-.243 1.287-.243.432 0 .837.066 1.215.198.378.126.693.306.945.54l-.351.864c-.498-.42-1.104-.63-1.818-.63-.414 0-.738.087-.972.261a.813.813 0 0 0-.351.684c0 .216.072.39.216.522.144.126.39.225.738.297l.98.207c.595.126 1.036.324 1.324.594.294.27.44.63.44 1.08 0 .378-.101.711-.305.999-.204.288-.495.513-.873.675-.372.156-.813.234-1.323.234"
  })))));
};

var _path$7;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgPix = function SvgPix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 52 52"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M33.654 39.101a9.96 9.96 0 0 0 3.178 2.071l-6.772 6.552c-2.24 2.166-5.906 2.166-8.146 0l-6.574-6.36a9.957 9.957 0 0 0 3.606-2.234L26.316 32zM9.467 35.382l-5.178-5.313c-2.185-2.24-2.185-5.903 0-8.144l5.178-5.313h2.822a2.98 2.98 0 0 1 2.11.901l7.708 7.908c.206.212.424.404.652.578a5.704 5.704 0 0 0-.652.574l-7.708 7.908a2.986 2.986 0 0 1-2.11.901zm30.864-18.74h2.232l5.15 5.283c2.184 2.241 2.184 5.903 0 8.144l-5.15 5.283H40.33a2.98 2.98 0 0 1-2.11-.9l-7.679-7.879a5.704 5.704 0 0 0-.651-.574c.228-.174.445-.366.651-.578l7.679-7.878a2.987 2.987 0 0 1 2.11-.901ZM30.054 4.273l6.773 6.545a9.956 9.956 0 0 0-3.172 2.068l-7.34 7.1-7.37-7.128a9.96 9.96 0 0 0-3.605-2.233l6.569-6.352c2.239-2.166 5.905-2.166 8.144 0zm-4.276 27.208.006.006-.006-.006z"
  })));
};

var _path$6;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgBarcodeMethod = function SvgBarcodeMethod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    className: "barcode-method_svg__icon barcode-method_svg__icon-tabler barcode-method_svg__icon-tabler-alt",
    viewBox: "0 0 24 24"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4v16m9-16v16M5 4h1v16H5zm9 0h1v16h-1z"
  })));
};

var _rect, _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgCheckboxNestedSelectionCheckedIcon = function SvgCheckboxNestedSelectionCheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F20D7A",
    rx: 4
  })), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M5.334 10h9.333"
  })));
};

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgBriefcaseExpense = function SvgBriefcaseExpense(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 11V9a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h8M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-4 5v.01M3 13a20 20 0 0 0 11 2.04m7-.04h-2.5a1.5 1.5 0 1 0 0 3h1a1.5 1.5 0 1 1 0 3H17m2 0v1m0-8v1"
  })));
};

var CustomIcons = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Add: SvgAdd,
    AddCircle: SvgAddCircle,
    BarcodeMethod: SvgBarcodeMethod,
    BriefCaseExpense: SvgBriefcaseExpense,
    CSVDownload: SvgCsvIcon,
    CheckboxCheckedIcon: SvgCheckboxCheckedIcon,
    CheckboxIcon: SvgCheckboxIcon,
    CheckboxNestedSelectionCheckedIcon: SvgCheckboxNestedSelectionCheckedIcon,
    CloudDownload: SvgCloudDownload,
    DefaultDownload: SvgDefaultDownload,
    ImageDownload: SvgImageDownload,
    PDFDownload: SvgPdfDownload,
    Pix: SvgPix,
    TXTDownload: SvgTxtIcon,
    TransferListIcon: SvgTransferListIcon,
    WordDownload: SvgWordDownload,
    XLSXDownload: SvgXlsxIcon
});

var tablerIconsNames = Object.keys(TablerIcons).filter(function (iconName) { return iconName !== 'createReactComponent'; });
var customIconsNames = Object.keys(CustomIcons);
var iconsOptions = __spreadArray(__spreadArray([], customIconsNames, true), tablerIconsNames, true);
var StyledIcon$1 = styled.svg(templateObject_4$r || (templateObject_4$r = __makeTemplateObject(["\n  stroke-width: ", "px;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  ", "\n  ", "\n", "\n"], ["\n  stroke-width: ", "px;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  ", "\n  ", "\n", "\n"])), function (_a) {
    var strokeWidth = _a.strokeWidth;
    return strokeWidth;
}, function (_a) {
    var fill = _a.fill;
    return fill && css(templateObject_1$1e || (templateObject_1$1e = __makeTemplateObject(["\n      fill: ", ";\n    "], ["\n      fill: ", ";\n    "])), fill);
}, function (_a) {
    var color = _a.color;
    return color && css(templateObject_2$M || (templateObject_2$M = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), color);
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && css(templateObject_3$v || (templateObject_3$v = __makeTemplateObject(["\n      stroke: ", ";\n    "], ["\n      stroke: ", ";\n    "])), stroke);
});
var Icons = forwardRef(function (_a, ref) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? '2' : _c, rest = __rest(_a, ["name", "size", "strokeWidth"]);
    var Icon = (name in CustomIcons
        ? CustomIcons[name]
        : TablerIcons[name]);
    return (React__default.createElement(StyledIcon$1, __assign({}, rest, { as: Icon, className: rest.className, width: rest.width || size, height: rest.height || size, strokeWidth: strokeWidth, style: rest.style, 
        //@ts-expect-error ref is not in SVGAttributes
        ref: ref })));
});
Icons.displayName = 'Icon';
var templateObject_1$1e, templateObject_2$M, templateObject_3$v, templateObject_4$r;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$E = ".spinner-lds-dual-ring{animation:spinner-lds-dual-ring 1.2s linear infinite;border-radius:50%}.spinner-lds-dual-ring.variant-primary{border:1px solid var(--color-secondary-light3);border-color:var(--color-secondary-dark4) var(--color-secondary-light3) var(--color-secondary-light3) var(--color-secondary-light3)}.spinner-lds-dual-ring.variant-secondary{border:1px solid var(--color-secondary-light1);border-color:var(--color-secondary-dark3) var(--color-secondary-light1) var(--color-secondary-light1) var(--color-secondary-light1)}.spinner-lds-dual-ring.variant-error{border:1px solid var(--color-feedback-error-70);border-color:var(--color-feedback-error-40) var(--color-feedback-error-70) var(--color-feedback-error-70) var(--color-feedback-error-70)}.spinner-lds-dual-ring.variant-info{border:1px solid var(--color-feedback-info-70);border-color:var(--color-feedback-info-40) var(--color-feedback-info-70) var(--color-feedback-info-70) var(--color-feedback-info-70)}.spinner-lds-dual-ring.variant-success{border:1px solid var(--color-feedback-success-70);border-color:var(--color-feedback-success-40) var(--color-feedback-success-70) var(--color-feedback-success-70) var(--color-feedback-success-70)}.spinner-lds-dual-ring.size-16{border-width:2px;height:16px;width:16px}.spinner-lds-dual-ring.size-24{border-width:3px;height:24px;width:24px}.spinner-lds-dual-ring.size-32{border-width:4px;height:32px;width:32px}.spinner-lds-dual-ring.size-48{border-width:6px;height:48px;width:48px}.spinner-lds-dual-ring.size-64{border-width:8px;height:64px;width:64px}@keyframes spinner-lds-dual-ring{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
styleInject(css_248z$E);

function Spinner(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, props = __rest(_a, ["variant"]);
    return (React__default.createElement("div", { className: "spinner-lds-dual-ring variant-".concat(variant, " size-").concat(props.size) }));
}

var StyledButton$2 = styled(ButtonBase)(templateObject_1$1d || (templateObject_1$1d = __makeTemplateObject(["\n  border: 1px solid;\n  background: transparent;\n  border-radius: 40px !important;\n  display: flex !important;\n  flex-wrap: nowrap;\n  align-self: flex-start;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  aspect-ratio: 1 / 1;\n\n  &.size-extra-small {\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n    &.label {\n      width: fit-content;\n      min-width: max-content;\n      padding: 8px;\n      aspect-ratio: unset;\n      font-size: 12px;\n      line-height: 19px;\n    }\n  }\n\n  &.size-small {\n    width: 40px;\n    height: 40px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n    &.label {\n      width: fit-content;\n      min-width: max-content;\n      padding: 12px;\n      aspect-ratio: unset;\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n\n  &.size-medium {\n    width: 48px;\n    height: 48px;\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n\n    &.label {\n      width: fit-content;\n      min-width: max-content;\n      padding: 12px;\n      aspect-ratio: unset;\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n\n  &.size-large {\n    width: 64px;\n    height: 64px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    &.label {\n      width: fit-content;\n      min-width: max-content;\n      padding: 12px 16px;\n      aspect-ratio: unset;\n      font-size: 16px;\n      line-height: 22px;\n    }\n  }\n\n  &.color-disabled {\n    border-color: var(--color-neutral-95);\n    background-color: var(--color-neutral-95);\n    color: var(--color-neutral-70);\n\n    svg {\n      color: var(--color-neutral-70);\n    }\n  }\n\n  &.secondary {\n    &.loading {\n      background-color: transparent;\n    }\n  }\n\n  &.color-default {\n    border-color: var(--color-neutral-80);\n    color: var(--color-neutral-40);\n\n    svg {\n      color: var(--color-neutral-40);\n    }\n\n    &.primary {\n      border-color: var(--color-neutral-95);\n      background-color: var(--color-neutral-95);\n    }\n\n    &:hover {\n      background-color: var(--color-neutral-90);\n      border-color: var(--color-neutral-90);\n    }\n\n    &:focus {\n      border-color: var(--color-secondary-95);\n      outline: 3px solid var(--color-secondary-95);\n    }\n\n    &:active {\n      background-color: var(--color-neutral-80);\n      border-color: var(--color-neutral-80);\n      color: var(--color-neutral-30);\n\n      svg {\n        color: var(--color-neutral-30);\n      }\n    }\n  }\n\n  &.color-success {\n    border-color: var(--color-feedback-success-40);\n    color: var(--color-feedback-success-40);\n\n    svg {\n      color: var(--color-feedback-success-40);\n    }\n\n    &.primary {\n      border-color: var(--color-feedback-success-90);\n      background-color: var(--color-feedback-success-90);\n\n      &.loading {\n        border-color: var(--color-feedback-success-90);\n        background-color: var(--color-feedback-success-90);\n      }\n    }\n\n    &:hover {\n      border-color: var(--color-feedback-success-90);\n      background-color: var(--color-feedback-success-90);\n    }\n\n    &:focus {\n      border-color: var(--color-feedback-success-90);\n      outline: 3px solid var(--color-feedback-success-90);\n\n      &.primary {\n        background-color: var(--color-feedback-success-70);\n      }\n    }\n\n    &:active {\n      background-color: var(--color-feedback-success-50);\n      border-color: var(--color-feedback-success-50);\n      color: var(--color-feedback-success-10);\n\n      svg {\n        color: var(--color-feedback-success-10);\n      }\n    }\n  }\n\n  &.color-info {\n    border-color: var(--color-feedback-info-40);\n    color: var(--color-feedback-info-40);\n\n    svg {\n      color: var(--color-feedback-info-40);\n    }\n\n    &.primary {\n      border-color: var(--color-feedback-info-90);\n      background-color: var(--color-feedback-info-90);\n\n      &.loading {\n        border-color: var(--color-feedback-info-90);\n        background-color: var(--color-feedback-info-90);\n      }\n    }\n\n    &:hover {\n      border-color: var(--color-feedback-info-90);\n      background-color: var(--color-feedback-info-90);\n    }\n\n    &:focus {\n      border-color: var(--color-feedback-info-70);\n      outline: 3px solid var(--color-feedback-info-70);\n\n      &.primary {\n        background-color: var(--color-feedback-info-90);\n      }\n    }\n\n    &:active {\n      background-color: var(--color-feedback-info-50);\n      border-color: var(--color-feedback-info-50);\n      color: var(--color-feedback-info-10);\n\n      svg {\n        color: var(--color-feedback-info-10);\n      }\n    }\n  }\n\n  &.color-error {\n    border-color: var(--color-feedback-error-40);\n    color: var(--color-feedback-error-40);\n\n    svg {\n      color: var(--color-feedback-error-40);\n    }\n\n    &.primary {\n      border-color: var(--color-feedback-error-90);\n      background-color: var(--color-feedback-error-90);\n\n      &.loading {\n        border-color: var(--color-feedback-error-90);\n        background-color: var(--color-feedback-error-90);\n      }\n    }\n\n    &:hover {\n      border-color: var(--color-feedback-error-90);\n      background-color: var(--color-feedback-error-90);\n    }\n\n    &:focus {\n      border-color: var(--color-feedback-error-90);\n      outline: 3px solid var(--color-feedback-error-90);\n\n      &.primary {\n        background-color: var(--color-feedback-error-70);\n      }\n    }\n\n    &:active {\n      background-color: var(--color-feedback-error-50);\n      border-color: var(--color-feedback-error-50);\n      color: var(--color-feedback-error-10);\n\n      svg {\n        color: var(--color-feedback-error-10);\n      }\n    }\n  }\n\n  &.color-pink {\n    border-color: var(--color-secondary-50);\n    color: var(--color-secondary-50);\n\n    svg {\n      color: var(--color-secondary-50);\n    }\n\n    &.primary {\n      border-color: var(--color-secondary-95);\n      background-color: var(--color-secondary-95);\n\n      &.loading {\n        border-color: var(--color-secondary-95);\n        background-color: var(--color-secondary-95);\n      }\n    }\n\n    &:hover {\n      border-color: var(--color-secondary-90);\n      background-color: var(--color-secondary-90);\n    }\n\n    &:focus {\n      border-color: var(--color-secondary-90);\n      outline: 3px solid var(--color-secondary-90);\n\n      &.primary {\n        background-color: var(--color-secondary-95);\n      }\n    }\n\n    &:active {\n      background-color: var(--color-secondary-70);\n      border-color: var(--color-secondary-70);\n      color: var(--color-secondary-10);\n      svg {\n        color: var(--color-secondary-10);\n      }\n    }\n  }\n\n  &.label {\n    font-family: var(--font-family-secondary);\n    font-weight: 700;\n\n    &.icon-position-left {\n      flex-direction: row-reverse;\n    }\n  }\n"], ["\n  border: 1px solid;\n  background: transparent;\n  border-radius: 40px !important;\n  display: flex !important;\n  flex-wrap: nowrap;\n  align-self: flex-start;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  aspect-ratio: 1 / 1;\n\n  &.size-extra-small {\n    width: 32px;\n    height: 32px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n    &.label {\n      width: fit-content;\n      min-width: max-content;\n      padding: 8px;\n      aspect-ratio: unset;\n      font-size: 12px;\n      line-height: 19px;\n    }\n  }\n\n  &.size-small {\n    width: 40px;\n    height: 40px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n    &.label {\n      width: fit-content;\n      min-width: max-content;\n      padding: 12px;\n      aspect-ratio: unset;\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n\n  &.size-medium {\n    width: 48px;\n    height: 48px;\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n\n    &.label {\n      width: fit-content;\n      min-width: max-content;\n      padding: 12px;\n      aspect-ratio: unset;\n      font-size: 14px;\n      line-height: 20px;\n    }\n  }\n\n  &.size-large {\n    width: 64px;\n    height: 64px;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n\n    &.label {\n      width: fit-content;\n      min-width: max-content;\n      padding: 12px 16px;\n      aspect-ratio: unset;\n      font-size: 16px;\n      line-height: 22px;\n    }\n  }\n\n  &.color-disabled {\n    border-color: var(--color-neutral-95);\n    background-color: var(--color-neutral-95);\n    color: var(--color-neutral-70);\n\n    svg {\n      color: var(--color-neutral-70);\n    }\n  }\n\n  &.secondary {\n    &.loading {\n      background-color: transparent;\n    }\n  }\n\n  &.color-default {\n    border-color: var(--color-neutral-80);\n    color: var(--color-neutral-40);\n\n    svg {\n      color: var(--color-neutral-40);\n    }\n\n    &.primary {\n      border-color: var(--color-neutral-95);\n      background-color: var(--color-neutral-95);\n    }\n\n    &:hover {\n      background-color: var(--color-neutral-90);\n      border-color: var(--color-neutral-90);\n    }\n\n    &:focus {\n      border-color: var(--color-secondary-95);\n      outline: 3px solid var(--color-secondary-95);\n    }\n\n    &:active {\n      background-color: var(--color-neutral-80);\n      border-color: var(--color-neutral-80);\n      color: var(--color-neutral-30);\n\n      svg {\n        color: var(--color-neutral-30);\n      }\n    }\n  }\n\n  &.color-success {\n    border-color: var(--color-feedback-success-40);\n    color: var(--color-feedback-success-40);\n\n    svg {\n      color: var(--color-feedback-success-40);\n    }\n\n    &.primary {\n      border-color: var(--color-feedback-success-90);\n      background-color: var(--color-feedback-success-90);\n\n      &.loading {\n        border-color: var(--color-feedback-success-90);\n        background-color: var(--color-feedback-success-90);\n      }\n    }\n\n    &:hover {\n      border-color: var(--color-feedback-success-90);\n      background-color: var(--color-feedback-success-90);\n    }\n\n    &:focus {\n      border-color: var(--color-feedback-success-90);\n      outline: 3px solid var(--color-feedback-success-90);\n\n      &.primary {\n        background-color: var(--color-feedback-success-70);\n      }\n    }\n\n    &:active {\n      background-color: var(--color-feedback-success-50);\n      border-color: var(--color-feedback-success-50);\n      color: var(--color-feedback-success-10);\n\n      svg {\n        color: var(--color-feedback-success-10);\n      }\n    }\n  }\n\n  &.color-info {\n    border-color: var(--color-feedback-info-40);\n    color: var(--color-feedback-info-40);\n\n    svg {\n      color: var(--color-feedback-info-40);\n    }\n\n    &.primary {\n      border-color: var(--color-feedback-info-90);\n      background-color: var(--color-feedback-info-90);\n\n      &.loading {\n        border-color: var(--color-feedback-info-90);\n        background-color: var(--color-feedback-info-90);\n      }\n    }\n\n    &:hover {\n      border-color: var(--color-feedback-info-90);\n      background-color: var(--color-feedback-info-90);\n    }\n\n    &:focus {\n      border-color: var(--color-feedback-info-70);\n      outline: 3px solid var(--color-feedback-info-70);\n\n      &.primary {\n        background-color: var(--color-feedback-info-90);\n      }\n    }\n\n    &:active {\n      background-color: var(--color-feedback-info-50);\n      border-color: var(--color-feedback-info-50);\n      color: var(--color-feedback-info-10);\n\n      svg {\n        color: var(--color-feedback-info-10);\n      }\n    }\n  }\n\n  &.color-error {\n    border-color: var(--color-feedback-error-40);\n    color: var(--color-feedback-error-40);\n\n    svg {\n      color: var(--color-feedback-error-40);\n    }\n\n    &.primary {\n      border-color: var(--color-feedback-error-90);\n      background-color: var(--color-feedback-error-90);\n\n      &.loading {\n        border-color: var(--color-feedback-error-90);\n        background-color: var(--color-feedback-error-90);\n      }\n    }\n\n    &:hover {\n      border-color: var(--color-feedback-error-90);\n      background-color: var(--color-feedback-error-90);\n    }\n\n    &:focus {\n      border-color: var(--color-feedback-error-90);\n      outline: 3px solid var(--color-feedback-error-90);\n\n      &.primary {\n        background-color: var(--color-feedback-error-70);\n      }\n    }\n\n    &:active {\n      background-color: var(--color-feedback-error-50);\n      border-color: var(--color-feedback-error-50);\n      color: var(--color-feedback-error-10);\n\n      svg {\n        color: var(--color-feedback-error-10);\n      }\n    }\n  }\n\n  &.color-pink {\n    border-color: var(--color-secondary-50);\n    color: var(--color-secondary-50);\n\n    svg {\n      color: var(--color-secondary-50);\n    }\n\n    &.primary {\n      border-color: var(--color-secondary-95);\n      background-color: var(--color-secondary-95);\n\n      &.loading {\n        border-color: var(--color-secondary-95);\n        background-color: var(--color-secondary-95);\n      }\n    }\n\n    &:hover {\n      border-color: var(--color-secondary-90);\n      background-color: var(--color-secondary-90);\n    }\n\n    &:focus {\n      border-color: var(--color-secondary-90);\n      outline: 3px solid var(--color-secondary-90);\n\n      &.primary {\n        background-color: var(--color-secondary-95);\n      }\n    }\n\n    &:active {\n      background-color: var(--color-secondary-70);\n      border-color: var(--color-secondary-70);\n      color: var(--color-secondary-10);\n      svg {\n        color: var(--color-secondary-10);\n      }\n    }\n  }\n\n  &.label {\n    font-family: var(--font-family-secondary);\n    font-weight: 700;\n\n    &.icon-position-left {\n      flex-direction: row-reverse;\n    }\n  }\n"])));
var templateObject_1$1d;

function PillButton(_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.type, type = _d === void 0 ? 'secondary' : _d, props = __rest(_a, ["size", "type"]);
    var variant = getVariant(props.variant, props.disabled, props.loading);
    return (React__default.createElement(StyledButton$2, { disableTouchRipple: true, onClick: props.onClick, className: "size-".concat(size, " ").concat(props.loading && 'loading', " color-").concat(variant, " ").concat(type, " icon-position-").concat((_b = props.iconPosition) !== null && _b !== void 0 ? _b : 'right', " ").concat(props.label && 'label'), disabled: props.disabled || props.loading },
        props.label,
        props.loading ? (React__default.createElement(Spinner, { size: spinnerSizeMap[size], variant: getSpinnerVariant(props.variant, type) })) : (props.icon && React__default.createElement(Icons, { name: props.icon, size: 50, fill: "transparent" }))));
}
function getVariant(variant, disabled, loading) {
    if (disabled && !loading) {
        return 'disabled';
    }
    return variant;
}
var spinnerSizeMap = {
    'extra-small': 16,
    small: 16,
    medium: 24,
    large: 32,
};
function getSpinnerVariant(variant, type) {
    switch ("".concat(variant, "-").concat(type)) {
        case 'default-primary':
            return 'secondary';
        case 'default-secondary':
            return 'success';
        case 'success-primary':
        case 'success-secondary':
            return 'success';
        case 'info-primary':
        case 'info-secondary':
            return 'info';
        case 'error-primary':
        case 'error-secondary':
            return 'error';
        case 'pink-primary':
        case 'pink-secondary':
            return 'primary';
        default:
            return 'secondary';
    }
}

var DotIcon = styled.div(function (_a) {
    var theme = _a.theme, variant = _a.variant, hasOutline = _a.hasOutline;
    return (__assign({ borderRadius: '50%', width: '6px', height: '6px', backgroundColor: getColorsByVariant$1(variant, theme.colors).backgroundColor, border: 'none', borderWidth: '0px' }, (hasOutline && {
        outline: "".concat(theme.spacings.xs5, " solid ").concat(getColorsByVariant$1(variant, theme.colors).borderOutlineColor),
    })));
});
var getColorsByVariant$1 = function (variant, colors) {
    switch (variant) {
        case 'gray':
            return {
                backgroundColor: colors === null || colors === void 0 ? void 0 : colors.neutral[70],
                borderOutlineColor: colors === null || colors === void 0 ? void 0 : colors.neutral[90],
            };
        case 'success':
        case 'green':
            return {
                backgroundColor: colors.feedback.success[70],
                borderOutlineColor: colors.feedback.success[90],
            };
        case 'info':
        case 'blue':
            return {
                backgroundColor: colors.feedback.info[70],
                borderOutlineColor: colors.feedback.info[90],
            };
        case 'yellow':
        case 'error':
            return {
                backgroundColor: colors.feedback.error[70],
                borderOutlineColor: colors.feedback.error[90],
            };
        case 'purple':
        case 'progress':
            return {
                backgroundColor: colors.status.progress[70],
                borderOutlineColor: colors.status.progress[90],
            };
        case 'red':
        case 'negative':
            return {
                backgroundColor: colors.status.negative[70],
                borderOutlineColor: colors.status.negative[90],
            };
        case 'primary':
        case 'pink':
        default:
            return {
                backgroundColor: colors.secondary[70],
                borderOutlineColor: colors.secondary[95],
            };
    }
};

function Dot(_a) {
    var variant = _a.variant, _b = _a.hasOutline, hasOutline = _b === void 0 ? false : _b, props = __rest(_a, ["variant", "hasOutline"]);
    return React__default.createElement(DotIcon, __assign({}, props, { variant: variant, hasOutline: hasOutline }));
}

var getColorsByVariant = function (variant, colors) {
    switch (variant) {
        case 'gray':
            return {
                textColor: colors === null || colors === void 0 ? void 0 : colors.neutral10,
                backgroundColor: colors === null || colors === void 0 ? void 0 : colors.neutral90,
                borderOutlineColor: colors === null || colors === void 0 ? void 0 : colors.neutral70,
                hoverBackgroundColor: colors === null || colors === void 0 ? void 0 : colors.neutral40,
            };
        case 'disabled':
            return {
                textColor: colors === null || colors === void 0 ? void 0 : colors.neutral70,
                backgroundColor: colors === null || colors === void 0 ? void 0 : colors.neutral90,
                borderOutlineColor: colors === null || colors === void 0 ? void 0 : colors.neutral70,
                hoverBackgroundColor: colors === null || colors === void 0 ? void 0 : colors.neutral40,
            };
        case 'success':
        case 'green':
            return {
                textColor: colors.success10,
                backgroundColor: colors.success90,
                borderOutlineColor: colors.success70,
                hoverBackgroundColor: colors.success40,
            };
        case 'info':
        case 'blue':
            return {
                textColor: colors.info10,
                backgroundColor: colors.info90,
                borderOutlineColor: colors.info70,
                hoverBackgroundColor: colors.info40,
            };
        case 'yellow':
        case 'error':
            return {
                textColor: colors.error10,
                backgroundColor: colors.error90,
                borderOutlineColor: colors.error70,
                hoverBackgroundColor: colors.error40,
            };
        case 'purple':
        case 'progress':
            return {
                textColor: colors.progress10,
                backgroundColor: colors.progress90,
                borderOutlineColor: colors.progress70,
                hoverBackgroundColor: colors.progress40,
            };
        case 'red':
        case 'negative':
            return {
                textColor: colors.negative10,
                backgroundColor: colors.negative90,
                borderOutlineColor: colors.negative70,
                hoverBackgroundColor: colors.negative40,
            };
        case 'primary':
        case 'pink':
        default:
            return {
                textColor: colors === null || colors === void 0 ? void 0 : colors.secondary50,
                backgroundColor: colors === null || colors === void 0 ? void 0 : colors.secondary95,
                borderOutlineColor: colors === null || colors === void 0 ? void 0 : colors.secondary70,
                hoverBackgroundColor: colors === null || colors === void 0 ? void 0 : colors.primary,
            };
    }
};
var getSizes = function (size, theme) {
    switch (size) {
        case 'extra-small':
            return css(templateObject_1$1c || (templateObject_1$1c = __makeTemplateObject(["\n        padding: ", " ", ";\n        gap: ", ";\n        font-size: 10px;\n        line-height: 12px;\n      "], ["\n        padding: ", " ", ";\n        gap: ", ";\n        font-size: 10px;\n        line-height: 12px;\n      "])), theme.spacings.xs5, theme.spacings.xs4, theme.spacings.xs5);
        case 'small':
            return css(templateObject_2$L || (templateObject_2$L = __makeTemplateObject(["\n        padding: ", " ", ";\n        gap: ", ";\n        font-size: ", ";\n        line-height: 18px;\n      "], ["\n        padding: ", " ", ";\n        gap: ", ";\n        font-size: ", ";\n        line-height: 18px;\n      "])), theme.spacings.xs5, theme.spacings.xs3, theme.spacings.xs5, theme.spacings.xs3);
        case 'medium':
            return css(templateObject_3$u || (templateObject_3$u = __makeTemplateObject(["\n        padding: ", " ", ";\n        gap: ", ";\n        font-size: 14px;\n        line-height: 20px;\n      "], ["\n        padding: ", " ", ";\n        gap: ", ";\n        font-size: 14px;\n        line-height: 20px;\n      "])), theme.spacings.xs5, theme.spacings.xs3, theme.spacings.xs4);
        case 'large':
        default:
            return css(templateObject_4$q || (templateObject_4$q = __makeTemplateObject(["\n        padding: ", " ", ";\n        gap: ", ";\n        font-size: ", ";\n        line-height: 22px;\n      "], ["\n        padding: ", " ", ";\n        gap: ", ";\n        font-size: ", ";\n        line-height: 22px;\n      "])), theme.spacings.xs5, theme.spacings.xs3, theme.spacings.xs4, theme.spacings.xs2);
    }
};
var TagStyled = styled(ButtonBase)(templateObject_7$b || (templateObject_7$b = __makeTemplateObject(["\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  font-family: ", ";\n  line-height: ", ";\n  text-align: center;\n  cursor: ", ";\n  width: fit-content;\n  > svg {\n    background-color: ", ";\n  }\n  ", ";\n  ", ";\n"], ["\n  border-radius: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  font-family: ", ";\n  line-height: ", ";\n  text-align: center;\n  cursor: ", ";\n  width: fit-content;\n  > svg {\n    background-color: ", ";\n  }\n  ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.xl;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.secondary;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var as = _a.as;
    return (as === 'button' ? 'pointer' : 'default');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral90;
}, function (_a) {
    var size = _a.size, theme = _a.theme;
    return getSizes(size, theme);
}, function (_a) {
    var variant = _a.variant, as = _a.as, theme = _a.theme;
    var _b = getColorsByVariant(variant, theme.colors), textColor = _b.textColor, backgroundColor = _b.backgroundColor, borderOutlineColor = _b.borderOutlineColor, hoverBackgroundColor = _b.hoverBackgroundColor;
    return css(templateObject_6$f || (templateObject_6$f = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n      &:disabled,\n      &[disabled] {\n        pointer-events: none;\n      }\n      ", "\n    "], ["\n      background-color: ", ";\n      color: ", ";\n      &:disabled,\n      &[disabled] {\n        pointer-events: none;\n      }\n      ", "\n    "])), backgroundColor, textColor, as === 'button' && css(templateObject_5$k || (templateObject_5$k = __makeTemplateObject(["\n        &:hover {\n          background-color: ", ";\n          color: ", ";\n        }\n        &:focus {\n          outline: 2px solid ", ";\n        }\n      "], ["\n        &:hover {\n          background-color: ", ";\n          color: ", ";\n        }\n        &:focus {\n          outline: 2px solid ", ";\n        }\n      "])), hoverBackgroundColor, theme.colors.neutral100, borderOutlineColor));
});
var templateObject_1$1c, templateObject_2$L, templateObject_3$u, templateObject_4$q, templateObject_5$k, templateObject_6$f, templateObject_7$b;

var Tag = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.hasLeftDotIcon, hasLeftDotIcon = _c === void 0 ? false : _c, _d = _a.variant, variant = _d === void 0 ? 'pink' : _d, _e = _a.as, as = _e === void 0 ? 'button' : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, props = __rest(_a, ["children", "className", "disabled", "hasLeftDotIcon", "variant", "as", "size"]);
    return (React__default.createElement(TagStyled, __assign({}, props, { className: className, disabled: disabled || variant === 'disabled', disableRipple: true, disableTouchRipple: true, variant: variant, size: size, as: as, ref: ref }),
        hasLeftDotIcon && React__default.createElement(Dot, { variant: variant }),
        children));
});
Tag.displayName = 'Tag';

/**
 * @deprecated This color will be removed in version 16
 **/
var deprecatedColors = {
    /**
     * @deprecated This color will be removed in version 16
     **/
    primary: '#FE2B8F',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary10: '#490424',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary20: '#78003C',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary30: '#AA0955',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary40: '#DA0B6D',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary50: '#F20D7A',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary70: '#FE67AF',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary80: '#FF9AC9',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary90: '#FFCCE4',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary95: '#FFE0EF',
    /**
     * @deprecated This color will be removed in version 16
     **/
    secondary99: '#FFF5FA',
    tertiary40: '#C8195A',
    /**
     * @deprecated This color will be removed in version 16
     **/
    tertiary70: '#FF738C',
    /**
     * @deprecated This color will be removed in version 16
     **/
    tertiary80: '#F0AAB4',
    /**
     * @deprecated This color will be removed in version 16
     **/
    tertiary90: '#F4E6E9',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral0: '#000000',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral10: '#1D161B',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral20: '#3B2E37',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral30: '#53464F',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral40: '#6B5B66',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral50: '#83727D',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral60: '#9F939B',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral70: '#B9ACB4',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral80: '#D1C7CE',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral90: '#EBE6E9',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral95: '#F8F6F8',
    /**
     * @deprecated This color will be removed in version 16
     **/
    neutral100: '#FFFFFF',
    /**
     * @deprecated This color will be removed in version 16
     **/
    success10: '#094338',
    /**
     * @deprecated This color will be removed in version 16
     **/
    success40: '#21A38A',
    /**
     * @deprecated This color will be removed in version 16
     **/
    success50: '#2ED9B8',
    /**
     * @deprecated This color will be removed in version 16
     **/
    success70: '#97ECDC',
    /**
     * @deprecated This color will be removed in version 16
     **/
    success90: '#D7F9F3',
    /**
     * @deprecated This color will be removed in version 16
     **/
    error10: '#4C2900',
    /**
     * @deprecated This color will be removed in version 16
     **/
    error40: '#C96C01',
    /**
     * @deprecated This color will be removed in version 16
     **/
    error50: '#FEA034',
    /**
     * @deprecated This color will be removed in version 16
     **/
    error70: '#FEC380',
    /**
     * @deprecated This color will be removed in version 16
     **/
    error90: '#FFECD6',
    /**
     * @deprecated This color will be removed in version 16
     **/
    info10: '#00244C',
    /**
     * @deprecated This color will be removed in version 16
     **/
    info40: '#015FCB',
    /**
     * @deprecated This color will be removed in version 16
     **/
    info50: '#4DA0FE',
    /**
     * @deprecated This color will be removed in version 16
     **/
    info70: '#8AC1FE',
    /**
     * @deprecated This color will be removed in version 16
     **/
    info90: '#D4E8FF',
    /**
     * @deprecated This color will be removed in version 16
     **/
    progress10: '#3C0166',
    /**
     * @deprecated This color will be removed in version 16
     **/
    progress40: '#8101CB',
    /**
     * @deprecated This color will be removed in version 16
     **/
    progress50: '#A10AFF',
    /**
     * @deprecated This color will be removed in version 16
     **/
    progress70: '#C371FE',
    /**
     * @deprecated This color will be removed in version 16
     **/
    progress90: '#F2E0FF',
    /**
     * @deprecated This color will be removed in version 16
     **/
    negative10: '#800707',
    /**
     * @deprecated This color will be removed in version 16
     **/
    negative40: '#B30A0A',
    /**
     * @deprecated This color will be removed in version 16
     **/
    negative50: '#D42525',
    /**
     * @deprecated This color will be removed in version 16
     **/
    negative70: '#FE6767',
    /**
     * @deprecated This color will be removed in version 16
     **/
    negative90: '#FFE0E0',
    /**
     * @deprecated This color will be removed in version 16
     **/
    glowPink: '254,43,143',
    /**
     * @deprecated This color will be removed in version 16
     **/
    glowGreen: '38,217,182',
    /**
     * @deprecated This color will be removed in version 16
     **/
    glowYellow: '254,160,52',
    /**
     * @deprecated This color will be removed in version 16
     **/
    glowBlue: '77,160,254',
    /**
     * @deprecated This color will be removed in version 16
     **/
    shadow: '0,0,0',
};

var appColors = {
    'flamingo-pink': '#FE2B8F',
    brand: {
        /** flamingo-pink */
        50: '#FE2B8F',
    },
    neutral: {
        100: '#FFFFFF',
        95: '#F8F6F8',
        90: '#EBE6E9',
        80: '#D1C7CE',
        70: '#B9ACB4',
        60: '#9F939B',
        50: '#83727D',
        40: '#6B5B66',
        30: '#53464F',
        20: '#3B2E37',
        10: '#1D161B',
        0: '#000000',
        /**
         * @deprecated This color will be removed in version 16
         **/
        dark: {
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.0
             **/
            pure: deprecatedColors.neutral0,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.10
             **/
            dark1: deprecatedColors.neutral10,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.20
             **/
            dark2: deprecatedColors.neutral20,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.30
             **/
            dark3: deprecatedColors.neutral30,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.40
             **/
            dark4: deprecatedColors.neutral40,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.50
             **/
            dark5: deprecatedColors.neutral50,
        },
        /**
         * @deprecated This color will be removed in version 16
         **/
        light: {
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.100
             **/
            pure: deprecatedColors.neutral100,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.95
             **/
            light1: deprecatedColors.neutral95,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.90
             **/
            light2: deprecatedColors.neutral90,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.80
             **/
            light3: deprecatedColors.neutral80,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.70
             **/
            light4: deprecatedColors.neutral70,
            /**
             * This colors will be removed in version 16
             * @deprecated use neutral.60
             **/
            light5: deprecatedColors.neutral60,
        },
    },
    secondary: {
        99: '#FFF5FA',
        95: '#FFE0EF',
        90: '#FFCCE4',
        80: '#FF9AC9',
        70: '#FE67AF',
        50: '#F20D7A',
        40: '#DA0B6D',
        30: '#AA0955',
        20: '#78003C',
        10: '#490424',
        /**
         * @deprecated This color will be removed in version 16
         **/
        dark: {
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.10
             **/
            dark1: deprecatedColors.secondary10,
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.20
             **/
            dark2: deprecatedColors.secondary20,
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.30
             **/
            dark3: deprecatedColors.secondary30,
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.40
             **/
            dark4: deprecatedColors.secondary40,
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.50
             **/
            dark5: deprecatedColors.secondary50,
        },
        /**
         * @deprecated This color will be removed in version 16
         **/
        light: {
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.99
             **/
            light1: deprecatedColors.secondary99,
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.95
             **/
            light2: deprecatedColors.secondary95,
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.90
             **/
            light3: deprecatedColors.secondary90,
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.80
             **/
            light4: deprecatedColors.secondary80,
            /**
             * This colors will be removed in version 16
             * @deprecated use secondary.70
             **/
            light5: deprecatedColors.secondary70,
        },
    },
    tertiary: {
        90: '#F4E6E9',
        80: '#F0AAB4',
        70: '#FF738C',
        40: '#C8195A',
        /**
         * This colors will be removed in version 16
         * @deprecated use tertiary.90
         **/
        first: deprecatedColors.tertiary90,
        /**
         * This colors will be removed in version 16
         * @deprecated use tertiary.80
         * */
        second: deprecatedColors.tertiary80,
        /**
         * This colors will be removed in version 16
         * @deprecated use tertiary.70
         * */
        third: deprecatedColors.tertiary70,
        /**
         * This colors will be removed in version 16
         * @deprecated use tertiary.40
         * */
        fourth: deprecatedColors.tertiary40,
    },
    feedback: {
        success: {
            90: '#D7F9F3',
            70: '#97ECDC',
            50: '#2ED9B8',
            40: '#21A38A',
            10: '#094338',
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.success.50
             * */
            pure: deprecatedColors.success50,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.success.90
             * */
            light1: deprecatedColors.success90,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.success.70
             * */
            light2: deprecatedColors.success70,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.success.40
             * */
            dark1: deprecatedColors.success40,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.success.10
             * */
            dark2: deprecatedColors.success10,
        },
        error: {
            90: '#FFECD6',
            70: '#FEC380',
            50: '#FEA034',
            40: '#C96C01',
            10: '#4C2900',
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.error.50
             * */
            pure: deprecatedColors.error50,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.error.90
             * */
            light1: deprecatedColors.error90,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.error.70
             * */
            light2: deprecatedColors.error70,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.error.40
             * */
            dark1: deprecatedColors.error40,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.error.10
             * */
            dark2: deprecatedColors.error10,
        },
        info: {
            90: '#D4E8FF',
            70: '#8AC1FE',
            50: '#4DA0FE',
            40: '#015FCB',
            10: '#00244C',
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.info.50
             * */
            pure: deprecatedColors.info50,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.info.90
             * */
            light1: deprecatedColors.info90,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.info.70
             * */
            light2: deprecatedColors.info70,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.info.40
             * */
            dark1: deprecatedColors.info40,
            /**
             * This colors will be removed in version 16
             * @deprecated use feedback.info.10
             * */
            dark2: deprecatedColors.info10,
        },
        /**
         * This colors will be removed in version 16
         * @deprecated use status.progress
         * */
        progress: {
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.10
             * */
            10: deprecatedColors.progress10,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.40
             * */
            40: deprecatedColors.progress40,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.50
             * */
            50: deprecatedColors.progress50,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.70
             * */
            70: deprecatedColors.progress70,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.90
             * */
            90: deprecatedColors.progress90,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.50
             * */
            pure: deprecatedColors.progress50,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.90
             * */
            light1: deprecatedColors.progress90,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.70
             * */
            light2: deprecatedColors.progress70,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.40
             * */
            dark1: deprecatedColors.progress40,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.progress.10
             * */
            dark2: deprecatedColors.progress10,
        },
        /**
         * This colors will be removed in version 16
         * @deprecated use status.negative
         * */
        negative: {
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.10
             * */
            10: deprecatedColors.negative10,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.40
             * */
            40: deprecatedColors.negative40,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.50
             * */
            50: deprecatedColors.negative50,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.70
             * */
            70: deprecatedColors.negative70,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.90
             * */
            90: deprecatedColors.negative90,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.50
             * */
            pure: deprecatedColors.negative50,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.90
             * */
            light1: deprecatedColors.negative90,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.70
             * */
            light2: deprecatedColors.negative70,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.40
             * */
            dark1: deprecatedColors.negative40,
            /**
             * This colors will be removed in version 16
             * @deprecated use status.negative.10
             * */
            dark2: deprecatedColors.negative10,
        },
    },
    status: {
        attention: {
            90: '#FFECD6',
            70: '#FEC380',
            50: '#FEA034',
            40: '#C96C01',
            10: '#4C2900',
        },
        complete: {
            90: '#D7F9F3',
            70: '#97ECDC',
            50: '#2ED9B8',
            40: '#21A38A',
            10: '#094338',
        },
        inactive: {
            90: '#EBE6E9',
            70: '#B9ACB4',
            50: '#83727D',
            40: '#6B5B66',
            10: '#1D161B',
        },
        negative: {
            90: '#FFE0E0',
            70: '#FE6767',
            50: '#D42525',
            40: '#B30A0A',
            10: '#800707',
        },
        pending: {
            90: '#D4E8FF',
            70: '#8AC1FE',
            50: '#4DA0FE',
            40: '#015FCB',
            10: '#00244C',
        },
        progress: {
            90: '#F2E0FF',
            70: '#C371FE',
            50: '#A10AFF',
            40: '#8101CB',
            10: '#3C0166',
        },
    },
};
/**
 * Flash colors
 *
 * Design tokens
 * https://www.figma.com/design/h6L9nxp9GcD5bTYErb11bg/Global-Tokens-%E2%80%A2-Flamingo-UI-%E2%80%A2-Design-System?node-id=2-5301&node-type=frame&t=jPkbXjYVM6LKh6Qn-0
 */
var colors = __assign(__assign({}, appColors), { 
    /**
     * Gets a color based on token name or fallback to an existing color
     *
     * @param token - Color token to get
     * @default secondary.70
     * @returns found color based on token name
     */
    get: function (token) {
        return get(appColors, token, appColors.secondary[70]); // TODO: remove after update typescript
    } });

var getKeysRecursive = function (data) {
    var keys = [];
    Object.keys(data).forEach(function (key) {
        if (typeof data[key] === 'object' && data[key]) {
            getKeysRecursive(data[key]).forEach(function (innerKey) {
                keys.push("".concat(key, ".").concat(innerKey));
            });
        }
        else {
            keys.push(key);
        }
    });
    return keys;
};
var getValueFromKey = function (_a) {
    var key = _a.key, data = _a.data;
    var target = cloneDeep(data);
    var path = key.split('.');
    for (var i = 0; i < path.length; i++) {
        target = target[path[i]];
    }
    return target;
};
var updateObjectFromKey = function (_a) {
    var data = _a.data, paths = _a.paths;
    var objectToUpdate = cloneDeep(data);
    Object.entries(Object.assign.apply(Object, __spreadArray([{}], paths, false))).forEach(function (_a) {
        var path = _a[0], value = _a[1];
        var pathSplitted = path.split('.');
        var final = pathSplitted.pop() || '';
        var obj = pathSplitted.reduce(function (a, b) { return a && a[b]; }, objectToUpdate);
        if (obj && obj.hasOwnProperty(final))
            obj[final] = value;
    });
    return objectToUpdate;
};
var overrideTheme = function (_a) {
    var overrides = _a.overrides, theme = _a.theme;
    var keys = getKeysRecursive(overrides);
    var themeToOverride = cloneDeep(theme);
    var paths = keys.map(function (key) {
        var _a;
        return _a = {}, _a[key] = getValueFromKey({ key: key, data: overrides }), _a;
    });
    return updateObjectFromKey({ data: themeToOverride, paths: paths });
};

var calculateEasterSunday = function (year) {
    // Calculating the Metonic cycle, centuries, and secular corrections
    var metonicCycle = year % 19;
    var centuries = Math.floor(year / 100);
    var yearsInCentury = year % 100;
    var secularCorrection = Math.floor(centuries / 4);
    var secularCorrectionRemainder = centuries % 4;
    // Calculating leap year and Easter corrections
    var leapYearCorrection = Math.floor((centuries + 8) / 25);
    var easterCorrection = Math.floor((centuries - leapYearCorrection + 1) / 3);
    // Calculating the epact, solar, and lunar parts
    var epact = (19 * metonicCycle +
        centuries -
        secularCorrection -
        easterCorrection +
        15) %
        30;
    var solarPart = Math.floor(yearsInCentury / 4);
    var solarPartRemainder = yearsInCentury % 4;
    var lunarCorrection = (32 +
        2 * secularCorrectionRemainder +
        2 * solarPart -
        epact -
        solarPartRemainder) %
        7;
    // Calculating the offset and the month and day of Easter Sunday
    var dayOffset = Math.floor((metonicCycle + 11 * epact + 22 * lunarCorrection) / 451);
    var month = Math.floor((epact + lunarCorrection - 7 * dayOffset + 114) / 31);
    var day = ((epact + lunarCorrection - 7 * dayOffset + 114) % 31) + 1;
    // Returning the Dayjs object representing Easter Sunday
    return new Date(year, month - 1, day);
};
dayjs.extend(arraySupport);
dayjs.extend(businessTime);
dayjs.extend(calendar);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isLeapYear);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
dayjs.extend(isYesterday);
dayjs.extend(isoWeek);
dayjs.extend(isoWeeksInYear);
dayjs.extend(localeData);
dayjs.extend(objectSupport);
dayjs.extend(pluralGetSet);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(toObject);
dayjs.extend(utc);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(weekday);
dayjs.tz.setDefault('America/Sao_Paulo');
var today = dayjs();
var currentYear = parseInt(today.format('YYYY'));
var nextYear = currentYear + 1;
var easterSunday = dayjs(calculateEasterSunday(currentYear));
var corpusChristi = dayjs(easterSunday).add(60, 'days');
var goodFriday = dayjs(easterSunday).subtract(2, 'days');
var carnivalTuesday = dayjs(easterSunday).subtract(47, 'days');
var carnivalMonday = dayjs(carnivalTuesday).subtract(1, 'days');
var flashHolidaysMap = {
    UNIVERSAL: "".concat(nextYear, "-01-01"),
    CARNAVAL_MONDAY: carnivalMonday.format('YYYY-MM-DD'),
    CARNAVAL_TUESDAY: carnivalTuesday.format('YYYY-MM-DD'),
    PAIXAO: goodFriday.format('YYYY-MM-DD'),
    TIRADENTES: "".concat(currentYear, "-04-21"),
    TRABALHO: "".concat(currentYear, "-05-01"),
    CORPUS_CHRISTI: corpusChristi.format('YYYY-MM-DD'),
    INDEPENDENCIA: "".concat(currentYear, "-09-07"),
    APARECIDA: "".concat(currentYear, "-10-12"),
    FINADOS: "".concat(currentYear, "-11-02"),
    REPUBLICA: "".concat(currentYear, "-11-15"),
    NATAL: "".concat(currentYear, "-12-25"),
};
var FLASH_HOLIDAYS = Object.values(flashHolidaysMap);
var businessHours = [{ start: '09:00:00', end: '18:00:00' }];
dayjs.locale('pt-br', {
    holidays: FLASH_HOLIDAYS,
    businessHours: {
        sunday: null,
        monday: businessHours,
        tuesday: businessHours,
        wednesday: businessHours,
        thursday: businessHours,
        friday: businessHours,
        saturday: null,
    },
});

var isUndefined = function (value) { return typeof value === 'undefined'; };
var isNull = function (value) { return value === null; };

var nameInitials = function (name) {
    if (name === void 0) { name = ''; }
    var nameSplited = name.split(' ');
    var firstName = nameSplited[0] || '';
    var lastName = nameSplited[1] || '';
    return "".concat(firstName[0] || '').concat(lastName[0] || '');
};

var useSyncedRef = function (ref) {
    var innerRef = useRef();
    useEffect(function () {
        if (!ref)
            return;
        if (typeof ref === 'function') {
            ref(innerRef.current);
        }
        else {
            ref.current = innerRef.current;
        }
    });
    return innerRef;
};

function pxToRem(px) {
    return "".concat(px * 0.063, "rem");
}

var StyledTypography = styled.p(templateObject_1$1b || (templateObject_1$1b = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var variantColor = _a.variantColor;
    return (variantColor ? variantColor : 'inherit');
});
var TitleBase = styled.h1(templateObject_4$p || (templateObject_4$p = __makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.primary;
}, function (_a) {
    var weight = _a.weight;
    return weight !== null && weight !== void 0 ? weight : 400;
}, function (_a) {
    var color = _a.color, variantColor = _a.variantColor;
    return color
        ? css(templateObject_2$K || (templateObject_2$K = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), colors.get(color)) : variantColor && css(templateObject_3$t || (templateObject_3$t = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), variantColor);
});
var BodyBase = styled.p(templateObject_6$e || (templateObject_6$e = __makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.secondary;
}, function (_a) {
    var weight = _a.weight;
    return weight !== null && weight !== void 0 ? weight : 400;
}, function (_a) {
    var color = _a.color;
    return color && css(templateObject_5$j || (templateObject_5$j = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), colors.get(color));
});
/**
 * font-size 96px
 * @default h1 default html tag name
 */
var Display1 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h1',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 800,
    });
})(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(96), pxToRem(112));
/**
 * font-size 88px
 * @default h2 default html tag name
 */
var Display2 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h2',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 800,
    });
})(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(88), pxToRem(98));
/**
 * font-size 72px
 * @default h1 default html tag name
 */
var Headline1 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h1',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(72), pxToRem(80));
/**
 * font-size 64px
 * @default h2 default html tag name
 */
var Headline2 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h2',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(64), pxToRem(72));
/**
 * font-size 56px
 * @default h3 default html tag name
 */
var Headline3 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h3',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(56), pxToRem(64));
/**
 * font-size 48px
 * @default h4 default html tag name
 */
var Headline4 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h4',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(48), pxToRem(58));
/**
 * font-size 40px
 * @default h5 default html tag name
 */
var Headline5 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h5',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(40), pxToRem(48));
/**
 * font-size 32px
 * @default h6 default html tag name
 */
var Headline6 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h6',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(32), pxToRem(38));
/**
 * font-size 24px
 * @default h6 default html tag name
 */
var Headline7 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h6',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(24), pxToRem(28));
/**
 * font-size 20px
 * @default h6 default html tag name
 */
var Headline8 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h6',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(20), pxToRem(24));
/**
 * font-size 16px
 * @default h6 default html tag name
 */
var Headline9 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h6',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(16), pxToRem(24));
/**
 * font-size 14px
 * @default h6 default html tag name
 */
var Headline10 = styled(TitleBase).attrs(function (props) {
    var _a, _b;
    return ({
        as: (_a = props.as) !== null && _a !== void 0 ? _a : 'h6',
        weight: (_b = props.weight) !== null && _b !== void 0 ? _b : 700,
    });
})(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(14), pxToRem(24));
/**
 * font-size 24px
 * @default p default html tag name
 */
var Body1 = styled(BodyBase)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(24), pxToRem(32));
/**
 * font-size 20px
 * @default p default html tag name
 */
var Body2 = styled(BodyBase)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(20), pxToRem(28));
/**
 * font-size 16px
 * @default p default html tag name
 */
var Body3 = styled(BodyBase)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(16), pxToRem(22));
/**
 * font-size 14px
 * @default p default html tag name
 */
var Body4 = styled(BodyBase)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(14), pxToRem(20));
/**
 * font-size 12px
 * @default p default html tag name
 */
var Caption$1 = styled(BodyBase)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(12), pxToRem(18));
/**
 * font-size 8px
 * @default p default html tag name
 */
var Overline = styled(BodyBase)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n"])), pxToRem(8), pxToRem(12));
var templateObject_1$1b, templateObject_2$K, templateObject_3$t, templateObject_4$p, templateObject_5$j, templateObject_6$e, templateObject_7$a, templateObject_8$4, templateObject_9$3, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;

var v2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Body1: Body1,
    Body2: Body2,
    Body3: Body3,
    Body4: Body4,
    Caption: Caption$1,
    Display1: Display1,
    Display2: Display2,
    Headline1: Headline1,
    Headline10: Headline10,
    Headline2: Headline2,
    Headline3: Headline3,
    Headline4: Headline4,
    Headline5: Headline5,
    Headline6: Headline6,
    Headline7: Headline7,
    Headline8: Headline8,
    Headline9: Headline9,
    Overline: Overline,
    StyledTypography: StyledTypography
});

var Typography = function (props) {
    var _a;
    var variant = capitalize(props.variant);
    return React__default.createElement(v2[variant], __assign(__assign({}, props), { as: (_a = props.as) !== null && _a !== void 0 ? _a : props.tag }));
};
Typography.Display1 = Display1;
Typography.Display2 = Display2;
Typography.Headline1 = Headline1;
Typography.Headline2 = Headline2;
Typography.Headline3 = Headline3;
Typography.Headline4 = Headline4;
Typography.Headline5 = Headline5;
Typography.Headline6 = Headline6;
Typography.Headline7 = Headline7;
Typography.Headline8 = Headline8;
Typography.Headline9 = Headline9;
Typography.Headline10 = Headline10;
Typography.Body1 = Body1;
Typography.Body2 = Body2;
Typography.Body3 = Body3;
Typography.Body4 = Body4;
Typography.Caption = Caption$1;
Typography.Overline = Overline;

var AccordionDetailsComponent = styled(AccordionDetails)(templateObject_1$1a || (templateObject_1$1a = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  padding: ", ";\n"], ["\n  border-top: 1px solid ", ";\n  padding: ", ";\n"])), function (props) { return props.theme.colors.neutral[90]; }, function (props) { return props.theme.spacings.xs; });
var AccordionContainer = styled(Accordion$1)(templateObject_2$J || (templateObject_2$J = __makeTemplateObject(["\n  border: ", " solid\n    ", ";\n  box-shadow: unset;\n  margin: unset;\n  overflow: hidden;\n\n  &.Mui-disabled {\n    background-color: unset;\n  }\n\n  &.MuiAccordion-rounded {\n    border-radius: ", ";\n  }\n\n  &.Mui-expanded {\n    border: ", " solid\n      ", ";\n  }\n\n  .Mui-expanded {\n    ", ";\n  }\n\n  ", "\n"], ["\n  border: ", " solid\n    ", ";\n  box-shadow: unset;\n  margin: unset;\n  overflow: hidden;\n\n  &.Mui-disabled {\n    background-color: unset;\n  }\n\n  &.MuiAccordion-rounded {\n    border-radius: ", ";\n  }\n\n  &.Mui-expanded {\n    border: ", " solid\n      ", ";\n  }\n\n  .Mui-expanded {\n    ", ";\n  }\n\n  ", "\n"])), function (props) { return props.theme.borders.width.xs2; }, function (props) {
    return props.selected
        ? props.theme.colors.secondary[90]
        : props.theme.colors.neutral[90];
}, function (_a) {
    var theme = _a.theme, type = _a.type;
    return type === 'soft' ? theme.borders.radius.m : theme.borders.radius.s;
}, function (props) { return props.theme.borders.width.xs2; }, function (props) {
    return props.type === 'soft'
        ? props.theme.colors.neutral[90]
        : props.theme.colors.secondary70;
}, function (_a) {
    var type = _a.type;
    return (type === 'soft' ? 'min-height: 32px' : '');
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return selected
        ? "\n  .MuiAccordionSummary-root {\n    background-color: ".concat(theme.colors.secondary[99], ";\n  }\n  ")
        : "\n    :hover {\n      .MuiAccordionSummary-root {\n        background-color: ".concat(theme.colors.neutral[95], ";\n      }\n    }\n  ");
});
var AccordionSummaryComponent = styled(AccordionSummary)(templateObject_3$s || (templateObject_3$s = __makeTemplateObject(["\n  padding: ", ";\n\n  &.Mui-focusVisible {\n    background-color: unset;\n    border-radius: ", ";\n    outline: 4px solid ", ";\n  }\n\n  &.Mui-disabled {\n    opacity: unset;\n  }\n\n  .MuiAccordionSummary-content {\n    align-items: center;\n    display: flex;\n    gap: ", ";\n    margin: 0;\n\n    .iconButton-custom-theme-filled {\n      align-self: unset;\n    }\n  }\n\n  .Mui-expanded {\n    margin: 0;\n  }\n"], ["\n  padding: ", ";\n\n  &.Mui-focusVisible {\n    background-color: unset;\n    border-radius: ", ";\n    outline: 4px solid ", ";\n  }\n\n  &.Mui-disabled {\n    opacity: unset;\n  }\n\n  .MuiAccordionSummary-content {\n    align-items: center;\n    display: flex;\n    gap: ", ";\n    margin: 0;\n\n    .iconButton-custom-theme-filled {\n      align-self: unset;\n    }\n  }\n\n  .Mui-expanded {\n    margin: 0;\n  }\n"])), function (props) { return props.theme.spacings.xs; }, function (props) { return props.theme.borders.radius.s; }, function (props) { return props.theme.colors.secondary95; }, function (props) { return props.theme.spacings.xs; });
var TitleWrapper$1 = styled.div(templateObject_4$o || (templateObject_4$o = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: ", ";\n"])), function (props) { return props.theme.spacings.xs5; });
var TitleContainer$1 = styled.div(templateObject_5$i || (templateObject_5$i = __makeTemplateObject(["\n  align-items: flex-start;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n\n  .tag-custom-theme-disabled {\n    color: ", ";\n  }\n"], ["\n  align-items: flex-start;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n\n  .tag-custom-theme-disabled {\n    color: ", ";\n  }\n"])), function (props) {
    return props.disabled ? props.theme.colors.neutral[60] : 'inherit';
}, function (props) { return props.theme.spacings.xs2; }, function (props) {
    return props.disabled ? 'inherit' : props.theme.colors.neutral[10];
});
var ButtonsContainer = styled.div(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n  display: flex;\n  padding-right: ", ";\n  gap: 16px;\n\n  svg {\n    stroke: ", ";\n  }\n"], ["\n  display: flex;\n  padding-right: ", ";\n  gap: 16px;\n\n  svg {\n    stroke: ", ";\n  }\n"])), function (props) {
    return props.type === 'soft' ? '0px' : props.theme.spacings.xs2;
}, function (props) {
    return props.disabled
        ? props.theme.colors.neutral[80]
        : props.theme.colors.neutral[40];
});
var LeftIconContainer = styled.div(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  aspect-ratio: 1 / 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  width: 48px;\n  background-color: ", ";\n  border-radius: ", ";\n"], ["\n  aspect-ratio: 1 / 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n  width: 48px;\n  background-color: ", ";\n  border-radius: ", ";\n"])), function (props) {
    return props.disabled
        ? props.theme.colors.neutral[95]
        : props.theme.colors.secondary[95];
}, function (props) { return props.theme.borders.radius.circular; });
var templateObject_1$1a, templateObject_2$J, templateObject_3$s, templateObject_4$o, templateObject_5$i, templateObject_6$d, templateObject_7$9;

function Accordion(_a) {
    var _b;
    var children = _a.children, tagName = _a.tagName, tagVariant = _a.tagVariant, tag = _a.tag, leftIcon = _a.leftIcon, title = _a.title, description = _a.description, customHeader = _a.customHeader, actions = _a.actions, disabled = _a.disabled, className = _a.className, expanded = _a.expanded, defaultExpanded = _a.defaultExpanded, onChange = _a.onChange, style = _a.style, fullWidth = _a.fullWidth, variant = _a.variant, selected = _a.selected;
    var colors = useTheme().colors;
    return (React__default.createElement(AccordionContainer, { elevation: 0, sx: {
            '&:before': {
                display: 'none',
            },
            width: fullWidth ? '100%' : 'auto',
        }, disabled: disabled, className: className, expanded: expanded, defaultExpanded: defaultExpanded, onChange: onChange, style: style, type: variant, selected: selected },
        customHeader ? (React__default.createElement(AccordionSummaryComponent, { expandIcon: variant !== 'soft' && (React__default.createElement(PillButton, { type: "secondary", size: "small", variant: "default", icon: 'IconChevronDown', disabled: disabled })) },
            React__default.createElement(TitleContainer$1, { disabled: disabled }, customHeader),
            (actions === null || actions === void 0 ? void 0 : actions.length) && (React__default.createElement(ButtonsContainer, { disabled: disabled, type: variant }, (_b = actions === null || actions === void 0 ? void 0 : actions.map) === null || _b === void 0 ? void 0 : _b.call(actions, function (_a, i) {
                var icon = _a.icon, children = _a.children, onClick = _a.onClick;
                return (React__default.createElement(React__default.Fragment, null, icon ? (React__default.createElement(PillButton, { type: "secondary", size: "small", variant: "default", icon: icon, onClick: function (e) {
                        onClick === null || onClick === void 0 ? void 0 : onClick();
                        e.stopPropagation();
                    }, key: i })) : (React__default.createElement(React__default.Fragment, null, children))));
            }))))) : (React__default.createElement(AccordionSummaryComponent, { expandIcon: variant !== 'soft' && (React__default.createElement(PillButton, { type: "primary", size: "small", variant: "default", icon: 'IconChevronDown', disabled: disabled })) },
            typeof leftIcon === 'string' ? (React__default.createElement(LeftIconContainer, { disabled: disabled },
                React__default.createElement(Icons, { name: leftIcon, color: disabled ? colors.neutral[90] : colors.primary, fill: "transparent" }))) : (leftIcon),
            React__default.createElement(TitleContainer$1, { disabled: disabled },
                tagName && tagVariant && React__default.createElement(Tag, { variant: tagVariant }, tagName),
                tag,
                React__default.createElement(TitleWrapper$1, null,
                    typeof title === 'string' ? (React__default.createElement(Typography, { variant: "headline8", variantColor: colors.neutral30 }, title)) : (title),
                    description && typeof description === 'string' ? (React__default.createElement(Typography, { variant: "body4", variantColor: colors.neutral50 }, description)) : (description))),
            React__default.createElement(ButtonsContainer, { disabled: disabled, type: variant }, actions === null || actions === void 0 ? void 0 : actions.map(function (_a, i) {
                var icon = _a.icon, children = _a.children, onClick = _a.onClick;
                return (React__default.createElement(React__default.Fragment, null, icon ? (React__default.createElement(PillButton, { size: "small", variant: "default", type: "secondary", icon: icon, onClick: function (e) {
                        onClick === null || onClick === void 0 ? void 0 : onClick();
                        e.stopPropagation();
                    }, key: i })) : (React__default.createElement(React__default.Fragment, null, children))));
            })))),
        React__default.createElement(AccordionDetailsComponent, null, children)));
}

var css_248z$D = ".box-adornment-container-custom-theme{align-items:center;align-self:flex-start;border:1px solid var(--color-neutral-light3);border-radius:8px;display:inline-flex;flex-direction:row;padding:16px 24px}.box-adornment-container-custom-theme .box-adornment-flex{display:flex;margin-right:20px}.box-adornment-container-custom-theme .box-adornment-flex-column{display:flex;flex-direction:column;word-break:break-word}.box-adornment-container-custom-theme .box-adornment-title{color:1px solid var(--color-neutral-dark3);font-weight:600}.box-adornment-container-custom-theme .box-adornment-description{color:1px solid var(--color-neutral-dark5);font-weight:400}";
styleInject(css_248z$D);

var BoxAdornment = function (_a) {
    var title = _a.title, description = _a.description, leftAdornment = _a.leftAdornment, className = _a.className, style = _a.style, onClick = _a.onClick;
    var Component = function (props) {
        return onClick ? (React__default.createElement("button", __assign({}, props, { onClick: onClick }), props.children)) : (React__default.createElement("div", __assign({}, props), props.children));
    };
    return (React__default.createElement(Component, { className: "box-adornment-container-custom-theme ".concat(className), style: style },
        React__default.createElement("div", { className: "box-adornment-flex" }, leftAdornment),
        React__default.createElement("div", { className: "box-adornment-flex-column" },
            React__default.createElement(Typography, { variant: "body3", className: "box-adornment-title" }, title),
            React__default.createElement(Typography, { variant: "body4", className: "box-adornment-description" }, description))));
};

var css_248z$C = "";
styleInject(css_248z$C);

var Breadcrumbs = function (_a) {
    var breadcrumbs = _a.breadcrumbs, _b = _a.separator, separator = _b === void 0 ? '-' : _b, style = _a.style, className = _a.className;
    return (React__default.createElement(Breadcrumbs$1, { className: "custom-theme-breadcrumbs ".concat(className), separator: separator, style: style }, breadcrumbs));
};

function BadgeContent(props) {
    return (React__default.createElement(Typography, { variant: props.size === 'sm' ? 'overline' : 'caption', weight: 700, color: "neutral.100" }, props.children));
}

var mappedColor = {
    primary: {
        attention: colors.get('status.attention.10'),
        brand: colors.get('secondary.40'),
        complete: colors.get('status.complete.10'),
        negative: colors.get('status.negative.10'),
        neutral: colors.get('neutral.30'),
    },
    secondary: {
        attention: colors.get('status.attention.40'),
        brand: colors.get('secondary.50'),
        complete: colors.get('status.complete.40'),
        negative: colors.get('status.negative.40'),
        neutral: colors.get('neutral.30'),
    },
};
var mappedSize = {
    sm: '12px',
    md: '16px',
    lg: '20px',
};
var Badge$1 = styled(Badge$2)(templateObject_1$19 || (templateObject_1$19 = __makeTemplateObject(["\n  .MuiBadge-badge {\n    color: ", ";\n    background-color: ", ";\n    min-height: ", ";\n    height: ", ";\n    min-width: ", ";\n    padding: 0 ", ";\n  }\n"], ["\n  .MuiBadge-badge {\n    color: ", ";\n    background-color: ", ";\n    min-height: ", ";\n    height: ", ";\n    min-width: ", ";\n    padding: 0 ", ";\n  }\n"])), colors.get('neutral.100'), function (_a) {
    var variantColors = _a.variantColors, $color = _a.$color;
    return mappedColor[variantColors][$color];
}, function (_a) {
    var size = _a.size;
    return mappedSize[size];
}, function (_a) {
    var size = _a.size;
    return mappedSize[size];
}, function (_a) {
    var size = _a.size;
    return mappedSize[size];
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var templateObject_1$19;

var anchor = {
    'left-bottom': { horizontal: 'left', vertical: 'bottom' },
    'left-top': { horizontal: 'left', vertical: 'top' },
    'right-bottom': { horizontal: 'right', vertical: 'bottom' },
    'right-top': { horizontal: 'right', vertical: 'top' },
};
function Badge(props) {
    var _a, _b, _c, _d, _e;
    return (React__default.createElement(Badge$1, { id: props.id, variant: props.isDot ? 'dot' : 'standard', variantColors: (_a = props.variant) !== null && _a !== void 0 ? _a : 'primary', "$color": (_b = props.color) !== null && _b !== void 0 ? _b : 'brand', anchorOrigin: anchor[(_c = props.anchor) !== null && _c !== void 0 ? _c : 'right-top'], size: (_d = props.size) !== null && _d !== void 0 ? _d : 'md', badgeContent: props.content ? (React__default.createElement(BadgeContent, { size: (_e = props.size) !== null && _e !== void 0 ? _e : 'md' }, props.content)) : undefined }, props.children));
}

var wave = keyframes(templateObject_1$18 || (templateObject_1$18 = __makeTemplateObject(["\n  0% {\n    background-position: -10vw 0;\n    transform: translateZ(0);\n  }\n  100% {\n    background-position: 100vw 0;\n    transform: translateZ(0);\n  }\n"], ["\n  0% {\n    background-position: -10vw 0;\n    transform: translateZ(0);\n  }\n  100% {\n    background-position: 100vw 0;\n    transform: translateZ(0);\n  }\n"])));
var StyledButton$1 = styled(ButtonBase)(templateObject_2$I || (templateObject_2$I = __makeTemplateObject(["\n  &.MuiPaper-root.MuiButtonBase-root {\n    border-radius: 12px;\n    display: flex;\n    align-self: flex-start;\n    justify-content: center;\n    align-items: center;\n    font-family: var(--font-family-secondary);\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 22px;\n    text-align: center;\n    gap: 8px;\n    will-change: transform;\n    border: 1px solid transparent;\n\n    &&:disabled {\n      background: var(--color-neutral-light2);\n      color: var(--color-neutral-light4);\n      border: 1px solid transparent;\n      pointer-events: none;\n      user-select: none;\n    }\n\n    &.loading {\n      pointer-events: none;\n      user-select: none;\n      animation-duration: 6s;\n      animation-fill-mode: forwards;\n      animation-iteration-count: infinite;\n      animation-name: ", ";\n      animation-timing-function: linear;\n    }\n\n    &.size-small {\n      min-width: 128px;\n      font-size: 12px;\n      line-height: 18px;\n      padding: 6px 8px;\n      gap: 4px;\n      border-radius: 8px;\n\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    &.size-medium {\n      min-width: 160px;\n      font-size: 14px;\n      line-height: 20px;\n      padding: 9px 16px;\n\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    &.size-large {\n      min-width: 184px;\n      padding: 12px 16px;\n\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n\n  &.variant-default {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-secondary-dark5);\n        color: var(--color-neutral-pureLight);\n        border: 1px solid transparent;\n\n        &:hover {\n          background: var(--color-secondary-40);\n        }\n\n        &:active {\n          background: var(--color-secondary-30);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-secondary-30) 0%,\n            var(--color-secondary-50) 100%\n          );\n          &:disabled {\n            color: var(--color-neutral-pureLight);\n          }\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-secondary-95);\n        }\n      }\n    }\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: transparent;\n        border: 1px solid var(--color-neutral-90);\n        color: var(--color-secondary-50);\n\n        &:hover {\n          background: var(--color-secondary-90);\n          border-color: var(--color-secondary-90);\n        }\n\n        &:active {\n          background: transparent;\n          border-color: var(--color-secondary-70);\n          color: var(--color-secondary-50);\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-secondary-80);\n          border-color: var(--color-secondary-70);\n        }\n\n        &.loading {\n          border-color: var(--color-secondary-70);\n          background: linear-gradient(\n            to right,\n            white 50%,\n            var(--color-secondary-90) 80%\n          );\n          &:disabled {\n            color: var(--color-secondary-50);\n            border-color: var(--color-secondary-50);\n          }\n        }\n      }\n    }\n  }\n\n  &.variant-success {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-feedback-success-90);\n        background-color: var(--color-feedback-success-90);\n        color: var(--color-feedback-success-10);\n\n        &:hover {\n          background: var(--color-feedback-success-70);\n          background-color: var(--color-feedback-success-70);\n        }\n\n        &:active {\n          background: var(--color-feedback-success-50);\n          background-color: var(--color-feedback-success-50);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-feedback-success-70) 0%,\n            var(--color-feedback-success-50) 100%\n          );\n          &:disabled {\n            color: var(--color-feedback-success-10);\n          }\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-feedback-success-70);\n          background: var(--color-feedback-success-90);\n          background-color: var(--color-feedback-success-90);\n        }\n      }\n    }\n\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        color: var(--color-feedback-success-40);\n        background: transparent;\n        border: 1px solid var(--color-neutral-90);\n\n        &:hover {\n          background: var(--color-feedback-success-90);\n          border: 1px solid var(--color-feedback-success-90);\n        }\n\n        &:active {\n          background: transparent;\n          border: 1px solid var(--color-feedback-success-50);\n        }\n\n        &:focus-visible {\n          border: 1px solid var(--color-feedback-success-50);\n          outline: 4px solid var(--color-feedback-success-70);\n        }\n\n        &.loading {\n          border: 1px solid var(--color-feedback-success-50);\n          background: linear-gradient(\n            to right,\n            white 50%,\n            var(--color-feedback-success-90) 80%\n          );\n        }\n      }\n    }\n  }\n\n  &.variant-attention {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-feedback-attention-90);\n        color: var(--color-feedback-attention-10);\n\n        &:hover {\n          background: var(--color-feedback-attention-70);\n        }\n\n        &:active {\n          background: var(--color-feedback-attention-50);\n        }\n\n        &:focus-visible {\n          background: var(--color-feedback-attention-90);\n          outline: 4px solid var(--color-feedback-attention-70);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-feedback-attention-70) 0%,\n            var(--color-feedback-attention-90) 100%\n          );\n          &:disabled {\n            color: var(--color-feedback-attention-10);\n          }\n        }\n      }\n    }\n\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: transparent;\n        color: var(--color-feedback-attention-40);\n        border: 1px solid var(--color-neutral-90);\n\n        &:hover {\n          background: var(--color-feedback-error-90);\n          border-color: var(--color-feedback-error-90);\n        }\n\n        &:active {\n          background: transparent;\n          border-color: var(--color-feedback-error-50);\n        }\n\n        &:focus-visible {\n          border-color: var(--color-feedback-attention-50);\n          outline: 4px solid var(--color-feedback-attention-70);\n        }\n\n        &.loading {\n          border-color: var(--color-feedback-error-50);\n          background: linear-gradient(\n            to right,\n            white 50%,\n            var(--color-feedback-attention-90) 80%\n          );\n          &:disabled {\n            color: var(--color-feedback-attention-40);\n          }\n        }\n      }\n    }\n  }\n\n  &.variant-negative {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-feedback-negative-90);\n        color: var(--color-feedback-negative-10);\n\n        &:hover {\n          background: var(--color-feedback-negative-70);\n        }\n\n        &:active {\n          color: var(--color-feedback-negative-90);\n          background: var(--color-feedback-negative-50);\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-feedback-negative-70);\n          background: var(--color-feedback-negative-90);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-feedback-negative-70) 0%,\n            var(--color-feedback-negative-90) 100%\n          );\n          &:disabled {\n            color: var(--color-feedback-negative-10);\n          }\n        }\n      }\n    }\n\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: transparent;\n        color: var(--color-feedback-negative-40);\n        border: 1px solid var(--color-neutral-90);\n\n        &:hover {\n          background: var(--color-feedback-negative-90);\n          border-color: var(--color-feedback-negative-90);\n        }\n\n        &:active {\n          background: transparent;\n          border-color: 1px solid var(--color-feedback-negative-50);\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-feedback-negative-70);\n          border-color: 1px solid var(--color-feedback-negative-50);\n        }\n\n        &.loading {\n          border-color: 1px solid var(--color-feedback-negative-50);\n          background: linear-gradient(\n            to right,\n            white 50%,\n            var(--color-feedback-negative-90) 80%\n          );\n          &:disabled {\n            color: var(--color-feedback-negative-40);\n          }\n        }\n      }\n    }\n  }\n\n  &.variant-neutral {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-neutral-90);\n        color: var(--color-neutral-10);\n\n        &:hover {\n          background: var(--color-neutral-70);\n        }\n\n        &:active {\n          background: var(--color-neutral-60);\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-neutral-light4);\n          background: var(--color-neutral-90);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-neutral-70) 0%,\n            var(--color-neutral-90) 100%\n          );\n          &:disabled {\n            color: var(--color-neutral-10);\n          }\n        }\n      }\n    }\n\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        color: var(--color-neutral-20);\n        background: transparent;\n        border: 1px solid var(--color-neutral-90);\n\n        &:hover {\n          background: var(--color-neutral-80);\n          border: 1px solid var(--color-neutral-80);\n        }\n\n        &:active {\n          background: transparent;\n          border: 1px solid var(--color-neutral-50);\n        }\n\n        &:focus-visible:not(:disabled) {\n          outline: 4px solid var(--color-neutral-70);\n          border: 1px solid var(--color-neutral-50);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            white 0%,\n            var(--color-neutral-light2) 100%\n          );\n          border: 1px solid var(--color-neutral-50);\n\n          &:disabled {\n            color: var(--color-neutral-40);\n          }\n        }\n      }\n    }\n  }\n"], ["\n  &.MuiPaper-root.MuiButtonBase-root {\n    border-radius: 12px;\n    display: flex;\n    align-self: flex-start;\n    justify-content: center;\n    align-items: center;\n    font-family: var(--font-family-secondary);\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 22px;\n    text-align: center;\n    gap: 8px;\n    will-change: transform;\n    border: 1px solid transparent;\n\n    &&:disabled {\n      background: var(--color-neutral-light2);\n      color: var(--color-neutral-light4);\n      border: 1px solid transparent;\n      pointer-events: none;\n      user-select: none;\n    }\n\n    &.loading {\n      pointer-events: none;\n      user-select: none;\n      animation-duration: 6s;\n      animation-fill-mode: forwards;\n      animation-iteration-count: infinite;\n      animation-name: ", ";\n      animation-timing-function: linear;\n    }\n\n    &.size-small {\n      min-width: 128px;\n      font-size: 12px;\n      line-height: 18px;\n      padding: 6px 8px;\n      gap: 4px;\n      border-radius: 8px;\n\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    &.size-medium {\n      min-width: 160px;\n      font-size: 14px;\n      line-height: 20px;\n      padding: 9px 16px;\n\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    &.size-large {\n      min-width: 184px;\n      padding: 12px 16px;\n\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n\n  &.variant-default {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-secondary-dark5);\n        color: var(--color-neutral-pureLight);\n        border: 1px solid transparent;\n\n        &:hover {\n          background: var(--color-secondary-40);\n        }\n\n        &:active {\n          background: var(--color-secondary-30);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-secondary-30) 0%,\n            var(--color-secondary-50) 100%\n          );\n          &:disabled {\n            color: var(--color-neutral-pureLight);\n          }\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-secondary-95);\n        }\n      }\n    }\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: transparent;\n        border: 1px solid var(--color-neutral-90);\n        color: var(--color-secondary-50);\n\n        &:hover {\n          background: var(--color-secondary-90);\n          border-color: var(--color-secondary-90);\n        }\n\n        &:active {\n          background: transparent;\n          border-color: var(--color-secondary-70);\n          color: var(--color-secondary-50);\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-secondary-80);\n          border-color: var(--color-secondary-70);\n        }\n\n        &.loading {\n          border-color: var(--color-secondary-70);\n          background: linear-gradient(\n            to right,\n            white 50%,\n            var(--color-secondary-90) 80%\n          );\n          &:disabled {\n            color: var(--color-secondary-50);\n            border-color: var(--color-secondary-50);\n          }\n        }\n      }\n    }\n  }\n\n  &.variant-success {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-feedback-success-90);\n        background-color: var(--color-feedback-success-90);\n        color: var(--color-feedback-success-10);\n\n        &:hover {\n          background: var(--color-feedback-success-70);\n          background-color: var(--color-feedback-success-70);\n        }\n\n        &:active {\n          background: var(--color-feedback-success-50);\n          background-color: var(--color-feedback-success-50);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-feedback-success-70) 0%,\n            var(--color-feedback-success-50) 100%\n          );\n          &:disabled {\n            color: var(--color-feedback-success-10);\n          }\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-feedback-success-70);\n          background: var(--color-feedback-success-90);\n          background-color: var(--color-feedback-success-90);\n        }\n      }\n    }\n\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        color: var(--color-feedback-success-40);\n        background: transparent;\n        border: 1px solid var(--color-neutral-90);\n\n        &:hover {\n          background: var(--color-feedback-success-90);\n          border: 1px solid var(--color-feedback-success-90);\n        }\n\n        &:active {\n          background: transparent;\n          border: 1px solid var(--color-feedback-success-50);\n        }\n\n        &:focus-visible {\n          border: 1px solid var(--color-feedback-success-50);\n          outline: 4px solid var(--color-feedback-success-70);\n        }\n\n        &.loading {\n          border: 1px solid var(--color-feedback-success-50);\n          background: linear-gradient(\n            to right,\n            white 50%,\n            var(--color-feedback-success-90) 80%\n          );\n        }\n      }\n    }\n  }\n\n  &.variant-attention {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-feedback-attention-90);\n        color: var(--color-feedback-attention-10);\n\n        &:hover {\n          background: var(--color-feedback-attention-70);\n        }\n\n        &:active {\n          background: var(--color-feedback-attention-50);\n        }\n\n        &:focus-visible {\n          background: var(--color-feedback-attention-90);\n          outline: 4px solid var(--color-feedback-attention-70);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-feedback-attention-70) 0%,\n            var(--color-feedback-attention-90) 100%\n          );\n          &:disabled {\n            color: var(--color-feedback-attention-10);\n          }\n        }\n      }\n    }\n\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: transparent;\n        color: var(--color-feedback-attention-40);\n        border: 1px solid var(--color-neutral-90);\n\n        &:hover {\n          background: var(--color-feedback-error-90);\n          border-color: var(--color-feedback-error-90);\n        }\n\n        &:active {\n          background: transparent;\n          border-color: var(--color-feedback-error-50);\n        }\n\n        &:focus-visible {\n          border-color: var(--color-feedback-attention-50);\n          outline: 4px solid var(--color-feedback-attention-70);\n        }\n\n        &.loading {\n          border-color: var(--color-feedback-error-50);\n          background: linear-gradient(\n            to right,\n            white 50%,\n            var(--color-feedback-attention-90) 80%\n          );\n          &:disabled {\n            color: var(--color-feedback-attention-40);\n          }\n        }\n      }\n    }\n  }\n\n  &.variant-negative {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-feedback-negative-90);\n        color: var(--color-feedback-negative-10);\n\n        &:hover {\n          background: var(--color-feedback-negative-70);\n        }\n\n        &:active {\n          color: var(--color-feedback-negative-90);\n          background: var(--color-feedback-negative-50);\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-feedback-negative-70);\n          background: var(--color-feedback-negative-90);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-feedback-negative-70) 0%,\n            var(--color-feedback-negative-90) 100%\n          );\n          &:disabled {\n            color: var(--color-feedback-negative-10);\n          }\n        }\n      }\n    }\n\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: transparent;\n        color: var(--color-feedback-negative-40);\n        border: 1px solid var(--color-neutral-90);\n\n        &:hover {\n          background: var(--color-feedback-negative-90);\n          border-color: var(--color-feedback-negative-90);\n        }\n\n        &:active {\n          background: transparent;\n          border-color: 1px solid var(--color-feedback-negative-50);\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-feedback-negative-70);\n          border-color: 1px solid var(--color-feedback-negative-50);\n        }\n\n        &.loading {\n          border-color: 1px solid var(--color-feedback-negative-50);\n          background: linear-gradient(\n            to right,\n            white 50%,\n            var(--color-feedback-negative-90) 80%\n          );\n          &:disabled {\n            color: var(--color-feedback-negative-40);\n          }\n        }\n      }\n    }\n  }\n\n  &.variant-neutral {\n    &--primary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        background: var(--color-neutral-90);\n        color: var(--color-neutral-10);\n\n        &:hover {\n          background: var(--color-neutral-70);\n        }\n\n        &:active {\n          background: var(--color-neutral-60);\n        }\n\n        &:focus-visible {\n          outline: 4px solid var(--color-neutral-light4);\n          background: var(--color-neutral-90);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            var(--color-neutral-70) 0%,\n            var(--color-neutral-90) 100%\n          );\n          &:disabled {\n            color: var(--color-neutral-10);\n          }\n        }\n      }\n    }\n\n    &--secondary {\n      &.MuiPaper-root.MuiButtonBase-root {\n        color: var(--color-neutral-20);\n        background: transparent;\n        border: 1px solid var(--color-neutral-90);\n\n        &:hover {\n          background: var(--color-neutral-80);\n          border: 1px solid var(--color-neutral-80);\n        }\n\n        &:active {\n          background: transparent;\n          border: 1px solid var(--color-neutral-50);\n        }\n\n        &:focus-visible:not(:disabled) {\n          outline: 4px solid var(--color-neutral-70);\n          border: 1px solid var(--color-neutral-50);\n        }\n\n        &.loading {\n          background: linear-gradient(\n            to right,\n            white 0%,\n            var(--color-neutral-light2) 100%\n          );\n          border: 1px solid var(--color-neutral-50);\n\n          &:disabled {\n            color: var(--color-neutral-40);\n          }\n        }\n      }\n    }\n  }\n"])), wave);
var templateObject_1$18, templateObject_2$I;

var Button$4 = forwardRef(function (_a, ref) {
    var variant = _a.variant, variantType = _a.variantType, buttonType = _a.buttonType, _b = _a.size, size = _b === void 0 ? 'medium' : _b, children = _a.children, className = _a.className, _c = _a.loading, loading = _c === void 0 ? false : _c, props = __rest(_a, ["variant", "variantType", "buttonType", "size", "children", "className", "loading"]);
    return (React__default.createElement(StyledButton$1, __assign({}, props, { className: cx("variant-".concat(variantType || 'default', "--").concat(buttonType || variant), 'MuiPaper-root', "size-".concat(size), { loading: loading }, className), ref: ref, disableRipple: true, disableTouchRipple: true, style: __assign({ minWidth: props.minWidth, maxWidth: props.maxWidth, minHeight: props.minHeight, maxHeight: props.maxHeight }, props.style) }), children));
});
Button$4.displayName = 'Button';

var Button$3 = styled(ButtonBase)(templateObject_1$17 || (templateObject_1$17 = __makeTemplateObject(["\n  align-items: center;\n  position: relative;\n  background: transparent;\n  display: flex;\n  padding-right: 2px;\n  gap: 2px;\n  font-family: ", ";\n  font-weight: 700;\n  line-height: 30px;\n  border-radius: ", "; // 4px\n\n  &.small {\n    --bottom-size: ", "; // 1.5px\n    font-size: 12px;\n  }\n\n  &.medium {\n    --bottom-size: ", "; // 2px;\n    font-size: 14px;\n  }\n\n  &.large {\n    --bottom-size: ", "; // 2px;\n    font-size: 16px;\n  }\n\n  &.default {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.success {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.info {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.error {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.neutral {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.underlined {\n    &:focus {\n      outline: 4px solid var(--outline-color);\n    }\n\n    &::before {\n      content: '';\n      border-bottom: var(--bottom-size) solid var(--color);\n      position: absolute;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n      transition: all 0.2s ease-in;\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    color: ", ";\n\n    &::before {\n      border-bottom-color: ", ";\n    }\n  }\n"], ["\n  align-items: center;\n  position: relative;\n  background: transparent;\n  display: flex;\n  padding-right: 2px;\n  gap: 2px;\n  font-family: ", ";\n  font-weight: 700;\n  line-height: 30px;\n  border-radius: ", "; // 4px\n\n  &.small {\n    --bottom-size: ", "; // 1.5px\n    font-size: 12px;\n  }\n\n  &.medium {\n    --bottom-size: ", "; // 2px;\n    font-size: 14px;\n  }\n\n  &.large {\n    --bottom-size: ", "; // 2px;\n    font-size: 16px;\n  }\n\n  &.default {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.success {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.info {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.error {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.neutral {\n    color: ", ";\n    --color: ", ";\n    --outline-color: ", ";\n  }\n\n  &.underlined {\n    &:focus {\n      outline: 4px solid var(--outline-color);\n    }\n\n    &::before {\n      content: '';\n      border-bottom: var(--bottom-size) solid var(--color);\n      position: absolute;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n      transition: all 0.2s ease-in;\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    color: ", ";\n\n    &::before {\n      border-bottom-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.secondary;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.width.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.width.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.width.s;
}, colors.get('secondary.50'), colors.get('secondary.50'), colors.get('secondary.90'), colors.get('feedback.success.40'), colors.get('feedback.success.40'), colors.get('feedback.success.90'), colors.get('feedback.info.40'), colors.get('feedback.info.40'), colors.get('feedback.info.90'), colors.get('feedback.error.40'), colors.get('feedback.error.40'), colors.get('feedback.error.90'), colors.get('neutral.40'), colors.get('neutral.40'), colors.get('neutral.90'), colors.get('neutral.80'), colors.get('neutral.80'));
var templateObject_1$17;

var LinkButton = forwardRef(function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, style = _a.style, type = _a.type, classes = _a.classes, disabled = _a.disabled, children = _a.children, href = _a.href, to = _a.to, target = _a.target, _d = _a.underlined, underlined = _d === void 0 ? true : _d, props = __rest(_a, ["variant", "size", "style", "type", "classes", "disabled", "children", "href", "to", "target", "underlined"]);
    return (React__default.createElement(Button$3, __assign({}, props, { className: "".concat(!!underlined && 'underlined', " ").concat(variant, " ").concat(size), style: style, classes: classes, ref: ref, disabled: disabled, type: type, disableRipple: true, disableTouchRipple: true }, (href && { href: href }), (target && { target: target }), (to && { to: to })), children));
});
LinkButton.displayName = 'LinkButton';

var ButtonWrapper = styled.div(templateObject_1$16 || (templateObject_1$16 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 16px;\n"])));
var StyledLinkButton = styled(LinkButton)(templateObject_2$H || (templateObject_2$H = __makeTemplateObject(["\n  opacity: 1 !important;\n  max-width: fit-content;\n"], ["\n  opacity: 1 !important;\n  max-width: fit-content;\n"])));
var StyledButton = styled(Button$4)(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1$16, templateObject_2$H, templateObject_3$r;

var BigNumberButton = function (_a) {
    var buttonVariant = _a.buttonVariant, tag = _a.tag, buttonLabel = _a.buttonLabel, onClick = _a.onClick;
    return (React__default.createElement(ButtonWrapper, null,
        buttonVariant === 'link' ? (React__default.createElement(StyledLinkButton, { onClick: onClick, variant: "default" }, buttonLabel)) : (React__default.createElement(StyledButton, { onClick: onClick, variant: buttonVariant }, buttonLabel)),
        tag && React__default.createElement(Tag, __assign({}, tag))));
};

var IconWrapper = styled.div(templateObject_1$15 || (templateObject_1$15 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 48px;\n  min-height: 48px;\n  background: ", ";\n  border-radius: 50%;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 48px;\n  min-height: 48px;\n  background: ", ";\n  border-radius: 50%;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var templateObject_1$15;

var BigNumberIcon = function (_a) {
    var iconColors = _a.iconColors, icon = _a.icon;
    return (React__default.createElement(IconWrapper, { color: iconColors.secondary },
        React__default.createElement(Icons, { name: icon, fill: "transparent", color: iconColors.primary })));
};

var css_248z$B = ".iconButton-custom-theme-filled.MuiButtonBase-root{align-items:center;align-self:flex-start;aspect-ratio:1/1;background:var(--color-neutral-light1);border-radius:50%;display:flex;justify-content:center}.iconButton-custom-theme-filled.MuiButtonBase-root.selected,.iconButton-custom-theme-filled.MuiButtonBase-root:hover{background:var(--color-neutral-light2)}.iconButton-custom-theme-filled.MuiButtonBase-root:active{background:var(--color-neutral-light3)}.iconButton-custom-theme-filled.MuiButtonBase-root:disabled{pointer-events:none}.iconButton-custom-theme-filled.MuiButtonBase-root:disabled .libIcon svg{stroke:var(--color-neutral-light3)}.iconButton-custom-theme-filled.MuiButtonBase-root:disabled .uiIcon svg{fill:var(--color-neutral-light3)}.iconButton-custom-theme-filled.MuiButtonBase-root.size-small{padding:12px}.iconButton-custom-theme-filled.MuiButtonBase-root.size-small svg{height:16px;width:16px}.iconButton-custom-theme-filled.MuiButtonBase-root.size-medium{padding:12px}.iconButton-custom-theme-filled.MuiButtonBase-root.size-medium svg{height:24px;width:24px}.iconButton-custom-theme-filled.MuiButtonBase-root.size-large{padding:18px}.iconButton-custom-theme-filled.MuiButtonBase-root.size-large svg{height:24px;width:24px}.iconButton-custom-theme-line.MuiButtonBase-root{align-items:center;align-self:flex-start;aspect-ratio:1/1;background:transparent;border:1px solid var(--color-neutral-light2);border-radius:50%;display:flex;justify-content:center}.iconButton-custom-theme-line.MuiButtonBase-root:hover{background:var(--color-neutral-light2)}.iconButton-custom-theme-line.MuiButtonBase-root:active{background:var(--color-neutral-light3);border-color:var(--color-neutral-light3)}.iconButton-custom-theme-line.MuiButtonBase-root:disabled{background:var(--color-neutral-light1);border-color:var(--color-neutral-light1);pointer-events:none}.iconButton-custom-theme-line.MuiButtonBase-root:disabled .libIcon svg{stroke:var(--color-neutral-light3)}.iconButton-custom-theme-line.MuiButtonBase-root:disabled .uiIcon svg{fill:var(--color-neutral-light3)}.iconButton-custom-theme-line.MuiButtonBase-root.size-small{padding:12px}.iconButton-custom-theme-line.MuiButtonBase-root.size-small svg{height:16px;width:16px}.iconButton-custom-theme-line.MuiButtonBase-root.size-medium{padding:12px}.iconButton-custom-theme-line.MuiButtonBase-root.size-medium svg{height:24px;width:24px}.iconButton-custom-theme-line.MuiButtonBase-root.size-large{padding:18px}.iconButton-custom-theme-line.MuiButtonBase-root.size-large svg{height:24px;width:24px}";
styleInject(css_248z$B);

/**
 * @deprecated - use PillButon
 * https://github.com/flash-tecnologia/hros-web-ui-v2/blob/main/src/components/PillButton/index.tsx
 */
var IconButton = function (_a) {
    var _b = _a.disableRipple, disableRipple = _b === void 0 ? true : _b, _c = _a.disableTouchRipple, disableTouchRipple = _c === void 0 ? true : _c, selected = _a.selected, variant = _a.variant, size = _a.size, style = _a.style, onClick = _a.onClick, onFocus = _a.onFocus, onSubmit = _a.onSubmit, onError = _a.onError, type = _a.type, ref = _a.ref, classes = _a.classes, id = _a.id, disabled = _a.disabled, icon = _a.icon, children = _a.children, className = _a.className, props = __rest(_a, ["disableRipple", "disableTouchRipple", "selected", "variant", "size", "style", "onClick", "onFocus", "onSubmit", "onError", "type", "ref", "classes", "id", "disabled", "icon", "children", "className"]);
    return (React__default.createElement(ButtonBase, __assign({ id: id, className: "iconButton-custom-theme-".concat(variant, " size-").concat(size, " loading ").concat(className, " ").concat(selected && 'selected'), style: style, classes: classes, ref: ref, disabled: disabled, type: type, disableRipple: disableRipple, disableTouchRipple: disableTouchRipple, onClick: onClick, onFocus: onFocus, onSubmit: onSubmit, onError: onError }, props),
        icon && (React__default.createElement(Icons, { name: icon, size: 50, color: "#53464F", fill: "transparent" })),
        children));
};

var css_248z$A = ".menu-base-custom-theme ul.MuiList-root{border-radius:8px;padding:12px}.menu-base-custom-theme li{color:var(--color-neutral-dark3);padding:12px}.menu-base-custom-theme li.Mui-selected{background-color:var(--color-secondary-light2);border-radius:8px;color:var(--color-primary)}.menu-base-custom-theme li.MuiButtonBase-root{margin-bottom:4px}.menu-base-custom-theme li.MuiButtonBase-root:hover{background-color:var(--color-neutral-light1);border-radius:8px;color:var(--color-neutral-dark3)}.menu-base-custom-theme li.MuiButtonBase-root:last-child{margin-bottom:0}.menu-base-custom-theme li.MuiButtonBase-root button{width:100%}.disabled{pointer-events:none}";
styleInject(css_248z$A);

var Menu$2 = function (_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? 'default' : _b, _c = _a.options, options = _c === void 0 ? [] : _c, anchorOrigin = _a.anchorOrigin, transformOrigin = _a.transformOrigin, disabled = _a.disabled, style = _a.style, className = _a.className, _d = _a.locked, locked = _d === void 0 ? false : _d, onClick = _a.onClick;
    var _e = React__default.useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var _f = React__default.useState(null), selectedIndex = _f[0], setSelectedIndex = _f[1];
    var handleClickListItem = function (event) {
        event.stopPropagation();
        event.preventDefault();
        onClick && onClick();
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = function (index, disabled) {
        setSelectedIndex(index);
        !disabled && setAnchorEl(null);
    };
    var handleClose = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setAnchorEl(null);
    };
    var renderOptions = useMemo(function () {
        return options.map(function (option, index) {
            var label = option.label, children = option.children, onClick = option.onClick, _a = option.disabled, disabled = _a === void 0 ? false : _a, selected = option.selected;
            if (type === 'select') {
                return (React__default.createElement(MenuItem$4, { key: index, disableTouchRipple: disabled, disableRipple: disabled, focusRipple: disabled, selected: index === selectedIndex, onClick: function (event) {
                        handleMenuItemClick(index, disabled);
                        if (event && onClick)
                            onClick(event);
                    } }, children || label));
            }
            return (React__default.createElement(MenuItem$4, { key: index, selected: selected, disableTouchRipple: disabled, disableRipple: disabled, onClick: function (event) {
                    handleMenuItemClick(index, disabled);
                    if (event && onClick)
                        onClick(event);
                } }, children || label));
        });
    }, [options, type]);
    var defaultTransformOrigin = transformOrigin || {
        horizontal: 'left',
        vertical: 'top',
    };
    var defaultAnchorOrigin = anchorOrigin || {
        horizontal: 'left',
        vertical: 'bottom',
    };
    return (React__default.createElement("div", { className: "menu-base-container-custom-theme ".concat(disabled && 'disabled') },
        children && (React__default.createElement("button", { onClick: handleClickListItem, type: "button" }, children)),
        React__default.createElement(Menu$3, { className: "".concat(className, " menu-base-custom-theme"), open: !!anchorEl, anchorEl: anchorEl, onClose: handleClose, onClick: function (e) {
                !locked && handleClose(e);
            }, transformOrigin: defaultTransformOrigin, anchorOrigin: defaultAnchorOrigin, style: style }, renderOptions)));
};

var StyledShapeIcon = styled(Icons)(templateObject_4$n || (templateObject_4$n = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  padding: calc(", "px / 4);\n  border-radius: ", ";\n  background-color: ", ";\n  cursor: ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  width: ", "px;\n  height: ", "px;\n  padding: calc(", "px / 4);\n  border-radius: ", ";\n  background-color: ", ";\n  cursor: ", ";\n\n  ", ";\n  ", ";\n  ", ";\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.pill;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    switch (variant) {
        case 'info':
        case 'success':
        case 'error':
        case 'progress':
        case 'negative':
            return theme.colors.feedback[variant][90];
        case 'neutral':
        case 'disabled':
            return theme.colors.neutral[90];
        case 'transparent':
            return 'transparent';
        default:
            return theme.colors.secondary[95];
    }
}, function (_a) {
    var variant = _a.variant;
    return variant === 'disabled' ? 'not-allowed' : 'default';
}, function (_a) {
    var stroke = _a.stroke, theme = _a.theme;
    return stroke && css(templateObject_1$14 || (templateObject_1$14 = __makeTemplateObject(["\n      stroke: ", ";\n    "], ["\n      stroke: ", ";\n    "])), function () {
        switch (stroke) {
            case 'info':
            case 'success':
            case 'error':
            case 'progress':
            case 'negative':
                return theme.colors.feedback[stroke][40];
            case 'neutral':
                return theme.colors.neutral[40];
            case 'disabled':
                return theme.colors.neutral[70];
            case 'transparent':
                return 'transparent';
            default:
                return theme.colors.secondary[50];
        }
    });
}, function (_a) {
    var fill = _a.fill, theme = _a.theme;
    return fill && css(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n      stroke: ", ";\n    "], ["\n      stroke: ", ";\n    "])), function () {
        switch (fill) {
            case 'info':
            case 'success':
            case 'error':
            case 'progress':
            case 'negative':
                return theme.colors.feedback[fill][40];
            case 'neutral':
                return theme.colors.neutral[40];
            case 'disabled':
                return theme.colors.neutral[70];
            case 'transparent':
                return 'transparent';
            default:
                return theme.colors.secondary[50];
        }
    });
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color && css(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), function () {
        switch (color) {
            case 'info':
            case 'success':
            case 'error':
            case 'progress':
            case 'negative':
                return theme.colors.feedback[color][40];
            case 'neutral':
                return theme.colors.neutral[40];
            case 'disabled':
                return theme.colors.neutral[70];
            case 'transparent':
                return 'transparent';
            default:
                return theme.colors.secondary[50];
        }
    });
});
var ShapeIcon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["name", "size"]);
    return React__default.createElement(StyledShapeIcon, __assign({ name: name, size: size }, props));
};
var templateObject_1$14, templateObject_2$G, templateObject_3$q, templateObject_4$n;

var Container$v = styled.button(templateObject_1$13 || (templateObject_1$13 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n"])));
var TextContainer = styled.div(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n"])));
var templateObject_1$13, templateObject_2$F;

var MenuOption$2 = function (_a) {
    var icon = _a.icon, shapeIcon = _a.shapeIcon, label = _a.label, subtitle = _a.subtitle, onClick = _a.onClick;
    return (React__default.createElement(Container$v, { onClick: onClick },
        icon && !shapeIcon && (React__default.createElement(Icons, { name: icon, size: 24, stroke: "default", fill: "transparent" })),
        shapeIcon && (React__default.createElement(ShapeIcon, { name: shapeIcon.name, variant: shapeIcon.variant || 'default', size: shapeIcon.size || 24, stroke: shapeIcon.stroke || 'default' })),
        React__default.createElement(TextContainer, null,
            React__default.createElement(Typography.Body4, { weight: 600, color: "neutral.30" }, label),
            subtitle && (React__default.createElement(Typography, { variant: "caption", color: "neutral.30" }, subtitle)))));
};

var BigNumberMenu = function (_a) {
    var menuOptions = _a.menuOptions;
    return (React__default.createElement(Menu$2, { options: menuOptions.map(function (option, index) {
            var _a;
            return {
                key: index,
                children: (React__default.createElement(MenuOption$2, { label: (_a = option.label) !== null && _a !== void 0 ? _a : '', icon: option.icon })),
            };
        }), type: "select" },
        React__default.createElement(IconButton, { icon: "IconDotsVertical", size: "small", variant: "filled" })));
};

var BigNumberTooltip = function (_a) {
    var tooltip = _a.tooltip, menuOptions = _a.menuOptions;
    return (React__default.createElement(Tooltip, { title: tooltip, arrow: true }, menuOptions ? (React__default.createElement(IconButton, { variant: "filled", size: "small", icon: "IconInfoCircle", disableTouchRipple: true, disableRipple: true, onClick: function () { return null; } })) : (React__default.createElement("button", null,
        React__default.createElement(Icons, { name: "IconInfoCircle", fill: "transparent", color: "#83727D" })))));
};

var StyledValueDetails = styled(Typography)(templateObject_1$12 || (templateObject_1$12 = __makeTemplateObject(["\n  color: ", ";\n\n  font-weight: 700;\n"], ["\n  color: ", ";\n\n  font-weight: 700;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[50];
});
var templateObject_1$12;

var BigNumberValueDetails = function (_a) {
    var valueDetails = _a.valueDetails;
    return (React__default.createElement(StyledValueDetails, { variant: "headline8" }, valueDetails));
};

var Card = styled.div(templateObject_1$11 || (templateObject_1$11 = __makeTemplateObject(["\n  ", "\n  display: flex;\n  padding: 24px;\n  flex: 1 0 0;\n  border-radius: 12px;\n  border: 1px solid ", ";\n  background: ", ";\n  max-width: fit-content;\n"], ["\n  ", "\n  display: flex;\n  padding: 24px;\n  flex: 1 0 0;\n  border-radius: 12px;\n  border: 1px solid ", ";\n  background: ", ";\n  max-width: fit-content;\n"])), function (_a) {
    var orientation = _a.orientation;
    if (orientation === 'horizontal') {
        return "\n      flex-direction: row;\n      align-items: center;\n      gap: 16px;\n    ";
    }
    return "\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  ";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[90];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[100];
});
var IconsContainer = styled.div(templateObject_2$E || (templateObject_2$E = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 8px;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 8px;\n"])));
var Content$6 = styled.div(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"])));
var StyledTitle = styled(Typography)(templateObject_4$m || (templateObject_4$m = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[50];
});
var StyledValue = styled(Typography)(templateObject_5$h || (templateObject_5$h = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[30];
});
var ValueWrapper = styled.div(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-direction: row;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-direction: row;\n"])));
var CornerButtonsWrapper = styled.div(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n"])));
var templateObject_1$11, templateObject_2$E, templateObject_3$p, templateObject_4$m, templateObject_5$h, templateObject_6$c, templateObject_7$8;

var BigNumberHorizontal = function (_a) {
    var iconColors = _a.iconColors, icon = _a.icon, title = _a.title, value = _a.value, tooltip = _a.tooltip, valueDetails = _a.valueDetails, menuOptions = _a.menuOptions, buttonLabel = _a.buttonLabel, buttonVariant = _a.buttonVariant, tag = _a.tag, button = _a.button, onSelect = _a.onSelect;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BigNumberIcon, { icon: icon, iconColors: iconColors }),
        React__default.createElement(Content$6, null,
            React__default.createElement(IconsContainer, null,
                React__default.createElement(StyledTitle, { variant: "body3" }, title),
                tooltip && (React__default.createElement(BigNumberTooltip, { tooltip: tooltip, menuOptions: menuOptions })),
                menuOptions && React__default.createElement(BigNumberMenu, { menuOptions: menuOptions })),
            React__default.createElement(StyledValue, { variant: "headline5" }, value),
            React__default.createElement(BigNumberValueDetails, { valueDetails: valueDetails }),
            button ? (button) : (React__default.createElement(BigNumberButton, { onClick: onSelect, buttonLabel: buttonLabel, buttonVariant: buttonVariant, tag: tag })))));
};

var BigNumberVertical = function (_a) {
    var iconColors = _a.iconColors, icon = _a.icon, title = _a.title, value = _a.value, tooltip = _a.tooltip, valueDetails = _a.valueDetails, menuOptions = _a.menuOptions, buttonLabel = _a.buttonLabel, buttonVariant = _a.buttonVariant, tag = _a.tag, button = _a.button, onSelect = _a.onSelect;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(IconsContainer, null,
            React__default.createElement(BigNumberIcon, { icon: icon, iconColors: iconColors }),
            React__default.createElement(CornerButtonsWrapper, null,
                tooltip && (React__default.createElement(BigNumberTooltip, { tooltip: tooltip, menuOptions: menuOptions })),
                menuOptions && React__default.createElement(BigNumberMenu, { menuOptions: menuOptions }))),
        React__default.createElement(Content$6, null,
            React__default.createElement(ValueWrapper, null,
                React__default.createElement(StyledValue, { variant: "headline5" }, value),
                valueDetails && React__default.createElement(Dot, { variant: "gray" }),
                React__default.createElement(BigNumberValueDetails, { valueDetails: valueDetails })),
            React__default.createElement(StyledTitle, { variant: "body3" }, title),
            button ? (button) : (React__default.createElement(BigNumberButton, { onClick: onSelect, buttonVariant: buttonVariant, buttonLabel: buttonLabel, tag: tag })))));
};

var BigNumber = function (props) {
    var orientation = props.orientation, onSelect = props.onSelect;
    var _a = useState(false), selected = _a[0], setSelected = _a[1];
    var handleSelect = function () {
        setSelected(function (prev) { return !prev; });
        onSelect && onSelect();
    };
    return (React__default.createElement(Card, __assign({}, props, { selected: selected, orientation: orientation }),
        orientation === 'horizontal' && (React__default.createElement(BigNumberHorizontal, __assign({}, props, { onSelect: handleSelect }))),
        orientation == 'vertical' && (React__default.createElement(BigNumberVertical, __assign({}, props, { onSelect: handleSelect })))));
};

var css_248z$z = ".button-group-custom-theme.MuiButtonGroup-root{border:1px solid var(--color-neutral-light2);border-radius:8px}.button-group-custom-theme.MuiButtonGroup-root button.MuiButtonBase-root{border:none;border-right:1px solid var(--color-neutral-light2);padding:8px 16px}.button-group-custom-theme.MuiButtonGroup-root button.MuiButtonBase-root:hover{border-color:var(--color-neutral-light2)}.button-group-custom-theme.MuiButtonGroup-root button.MuiButtonBase-root:last-child{border:none}";
styleInject(css_248z$z);

var ButtonGroup = function (_a) {
    var children = _a.children, style = _a.style;
    return (React__default.createElement(ButtonGroup$1, { className: "button-group-custom-theme", style: style }, children));
};

var useMediaQuery = function (mediaquery) {
    var query = React__default.useMemo(function () { return window.matchMedia(mediaquery); }, [mediaquery]);
    var _a = React__default.useState(query.matches), matches = _a[0], setMatches = _a[1];
    React__default.useEffect(function () {
        var listener = function (e) { return setMatches(e.matches); };
        query.addEventListener('change', listener);
        return function () { return query.removeEventListener('change', listener); };
    }, [query]);
    return matches;
};

var useDisclosure = function (defaultIsOpen) {
    if (defaultIsOpen === void 0) { defaultIsOpen = false; }
    var _a = useState(defaultIsOpen || false), isOpen = _a[0], setIsOpen = _a[1];
    var onOpen = useCallback(function () { return setIsOpen(true); }, []);
    var onClose = useCallback(function () { return setIsOpen(false); }, []);
    var onToggle = useCallback(function (toSet) {
        if (typeof toSet === undefined)
            setIsOpen(function (state) { return !state; });
        else
            setIsOpen(toSet);
    }, []);
    return { isOpen: isOpen, onOpen: onOpen, onClose: onClose, onToggle: onToggle };
};

var useOutsideClick = function (ref, handler) {
    useEffect(function () {
        var listener = function (event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};

var useToasts = function () {
    var _a = useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    return { showToast: enqueueSnackbar, closeToast: closeSnackbar };
};

var checkErrors = function (columns) {
    var hasGroups = !!columns.find(function (column) { return column.parent; });
    var stickyColumnsWithoutGroup = columns
        .filter(function (column) { return column.sticky && !column.parent; })
        .map(function (_a) {
        var Header = _a.Header;
        return "'".concat(Header, "'");
    });
    if (hasGroups && stickyColumnsWithoutGroup.length) {
        throw new Error("WARNING react-table-sticky:\n      \nYour ReactTable has group and sticky columns outside groups, and that will break UI.\n      \nYou must place ".concat(stickyColumnsWithoutGroup.join(' and '), " columns into a group (even a group with an empty Header label)\n"));
    }
    var bugWithUnderColumnsSticky = columns.find(function (parentCol) {
        return !parentCol.sticky &&
            parentCol.columns &&
            parentCol.columns.find(function (col) { return col.sticky; });
    });
    if (!bugWithUnderColumnsSticky)
        return;
    // @ts-ignore
    var childBugs = bugWithUnderColumnsSticky.columns.find(function (_a) {
        var sticky = _a.sticky;
        return sticky;
    });
    if (!childBugs)
        return;
    throw new Error("WARNING react-table-sticky:\n    \nYour ReactTable contain columns group with at least one child columns sticky.\n    \nWhen ReactTable has columns groups, only columns groups can be sticky\n    \nYou must set sticky: 'left' | 'right' for the '".concat(bugWithUnderColumnsSticky.Header, "'\n    column, or remove the sticky property of '").concat(childBugs.Header, "' column."));
};
function getStickyValue(column) {
    if (column.sticky === 'left' || column.sticky === 'right') {
        return column.sticky;
    }
    if (column.parent) {
        return getStickyValue(column.parent);
    }
    return null;
}
function columnIsLastLeftSticky(columnId, columns) {
    var index = columns.findIndex(function (_a) {
        var id = _a.id;
        return id === columnId;
    });
    var column = columns[index];
    var nextColumn = columns[index + 1];
    var columnIsLeftSticky = getStickyValue(column) === 'left';
    var nextColumnIsLeftSticky = nextColumn && getStickyValue(nextColumn) === 'left';
    return columnIsLeftSticky && !nextColumnIsLeftSticky;
}
function columnIsFirstRightSticky(columnId, columns) {
    var index = columns.findIndex(function (_a) {
        var id = _a.id;
        return id === columnId;
    });
    var column = columns[index];
    var prevColumn = columns[index - 1];
    var columnIsRightSticky = getStickyValue(column) === 'right';
    var prevColumnIsRightSticky = prevColumn && getStickyValue(prevColumn) === 'right';
    return columnIsRightSticky && !prevColumnIsRightSticky;
}
function getMarginRight(columnId, columns) {
    var currentIndex = columns.findIndex(function (_a) {
        var id = _a.id;
        return id === columnId;
    });
    var rightMargin = 0;
    for (var i = currentIndex + 1; i < columns.length; i += 1) {
        if (columns[i].isVisible !== false) {
            rightMargin += columns[i].width;
        }
    }
    return rightMargin;
}
var cellStylesSticky = {
    // hard coded inline style will be remove in the next major release
    position: 'sticky',
    zIndex: 3,
};
function findHeadersSameLevel(header, headers) {
    return headers.filter(function (flatHeaderItem) {
        return flatHeaderItem.depth === header.depth;
    });
}
function getStickyProps(header, instance) {
    var _a;
    var style = {};
    var dataAttrs = {};
    checkErrors(instance.columns);
    var sticky = getStickyValue(header);
    if (sticky) {
        style = __assign({}, cellStylesSticky);
        // @ts-ignore
        dataAttrs['data-sticky-td'] = true;
        var headers = findHeadersSameLevel(header, instance.flatHeaders);
        var margin = sticky === 'left' ? header.totalLeft : getMarginRight(header.id, headers);
        style = __assign(__assign({}, style), (_a = {}, _a[sticky] = "".concat(margin, "px"), _a));
        var isLastLeftSticky = columnIsLastLeftSticky(header.id, headers);
        if (isLastLeftSticky) {
            // @ts-ignore
            dataAttrs['data-sticky-last-left-td'] = true;
        }
        var isFirstRightSticky = columnIsFirstRightSticky(header.id, headers);
        if (isFirstRightSticky) {
            // @ts-ignore
            dataAttrs['data-sticky-first-right-td'] = true;
        }
    }
    return __assign({ style: style }, dataAttrs);
}
var useSticky = function (hooks) {
    hooks.getHeaderProps.push(function (props, _a) {
        var instance = _a.instance, column = _a.column;
        var nextProps = getStickyProps(column, instance);
        return [props, nextProps];
    });
    hooks.getCellProps.push(function (props, _a) {
        var instance = _a.instance, cell = _a.cell;
        var nextProps = getStickyProps(cell.column, instance);
        return [props, nextProps];
    });
};
useSticky.pluginName = 'useSticky';

var useAnimationFrame = function (callback) {
    var previousTimeRef = useRef(0);
    var animate = function (time) {
        if (previousTimeRef.current != undefined) {
            var deltaTime = time - previousTimeRef.current;
            callback(deltaTime);
        }
        previousTimeRef.current = time;
    };
    useEffect(function () {
        var animationFrame = requestAnimationFrame(animate);
        return function () { return cancelAnimationFrame(animationFrame); };
    }, []);
};

var Container$u = styled.div(templateObject_1$10 || (templateObject_1$10 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"])));
var DotsWrapper = styled.div(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n"])));
var ArrowsWrapper = styled.div(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n"])));
var templateObject_1$10, templateObject_2$D, templateObject_3$o;

var PaginationDots = function (_a) {
    var count = _a.count, initialPage = _a.initialPage, showArrows = _a.showArrows, onChange = _a.onChange;
    var _b = useState(initialPage !== null && initialPage !== void 0 ? initialPage : 0), selectedDot = _b[0], setSelectedDot = _b[1];
    var dotsRef = useRef(null);
    var handleChange = function (currentPage) {
        setSelectedDot(currentPage);
        if (onChange)
            onChange(currentPage);
    };
    useEffect(function () {
        setSelectedDot(initialPage !== null && initialPage !== void 0 ? initialPage : 0);
    }, [initialPage]);
    return (React__default.createElement(Container$u, null,
        React__default.createElement(DotsWrapper, { ref: dotsRef }, Array.from({ length: count }, function (_, index) { return (React__default.createElement(Dot, { key: index, variant: selectedDot === index ? 'primary' : 'gray', onClick: function () {
                handleChange(index);
            } })); })),
        showArrows && (React__default.createElement(ArrowsWrapper, null,
            React__default.createElement(IconButton, { icon: "IconChevronLeft", variant: 'line', size: 'small', disabled: selectedDot === 0, onClick: function () { return handleChange(selectedDot - 1); } }),
            React__default.createElement(IconButton, { icon: "IconChevronRight", variant: 'line', size: 'small', disabled: selectedDot === count - 1, onClick: function () { return handleChange(selectedDot + 1); } })))));
};

var Container$t = styled.div(templateObject_1$$ || (templateObject_1$$ = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 18px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 0 18px;\n"])));
var templateObject_1$$;

var Header$5 = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, title = _a.title, showVisibilityToggle = _a.showVisibilityToggle;
    return (React__default.createElement(Container$t, null,
        React__default.createElement(Typography, { variant: "headline8" }, title),
        showVisibilityToggle && (React__default.createElement(LinkButton, { variant: "default", onClick: function () { return setIsOpen(function (prevState) { return !prevState; }); } }, isOpen ? (React__default.createElement(React__default.Fragment, null,
            "Ocultar",
            React__default.createElement(Icons, { name: "IconChevronsUp", fill: "transparent" }))) : (React__default.createElement(React__default.Fragment, null,
            "Exibir",
            React__default.createElement(Icons, { name: "IconChevronsDown", fill: "transparent" })))))));
};

var SlideWrapper = styled.li(templateObject_1$_ || (templateObject_1$_ = __makeTemplateObject(["\n  opacity: ", ";\n  visibility: ", ";\n"], ["\n  opacity: ", ";\n  visibility: ", ";\n"])), function (_a) {
    var opacity = _a.opacity;
    return opacity;
}, function (_a) {
    var visibility = _a.visibility;
    return visibility;
});
var templateObject_1$_;

var Slide = function (_a) {
    var slide = _a.slide, visibility = _a.visibility, index = _a.index, selectedSlide = _a.selectedSlide, onSelect = _a.onSelect;
    var isSelected = selectedSlide === index;
    var opacity = selectedSlide ? (isSelected ? 1 : 0.5) : 1;
    return (React__default.createElement(SlideWrapper, { opacity: opacity, visibility: visibility, index: index, onClick: function () { return (isSelected ? onSelect(undefined) : onSelect(index)); } }, slide));
};

var expandAnimation = function (height) { return keyframes(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n  from {\n    height: 0;\n  }\n  to {\n    height: ", "px;\n  }\n"], ["\n  from {\n    height: 0;\n  }\n  to {\n    height: ", "px;\n  }\n"])), height); };
var collapseAnimation = function (height) { return keyframes(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n  from {\n    height: ", "px;\n  }\n  to {\n    height: 0;\n  }\n"], ["\n  from {\n    height: ", "px;\n  }\n  to {\n    height: 0;\n  }\n"])), height); };
var AnimationContainer = styled.div(templateObject_5$g || (templateObject_5$g = __makeTemplateObject(["\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 24px;\n  overflow: hidden;\n  transition: height 0.3s ease-in-out;\n  ", "\n"], ["\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 24px;\n  overflow: hidden;\n  transition: height 0.3s ease-in-out;\n  ", "\n"])), function (_a) {
    var isOpen = _a.isOpen, animationHeight = _a.animationHeight;
    if (animationHeight === undefined)
        return;
    return isOpen
        ? css(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n          animation: ", " 0.3s forwards;\n        "], ["\n          animation: ", " 0.3s forwards;\n        "])), expandAnimation(animationHeight)) : css(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n          animation: ", " 0.3s forwards;\n        "], ["\n          animation: ", " 0.3s forwards;\n        "])), collapseAnimation(animationHeight));
});
var CarouselContainer = styled.section(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n"])));
var Track = styled.ul(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  width: ", ";\n  margin: ", ";\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  transition: transform 0.3s ease;\n  transform: ", ";\n  align-items: ", ";\n  gap: ", "px;\n"], ["\n  width: ", ";\n  margin: ", ";\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  transition: transform 0.3s ease;\n  transform: ", ";\n  align-items: ", ";\n  gap: ", "px;\n"])), function (_a) {
    var sideButtons = _a.sideButtons;
    return (sideButtons ? 'calc(100% - 40px)' : '100%');
}, function (_a) {
    var sideButtons = _a.sideButtons;
    return (sideButtons ? '0 auto' : '0');
}, function (_a) {
    var offwidth = _a.offwidth;
    return "translateX(-".concat(offwidth, "px)");
}, function (_a) {
    var alignSlides = _a.alignSlides;
    return alignSlides;
}, function (_a) {
    var gap = _a.gap;
    return gap;
});
var StyledLeftIconButton = styled(IconButton)(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translate(0, -50%);\n"], ["\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translate(0, -50%);\n"])));
var StyledRightIconButton = styled(IconButton)(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translate(0, -50%);\n"], ["\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translate(0, -50%);\n"])));
var templateObject_1$Z, templateObject_2$C, templateObject_3$n, templateObject_4$l, templateObject_5$g, templateObject_6$b, templateObject_7$7, templateObject_8$3, templateObject_9$2;

var Carousel = function (_a) {
    var slides = _a.slides, gap = _a.gap, alignSlides = _a.alignSlides, arrows = _a.arrows, header = _a.header, onSelect = _a.onSelect;
    var animationContainerRef = useRef(null);
    var trackRef = useRef(null);
    var _b = useState([]), slidesRefs = _b[0], setSlidesRefs = _b[1];
    var _c = useState([]), slidesVisibilities = _c[0], setSlidesVisibilities = _c[1];
    var _d = useState(), initialTrackPosition = _d[0], setInitialTrackPosition = _d[1];
    var _e = useState(), offwidthsValues = _e[0], setOffwidthsValues = _e[1];
    var _f = useState(0), currentSlide = _f[0], setCurrentSlide = _f[1];
    var _g = useState(), dotsCount = _g[0], setDotsCount = _g[1];
    var _h = useState(), animationHeight = _h[0], setAnimationHeight = _h[1];
    var _j = useState(true), isOpen = _j[0], setIsOpen = _j[1];
    var _k = useState(), selectedSlide = _k[0], setSelectedSlide = _k[1];
    var handleSlideVisibility = function (direction) {
        var _a;
        if (!((_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.children) ||
            !initialTrackPosition ||
            !offwidthsValues) {
            return;
        }
        var nextOffwidthValue = direction === 'right'
            ? -offwidthsValues[currentSlide]
            : offwidthsValues[currentSlide];
        var updatedVisilities = slidesRefs.map(function (slide) {
            var slideRect = slide === null || slide === void 0 ? void 0 : slide.getBoundingClientRect();
            var offScreenLeft = (slideRect === null || slideRect === void 0 ? void 0 : slideRect.right) + nextOffwidthValue + gap < initialTrackPosition.left;
            var offScreenRight = (slideRect === null || slideRect === void 0 ? void 0 : slideRect.left) + nextOffwidthValue - gap > initialTrackPosition.right;
            if (offScreenRight || offScreenLeft) {
                return 'hidden';
            }
            else {
                return 'visible';
            }
        });
        setSlidesVisibilities(updatedVisilities);
    };
    var handleSlideChange = function (index) {
        setCurrentSlide(function (prev) {
            prev > index
                ? handleSlideVisibility('left')
                : handleSlideVisibility('right');
            return index;
        });
    };
    var calculateOffwidthsValues = useCallback(function (slidesWidths) {
        var _a, _b;
        var visibleAreaWidth = (_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        var visibleSlidesWidths = [];
        var visibleContentWidth = slidesWidths === null || slidesWidths === void 0 ? void 0 : slidesWidths.reduce(function (acc, slideWidth) {
            var visibleWidth = acc + slideWidth + gap;
            if (visibleAreaWidth && visibleWidth < visibleAreaWidth) {
                visibleSlidesWidths.push(slideWidth);
                return visibleWidth;
            }
            return acc;
        }, 0);
        var totalContentWidth = slidesWidths === null || slidesWidths === void 0 ? void 0 : slidesWidths.reduce(function (acc, slideWidth) { return acc + slideWidth + gap; }, 0);
        var visibleSlidesWidthsLength = visibleSlidesWidths.length;
        var overflownSlidesCount = slides.length - visibleSlidesWidthsLength + 1;
        var lastVisibleSlideWidth = slidesWidths === null || slidesWidths === void 0 ? void 0 : slidesWidths[visibleSlidesWidthsLength];
        var firstOffWidth = (visibleContentWidth !== null && visibleContentWidth !== void 0 ? visibleContentWidth : 0) -
            (visibleAreaWidth !== null && visibleAreaWidth !== void 0 ? visibleAreaWidth : 0) +
            (lastVisibleSlideWidth !== null && lastVisibleSlideWidth !== void 0 ? lastVisibleSlideWidth : 0);
        var offwidths = __spreadArray([
            firstOffWidth
        ], ((_b = slidesWidths === null || slidesWidths === void 0 ? void 0 : slidesWidths.splice(visibleSlidesWidthsLength + 1)) !== null && _b !== void 0 ? _b : []), true);
        if (visibleAreaWidth && totalContentWidth > visibleAreaWidth) {
            setOffwidthsValues(offwidths);
            setDotsCount(overflownSlidesCount);
        }
        else {
            setOffwidthsValues(undefined);
            setDotsCount(undefined);
        }
    }, []);
    var updateOffwidths = useCallback(function () {
        var _a, _b, _c;
        if (!trackRef.current)
            return;
        var trackRect = (_a = trackRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var slidesRefs = (_b = trackRef.current) === null || _b === void 0 ? void 0 : _b.children;
        var slidesWidths = slides.map(function (_, i) { var _a, _b; return (_b = (_a = slidesRefs === null || slidesRefs === void 0 ? void 0 : slidesRefs[i]) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0; });
        calculateOffwidthsValues(slidesWidths);
        setSlidesRefs(Array.from((_c = trackRef.current) === null || _c === void 0 ? void 0 : _c.children));
        setInitialTrackPosition(new DOMRect(trackRect.x, trackRect.y, trackRect.width, trackRect.height));
    }, []);
    var calculateOffwidth = useCallback(function () {
        if (offwidthsValues) {
            var offwidth = offwidthsValues === null || offwidthsValues === void 0 ? void 0 : offwidthsValues.reduce(function (acc, slideWidth, index) {
                if (index < currentSlide) {
                    return acc + slideWidth + gap;
                }
                return acc;
            }, 0);
            if (currentSlide > 0)
                return offwidth - gap;
            else
                return offwidth;
        }
        return 0;
    }, [currentSlide, offwidthsValues]);
    useEffect(function () {
        updateOffwidths();
        handleSlideVisibility('right');
        var handleResize = function () {
            setCurrentSlide(0);
            updateOffwidths();
            handleSlideVisibility('right');
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [trackRef.current]);
    useAnimationFrame(function () {
        var _a;
        setAnimationHeight((_a = animationContainerRef === null || animationContainerRef === void 0 ? void 0 : animationContainerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight);
    });
    return (React__default.createElement(React__default.Fragment, null,
        header && (React__default.createElement(Header$5, { isOpen: isOpen, setIsOpen: setIsOpen, title: header.title, showVisibilityToggle: header.showVisibilityToggle })),
        React__default.createElement(AnimationContainer, { ref: animationContainerRef, isOpen: isOpen, animationHeight: animationHeight },
            React__default.createElement(CarouselContainer, { "aria-labelledby": "carouselcontainer" },
                React__default.createElement(Track, { ref: trackRef, gap: gap, alignSlides: alignSlides !== null && alignSlides !== void 0 ? alignSlides : 'center', sideButtons: arrows === 'sides', offwidth: calculateOffwidth() }, slides.map(function (slide, index) {
                    return (React__default.createElement(Slide, { key: index, slide: slide, index: index, visibility: slidesVisibilities[index], selectedSlide: selectedSlide, onSelect: function (selectedSlide) {
                            setSelectedSlide(selectedSlide);
                            onSelect && onSelect(selectedSlide);
                        } }));
                })),
                arrows === 'sides' && isOpen && dotsCount && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(StyledLeftIconButton, { icon: "IconChevronLeft", variant: 'filled', size: 'small', disabled: !dotsCount || currentSlide === 0, onClick: function () { return handleSlideChange(currentSlide - 1); } }),
                    React__default.createElement(StyledRightIconButton, { icon: "IconChevronRight", variant: 'filled', size: 'small', disabled: !dotsCount || currentSlide === dotsCount - 1, onClick: function () { return handleSlideChange(currentSlide + 1); } })))),
            dotsCount && (React__default.createElement(PaginationDots, { count: dotsCount, initialPage: currentSlide, onChange: function (value) { return handleSlideChange(value); }, showArrows: arrows === 'bottom' })))));
};

var Checkbox = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, defaultChecked = _a.defaultChecked, inputProps = _a.inputProps, indeterminate = _a.indeterminate, disabled = _a.disabled, sx = _a.sx, onBlur = _a.onBlur, onFocus = _a.onFocus, className = _a.className, required = _a.required, disableRipple = _a.disableRipple, disableTouchRipple = _a.disableTouchRipple, disableFocusRipple = _a.disableFocusRipple, inputRef = _a.inputRef, _b = _a.nestedSelection, nestedSelection = _b === void 0 ? false : _b;
    var theme = useTheme$1();
    return (React__default.createElement(Checkbox$1, { checked: checked, onChange: onChange, defaultChecked: defaultChecked, inputProps: inputProps, indeterminate: indeterminate, disabled: disabled, required: required, disableRipple: disableRipple, disableTouchRipple: disableTouchRipple, disableFocusRipple: disableFocusRipple, inputRef: inputRef, sx: sx, onBlur: onBlur, onFocus: onFocus, checkedIcon: React__default.createElement(Icons, { name: nestedSelection
                ? 'CheckboxNestedSelectionCheckedIcon'
                : 'CheckboxCheckedIcon', size: 24, color: theme.colors.primary }), icon: React__default.createElement(Icons, { name: "CheckboxIcon", size: 24 }), className: "".concat(className, " checkbox-custom-theme") }));
};

var css_248z$y = ".theme-circular-progress .circle-background{color:var(--color-neutral-light4);position:absolute}.theme-circular-progress .MuiTypography-caption{color:var(--color-primary);font-size:20px}.theme-circular-progress .circulas-box-progress{align-items:center;bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0}";
styleInject(css_248z$y);

var CircularProgress = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'determinate' : _b, _c = _a.value, value = _c === void 0 ? 0 : _c, _d = _a.size, size = _d === void 0 ? 80 : _d, _e = _a.thickness, thickness = _e === void 0 ? 2.6 : _e, className = _a.className, children = _a.children;
    return (React__default.createElement("div", { className: "theme-circular-progress ".concat(className) },
        React__default.createElement(Box, { sx: { position: 'relative', display: 'inline-flex' } },
            variant === 'determinate' && (React__default.createElement(CircularProgress$1, { className: "circle-background", variant: variant, value: 100, size: size, thickness: thickness })),
            React__default.createElement(CircularProgress$1, { variant: variant, value: value, size: size, thickness: thickness }),
            React__default.createElement(Box, { className: "circulas-box-progress" }, variant === 'determinate' &&
                (children || (React__default.createElement(Typography$1, { variant: "caption", component: "div", color: "text.secondary" }, "".concat(value, "%"))))))));
};

var css_248z$x = ".clipboard{position:relative}.clipboard .clipboard-success-message-container{align-items:center;bottom:-65px;display:flex;justify-content:center;position:absolute;width:100%}.clipboard .clipboard-success-message{align-items:center;background-color:var(--color-feedback-success-light1);border:1px solid var(--color-feedback-success-light2);border-radius:8px;color:var(--color-feedback-success-dark2);display:inline-flex;font-weight:600;justify-content:space-between;padding:20px 24px}";
styleInject(css_248z$x);

var Clipboard = function (_a) {
    var children = _a.children, value = _a.value, successMessage = _a.successMessage;
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    useEffect(function () {
        if (visible) {
            setTimeout(function () {
                setVisible(!visible);
            }, 2000);
        }
    }, [visible]);
    var onClick = function () {
        if (!visible) {
            navigator.clipboard.writeText(value);
            setVisible(!visible);
        }
    };
    return (React__default.createElement("button", { className: "clipboard", onClick: onClick, type: "button" },
        children,
        React__default.createElement("div", { className: "clipboard-success-message-container" }, visible ? (React__default.createElement(Typography, { variant: "body3", tag: "span", className: "clipboard-success-message" }, successMessage)) : (React__default.createElement(React__default.Fragment, null)))));
};

var Container$s = styled.div(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n  position: relative;\n  height: 400px;\n  width: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-neutral-100);\n\n  .reactEasyCrop_Container {\n    border: 2px solid var(--color-primary);\n    border-radius: 8px;\n  }\n"], ["\n  position: relative;\n  height: 400px;\n  width: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--color-neutral-100);\n\n  .reactEasyCrop_Container {\n    border: 2px solid var(--color-primary);\n    border-radius: 8px;\n  }\n"])));
var templateObject_1$Y;

var CropperContainer = function (_a) {
    var children = _a.children;
    return (React__default.createElement(Container$s, null, children));
};

var Container$r = styled.div(templateObject_1$X || (templateObject_1$X = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"])));
var templateObject_1$X;

var MainContainer$2 = function (_a) {
    var children = _a.children;
    return (React__default.createElement(Container$r, null, children));
};

var StyledSlider = styled(Slider$1)(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\nwidth: 100%;\n  && {\n    &.MuiSlider-root .jpkivY {\n      &.MuiSlider-thumb-ctAwKi {\n        width: 15px;\n        height: 15px;\n        box-shadow: 0;\n        background-color: #F20D7A;\n        border 4px solid #FF9AC9;\n        transition: 0.1s;\n        \n        &.Mui-focusVisible {\n            box-shadow: none;\n            background-color: #F20D7A;\n            border 2px solid #FF9AC9;\n            transition: 0.1s;\n        }\n        &.jpkivY.Mui-Active {\n            box-shadow: none; \n        \n        }\n      }\n    }\n\n    &.MuiSlider-root .gdCnxw {\n        &.MuiSlider-mark-ciNidV {\n            width: 0;\n        }\n    }\n    &.MuiSlider-root .fzghgJ {\n        &.MuiSlider-rail-fNywgW  {\n            background: #D1C7CE;\n            transition: 0.1s\n        }\n    }\n\n    &.MuiSlider-root .tqkdE {\n        &.MuiSlider-track-hOjKBv  {\n            background: #FE67AF;\n            transition: 0.1s\n        }\n    }\n\n  }\n"], ["\nwidth: 100%;\n  && {\n    &.MuiSlider-root .jpkivY {\n      &.MuiSlider-thumb-ctAwKi {\n        width: 15px;\n        height: 15px;\n        box-shadow: 0;\n        background-color: #F20D7A;\n        border 4px solid #FF9AC9;\n        transition: 0.1s;\n        \n        &.Mui-focusVisible {\n            box-shadow: none;\n            background-color: #F20D7A;\n            border 2px solid #FF9AC9;\n            transition: 0.1s;\n        }\n        &.jpkivY.Mui-Active {\n            box-shadow: none; \n        \n        }\n      }\n    }\n\n    &.MuiSlider-root .gdCnxw {\n        &.MuiSlider-mark-ciNidV {\n            width: 0;\n        }\n    }\n    &.MuiSlider-root .fzghgJ {\n        &.MuiSlider-rail-fNywgW  {\n            background: #D1C7CE;\n            transition: 0.1s\n        }\n    }\n\n    &.MuiSlider-root .tqkdE {\n        &.MuiSlider-track-hOjKBv  {\n            background: #FE67AF;\n            transition: 0.1s\n        }\n    }\n\n  }\n"])));
var templateObject_1$W;

function SliderField(_a) {
    var _b = _a.valueLabelDisplay, valueLabelDisplay = _b === void 0 ? 'auto' : _b, _c = _a.disableSwap, disableSwap = _c === void 0 ? true : _c, fieldMask = _a.fieldMask, _d = _a.type, type = _d === void 0 ? 'default' : _d, disableMarks = _a.disableMarks, value = _a.value, props = __rest(_a, ["valueLabelDisplay", "disableSwap", "fieldMask", "type", "disableMarks", "value"]);
    var _e = props, min = _e.min, max = _e.max;
    var _f = useState([min, max]), rangeValue = _f[0], setRangeValue = _f[1];
    var _g = useState(type === 'range' ? [min, max] : value || 0), selectedValues = _g[0], setSelectedValues = _g[1];
    var marks = [];
    if (type === 'range') {
        value = value === undefined ? rangeValue : value;
        marks.push({
            value: props.min,
            label: fieldMask ? fieldMask(min) : min,
        });
        marks.push({
            value: props.max,
            label: fieldMask ? fieldMask(max) : max,
        });
    }
    function getValues() {
        if (Array.isArray(selectedValues)) {
            var _selectedValues = selectedValues;
            return (_selectedValues === null || _selectedValues === void 0 ? void 0 : _selectedValues.length) ? _selectedValues : rangeValue;
        }
        return selectedValues || rangeValue;
    }
    useEffect(function () {
        if (value !== undefined) {
            setSelectedValues(value);
        }
    }, [value]);
    useEffect(function () {
        if (min !== undefined && max !== undefined)
            setRangeValue([min, max]);
    }, [min, max]);
    return (React__default.createElement(StyledSlider, __assign({ marks: disableMarks ? [] : marks }, props, { valueLabelFormat: fieldMask, valueLabelDisplay: valueLabelDisplay, disableSwap: disableSwap, value: getValues(), onChange: function (event, value, activeThumb) {
            var _a;
            setSelectedValues(value);
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event, value, activeThumb);
        } })));
}

var Container$q = styled.div(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding-top: 10px;\n\n  :first-child {\n    margin-right: 5px;\n  }\n\n  :last-child {\n    margin-left: 5px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding-top: 10px;\n\n  :first-child {\n    margin-right: 5px;\n  }\n\n  :last-child {\n    margin-left: 5px;\n  }\n"])));
var templateObject_1$V;

var Slider = function (props) { return (React__default.createElement(Container$q, null,
    React__default.createElement(Icons, { name: "IconZoomIn", color: "var(--color-secondary-50)", fill: "var(--color-neutral-100)" }),
    React__default.createElement(SliderField, __assign({}, props)),
    React__default.createElement(Icons, { name: "IconZoomOut", color: "var(--color-secondary-50)", fill: "var(--color-neutral-100)" }))); };

var createImage = function (url) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.addEventListener('load', function () { return resolve(image); });
        image.addEventListener('error', function (error) { return reject(error); });
        image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
        image.src = url;
    });
};
function getRadianAngle(degreeValue) {
    return (degreeValue * Math.PI) / 180;
}
/**
 * Returns the new bounding area of a rotated rectangle.
 */
function rotateSize(width, height, rotation) {
    var rotRad = getRadianAngle(rotation);
    return {
        width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height),
    };
}
/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */
function getCroppedImage(imageSrc, pixelCrop) {
    return __awaiter(this, void 0, void 0, function () {
        var image, canvas, ctx, rotRad, _a, bBoxWidth, bBoxHeight, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, createImage(imageSrc)];
                case 1:
                    image = _b.sent();
                    canvas = document.createElement('canvas');
                    ctx = canvas.getContext('2d');
                    if (!ctx) {
                        return [2 /*return*/, null];
                    }
                    rotRad = getRadianAngle(0);
                    _a = rotateSize(image.width, image.height, 0), bBoxWidth = _a.width, bBoxHeight = _a.height;
                    // set canvas size to match the bounding box
                    canvas.width = bBoxWidth;
                    canvas.height = bBoxHeight;
                    // translate canvas context to a central location to allow rotating and flipping around the center
                    ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
                    ctx.rotate(rotRad);
                    ctx.scale(1, 1);
                    ctx.translate(-image.width / 2, -image.height / 2);
                    // draw rotated image
                    ctx.drawImage(image, 0, 0);
                    data = ctx.getImageData(pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height);
                    // set canvas width to final desired crop size - this will clear existing context
                    canvas.width = pixelCrop.width;
                    canvas.height = pixelCrop.height;
                    // paste generated rotate image at the top left corner
                    ctx.putImageData(data, 0, 0);
                    // As Base64 string
                    return [2 /*return*/, canvas.toDataURL('image/jpeg')];
            }
        });
    });
}

var Cropper = function (_a) {
    var image = _a.image, onChange = _a.onChange;
    var _b = useState({ x: 0, y: 0 }), crop = _b[0], setCrop = _b[1];
    var _c = useState(1), zoom = _c[0], setZoom = _c[1];
    var _d = useState(null), croppedAreaPixels = _d[0], setCroppedAreaPixels = _d[1];
    var onCropComplete = useCallback(function (_, croppedAreaPixels) { return setCroppedAreaPixels(croppedAreaPixels); }, []);
    useEffect(function () {
        if (croppedAreaPixels)
            onChange(croppedAreaPixels);
    }, [zoom, croppedAreaPixels]);
    return (React__default.createElement(MainContainer$2, null,
        React__default.createElement(CropperContainer, null,
            React__default.createElement(EasyCropper, { image: image, crop: crop, zoom: zoom, aspect: 1 / 1, onCropChange: setCrop, onCropComplete: onCropComplete, onZoomChange: setZoom, maxZoom: 3, minZoom: 1 })),
        React__default.createElement(Slider, { min: 1, max: 3, step: 0.1, value: zoom, onChange: function (e) { var _a; return setZoom(((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || 0); } })));
};

var _path$3, _path2$3, _path3$3, _path4$3, _path5$3, _path6$3, _path7$3, _path8$2, _path9$2, _g$1, _path10$2, _path11$1, _path12$1, _path13$1, _path14$1, _defs$1;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgEmptyFilteredTable = function SvgEmptyFilteredTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 155,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4E57",
    strokeLinecap: "round",
    strokeOpacity: 0.3,
    strokeWidth: 1.562,
    d: "M6.136 71.058v1.604M2.533 71.927l1.311 1.35M1 75.52h1.854M2.383 79.176l1.311-1.35M6.136 79.615V78.01M8.81 78.545l-1.07-1.07M10.95 75.871H9.345M9.88 72.128l-1.07 1.07M92.238 1v1.07M89.03 4.209h1.069M92.238 7.418v-1.07M94.912 4.209h-1.07M30.202 45.923v1.604M25.389 50.736h1.604M30.202 55.014V53.41M34.48 50.736h-1.604M145.319 104.236a2.316 2.316 0 1 1-2.314 2.315"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M155.912 83.232c1.375-.43 3.481-2.11 3.969-3.918.442 1.598 2.296 3.489 3.969 3.632-1.883.667-3.683 2.647-3.969 4.203-.194-1.586-2.684-3.686-3.969-3.917M14.84 103.523c.687-.215 1.74-1.055 1.984-1.959.221.799 1.148 1.744 1.984 1.816-.941.333-1.841 1.324-1.984 2.102-.097-.793-1.342-1.844-1.984-1.959",
    clipRule: "evenodd"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M27.596 29.129a1.795 1.795 0 1 1-3.59 0 1.795 1.795 0 0 1 3.59 0",
    clipRule: "evenodd"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M147.44 33.949a3 3 0 1 1-6 0 3 3 0 0 1 6 0M188.991 25.82a2.38 2.38 0 1 1-4.759.001 2.38 2.38 0 0 1 4.759-.002",
    clipRule: "evenodd"
  })), _path5$3 || (_path5$3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4E57",
    strokeLinecap: "round",
    strokeOpacity: 0.3,
    strokeWidth: 1.562,
    d: "M61.137 136.981a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM60.245 17.596a1.795 1.795 0 1 1-3.59 0 1.795 1.795 0 0 1 3.59 0ZM106.025 153.596a2.221 2.221 0 0 1-1.58-4.154 2.221 2.221 0 1 1 1.58 4.154Z",
    clipRule: "evenodd"
  })), _path6$3 || (_path6$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    fillRule: "evenodd",
    d: "M105.342 111.167H61.486c-3.086 0-5.613-2.534-5.613-5.631v-62.54c0-3.097 2.527-5.63 5.613-5.63h43.856c3.088 0 5.615 2.533 5.615 5.63v62.54c0 3.097-2.527 5.631-5.615 5.631",
    clipRule: "evenodd"
  })), _path7$3 || (_path7$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M101.598 113.841H57.743c-3.087 0-5.614-2.534-5.614-5.631V45.67c0-3.097 2.527-5.63 5.614-5.63h43.855c3.088 0 5.615 2.533 5.615 5.63v62.54c0 3.097-2.527 5.631-5.615 5.631",
    clipRule: "evenodd"
  })), _path8$2 || (_path8$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M97.957 115.952H54.011c-3.093 0-5.625-2.523-5.625-5.608v-62.28c0-3.085 2.532-5.608 5.625-5.608h43.946c3.094 0 5.626 2.523 5.626 5.607v62.281c0 3.085-2.532 5.608-5.626 5.608",
    clipRule: "evenodd"
  })), _path9$2 || (_path9$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M97.957 115.952H54.011c-3.093 0-5.625-2.523-5.625-5.608v-62.28c0-3.085 2.532-5.608 5.625-5.608h43.946c3.094 0 5.626 2.523 5.626 5.607v62.281c0 3.085-2.532 5.608-5.626 5.608",
    clipRule: "evenodd"
  })), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "#4A4E57",
    fillOpacity: 0.5,
    clipPath: "url(#empty_filtered_table_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.788 63.133a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M67.788 65.383c-3.006 0-9 1.512-9 4.5v1.125a1.125 1.125 0 0 0 1.125 1.125h15.75a1.125 1.125 0 0 0 1.125-1.125v-1.125c0-2.988-5.994-4.5-9-4.5"
  }))), _path10$2 || (_path10$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    fillRule: "evenodd",
    d: "M91.623 80.684h-32.46c-.927 0-1.686-.722-1.686-1.604 0-.882.759-1.605 1.686-1.605h32.46c.927 0 1.685.724 1.685 1.605 0 .882-.758 1.604-1.685 1.604M91.623 90.31h-32.46c-.927 0-1.686-.722-1.686-1.603 0-.883.759-1.605 1.686-1.605h32.46c.927 0 1.685.722 1.685 1.605 0 .882-.758 1.603-1.685 1.603M76.106 99.937H59.17c-.93 0-1.693-.722-1.693-1.604 0-.883.762-1.605 1.693-1.605h16.936c.931 0 1.693.722 1.693 1.605 0 .882-.762 1.604-1.693 1.604",
    clipRule: "evenodd"
  })), _path11$1 || (_path11$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M110.291 87.496c-6.491 6.49-16.54 7.221-23.834 2.21a19.681 19.681 0 0 1-2.647-2.21 17.985 17.985 0 0 1-3.168-4.243 17.888 17.888 0 0 1-1.963-5.415c-1.146-5.897.567-12.245 5.13-16.807 4.575-4.574 10.924-6.277 16.823-5.142 1.879.366 3.7 1.017 5.415 1.962a18.81 18.81 0 0 1 2.909 1.975c.46.377.898.78 1.323 1.205a18.64 18.64 0 0 1 2.211 2.647c5.013 7.292 4.279 17.34-2.199 23.818",
    clipRule: "evenodd"
  })), _path12$1 || (_path12$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    fillRule: "evenodd",
    d: "M108.475 86.218c-6.752 6.753-17.696 6.752-24.45 0-6.745-6.746-6.745-17.69.01-24.443 6.744-6.745 17.688-6.745 24.433 0 6.752 6.753 6.752 17.697.007 24.443m3.466-27.912c-8.668-8.668-22.713-8.668-31.381 0-8.666 8.666-8.674 22.72-.008 31.388 7.889 7.886 20.253 8.597 28.95 2.122a22.538 22.538 0 0 0 2.447-2.122 22.393 22.393 0 0 0 2.121-2.448c6.475-8.697 5.758-21.053-2.129-28.94M146.051 122.367l-.364.364c-2.407 2.408-6.35 2.408-8.758 0L114.7 100.502l9.122-9.122 22.229 22.229c2.409 2.408 2.409 6.349 0 8.758",
    clipRule: "evenodd"
  })), _path13$1 || (_path13$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    fillRule: "evenodd",
    d: "m114.549 86.567 6.569 6.569-4.664 4.662-6.567-6.57a23.162 23.162 0 0 0 4.662-4.661",
    clipRule: "evenodd"
  })), _path14$1 || (_path14$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CACD",
    fillRule: "evenodd",
    d: "m145.718 113.335-9.064 9.063-1.632-1.633 9.063-9.063zM124.327 91.694l-9.313 9.312-1.383-1.383 9.312-9.313z",
    clipRule: "evenodd"
  })), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_filtered_table_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.788 51.133h24v24h-24z"
  })))));
};

var _path$2, _path2$2, _path3$2, _path4$2, _path5$2, _path6$2, _path7$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgEmptyTable = function SvgEmptyTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191,
    height: 153,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M47.882 101.845h69.163c.391 0 .773-.043 1.14-.123.367.08.749.123 1.14.123h39.522a5.32 5.32 0 0 0 0-10.64h-4.56a5.32 5.32 0 1 1 0-10.641h14.44a5.32 5.32 0 1 0 0-10.64h-16.72a5.32 5.32 0 0 0 0-10.641h-48.643a5.32 5.32 0 1 0 0-10.64H60.042a5.32 5.32 0 0 0 0 10.64h-30.4a5.32 5.32 0 1 0 0 10.64h19a5.32 5.32 0 1 1 0 10.64H18.24a5.32 5.32 0 1 0 0 10.641h29.64a5.32 5.32 0 0 0 0 10.641m123.885 0a5.32 5.32 0 1 0 0-10.641 5.32 5.32 0 0 0 0 10.641",
    clipRule: "evenodd"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M85.974 85.357a9.12 9.12 0 0 0 9.03 10.407 9.12 9.12 0 0 0 9.031-10.407h22.131v20.288a2.28 2.28 0 0 1-2.28 2.28H66.123a2.28 2.28 0 0 1-2.28-2.28V85.357z",
    clipRule: "evenodd"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M104.885 85.124c0 5.457-4.424 9.88-9.88 9.88-5.458 0-9.881-4.423-9.881-9.88 0-.177.005-.353.014-.527H63.843l7.266-21.485a2.28 2.28 0 0 1 2.16-1.55h43.47a2.28 2.28 0 0 1 2.16 1.55l7.267 21.485h-21.295c.009.174.014.35.014.527",
    clipRule: "evenodd"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBE6E9",
    fillRule: "evenodd",
    d: "M103.439 85.85c0 4.216-3.776 8.394-8.435 8.394-4.658 0-8.434-4.178-8.434-8.395 0-.136.004-1.032.012-1.167H70.683L76.886 69.6c.267-.715 1.01-1.197 1.844-1.197h32.549c.834 0 1.576.482 1.843 1.197l6.203 15.082h-15.898c.008.135.012 1.03.012 1.167",
    clipRule: "evenodd"
  })), _path5$2 || (_path5$2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#83727D",
    strokeWidth: 3.11,
    d: "M64.793 84.753v20.132c0 .734.595 1.33 1.33 1.33h57.763a1.33 1.33 0 0 0 1.33-1.33V84.753l-7.217-21.336a1.329 1.329 0 0 0-1.26-.904h-43.47a1.33 1.33 0 0 0-1.26.904z",
    clipRule: "evenodd"
  })), _path6$2 || (_path6$2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#83727D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.11,
    d: "M68.84 84.364h1.844m3.8 0h9.686c1.426 0 1.426 1.002 1.426 1.52 0 5.037 4.178 9.12 9.33 9.12 5.154 0 9.331-4.083 9.331-9.12 0-.518 0-1.52 1.426-1.52h18.963"
  })), _path7$2 || (_path7$2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9F939B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.11,
    d: "m114.081 44.312-8.436 9.465M94.32 41.042v12.735zm-19.837 3.27 8.436 9.465z"
  })));
};

var css_248z$w = ".data-grid-table-border{border:1px solid var(--color-neutral-light2);border-radius:12px;max-width:100%;overflow-y:auto;position:relative;width:100%}.data-grid-loader-text{color:var(--color-primary)}.data-grid-empty-table-container{align-items:center;background-color:var(--color-neutral-light1);display:flex;flex-direction:column;height:100%;justify-content:center;min-height:400px;min-width:600px;width:100%}.data-grid-empty-table-container.loader{background-color:unset;left:0;margin-left:auto;margin-right:auto;position:absolute;right:0;z-index:5}.data-grid-empty-table-container.shadow{background-color:var(--color-neutral-light1);opacity:.8}.data-grid-empty-table-children{padding:24px 0}.data-grid-table-container{width:100%}.data-grid-table-container.sticky .data-grid-table-header-container{position:sticky;right:0;width:-moz-fit-content;width:fit-content;z-index:1}.data-grid-table-container.sticky [data-sticky-td]{filter:drop-shadow(0 4px 24px rgba(0,0,0,.06));position:sticky;z-index:1}.data-grid-table-container .data-grid-table-header-container{background-color:var(--color-neutral-light1)}.data-grid-table-container .data-grid-table-header-container .data-grid-table-header-container{color:var(--color-neutral-dark4);font-family:Nunito;font-size:16px;font-style:normal;font-weight:700;line-height:22px}.data-grid-table-container .data-grid-table-header-container .data-grid-table-header-container .data-grid-table-header-subcontainer{align-items:center;display:flex;justify-content:space-between;padding:32px 24px}.data-grid-table-container .data-grid-table-header-container .data-grid-table-header-container .data-grid-table-header-subcontainer .data-grid-table-header-subcontainer-svg{display:flex;margin-left:6px}.data-grid-table-container .data-grid-table-header-container .data-grid-table-header-container .data-grid-table-header-subcontainer .data-grid-table-header-subcontainer-svg .data-grid-table-header-subcontainer-icon-sort{cursor:pointer;transition:transform .2s}.data-grid-table-container .data-grid-table-header-container .data-grid-table-header-container .data-grid-table-header-subcontainer .data-grid-table-header-subcontainer-svg .data-grid-table-header-subcontainer-icon-sort:hover{transform:scale(1.2)}.data-grid-table-container .data-grid-table-body-container{color:var(--color-neutral-dark4);font-family:Nunito;font-size:16px;font-style:normal;font-weight:600;line-height:22px}.data-grid-table-container .data-grid-table-body-container .data-grid-table-body-subcontainer .data-grid-table-body-td{background-color:#fff;border-bottom:1px solid var(--color-neutral-light2);padding:24px;vertical-align:middle}.data-grid-table-container .data-grid-table-body-container .data-grid-table-body-subcontainer .data-grid-table-body-subTd{background-color:#f8f6f8;border-bottom:1px solid var(--color-neutral-light2);padding:24px;vertical-align:middle}.data-grid-custom-select{border:1px solid var(--color-neutral-light2)!important;border-radius:200px!important;margin-right:16px;padding-right:0!important}.data-grid-custom-select .select-field-custom-theme{min-width:143px}.data-grid-custom-select .select-field-custom-theme .MuiFilledInput-root{padding:9px 39px 9px 8px}.data-grid-custom-select:after,.data-grid-custom-select:before{content:none!important}.data-grid-custom-select:focus{background-color:transparent!important}.data-grid-custom-select .MuiSelect-select{color:var(--color-neutral-dark4);font-family:Nunito;font-size:16px;font-style:normal;font-weight:600;line-height:22px;padding:9px 26px 9px 16px!important;text-align:center}.data-grid-custom-select .MuiSelect-select:focus{background-color:transparent!important}.data-grid-custom-select .select-icon-custom{cursor:pointer!important}.data-grid-custom-select .select-icon-custom .icon-container{margin-right:12px;position:unset!important;top:unset!important}.data-grid-custom-pagination-container{margin-top:20px}.data-grid-table-header-bulk-actions-container{background-color:var(--color-neutral-light1);display:table-caption}.data-grid-table-header-bulk-actions{padding:24px}.data-grid-custom-pagination-text{align-items:center;color:var(--color-neutral-dark5);display:flex;font-family:Nunito;font-size:16px;font-style:normal;font-weight:700;line-height:22px;text-align:center}.data-grid-pagination-container{display:flex;justify-content:space-between;margin:32px 0}@media screen and (max-width:768px){.data-grid-pagination-container{flex-direction:column}}.data-grid-pagination-container .data-grid-pagination-select-container{align-items:center;display:flex}@media screen and (max-width:768px){.data-grid-pagination-container .data-grid-pagination-select-container{justify-content:center}.data-grid-pagination-container .data-grid-pagination-number-container{align-items:center;display:flex;justify-content:center;margin-top:20px}}.data-grid-sort-options-container{align-items:center;display:flex}.data-grid-sort-options-container-active{color:var(--color-feedback-success-dark1);cursor:default!important}.data-grid-sort-options-container .data-grid-sort-options-description{font-weight:700;margin-left:8px}.tabs{border-radius:8px;box-shadow:0 4px 4px -2px rgba(0,0,0,.5)}.tab,.tabs{overflow:hidden}.tab{width:100%}.tab-content{display:block;max-height:0;overflow:hidden;padding:0 1em;transition:all .35s}.tab-close{display:flex;font-size:.75em;justify-content:flex-end;padding:1em}.tab-content-active{display:table-row;max-height:100vh;transition:all .35s}";
styleInject(css_248z$w);

var Pagination$2 = styled(Pagination$3)(function (_a) {
    var theme = _a.theme, type = _a.type;
    return (__assign({ '.MuiPaginationItem-previousNext': {
            border: "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]),
        }, '.Mui-disabled': {
            border: 'none',
            backgroundColor: theme.colors.neutral[90],
            opacity: 1,
            svg: {
                color: theme.colors.neutral[80],
            },
        }, '.MuiButtonBase-root': {
            fontFamily: 'var(--font-family-secondary)',
            color: theme.colors.neutral[50],
            fontWeight: 700,
        }, '.Mui-selected': {
            color: theme.colors.primary,
        } }, (type === 'soft' && {
        padding: theme.spacings.xs5,
        border: "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]),
        borderRadius: theme.borders.radius.pill,
        '.MuiPaginationItem-previousNext': {
            border: 'none',
            borderRadius: theme.borders.radius.circular,
            '&:disabled': {
                backgroundColor: 'transparent',
            },
        },
    })));
});

var Pagination$1 = function (_a) {
    var page = _a.page, onChange = _a.onChange, count = _a.count, _b = _a.color, color = _b === void 0 ? 'secondary' : _b, variant = _a.variant, disabled = _a.disabled, shape = _a.shape, size = _a.size, showFirstButton = _a.showFirstButton, showLastButton = _a.showLastButton, hidePrevButton = _a.hidePrevButton, hideNextButton = _a.hideNextButton, renderItem = _a.renderItem, defaultPage = _a.defaultPage, siblingCount = _a.siblingCount, boundaryCount = _a.boundaryCount, className = _a.className;
    return (React__default.createElement(Pagination$2, { page: page, onChange: onChange, count: count, color: color, type: variant, disabled: disabled, shape: shape !== null && shape !== void 0 ? shape : (variant === 'soft' ? 'rounded' : 'circular'), size: size, showFirstButton: showFirstButton, showLastButton: showLastButton, hidePrevButton: hidePrevButton, hideNextButton: hideNextButton, renderItem: renderItem, defaultPage: defaultPage, siblingCount: siblingCount, boundaryCount: boundaryCount, className: "custom-theme-pagination ".concat(className) }));
};

var EOrderBy;
(function (EOrderBy) {
    EOrderBy["ASC"] = "ASC";
    EOrderBy["DESC"] = "DESC";
})(EOrderBy || (EOrderBy = {}));
function DataGrid(_a) {
    var _b;
    var columns = _a.columns, data = _a.data, hasPagination = _a.hasPagination, customPagination = _a.customPagination, pageSizeOptions = _a.pageSizeOptions, customSortByOptions = _a.customSortByOptions, customSortIcon = _a.customSortIcon, emptyState = _a.emptyState, initialState = _a.initialState, loading = _a.loading, _c = _a.paginateExpandedRows, paginateExpandedRows = _c === void 0 ? false : _c, _d = _a.expandSubRows, expandSubRows = _d === void 0 ? false : _d, controlledPageCount = _a.pageCount, fetchData = _a.fetchData, _e = _a.withAccordion, withAccordion = _e === void 0 ? false : _e, bulkActions = _a.bulkActions, onRowClick = _a.onRowClick;
    var _f = useState(data || []), controlledData = _f[0], setControlledData = _f[1];
    var _g = useState(columns || []), controlledCollumns = _g[0], setControlledCollumns = _g[1];
    var _h = useState(!controlledPageCount), firstLoad = _h[0], setFirstLoad = _h[1];
    var _j = useState(''), check = _j[0], setCheck = _j[1];
    var integerPageCount = controlledPageCount && Math.ceil(controlledPageCount);
    var _k = useTable({
        initialState: initialState,
        columns: controlledCollumns,
        data: controlledData,
        manualPagination: !!integerPageCount,
        pageCount: integerPageCount,
        paginateExpandedRows: paginateExpandedRows,
        expandSubRows: expandSubRows,
    }, useSortBy, useExpanded, usePagination, useRowSelect, useSticky), getTableProps = _k.getTableProps, getTableBodyProps = _k.getTableBodyProps, gotoPage = _k.gotoPage, headerGroups = _k.headerGroups, prepareRow = _k.prepareRow, setPageSize = _k.setPageSize, _l = _k.page, page = _l === void 0 ? [] : _l, state = _k.state, table = __rest(_k, ["getTableProps", "getTableBodyProps", "gotoPage", "headerGroups", "prepareRow", "setPageSize", "page", "state"]);
    var pageSize = state.pageSize, pageIndex = state.pageIndex, sortBy = state.sortBy;
    var customSortFunctions = columns.reduce(function (sortFunctions, column) {
        var _a;
        if (column.customSortKey) {
            return __assign(__assign({}, sortFunctions), (_a = {}, _a[column.customSortKey] = function (rowA, rowB) {
                var a = rowA.values[column.customSortKey];
                var b = rowB.values[column.customSortKey];
                return a > b ? 1 : -1;
            }, _a));
        }
        return sortFunctions;
    }, {});
    useEffect(function () {
        if (data) {
            setControlledData(data);
            setFirstLoad(true);
        }
        if (columns)
            setControlledCollumns(columns);
    }, [data, columns]);
    var lastPageSize = integerPageCount && controlledPageCount
        ? pageSize * (1 - integerPageCount + controlledPageCount)
        : controlledData.length - pageSize * (table.pageCount - 1);
    function getSortByOptionDefault(column, newSortBy) {
        var selected = false;
        var activeLanguage = window.navigator.language;
        var descendingOrderDescription = activeLanguage === 'pt-BR' ? 'Ordem decrescente' : 'Descending order';
        var ascendingOrderDescription = activeLanguage === 'pt-BR' ? 'Ordem crescente' : 'Ascending order';
        if (column.isSorted)
            selected =
                (column.isSortedDesc && newSortBy === EOrderBy.DESC) ||
                    (!column.isSortedDesc && newSortBy === EOrderBy.ASC);
        return {
            selected: selected,
            children: (React__default.createElement("div", { className: "data-grid-sort-options-container" },
                React__default.createElement(Icons, { name: newSortBy == EOrderBy.DESC ? 'IconArrowDown' : 'IconArrowUp', size: 24 }),
                React__default.createElement("div", { className: "data-grid-sort-options-description" }, newSortBy == EOrderBy.DESC
                    ? descendingOrderDescription
                    : ascendingOrderDescription))),
            onClick: function () {
                var newSortByState = __spreadArray([], sortBy.filter(function (_a) {
                    var id = _a.id;
                    return id !== column.id;
                }), true);
                if (selected) {
                    column.clearSortBy();
                }
                else {
                    newSortByState.push({
                        id: column.id,
                        desc: newSortBy === EOrderBy.DESC,
                    });
                    column.toggleSortBy(newSortBy === EOrderBy.DESC, true);
                }
                fetchData === null || fetchData === void 0 ? void 0 : fetchData({
                    pageIndex: pageIndex,
                    pageSize: pageSize,
                    sortBy: newSortByState,
                });
            },
        };
    }
    var numberOfElements = pageIndex * pageSize;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "data-grid-table-border" },
            loading && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { className: "data-grid-empty-table-container loader shadow" }),
                React__default.createElement("div", { className: "data-grid-empty-table-container loader" },
                    React__default.createElement(CircularProgress, { size: 120, variant: "indeterminate" }),
                    React__default.createElement(Typography, { variant: "body3", className: "data-grid-loader-text" }, "Processando...")))),
            !page.length ? (React__default.createElement("div", { className: "data-grid-empty-table-container" }, firstLoad && (React__default.createElement(React__default.Fragment, null,
                (emptyState === null || emptyState === void 0 ? void 0 : emptyState.isFiltered) ? (React__default.createElement(SvgEmptyFilteredTable, null)) : (React__default.createElement(SvgEmptyTable, null)),
                React__default.createElement(Typography, { variant: "body3" }, (_b = emptyState === null || emptyState === void 0 ? void 0 : emptyState.message) !== null && _b !== void 0 ? _b : 'Lista vazia'),
                (emptyState === null || emptyState === void 0 ? void 0 : emptyState.children) && (React__default.createElement("div", { className: "data-grid-empty-table-children" }, emptyState === null || emptyState === void 0 ? void 0 : emptyState.children)))))) : withAccordion ? (React__default.createElement("table", __assign({ className: "data-grid-table-container sticky" }, getTableProps()),
                React__default.createElement("thead", { className: "data-grid-table-header-container" }, headerGroups.map(function (headerGroup, index) {
                    var headers = headerGroup.headers.filter(function (f) { return f.id !== 'children' && f.id !== 'expander'; });
                    return (React__default.createElement("tr", __assign({ key: index }, headerGroup.getHeaderGroupProps()), headers.map(function (column, index) {
                        var sortByOptions = [];
                        var hasSortBy = !(column === null || column === void 0 ? void 0 : column.disableSortBy);
                        if (column.customSortKey)
                            column.sortType =
                                customSortFunctions[column.customSortKey];
                        if (hasSortBy)
                            if (!customSortByOptions)
                                Object.values(EOrderBy).map(function (orderBy) {
                                    return sortByOptions.push(getSortByOptionDefault(column, orderBy));
                                });
                            else
                                sortByOptions = customSortByOptions;
                        if (index === headers.length - 1)
                            return (React__default.createElement(React__default.Fragment, null,
                                React__default.createElement("th", __assign({ key: index, className: "data-grid-table-header-container" }, column.getHeaderProps()),
                                    React__default.createElement("div", { className: "data-grid-table-header-subcontainer" },
                                        React__default.createElement("div", { className: "data-grid-table-header-subcontainer-text" }, column.render('Header')),
                                        React__default.createElement("div", { className: "data-grid-table-header-subcontainer-svg" }, hasSortBy && (React__default.createElement("div", { className: "data-grid-table-header-subcontainer-icon-sort" },
                                            React__default.createElement(Menu$2, { type: 'default', transformOrigin: {
                                                    horizontal: 'right',
                                                    vertical: 'top',
                                                }, anchorOrigin: {
                                                    horizontal: 'right',
                                                    vertical: 'bottom',
                                                }, options: sortByOptions },
                                                React__default.createElement(Icons, { name: customSortIcon || 'IconArrowsSort', size: 16 }))))))),
                                React__default.createElement("th", { key: index, className: "data-grid-table-header-container" },
                                    React__default.createElement("div", { className: "data-grid-table-header-subcontainer" },
                                        React__default.createElement("div", { className: "data-grid-table-header-subcontainer-text" })))));
                        return (React__default.createElement("th", { key: index, className: "data-grid-table-header-container" },
                            React__default.createElement("div", { className: "data-grid-table-header-subcontainer" },
                                React__default.createElement("div", { className: "data-grid-table-header-subcontainer-text" }, column.render('Header')),
                                React__default.createElement("div", { className: "data-grid-table-header-subcontainer-svg" }, hasSortBy && (React__default.createElement("div", { className: "data-grid-table-header-subcontainer-icon-sort" },
                                    React__default.createElement(Menu$2, { type: 'default', transformOrigin: {
                                            horizontal: 'right',
                                            vertical: 'top',
                                        }, anchorOrigin: {
                                            horizontal: 'right',
                                            vertical: 'bottom',
                                        }, options: sortByOptions },
                                        React__default.createElement(Icons, { name: customSortIcon || 'IconArrowsSort', size: 16 }))))))));
                    })));
                })),
                React__default.createElement("tbody", __assign({ className: "data-grid-table-body-container tabs" }, getTableBodyProps()), page.map(function (row, index1) {
                    prepareRow(row);
                    var cells = row.cells.filter(function (f) {
                        return f.column.id !== 'children' && f.column.id !== 'expander';
                    });
                    var children = row.cells.find(function (f) { return f.column.id === 'children'; });
                    return (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement("tr", __assign({ key: index1, className: "data-grid-table-body-subcontainer tab-label" }, row.getRowProps()), cells.map(function (cell, index) {
                            if (index === cells.length - 1)
                                return (React__default.createElement(React__default.Fragment, null,
                                    React__default.createElement("td", __assign({ key: index, className: row.depth !== 0
                                            ? 'data-grid-table-body-subTd'
                                            : 'data-grid-table-body-td' }, cell.getCellProps()), cell.render('Cell')),
                                    React__default.createElement("td", __assign({ key: index, className: row.depth !== 0
                                            ? 'data-grid-table-body-subTd'
                                            : 'data-grid-table-body-td' }, cell.getCellProps()),
                                        React__default.createElement(Box, { sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-around',
                                            } },
                                            React__default.createElement(IconButton, { icon: 'IconChevronDown', size: "medium", variant: "line", onClick: function () {
                                                    if (check === "chck-".concat(index1)) {
                                                        setCheck('');
                                                    }
                                                    else {
                                                        setCheck("chck-".concat(index1));
                                                    }
                                                } })))));
                            return (React__default.createElement("td", __assign({ key: index, className: row.depth !== 0
                                    ? 'data-grid-table-body-subTd'
                                    : 'data-grid-table-body-td' }, cell.getCellProps()), cell.render('Cell')));
                        })),
                        React__default.createElement("tr", { className: check === "chck-".concat(index1)
                                ? 'tab-content-active'
                                : 'tab-content' },
                            React__default.createElement("td", { colSpan: cells.length + 1 }, children === null || children === void 0 ? void 0 : children.render('Cell')))));
                })))) : (React__default.createElement("table", __assign({ className: "data-grid-table-container sticky" }, getTableProps()),
                bulkActions ? (React__default.createElement("tr", { className: "data-grid-table-header-bulk-actions-container", role: "row" },
                    React__default.createElement("th", { className: "data-grid-table-header-bulk-actions" },
                        React__default.createElement(Checkbox, { onChange: function () { return bulkActions.selectAll(); }, checked: bulkActions.allSelected, "aria-label": "column row checkbox" })),
                    bulkActions.actions.map(function (action) {
                        return (React__default.createElement("th", { className: "data-grid-table-header-bulk-actions", key: action.label },
                            React__default.createElement(LinkButton, { variant: "neutral", onClick: function () { return action.onClick(action.selectedRows); } }, action.label)));
                    }))) : (React__default.createElement("thead", { className: "data-grid-table-header-container" }, headerGroups.map(function (headerGroup, index) { return (React__default.createElement("tr", __assign({ className: "data-grid-table-header-subcontainer", key: index }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column, index) {
                    var sortByOptions = [];
                    var hasSortBy = !(column === null || column === void 0 ? void 0 : column.disableSortBy);
                    if (column.customSortKey)
                        column.sortType =
                            customSortFunctions[column.customSortKey];
                    if (hasSortBy)
                        if (!customSortByOptions)
                            Object.values(EOrderBy).map(function (orderBy) {
                                return sortByOptions.push(getSortByOptionDefault(column, orderBy));
                            });
                        else
                            sortByOptions = customSortByOptions;
                    return (React__default.createElement("th", __assign({ key: index, className: "data-grid-table-header-container" }, column.getHeaderProps()),
                        React__default.createElement("div", { className: "data-grid-table-header-subcontainer" },
                            React__default.createElement("div", { className: "data-grid-table-header-subcontainer-text" }, column.render('Header')),
                            React__default.createElement("div", { className: "data-grid-table-header-subcontainer-svg" }, hasSortBy && (React__default.createElement("div", { className: "data-grid-table-header-subcontainer-icon-sort" },
                                React__default.createElement(Menu$2, { type: 'default', transformOrigin: {
                                        horizontal: 'right',
                                        vertical: 'top',
                                    }, anchorOrigin: {
                                        horizontal: 'right',
                                        vertical: 'bottom',
                                    }, options: sortByOptions },
                                    React__default.createElement(Icons, { name: customSortIcon || 'IconArrowsSort', size: 16 }))))))));
                }))); }))),
                React__default.createElement("tbody", __assign({ className: "data-grid-table-body-container" }, getTableBodyProps()), page.map(function (row, index) {
                    prepareRow(row);
                    return (React__default.createElement("tr", __assign({ key: index, className: "data-grid-table-body-subcontainer", onClick: function (e) {
                            onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(row.values);
                            e.stopPropagation();
                        } }, row.getRowProps()), row.cells.map(function (cell, index) {
                        return (React__default.createElement("td", __assign({ key: index, className: row.depth !== 0
                                ? 'data-grid-table-body-subTd'
                                : 'data-grid-table-body-td' }, cell.getCellProps()), cell.render('Cell')));
                    })));
                }))))),
        hasPagination &&
            (!customPagination ? (React__default.createElement("div", { className: "data-grid-pagination-container" },
                React__default.createElement("div", { className: "data-grid-pagination-select-container" },
                    React__default.createElement(Select$1, { className: "data-grid-custom-select", disabled: !page.length, variant: "standard", value: pageSize, IconComponent: function (props) { return (React__default.createElement("div", { className: "select-icon-custom" },
                            React__default.createElement(Icons, __assign({ name: "IconChevronDown", fill: "transparent" }, props)))); }, onChange: function (e) {
                            var _a;
                            var newPageSize = Number((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
                            fetchData === null || fetchData === void 0 ? void 0 : fetchData({
                                pageIndex: pageIndex,
                                pageSize: newPageSize,
                                sortBy: sortBy,
                            });
                            setPageSize(newPageSize);
                        } }, pageSizeOptions === null || pageSizeOptions === void 0 ? void 0 : pageSizeOptions.map(function (opt) { return (React__default.createElement(MenuItem$4, { key: opt === null || opt === void 0 ? void 0 : opt.value, value: opt === null || opt === void 0 ? void 0 : opt.value }, opt === null || opt === void 0 ? void 0 : opt.label)); })),
                    React__default.createElement("div", { className: "data-grid-custom-pagination-text" },
                        "Resultados:\u00A0",
                        numberOfElements + Math.sign(table.pageCount),
                        "-",
                        numberOfElements +
                            (lastPageSize < pageSize && pageIndex === table.pageCount - 1
                                ? lastPageSize
                                : pageSize),
                        "\u00A0de\u00A0",
                        (table.pageCount - 1) * pageSize + lastPageSize,
                        "\u00A0",
                        controlledData.length === 1 ? 'item' : 'itens')),
                React__default.createElement("div", { className: "data-grid-pagination-number-container" },
                    React__default.createElement(Pagination$1, { disabled: !page.length, page: pageIndex + 1, count: table.pageCount, onChange: function (_, value) {
                            fetchData === null || fetchData === void 0 ? void 0 : fetchData({
                                pageIndex: value - 1,
                                pageSize: pageSize,
                                sortBy: sortBy,
                            });
                            gotoPage(value - 1);
                        } })))) : (customPagination({
                gotoPage: gotoPage,
                setPageSize: setPageSize,
            })))));
}

var TextFieldStyled = styled(TextField$2)(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n  .MuiInputLabel-root {\n    color: ", ";\n    font-family: ", ";\n    font-weight: 600;\n    transition: all 0.2s ease-in-out;\n\n    .MuiInputLabel-asterisk {\n      color: ", ";\n    }\n  }\n\n  .MuiInputLabel-shrink {\n    color: ", ";\n  }\n\n  .MuiFilledInput-root {\n    background-color: transparent;\n    border: 1px solid ", ";\n    margin: 1px;\n    border-radius: ", ";\n    transition:\n      border-color 0.1s ease-in-out,\n      background-color 0.1s ease-in-out;\n\n    &.MuiInputBase-adornedEnd {\n      padding-right: ", ";\n    }\n\n    &:hover:not(.MuiInputLabel-shrink):not(.Mui-disabled):not(.Mui-focused):not(\n        .Mui-error\n      ) {\n      border: 2px solid ", ";\n      margin: unset;\n    }\n\n    &.Mui-disabled {\n      border: 1px solid ", ";\n    }\n\n    &::before,\n    &::after {\n      content: none;\n    }\n\n    input {\n      color: ", ";\n      font-family: ", ";\n      font-weight: 600;\n    }\n  }\n\n  .MuiFilledInput-input {\n    border-radius: ", ";\n    color: ", ";\n  }\n\n  &.size-large {\n    & .MuiInputLabel-root {\n      font-size: 1rem;\n      line-height: 22px;\n      transform: translate(16px, 18px);\n    }\n\n    & .MuiInputLabel-shrink {\n      transform: translate(16px, 9px);\n      font-size: 0.75rem;\n      line-height: 18px;\n    }\n\n    & .MuiFilledInput-input {\n      padding: 27px 14px 7px;\n      height: 1.25rem;\n      line-height: 20px;\n      font-size: 0.875rem;\n    }\n  }\n\n  &.size-medium {\n    & .MuiInputLabel-root {\n      font-size: 0.875rem;\n      line-height: 20px;\n      transform: translate(16px, 14px);\n    }\n\n    & .MuiInputLabel-shrink {\n      transform: translate(16px, 5px);\n      font-size: 0.75rem;\n      line-height: 18px;\n    }\n\n    & .MuiFilledInput-input {\n      padding: 21px 14px 3px;\n      height: 1.25rem;\n      line-height: 20px;\n      font-size: 0.875rem;\n    }\n  }\n\n  &.size-small {\n    & .MuiInputLabel-root {\n      font-size: 0.875rem;\n      line-height: 20px;\n      transform: translate(16px, 10px);\n    }\n\n    & .MuiInputLabel-shrink {\n      display: none;\n    }\n\n    & .MuiFilledInput-input {\n      padding: 8px 14px;\n      height: 1.25rem;\n      line-height: 20px;\n      font-size: 0.875rem;\n    }\n  }\n\n  .Mui-focused:not(label) {\n    border: 2px solid ", ";\n    margin: unset;\n  }\n\n  .Mui-focused {\n    ::-webkit-scrollbar-thumb {\n      background-color: var(--color-secondary-light5);\n      margin: 1px;\n    }\n\n    svg {\n      stroke: var(--color-secondary-light5);\n    }\n  }\n\n  & .Mui-disabled,\n  & .Mui-disabled input {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n  }\n\n  & .Mui-disabled:not(label):not(input) {\n    svg {\n      stroke: var(--color-neutral-light5);\n    }\n  }\n\n  .Mui-error:not(label):not(.MuiFormLabel-asterisk) {\n    background: ", ";\n    margin: unset;\n    border: 2px solid ", ";\n  }\n"], ["\n  .MuiInputLabel-root {\n    color: ", ";\n    font-family: ", ";\n    font-weight: 600;\n    transition: all 0.2s ease-in-out;\n\n    .MuiInputLabel-asterisk {\n      color: ", ";\n    }\n  }\n\n  .MuiInputLabel-shrink {\n    color: ", ";\n  }\n\n  .MuiFilledInput-root {\n    background-color: transparent;\n    border: 1px solid ", ";\n    margin: 1px;\n    border-radius: ", ";\n    transition:\n      border-color 0.1s ease-in-out,\n      background-color 0.1s ease-in-out;\n\n    &.MuiInputBase-adornedEnd {\n      padding-right: ", ";\n    }\n\n    &:hover:not(.MuiInputLabel-shrink):not(.Mui-disabled):not(.Mui-focused):not(\n        .Mui-error\n      ) {\n      border: 2px solid ", ";\n      margin: unset;\n    }\n\n    &.Mui-disabled {\n      border: 1px solid ", ";\n    }\n\n    &::before,\n    &::after {\n      content: none;\n    }\n\n    input {\n      color: ", ";\n      font-family: ", ";\n      font-weight: 600;\n    }\n  }\n\n  .MuiFilledInput-input {\n    border-radius: ", ";\n    color: ", ";\n  }\n\n  &.size-large {\n    & .MuiInputLabel-root {\n      font-size: 1rem;\n      line-height: 22px;\n      transform: translate(16px, 18px);\n    }\n\n    & .MuiInputLabel-shrink {\n      transform: translate(16px, 9px);\n      font-size: 0.75rem;\n      line-height: 18px;\n    }\n\n    & .MuiFilledInput-input {\n      padding: 27px 14px 7px;\n      height: 1.25rem;\n      line-height: 20px;\n      font-size: 0.875rem;\n    }\n  }\n\n  &.size-medium {\n    & .MuiInputLabel-root {\n      font-size: 0.875rem;\n      line-height: 20px;\n      transform: translate(16px, 14px);\n    }\n\n    & .MuiInputLabel-shrink {\n      transform: translate(16px, 5px);\n      font-size: 0.75rem;\n      line-height: 18px;\n    }\n\n    & .MuiFilledInput-input {\n      padding: 21px 14px 3px;\n      height: 1.25rem;\n      line-height: 20px;\n      font-size: 0.875rem;\n    }\n  }\n\n  &.size-small {\n    & .MuiInputLabel-root {\n      font-size: 0.875rem;\n      line-height: 20px;\n      transform: translate(16px, 10px);\n    }\n\n    & .MuiInputLabel-shrink {\n      display: none;\n    }\n\n    & .MuiFilledInput-input {\n      padding: 8px 14px;\n      height: 1.25rem;\n      line-height: 20px;\n      font-size: 0.875rem;\n    }\n  }\n\n  .Mui-focused:not(label) {\n    border: 2px solid ", ";\n    margin: unset;\n  }\n\n  .Mui-focused {\n    ::-webkit-scrollbar-thumb {\n      background-color: var(--color-secondary-light5);\n      margin: 1px;\n    }\n\n    svg {\n      stroke: var(--color-secondary-light5);\n    }\n  }\n\n  & .Mui-disabled,\n  & .Mui-disabled input {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n  }\n\n  & .Mui-disabled:not(label):not(input) {\n    svg {\n      stroke: var(--color-neutral-light5);\n    }\n  }\n\n  .Mui-error:not(label):not(.MuiFormLabel-asterisk) {\n    background: ", ";\n    margin: unset;\n    border: 2px solid ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[30];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.secondary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.feedback.error[40];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[40];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[90];
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.m;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[50];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[80];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[30];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.secondary;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.m;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[30];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary[70];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[70];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[95];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[80];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.feedback.error[90];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.feedback.error[50];
});
var HelperTextStyled$1 = styled.p(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n  margin: ", " 0 0\n    ", ";\n  font-size: 12px;\n  color: ", ";\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  fill: transparent;\n"], ["\n  margin: ", " 0 0\n    ", ";\n  font-size: 12px;\n  color: ", ";\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  fill: transparent;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[50];
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var templateObject_1$U, templateObject_2$B;

var TextMaskCustom = React__default.forwardRef(function TextMaskCustom(props, ref) {
    var onChange = props.onChange, imaskprops = props.imaskprops, other = __rest(props, ["onChange", "imaskprops"]);
    return (React__default.createElement(IMaskInput, __assign({}, other, imaskprops, { inputRef: ref, onAccept: function (value) {
            return onChange({ target: { name: props.name, value: value } });
        }, overwrite: false })));
});
var TextField$1 = forwardRef(function (_a, ref) {
    var _b = _a.id, id = _b === void 0 ? 'customId' : _b, name = _a.name, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.autoComplete, autoComplete = _d === void 0 ? 'off' : _d, hiddenLabel = _a.hiddenLabel, focused = _a.focused, placeholder = _a.placeholder, error = _a.error, type = _a.type, helperText = _a.helperText, defaultValue = _a.defaultValue, value = _a.value, label = _a.label, InputProps = _a.InputProps, inputProps = _a.inputProps, InputLabelProps = _a.InputLabelProps, style = _a.style, _e = _a.multiline, multiline = _e === void 0 ? false : _e, _f = _a.required, required = _f === void 0 ? false : _f, rows = _a.rows, disabled = _a.disabled, maxRows = _a.maxRows, className = _a.className, fullWidth = _a.fullWidth, onError = _a.onError, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onClick = _a.onClick, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, imaskProps = _a.imaskProps;
    var theme = useTheme();
    var InputPropsMasked = useMemo(function () {
        var props = __assign({}, InputProps);
        if (imaskProps)
            props = __assign(__assign({}, props), { inputComponent: TextMaskCustom });
        return props;
    }, [imaskProps, InputProps]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TextFieldStyled, { inputRef: ref, id: id, name: name, defaultValue: defaultValue, autoComplete: autoComplete, hiddenLabel: hiddenLabel, InputLabelProps: InputLabelProps, focused: focused, placeholder: placeholder, type: type, label: label, value: value, helperText: false, error: error, InputProps: InputPropsMasked, inputProps: __assign(__assign({}, inputProps), { imaskprops: imaskProps }), style: style, multiline: multiline, rows: rows, disabled: disabled, maxRows: maxRows, fullWidth: fullWidth, variant: "filled", required: required, onError: onError, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onChange: onChange, onClick: onClick, onBlur: onBlur, className: cx("size-".concat(size), { warning: !!error }, className) }),
        helperText && (React__default.createElement(HelperTextStyled$1, { className: "".concat(error && 'warning') },
            error && (React__default.createElement(Icons, { color: theme.colors.feedback.error[50], name: "IconInfoCircle", size: 18 })),
            helperText))));
});
TextField$1.displayName = 'TextField';

var css_248z$v = ".date-picker-caption{display:flex;flex-direction:row;justify-content:space-between}.date-picker-caption .date-picker-caption-nav-button{align-items:center;background:#f8f6f8;border-radius:4px;display:flex;height:28px;justify-content:center;width:28px}.date-picker-caption .date-picker-caption-nav-button>div>svg{stroke:var(--color-neutral-dark5)}.date-picker-caption .date-picker-caption-title{color:var(--color-neutral-dark);font-size:16px;font-weight:700;line-height:22px;min-width:125px;text-align:center;text-decoration:underline;text-underline-offset:10px}";
styleInject(css_248z$v);

var Caption = function (_a) {
    var toDate = _a.toDate, fromDate = _a.fromDate, displayMonth = _a.displayMonth, locale = _a.locale;
    var _b = useNavigation(), goToMonth = _b.goToMonth, nextMonth = _b.nextMonth, previousMonth = _b.previousMonth;
    var nextButtonDisabled = !!toDate && toDate <= displayMonth;
    var backButtonDisabled = !!fromDate && fromDate > displayMonth;
    return (React__default.createElement("div", { className: "date-picker-caption" },
        React__default.createElement("button", { className: "date-picker-caption-nav-button", disabled: backButtonDisabled, style: backButtonDisabled ? { visibility: 'hidden', cursor: 'default' } : {}, onClick: function () {
                previousMonth &&
                    goToMonth(new Date(displayMonth.getFullYear() - 1, displayMonth.getMonth()));
            } },
            React__default.createElement(Icons, { name: 'IconChevronsLeft', fill: "transparent", size: 16 })),
        React__default.createElement("button", { className: "date-picker-caption-nav-button", disabled: backButtonDisabled, style: backButtonDisabled ? { visibility: 'hidden', cursor: 'default' } : {}, onClick: function () { return previousMonth && goToMonth(previousMonth); } },
            React__default.createElement(Icons, { name: 'IconChevronLeft', fill: "transparent", size: 16 })),
        React__default.createElement("div", { className: "date-picker-caption-title" }, format(displayMonth, 'MMMM yyy', { locale: locale })),
        React__default.createElement("button", { className: "date-picker-caption-nav-button", disabled: nextButtonDisabled, style: nextButtonDisabled ? { visibility: 'hidden', cursor: 'default' } : {}, onClick: function () { return nextMonth && goToMonth(nextMonth); } },
            React__default.createElement(Icons, { name: 'IconChevronRight', fill: "transparent", size: 16 })),
        React__default.createElement("button", { className: "date-picker-caption-nav-button", disabled: nextButtonDisabled, style: nextButtonDisabled ? { visibility: 'hidden', cursor: 'default' } : {}, onClick: function () {
                nextMonth &&
                    goToMonth(new Date(displayMonth.getFullYear() + 1, displayMonth.getMonth()));
            } },
            React__default.createElement(Icons, { name: 'IconChevronsRight', fill: "transparent", size: 16 }))));
};

var css_248z$u = ".date-picker-container{display:flex;flex-direction:column;position:relative;width:100%}.date-picker-container .MuiInputBase-root.MuiFilledInput-root.Mui-disabled{background-color:var(--color-neutral-light1)!important;color:var(--color-neutral-light4)!important}.date-picker-wrapper{z-index:2}.date-picker-wrapper .rdp{background:var(--color-neutral-pureLight);border-radius:4px;box-shadow:0 4px 26px rgba(0,0,0,.1);margin:0;padding:20px}.date-picker-wrapper.open-calendar .rdp{padding-bottom:70px}.date-picker-wrapper .rdp-table{border-collapse:separate;border-spacing:4px 8px;margin-top:15px;position:relative}.date-picker-wrapper .DayPicker-Day{border-radius:0;padding:0!important;text-align:center}.date-picker-wrapper .rdp-day{color:var(--color-neutral-30);font-size:16px;font-weight:700;height:36px;line-height:22px;width:36px}.date-picker-wrapper .rdp-day_today:not(.rdp-day_outside){font-size:16px;font-weight:400;font-weight:700;line-height:22px}.date-picker-wrapper .rdp-button[disabled]:not(.rdp-day_selected){opacity:.5;pointer-events:none!important}.date-picker-wrapper .rdp-button:hover:not([disabled]):not(.rdp-day_selected){background-color:var(--color-secondary-light3)!important}.date-picker-wrapper .rdp-day_selected{background-color:var(--color-primary)!important;color:var(--color-neutral-pureLight)}.date-picker-wrapper th.rdp-head_cell{color:var(--color-neutral-50);font-size:16px;font-weight:400;line-height:22px}";
styleInject(css_248z$u);

var DateInput = function (_a) {
    var label = _a.label, fromDate = _a.fromDate, toDate = _a.toDate, fullWidth = _a.fullWidth, helperText = _a.helperText, error = _a.error, onError = _a.onError, onClick = _a.onClick, onDateChange = _a.onDateChange, onBlur = _a.onBlur, onFocus = _a.onFocus, value = _a.value, placeholder = _a.placeholder, className = _a.className, id = _a.id, name = _a.name, disabled = _a.disabled, style = _a.style, disabledDate = _a.disabledDate, size = _a.size;
    var inputRef = useRef(null);
    var _b = useState(false), invalidDate = _b[0], setInvalidDate = _b[1];
    var _c = useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var checkDisabledDate = useCallback(function (date) {
        if (disabledDate) {
            var disabledDates = Array.isArray(disabledDate)
                ? disabledDate
                : [disabledDate];
            return isMatch(dayjs(date).toDate(), disabledDates);
        }
        return false;
    }, [disabledDate]);
    var validateValue = useMemo(function () {
        var hasValue = !!value;
        var isValid = hasValue && dayjs(value).isValid();
        var isDisabledDate = checkDisabledDate(value);
        if (hasValue && !isValid && !invalidDate && isDisabledDate)
            setInvalidDate(true);
        return isValid && !isDisabledDate ? dayjs(value).toDate() : undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    var _d = useInput({
        fromDate: fromDate && dayjs(fromDate).isValid()
            ? dayjs(fromDate).toDate()
            : undefined,
        toDate: toDate && dayjs(toDate).isValid() ? dayjs(toDate).toDate() : undefined,
        format: 'dd/MM/yyyy',
        locale: ptBR,
        defaultSelected: validateValue,
    }), inputProps = _d.inputProps, dayPickerProps = _d.dayPickerProps, setSelected = _d.setSelected;
    useEffect(function () {
        if (validateValue)
            setSelected(validateValue);
    }, [validateValue]);
    var handleInputChange = useCallback(function (e) {
        var _a;
        var invalidDate = dayjs('00/', 'DD/MM/YYYY', true);
        var typedValue = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value;
        var typedDate = dayjs(typedValue, 'DD/MM/YYYY', true);
        var settedValue = dayjs(value, 'DD/MM/YYYY');
        var isTypedValid = typedDate.isValid();
        var isSettedValid = settedValue.isValid();
        var hasFromDate = fromDate && dayjs(fromDate).isValid() ? dayjs(fromDate) : undefined;
        var hasToDate = toDate && dayjs(toDate).isValid() ? dayjs(toDate) : undefined;
        var isBefore = hasFromDate &&
            isTypedValid &&
            !hasFromDate.isSameOrBefore(typedDate, 'day');
        var isAfter = hasToDate && isTypedValid && !hasToDate.isSameOrAfter(typedDate, 'day');
        (!isTypedValid && typedValue) || isBefore || isAfter
            ? setInvalidDate(true)
            : setInvalidDate(false);
        if (isSettedValid && isTypedValid && typedDate.isSame(settedValue, 'day'))
            return;
        if (!typedValue && !value)
            return;
        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(typedValue
            ? isAfter || isBefore
                ? invalidDate
                : typedDate
            : undefined);
    }, [setInvalidDate, onDateChange, value]);
    return (React__default.createElement("div", { className: cx('date-picker-container', className) },
        React__default.createElement(TextField$1, __assign({ id: id, name: name, disabled: disabled }, inputProps, { style: style, size: size, label: label || 'Selecionar data', placeholder: placeholder || 'dd/mm/yyyy', ref: inputRef, fullWidth: fullWidth, error: error, helperText: helperText, onError: onError, onClick: onClick, type: 'text', onChange: function (e) {
                inputProps.onChange && inputProps.onChange(e);
                handleInputChange(e);
            }, onBlur: function (e) {
                var date = parse(e.target.value, 'dd/MM/yyyy', new Date(), {
                    locale: ptBR,
                });
                if (checkDisabledDate(date)) {
                    setSelected(undefined);
                }
                onBlur && onBlur(e);
                inputProps.onBlur && inputProps.onBlur(e);
            }, onFocus: function (e) {
                onFocus && onFocus(e);
                inputProps.onFocus && inputProps.onFocus(e);
            }, imaskProps: {
                mask: '00/00/0000',
            }, InputProps: {
                endAdornment: (React__default.createElement(InputAdornment, { position: "end", disablePointerEvents: disabled },
                    React__default.createElement(IconButton$1, { onClick: function (e) {
                            var _a;
                            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                            setAnchorEl(e.currentTarget);
                        }, onMouseDown: function (e) { return e.preventDefault(); } },
                        React__default.createElement(Icons, { name: "IconCalendarEvent", fill: "transparent", size: 24 })))),
            } })),
        React__default.createElement(Popover, { open: !!anchorEl, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, onKeyDown: function () { return setAnchorEl(null); }, PaperProps: {
                style: {
                    marginTop: '5px',
                },
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            } },
            React__default.createElement("span", { className: "date-picker-wrapper ".concat(cx({
                    'open-calendar': validateValue,
                })) },
                React__default.createElement(DayPicker, __assign({ mode: "single", locale: ptBR, formatters: {
                        formatWeekdayName: function (weekDay) {
                            return format(weekDay, 'EEEEE', { locale: ptBR });
                        },
                    }, disabled: disabled || disabledDate }, dayPickerProps, { components: {
                        Caption: function (props) { return (React__default.createElement(Caption, __assign({}, props, { locale: ptBR, toDate: toDate ? dayjs(toDate).toDate() : undefined, fromDate: fromDate ? dayjs(fromDate).toDate() : undefined }))); },
                    }, onSelect: function (e) {
                        onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(e ? dayjs(e) : undefined);
                        setAnchorEl(null);
                    } }))))));
};
var DatePicker = function (props) {
    return (React__default.createElement(DayPickerProvider, { initialProps: { mode: 'single' } },
        React__default.createElement(NavigationProvider, null,
            React__default.createElement(DateInput, __assign({}, props)))));
};

/**
 * Format date
 *
 * @param date date or iso date string
 * @returns formatted date
 */
function formatDate(date) {
    if (!date) {
        return '';
    }
    var finalDate = typeof date === 'string' ? parseISO(date) : date;
    return isValid(finalDate) ? format(finalDate, 'dd/MM/yyyy') : '';
}

var css_248z$t = "@charset \"UTF-8\";.date-range-picker--container{font-family:var(--font-family-secondary)}.date-range-picker--container .rdp{margin:0}.date-range-picker--container .date-range-picker--header{color:var(--color-neutral-light5);font-weight:600}.date-range-picker--container .date-range-picker--weekday-name{font-weight:400}.date-range-picker--container .date-range-picker--day{font-weight:700}.date-range-picker--container .date-range-picker--day-weekend{color:var(--color-neutral-light4);font-weight:700}.date-range-picker--container .rdp-day_range_end>p,.date-range-picker--container .rdp-day_range_start>p{color:#fff!important}.date-range-picker--container .date-range-picker--input-area{margin:5px}.date-range-picker--container .date-range-picker--input-area .date-range-picker--input-label{color:var(--color-neutral-light5)}.date-range-picker--container .date-range-picker--input-area .date-range-picker--inputs{align-items:center;display:flex;gap:1rem}.date-range-picker--container .date-range-picker--input-area .date-range-picker--inputs input{border-bottom:2px solid var(--color-neutral-dark3);color:var(--color-neutral-dark3);width:5.4rem}.date-range-picker--container .date-range-picker--input-area .date-range-picker--inputs input:focus{outline:none}.date-range-picker--container .rdp-day{max-width:unset;width:100%}.date-range-picker--container .rdp-head{box-shadow:0 5px 4px -2px rgba(0,0,0,.102)}.date-range-picker--container .rdp-head:before,.date-range-picker--container .rdp-tbody:before{content:\"‌\";display:block;line-height:1em}.date-range-picker--container .rdp:not([dir=rtl]) .rdp-cell:has(.rdp-day_range_start:not(.rdp-day_range_end)){background-color:var(--color-secondary-light2)!important;border-bottom-left-radius:50%;border-top-left-radius:50%;padding:3px}.date-range-picker--container .rdp:not([dir=rtl]) .rdp-cell:has(.rdp-day_range_start:not(.rdp-day_range_end)) .rdp-day_range_start{border-radius:50%;height:100%;width:100%}.date-range-picker--container .rdp:not([dir=rtl]) .rdp-cell:has(.rdp-day_range_end:not(.rdp-day_range_start)){background-color:var(--color-secondary-light2)!important;border-bottom-right-radius:50%;border-top-right-radius:50%;padding:3px}.date-range-picker--container .rdp:not([dir=rtl]) .rdp-cell:has(.rdp-day_range_end:not(.rdp-day_range_start)) .rdp-day_range_end{border-radius:50%;height:100%;width:100%}.date-range-picker--container .rdp:not([dir=rtl]) .rdp-day_range_middle>p{color:var(--color-secondary-dark2)}.date-range-picker--container .date-range-picker--footer-buttons{align-items:center;display:flex;justify-content:space-between}";
styleInject(css_248z$t);

var MONTHS = [
    'JAN',
    'FEV',
    'MAR',
    'ABR',
    'MAI',
    'JUN',
    'JUL',
    'AGO',
    'SET',
    'OUT',
    'NOV',
    'DEZ',
];
var WEEKDAYS = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
/** Formats the displayed month and year */
var formatCaption = function (date) { return (React__default.createElement(Typography, { variant: "body4", className: "date-range-picker--header" }, "".concat(MONTHS[date.getMonth()], " ").concat(date.getFullYear()))); };
/** Formats the head-row of weekdays */
var formatWeekdayName = function (date) { return (React__default.createElement(Typography, { variant: "body3", className: "date-range-picker--weekday-name" }, WEEKDAYS[date.getDay()])); };
/** Formats the text of each day-cell */
var formatDay = function (date) { return (React__default.createElement(Typography, { variant: "body3", className: [0, 6].includes(date.getDay())
        ? 'date-range-picker--day-weekend'
        : 'date-range-picker--day' }, date.getDate())); };
function DateRangePicker(_a) {
    var _b, _c;
    var _d = _a.disableFooter, disableFooter = _d === void 0 ? false : _d, props = __rest(_a, ["disableFooter"]);
    var theme = useTheme();
    var _e = useState((_b = props.initialRange) !== null && _b !== void 0 ? _b : { from: undefined, to: undefined }), selectedRange = _e[0], setSelectedRange = _e[1];
    var _f = useState({
        from: selectedRange.from ? format(selectedRange.from, 'dd/MM/yyyy') : '',
        to: selectedRange.to ? format(selectedRange.to, 'dd/MM/yyyy') : '',
    }), inputValues = _f[0], setInputValues = _f[1];
    var _g = useState(''), errorMessage = _g[0], setErrorMessage = _g[1];
    /** Formats the input as dd/mm/aaaa */
    var formatDateInput = function (value) {
        return [
            value.replace(/\D/g, '').slice(0, 2), // Dia
            value.replace(/\D/g, '').slice(2, 4), // Mês
            value.replace(/\D/g, '').slice(4, 8), // Ano
        ]
            .filter(Boolean)
            .join('/');
    };
    var updateSelectedRange = function (newRange) {
        var _a;
        setSelectedRange(newRange);
        (_a = props.onRangeChange) === null || _a === void 0 ? void 0 : _a.call(props, newRange);
    };
    var handleInputChange = function (field, value) {
        var _a, _b;
        var formattedValue = formatDateInput(value);
        setInputValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = formattedValue, _a)));
        });
        if (formattedValue.length < 10) {
            updateSelectedRange(__assign(__assign({}, selectedRange), (_a = {}, _a[field] = undefined, _a)));
            setErrorMessage('');
            return;
        }
        var date = parse(formattedValue, 'dd/MM/yyyy', new Date());
        var updatedRange = __assign(__assign({}, selectedRange), (_b = {}, _b[field] = date, _b));
        if (updatedRange.from &&
            updatedRange.to &&
            isAfter(updatedRange.from, updatedRange.to)) {
            setErrorMessage('Data anterior maior que a data posterior');
            return;
        }
        if (!isValid(date)) {
            setErrorMessage('Data inválida');
            return;
        }
        updateSelectedRange(updatedRange);
        setErrorMessage('');
    };
    /** Synchronizes DayPicker selection with inputs */
    var handleSelect = function (range) {
        var _a;
        var updatedRange = range !== null && range !== void 0 ? range : { from: undefined, to: undefined };
        (_a = props.onRangeChange) === null || _a === void 0 ? void 0 : _a.call(props, updatedRange);
        updateSelectedRange(updatedRange);
        setInputValues({
            from: updatedRange.from ? format(updatedRange.from, 'dd/MM/yyyy') : '',
            to: updatedRange.to ? format(updatedRange.to, 'dd/MM/yyyy') : '',
        });
        setErrorMessage('');
    };
    var handleClearInputs = function () {
        updateSelectedRange({ from: undefined, to: undefined });
        setInputValues({ from: '', to: '' });
        setErrorMessage('');
        props.onSubmit({ from: undefined, to: undefined });
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        if (!errorMessage && selectedRange.from && selectedRange.to) {
            props.onSubmit(selectedRange);
        }
    };
    var isFormValid = selectedRange.from &&
        selectedRange.to &&
        !isAfter(selectedRange.from, selectedRange.to) &&
        !errorMessage;
    return (React__default.createElement("form", { className: "date-range-picker--container", onSubmit: handleSubmit },
        React__default.createElement("div", { className: "date-range-picker--input-area" },
            React__default.createElement(Typography, { variant: "body4", className: "date-range-picker--input-label" }, "Selecione ou digite"),
            React__default.createElement("div", { className: "date-range-picker--inputs" },
                React__default.createElement("input", { placeholder: "dd/mm/aaaa", type: "text", value: inputValues.from, onChange: function (e) { return handleInputChange('from', e.target.value); }, maxLength: 10 }),
                React__default.createElement(Typography, { variant: "body4" }, "-"),
                React__default.createElement("input", { placeholder: "dd/mm/aaaa", type: "text", value: inputValues.to, onChange: function (e) { return handleInputChange('to', e.target.value); }, maxLength: 10 })),
            errorMessage && (React__default.createElement(Typography, { variant: "body4", style: { color: theme.colors.status.negative[50] } }, errorMessage))),
        React__default.createElement(DayPicker, __assign({ selected: selectedRange, onSelect: handleSelect, locale: (_c = props.locale) !== null && _c !== void 0 ? _c : ptBR, mode: "range", formatters: { formatCaption: formatCaption, formatWeekdayName: formatWeekdayName, formatDay: formatDay }, modifiersStyles: {
                range_start: { backgroundColor: theme.colors.primary },
                range_middle: { backgroundColor: theme.colors.secondary[95] },
                range_end: { backgroundColor: theme.colors.primary },
            }, footer: !disableFooter && (React__default.createElement("div", { className: "date-range-picker--footer-buttons" },
                React__default.createElement(LinkButton, { variant: "default", onClick: handleClearInputs }, "Limpar"),
                React__default.createElement(Button$4, { variant: "primary", size: "small", type: "submit", disabled: !isFormValid }, "Aplicar"))) }, props))));
}

function DateRangeField(props) {
    var _a;
    var theme = useTheme();
    var _b = React__default.useState((_a = props.initialValue) !== null && _a !== void 0 ? _a : null), dateRange = _b[0], setDateRange = _b[1];
    var _c = React__default.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleSetDateRange = function (dateRange) {
        var newDateRange;
        if (!dateRange.from)
            newDateRange = null;
        else if (!dateRange.to)
            newDateRange = { from: dateRange.from, to: dateRange.from };
        else
            newDateRange = dateRange;
        setDateRange(newDateRange);
        props.onChange(newDateRange);
        if (newDateRange)
            handleClose();
    };
    var formattedDateRange = dateRange
        ? "".concat(formatDate(dateRange.from), " - ").concat(formatDate(dateRange.to))
        : '';
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TextField$1, { label: props.label, size: props.size, fullWidth: props.fullWidth, onClick: handleClick, value: formattedDateRange, InputProps: {
                endAdornment: (React__default.createElement(InputAdornment, { position: "end" },
                    React__default.createElement(Icons, { name: "IconCalendarEvent", fill: "transparent", size: 24, color: props.error
                            ? theme.colors.feedback.error[50]
                            : theme.colors.neutral[50] }))),
            }, disabled: props.disabled, error: props.error, helperText: props.helperText, required: props.required }),
        React__default.createElement(Popover, { open: Boolean(anchorEl) && !props.disabled, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            } },
            React__default.createElement("div", { style: { padding: '20px' } },
                React__default.createElement(DateRangePicker, __assign({}, props.pickerProps, { onSubmit: handleSetDateRange, initialRange: dateRange || undefined }))))));
}

var ComponentDivider = styled.div(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n  background: var(--color-neutral-light2);\n\n  ", "\n\n  ", "\n\n\n  ", "\n\n\n  ", "\n"], ["\n  background: var(--color-neutral-light2);\n\n  ", "\n\n  ", "\n\n\n  ", "\n\n\n  ", "\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'vertical' && 'width: 1px; height: 100%;';
}, function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal' && 'width: 100%; height: 1px;';
}, function (_a) {
    var appearAt = _a.appearAt;
    return appearAt &&
        "\n      display: none; \n      @media screen and (min-width: ".concat(appearAt, "px)  { \n        display: block; \n      }\n    ");
}, function (_a) {
    var removeAt = _a.removeAt;
    return removeAt &&
        "\n    @media screen and (min-width: ".concat(removeAt, "px) {\n        display: none;\n      }\n    ");
});
var Divider = function (props) {
    return React__default.createElement(ComponentDivider, __assign({}, props));
};
var DividerExample = function (props) {
    return (React__default.createElement("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
        } },
        React__default.createElement(Divider, __assign({}, props))));
};
var templateObject_1$T;

var css_248z$s = ".download-button-container{align-items:center;border:1px solid rgba(74,78,87,.2);border-radius:10px;display:flex;justify-content:space-evenly;padding:16px 24px}.download-button-container:hover{opacity:.75}.download-button-container .text-container{align-items:flex-start;display:flex;flex-direction:column;margin-left:16px;margin-right:16px;overflow:hidden}.download-button-container .title-text{font-size:18px;font-weight:700;line-height:30px;text-align:left}.download-button-container .subtitle-text{font-size:14px;font-weight:400;line-height:22px;max-width:175px;overflow:hidden;text-align:left;text-overflow:ellipsis;white-space:nowrap}";
styleInject(css_248z$s);

var DownloadButton = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Baixar' : _b, fileName = _a.fileName, filePath = _a.filePath, _c = _a.icon, icon = _c === void 0 ? 'IconCloudDownload' : _c, _d = _a.style, style = _d === void 0 ? {} : _d, onClick = _a.onClick, classes = _a.classes, docIconSize = _a.docIconSize, rest = __rest(_a, ["title", "fileName", "filePath", "icon", "style", "onClick", "classes", "docIconSize"]);
    var renderIconDownload = function () {
        if (fileName.match(/xls|xlsx/))
            return (React__default.createElement(Icons, { name: 'XLSXDownload', width: docIconSize, height: docIconSize }));
        if (fileName.match(/csv/))
            return (React__default.createElement(Icons, { name: 'CSVDownload', width: docIconSize, height: docIconSize }));
        if (fileName.match(/txt/))
            return (React__default.createElement(Icons, { name: 'TXTDownload', width: docIconSize, height: docIconSize }));
        if (fileName.match(/docx/))
            return (React__default.createElement(Icons, { name: 'WordDownload', width: docIconSize, height: docIconSize }));
        if (fileName.match(/pdf/))
            return (React__default.createElement(Icons, { name: 'PDFDownload', width: docIconSize, height: docIconSize }));
        if (fileName.match(/png|jpeg|jpg/))
            return (React__default.createElement(Icons, { name: 'ImageDownload', width: docIconSize, height: docIconSize }));
        return (React__default.createElement(Icons, { name: 'DefaultDownload', width: docIconSize, height: docIconSize }));
    };
    return (React__default.createElement("button", __assign({ className: "download-button-container ".concat(classes), onClick: function (event) {
            if (filePath)
                window.open(filePath, '_blank');
            if (event && onClick)
                onClick(event);
        }, style: style || {} }, rest),
        renderIconDownload(),
        React__default.createElement("div", { className: "text-container" },
            React__default.createElement("p", { className: "title-text" }, title),
            React__default.createElement("p", { className: "subtitle-text" }, (fileName === null || fileName === void 0 ? void 0 : fileName.length) > 16 ? "".concat(fileName.slice(0, 16), "...") : fileName)),
        React__default.createElement(Icons, { name: icon, fill: "none", size: 24 })));
};

var Container$p = styled.div(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  height: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  height: 20px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var Bar = styled.progress(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  width: 100%;\n  height: 8px;\n\n  ::-webkit-progress-bar {\n    border-radius: 5px;\n    background-color: ", ";\n  }\n\n  ::-webkit-progress-value {\n    border-radius: 5px;\n    background-color: ", ";\n  }\n"], ["\n  width: 100%;\n  height: 8px;\n\n  ::-webkit-progress-bar {\n    border-radius: 5px;\n    background-color: ", ";\n  }\n\n  ::-webkit-progress-value {\n    border-radius: 5px;\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral90;
}, function (_a) {
    var $color = _a.$color;
    return $color;
});
var templateObject_1$S, templateObject_2$A;

var ProgressBar = function (props) {
    var _a;
    var theme = useTheme();
    var progress = (_a = props.progress) !== null && _a !== void 0 ? _a : 0;
    if (progress < 0) {
        console.warn('ProgressBar: progress should not be less than 0');
        progress = 0;
    }
    else if (progress > 100) {
        console.warn('ProgressBar: progress should not be greater than 100');
        progress = 100;
    }
    var colorMap = {
        default: theme.colors.secondary50,
        error: theme.colors.error40,
        success: theme.colors.success40,
    };
    return (React__default.createElement(Container$p, null,
        React__default.createElement(Bar, { role: "progressbar", value: progress, "$color": props.variant ? colorMap[props.variant] : colorMap.default, "aria-valuenow": progress, "aria-valuemin": 0, "aria-valuemax": 100, max: 100 }),
        !(props === null || props === void 0 ? void 0 : props.hideLabel) && (React__default.createElement(Typography, { tag: "span", variant: "body4", weight: 400, variantColor: colorMap[props.variant] }, "".concat(progress, "%")))));
};

var css_248z$r = ".dropzone{align-items:center;background-color:var(--color-secondary-light1);border:1px solid var(--color-secondary-light5);border-radius:10px;cursor:pointer;display:flex;height:100%;justify-content:center;width:100%}.dropzone .dropzone-file-input{height:0;opacity:0;width:0}.dropzone:hover{background-color:var(--color-secondary-light2);border-color:var(--color-secondary-light2);box-shadow:0 0 .1px 2px var(--color-primary)}.dropzone .dropzone-children-container{align-items:center;display:flex;height:100%;justify-content:center;pointer-events:none;width:100%}.dropzone .dropzone-default-children-container{align-items:center;display:flex;flex-direction:column;justify-content:center;width:100%}.dropzone .dropzone-default-children-container p{color:var(--color-neutral-light5);font-weight:500;margin-bottom:5px}.dropzone .dropzone-default-children-container .dropzone-file-container{align-items:center;display:flex;flex-direction:column;justify-content:center;margin-bottom:25px;width:100%}.dropzone .dropzone-default-children-container .dropzone-file-container:last-child{margin-bottom:0}.dropzone .dropzone-default-children-container #dropzone-guide-text{color:var(--color-neutral-30);font-weight:400;margin-top:25px}.dropzone .dropzone-default-children-container .dropzone-file-extension{color:var(--color-neutral-30);font-weight:600;text-align:center}.dropzone .dropzone-default-children-container .dropzone-file-name{color:var(--color-neutral-dark2);font-weight:700;overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:nowrap;width:100%}.dropzone .dropzone-default-children-container .dropzone-file-name-error{color:var(--color-neutral-dark3);font-weight:700;overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:nowrap;width:100%}.dropzone .dropzone-default-children-container .dropzone-text-container{align-items:center;display:flex;flex-direction:column;justify-content:flex-start}@media screen and (max-width:992px){.dropzone .dropzone-default-children-container .dropzone-text-container{align-items:center;justify-content:center}}.dropzone .dropzone-default-children-container .dropzone-select-file-container{align-items:center;border-bottom:2px solid var(--color-secondary-50);display:inline-flex;padding-bottom:2px}.dropzone .dropzone-default-children-container .dropzone-select-file-container>p{margin-left:2px}.dropzone .dropzone-default-children-container .dropzone-select-file-container-error{align-items:center;border-bottom:2px solid var(--color-feedback-attention-40);display:inline-flex;padding-bottom:2px}.dropzone .dropzone-default-children-container .dropzone-select-file-container-error>p{margin-left:2px}.dropzone .dropzone-default-children-container .dropzone-icon{align-items:center;background-color:var(--color-secondary-light2);border-radius:500px;display:inline-flex;justify-content:center;margin-bottom:20px;padding:10px}.dropzone .dropzone-default-children-container .dropzone-error-icon{align-items:center;background-color:var(--color-feedback-error-light1);border-radius:500px;display:inline-flex;justify-content:center;margin-bottom:20px;padding:10px}.dropzone .dropzone-default-children-container .dropzone-link,.dropzone .dropzone-default-children-container .dropzone-strong-text{color:var(--color-secondary-50);font-weight:700;margin-bottom:0}.dropzone .dropzone-default-children-container .dropzone-title-error{color:var(--color-neutral-dark3);font-weight:700;margin-bottom:0}.dropzone .dropzone-default-children-container .dropzone-link{border-bottom:2px solid var(--color-secondary-50)}.dropzone .dropzone-default-children-container .dropzone-link-error{color:var(--color-feedback-attention-40);font-weight:700;margin-bottom:0}.dropzone-error{background-color:#fff;border:1px solid var(--color-feedback-error-pure)}.dropzone-error:hover{background-color:#fff;border-color:var(--color-feedback-error-pure);box-shadow:0 0 .1px 2px var(--color-feedback-error-pure)}.dropzone-focus{background-color:var(--color-secondary-light2);border-color:var(--color-primary);box-shadow:0 0 .1px 2px var(--color-primary)}.dropzone-error-focus{background-color:#fff;border-color:var(--color-feedback-error-pure);box-shadow:0 0 .1px 2px var(--color-feedback-error-pure)}.dropzone-padding{padding:50px}";
styleInject(css_248z$r);

function Dropzone$1(_a) {
    var accept = _a.accept, _b = _a.error, error = _b === void 0 ? false : _b, multiple = _a.multiple, onDrop = _a.onDrop, onFileSizeError = _a.onFileSizeError, title = _a.title, files = _a.files, maxSize = _a.maxSize, infoContent = _a.infoContent, maxNumberOfFiles = _a.maxNumberOfFiles;
    var _c = useState(false), dragging = _c[0], setDraggind = _c[1];
    var acceptFiles = useMemo(function () {
        return (accept === null || accept === void 0 ? void 0 : accept.reduce(function (a, c, i) { return a + ".".concat(c).concat(++i < (accept === null || accept === void 0 ? void 0 : accept.length) ? ',' : ''); }, '')) || '*';
    }, [accept]);
    var acceptFilesDescription = useMemo(function () {
        return accept === null || accept === void 0 ? void 0 : accept.reduce(function (a, c, i) {
            return a + "".concat(c.toUpperCase()).concat(++i < (accept === null || accept === void 0 ? void 0 : accept.length) ? ', ' : '');
        }, 'Formatos permitidos: ');
    }, [accept]);
    var asError = useMemo(function () { return error || !!(files === null || files === void 0 ? void 0 : files.find(function (_a) {
        var error = _a.error;
        return error;
    })); }, [error, files]);
    var showFileLimitMessage = multiple && maxNumberOfFiles && maxNumberOfFiles > 1;
    return (React__default.createElement("label", { className: "dropzone dropzone-padding ".concat(dragging ? (asError ? 'dropzone-error-focus' : 'dropzone-focus') : '', " ").concat(asError ? 'dropzone-error' : ''), onDrop: function (e) {
            var _a, _b, _c, _d, _e, _f;
            e.preventDefault();
            var newFiles = (_b = Object.values((_a = e === null || e === void 0 ? void 0 : e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files)) === null || _b === void 0 ? void 0 : _b.map(function (file) {
                var _a;
                if (maxSize && (file === null || file === void 0 ? void 0 : file.size) > maxSize) {
                    onFileSizeError && onFileSizeError();
                    return { error: true, file: file };
                }
                if (!(accept === null || accept === void 0 ? void 0 : accept.length))
                    return { error: false, file: file };
                var splitedNameFile = (_a = file === null || file === void 0 ? void 0 : file.name) === null || _a === void 0 ? void 0 : _a.split('.');
                var fileExtension = splitedNameFile[(splitedNameFile === null || splitedNameFile === void 0 ? void 0 : splitedNameFile.length) - 1];
                if (accept.includes(fileExtension))
                    return { error: false, file: file };
                return { error: true, file: file };
            });
            var acceptedFiles = (_c = newFiles === null || newFiles === void 0 ? void 0 : newFiles.filter(function (_a) {
                var error = _a.error;
                return !error;
            })) === null || _c === void 0 ? void 0 : _c.map(function (_a) {
                var file = _a.file;
                return file;
            });
            var rejectedFiles = (_d = newFiles === null || newFiles === void 0 ? void 0 : newFiles.filter(function (_a) {
                var error = _a.error;
                return error;
            })) === null || _d === void 0 ? void 0 : _d.map(function (_a) {
                var file = _a.file;
                return file;
            });
            if (((_e = __spreadArray(__spreadArray([], acceptedFiles, true), rejectedFiles, true)) === null || _e === void 0 ? void 0 : _e.length) && onDrop) {
                if (!multiple && ((_f = files === null || files === void 0 ? void 0 : files.filter(function (_a) {
                    var error = _a.error;
                    return !error;
                })) === null || _f === void 0 ? void 0 : _f.length))
                    return;
                onDrop({
                    acceptedFiles: multiple
                        ? acceptedFiles
                        : (acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.length)
                            ? [acceptedFiles[0]]
                            : [],
                    rejectedFiles: multiple
                        ? rejectedFiles
                        : (rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length)
                            ? [rejectedFiles[0]]
                            : [],
                });
            }
        }, onDragOver: function (e) { return e.preventDefault(); }, onDragLeave: function () { return setDraggind(false); }, onMouseLeave: function () { return setDraggind(false); }, onDragEnter: function () { return setDraggind(true); } },
        React__default.createElement("input", { className: "dropzone-file-input", type: "file", value: '', onChange: function (e) {
                var _a, _b, _c;
                if (((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) && onDrop) {
                    var currentFiles_1 = (_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.files;
                    var fileArray_1 = [];
                    var hasFileSizeExceeded_1 = false;
                    Object.keys(currentFiles_1).map(function (key) {
                        var found = currentFiles_1[key];
                        if (maxSize && found.size > maxSize) {
                            hasFileSizeExceeded_1 = true;
                            return;
                        }
                        fileArray_1.push(found);
                    });
                    if (hasFileSizeExceeded_1)
                        onFileSizeError && onFileSizeError();
                    onDrop({
                        acceptedFiles: __spreadArray([], Object.values(fileArray_1), true),
                        rejectedFiles: [],
                    });
                }
            }, multiple: !!multiple, accept: acceptFiles }),
        React__default.createElement("div", { className: "dropzone-children-container" },
            React__default.createElement("div", { className: "dropzone-default-children-container" },
                asError ? (React__default.createElement(Icons, { name: 'IconCloudUpload', fill: "transparent", color: "var(--color-feedback-error-dark1)", size: 64, className: "dropzone-error-icon" })) : (React__default.createElement(Icons, { name: (files === null || files === void 0 ? void 0 : files.length) ? 'IconFileDescription' : 'IconCloudUpload', fill: (files === null || files === void 0 ? void 0 : files.length) ? 'var(--color-secondary-light3)' : 'transparent', color: 'var(--color-secondary-50)', size: 64, className: "dropzone-icon" })),
                files && (files === null || files === void 0 ? void 0 : files.length) ? (files === null || files === void 0 ? void 0 : files.map(function (file, i) { return (React__default.createElement("div", { key: i, className: "dropzone-file-container" },
                    React__default.createElement(Typography, { variant: "body3", className: error ? 'dropzone-file-name-error' : 'dropzone-file-name' }, file === null || file === void 0 ? void 0 : file.name),
                    React__default.createElement(Typography, { variant: "body3" }, (file === null || file === void 0 ? void 0 : file.error)
                        ? 'Erro no envio do seu arquivo.'
                        : (file === null || file === void 0 ? void 0 : file.loaded)
                            ? 'Arquivo enviado com sucesso!'
                            : 'Enviando arquivo...'),
                    (file === null || file === void 0 ? void 0 : file.error) ? (!multiple ? (React__default.createElement(Typography, { variant: "body3", className: "dropzone-strong-text dropzone-link" }, "Tente novamente")) : null) : (React__default.createElement(ProgressBar, { variant: "default", progress: (file === null || file === void 0 ? void 0 : file.progress) || 0 })))); })) : (React__default.createElement("div", { className: "dropzone-text-container" },
                    title ? (React__default.createElement(Typography, { variant: "body3", className: error ? 'dropzone-title-error ' : 'dropzone-strong-text' }, title)) : null,
                    (accept === null || accept === void 0 ? void 0 : accept.length) ? (React__default.createElement(Typography, { variant: "body3", className: "dropzone-file-extension" }, acceptFilesDescription)) : null,
                    showFileLimitMessage && (React__default.createElement(Typography, { variant: "body3", className: "dropzone-file-extension" },
                        "Voc\u00EA pode enviar at\u00E9 ",
                        maxNumberOfFiles,
                        " arquivos.")),
                    infoContent ? (typeof infoContent === 'string' ? (React__default.createElement(Typography, { variant: "body3" }, infoContent)) : (infoContent)) : null,
                    React__default.createElement(Typography, { variant: "body3", id: "dropzone-guide-text" }, "Arraste e solte aqui, ou"),
                    React__default.createElement("div", { className: error
                            ? 'dropzone-select-file-container-error '
                            : 'dropzone-select-file-container' },
                        React__default.createElement(Icons, { name: "IconFileUpload", size: 30, fill: 'transparent', color: error
                                ? 'var(--color-feedback-error-dark1)'
                                : 'var(--color-secondary-50)' }),
                        React__default.createElement(Typography, { variant: "body3", className: error ? 'dropzone-link-error' : 'dropzone-strong-text' }, "Selecione seu arquivo"))))))));
}

var css_248z$q = ".dropzone-file-item{align-items:center;background-color:var(--color-secondary-light1);border:1px solid var(--color-secondary-light4);border-radius:10px;color:var(--color-neutral-dark2);display:flex;font-weight:700;justify-content:space-between;line-height:22px;padding:32px 40px;width:100%}.dropzone-file-item:hover{border-color:var(--color-primary)}.dropzone-file-item .dropzone-file-item-content{align-items:center;display:flex;justify-content:flex-start;width:calc(100% - 50px)}.dropzone-file-item .dropzone-file-item-name-container{font-weight:700;max-width:calc(100% - 100px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dropzone-file-item .dropzone-file-item-image{align-items:center;background-position:50%;background-repeat:no-repeat;background-size:cover;border:1px solid transparent;display:flex;height:48px;justify-content:center;margin-right:10px;overflow:hidden;width:71px}.dropzone-file-item .dropzone-file-item-icon-container{border:1px solid var(--color-secondary-light4);border-radius:30px;cursor:pointer;padding:10px 10px 7px}.dropzone-file-item .dropzone-file-item-icon-container:hover{border-color:var(--color-primary)}.dropzone-file-item-error{background-color:var(--color-feedback-error-light1);border:1px solid var(--color-feedback-error-pure)}.dropzone-file-item-error:hover{border-color:var(--color-feedback-error-dark1)}.dropzone-file-item-error .dropzone-file-item-icon-container{border:1px solid var(--color-feedback-error-pure)}.dropzone-file-item-error .dropzone-file-item-icon-container:hover{border-color:var(--color-feedback-error-dark1)}";
styleInject(css_248z$q);

function FileItem(_a) {
    var name = _a.name, image = _a.image, progress = _a.progress, customPreview = _a.customPreview, error = _a.error, onClick = _a.onClick;
    if (customPreview)
        return customPreview({ name: name, image: image, progress: progress, error: error, onClick: onClick });
    return (React__default.createElement("div", { className: "dropzone-file-item ".concat(error ? 'dropzone-file-item-error' : '') },
        React__default.createElement("div", { className: "dropzone-file-item-content" },
            React__default.createElement("div", { style: {
                    backgroundImage: "url(\"".concat(image, "\")"),
                    borderColor: !image
                        ? error
                            ? 'var(--color-feedback-error-pure)'
                            : 'var(--color-secondary-light4)'
                        : undefined,
                }, className: "dropzone-file-item-image" }, image ? null : (React__default.createElement(Icons, { name: "IconFileDescription", fill: error
                    ? 'var(--color-feedback-error-light1)'
                    : 'var(--color-secondary-light2)', color: error
                    ? 'var(--color-feedback-error-pure)'
                    : 'var(--color-secondary-light4)', size: 20, className: "dropzone-icon" }))),
            React__default.createElement(Typography, { variant: "body3", className: "dropzone-file-item-name-container" }, name)),
        progress === 100 ? (React__default.createElement(PillButton, { size: "large", variant: error ? 'default' : 'pink', onClick: onClick, icon: "IconTrash" })) : null));
}

var css_248z$p = ".dropzone-main-container{width:100%}.dropzone-main-container .dropzone-file-item{margin-top:15px}";
styleInject(css_248z$p);

function Dropzone(_a) {
    var title = _a.title, multiple = _a.multiple, accept = _a.accept, customPreview = _a.customPreview, className = _a.className, style = _a.style, onChange = _a.onChange, onFileSizeError = _a.onFileSizeError, onRemove = _a.onRemove, maxNumberOfFiles = _a.maxNumberOfFiles, maxSize = _a.maxSize, infoContent = _a.infoContent, initialFiles = _a.initialFiles, _b = _a.disableFileName, disableFileName = _b === void 0 ? false : _b, error = _a.error;
    var _c = useState(initialFiles || []), files = _c[0], setFiles = _c[1];
    function addFile(file) {
        var fileAlreadyExist = files.some(function (_a) {
            var id = _a.id;
            return id === file.id;
        });
        if (!fileAlreadyExist) {
            setFiles(function (prevFiles) {
                var files = multiple ? __spreadArray(__spreadArray([], prevFiles, true), [file], false) : [file];
                if (file.loaded) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(files);
                }
                return files;
            });
        }
    }
    var loadedFiles = useMemo(function () { return files.filter(function (_a) {
        var loaded = _a.loaded;
        return loaded;
    }); }, [files]);
    var canUploadMore = maxNumberOfFiles
        ? files.length < maxNumberOfFiles
        : true;
    var showDropzoneInput = multiple ? canUploadMore : files.length === 0;
    var generateFileId = function (fileName) {
        return "".concat(new Date().getTime(), "-").concat(fileName);
    };
    var removeFile = function (fileId) {
        var currentFiles = files.filter(function (_a) {
            var id = _a.id;
            return id !== fileId;
        });
        if (!(currentFiles === null || currentFiles === void 0 ? void 0 : currentFiles.length) && onChange)
            onChange([]);
        setFiles(__spreadArray([], currentFiles, true));
    };
    function readFile(file) {
        var _a;
        var fileId = generateFileId(file === null || file === void 0 ? void 0 : file.name);
        var reader = new FileReader();
        reader.onprogress = function (e) {
            var currentProgress = Math.round((e.loaded / e.total) * 100);
            if (currentProgress < 100) {
                addFile({
                    id: fileId,
                    progress: currentProgress,
                    loaded: false,
                    error: false,
                    file: file,
                    mime: "data:".concat(file.type, ";base64,"),
                });
            }
        };
        reader.onloadend = function (e) {
            var _a;
            addFile({
                id: fileId,
                progress: 100,
                data: (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.result,
                loaded: true,
                error: false,
                file: file,
                mime: "data:".concat(file.type, ";base64,"),
            });
        };
        reader.onerror = function () {
            addFile({
                id: fileId,
                progress: 0,
                loaded: false,
                error: true,
                file: file,
                mime: "data:".concat(file.type, ";base64,"),
            });
        };
        ((_a = file === null || file === void 0 ? void 0 : file.type) === null || _a === void 0 ? void 0 : _a.includes('image'))
            ? reader.readAsDataURL(file)
            : reader.readAsArrayBuffer(file);
    }
    var onDropFiles = function (newFiles) {
        var _a, _b, _c;
        if (maxNumberOfFiles &&
            files.length + newFiles.acceptedFiles.length > maxNumberOfFiles) {
            return;
        }
        if ((_a = newFiles === null || newFiles === void 0 ? void 0 : newFiles.rejectedFiles) === null || _a === void 0 ? void 0 : _a.length) {
            var newRejectedFiles = (_b = newFiles === null || newFiles === void 0 ? void 0 : newFiles.rejectedFiles) === null || _b === void 0 ? void 0 : _b.map(function (file) { return ({
                id: generateFileId(file === null || file === void 0 ? void 0 : file.name),
                progress: 0,
                loaded: false,
                error: true,
                file: file,
            }); });
            setFiles(multiple ? __spreadArray(__spreadArray([], files, true), newRejectedFiles, true) : newRejectedFiles);
        }
        (_c = newFiles === null || newFiles === void 0 ? void 0 : newFiles.acceptedFiles) === null || _c === void 0 ? void 0 : _c.forEach(function (newFile) { return readFile(newFile); });
    };
    return (React__default.createElement("div", { className: "dropzone-main-container ".concat(className), style: style },
        showDropzoneInput && (React__default.createElement(Dropzone$1, { error: error, maxSize: maxSize, title: title, infoContent: infoContent, accept: accept, multiple: multiple, onFileSizeError: onFileSizeError, onDrop: onDropFiles, files: files === null || files === void 0 ? void 0 : files.map(function (_a) {
                var file = _a.file, rest = __rest(_a, ["file"]);
                return (__assign({ name: file === null || file === void 0 ? void 0 : file.name }, rest));
            }), maxNumberOfFiles: maxNumberOfFiles })),
        loadedFiles.map(function (_a, i) {
            var id = _a.id, file = _a.file, data = _a.data, progress = _a.progress, loaded = _a.loaded, uploadError = _a.error;
            return (React__default.createElement(FileItem, { key: i, name: (!disableFileName && (file === null || file === void 0 ? void 0 : file.name)) || '', image: typeof data === 'string' && (data === null || data === void 0 ? void 0 : data.includes('image')) ? data : '', customPreview: customPreview, progress: progress, error: error || uploadError, onClick: function () {
                    if (onRemove)
                        onRemove(id);
                    if (id && loaded)
                        removeFile(id);
                } }));
        })));
}

var _path$1, _path2$1, _path3$1, _path4$1, _path5$1, _path6$1, _path7$1, _path8$1, _path9$1, _g, _path10$1, _path11, _path12, _path13, _path14, _defs;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgEmptyState = function SvgEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 156,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4E57",
    strokeLinecap: "round",
    strokeOpacity: 0.3,
    strokeWidth: 1.562,
    d: "M6.142 71.688v1.604M2.538 72.557l1.311 1.35M1.005 76.148h1.854M2.389 79.805l1.31-1.35M6.142 80.243V78.64M8.816 79.173l-1.07-1.07M10.954 76.5H9.35M9.885 72.756l-1.07 1.07M92.243 1.629v1.07M89.034 4.838h1.07M92.243 8.046v-1.07M94.917 4.838h-1.07M30.207 46.55v1.605M25.394 51.365h1.604M30.207 55.643V54.04M34.485 51.365h-1.604M145.324 104.865a2.316 2.316 0 1 1-2.314 2.315"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M155.917 83.861c1.374-.428 3.481-2.11 3.969-3.918.442 1.599 2.296 3.49 3.968 3.633-1.883.666-3.683 2.647-3.968 4.203-.195-1.586-2.685-3.687-3.969-3.918M14.845 104.152c.687-.214 1.74-1.054 1.984-1.959.22.799 1.148 1.745 1.984 1.816-.941.333-1.841 1.324-1.984 2.102-.097-.793-1.342-1.844-1.984-1.959",
    clipRule: "evenodd"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M27.601 29.758a1.795 1.795 0 1 1-3.59 0 1.795 1.795 0 0 1 3.59 0",
    clipRule: "evenodd"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M147.445 34.579a3 3 0 1 1-6 0 3 3 0 0 1 6 0M188.996 26.449a2.38 2.38 0 1 1-4.759.001 2.38 2.38 0 0 1 4.759-.002",
    clipRule: "evenodd"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4E57",
    strokeLinecap: "round",
    strokeOpacity: 0.3,
    strokeWidth: 1.562,
    d: "M61.142 137.61a1.5 1.5 0 1 1-2.999 0 1.5 1.5 0 0 1 3 0ZM60.25 18.225a1.795 1.795 0 1 1-3.59 0 1.795 1.795 0 0 1 3.59 0ZM106.03 154.226a2.223 2.223 0 1 1-1.58-4.156 2.223 2.223 0 0 1 1.58 4.156Z",
    clipRule: "evenodd"
  })), _path6$1 || (_path6$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    fillRule: "evenodd",
    d: "M105.347 111.796H61.491c-3.086 0-5.613-2.535-5.613-5.632v-62.54c0-3.097 2.527-5.63 5.613-5.63h43.856c3.088 0 5.615 2.533 5.615 5.63v62.54c0 3.097-2.527 5.632-5.615 5.632",
    clipRule: "evenodd"
  })), _path7$1 || (_path7$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M101.603 114.469H57.747c-3.087 0-5.613-2.534-5.613-5.631v-62.54c0-3.097 2.526-5.63 5.613-5.63h43.856c3.088 0 5.615 2.533 5.615 5.63v62.54c0 3.097-2.527 5.631-5.615 5.631",
    clipRule: "evenodd"
  })), _path8$1 || (_path8$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4E57",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M97.962 116.58H54.016c-3.093 0-5.625-2.524-5.625-5.608V48.691c0-3.085 2.532-5.607 5.625-5.607h43.946c3.094 0 5.626 2.522 5.626 5.607v62.281c0 3.084-2.532 5.608-5.626 5.608",
    clipRule: "evenodd"
  })), _path9$1 || (_path9$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M97.962 116.58H54.016c-3.093 0-5.625-2.524-5.625-5.608V48.691c0-3.085 2.532-5.607 5.625-5.607h43.946c3.094 0 5.626 2.522 5.626 5.607v62.281c0 3.084-2.532 5.608-5.626 5.608",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4A4E57",
    fillOpacity: 0.5,
    clipPath: "url(#empty-state_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.793 63.762a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M67.793 66.012c-3.006 0-9 1.512-9 4.5v1.125a1.125 1.125 0 0 0 1.125 1.125h15.75a1.125 1.125 0 0 0 1.125-1.125v-1.125c0-2.988-5.994-4.5-9-4.5"
  }))), _path10$1 || (_path10$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    fillRule: "evenodd",
    d: "M91.628 81.312h-32.46c-.927 0-1.686-.722-1.686-1.603 0-.882.76-1.606 1.686-1.606h32.46c.927 0 1.686.724 1.686 1.606 0 .881-.76 1.603-1.686 1.603M91.628 90.94h-32.46c-.927 0-1.686-.723-1.686-1.605 0-.883.76-1.604 1.686-1.604h32.46c.927 0 1.686.721 1.686 1.605 0 .881-.76 1.603-1.686 1.603M76.112 100.564H59.175c-.93 0-1.693-.722-1.693-1.603 0-.884.763-1.605 1.693-1.605h16.937c.93 0 1.693.721 1.693 1.605 0 .881-.763 1.603-1.693 1.603",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M110.296 88.125c-6.49 6.49-16.539 7.221-23.833 2.21a19.681 19.681 0 0 1-2.648-2.21 17.998 17.998 0 0 1-3.168-4.243 17.887 17.887 0 0 1-1.963-5.415c-1.146-5.897.568-12.245 5.131-16.807 4.575-4.575 10.924-6.277 16.822-5.142a18.512 18.512 0 0 1 5.416 1.962 18.857 18.857 0 0 1 2.908 1.975c.46.377.899.78 1.323 1.205a18.647 18.647 0 0 1 2.212 2.647c5.012 7.292 4.279 17.34-2.2 23.818",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    fillRule: "evenodd",
    d: "M108.48 86.846c-6.752 6.754-17.696 6.752-24.45 0-6.745-6.745-6.745-17.69.01-24.442 6.744-6.745 17.688-6.745 24.433 0 6.752 6.752 6.752 17.697.007 24.442m3.466-27.912c-8.668-8.667-22.713-8.667-31.381 0-8.666 8.667-8.674 22.721-.007 31.389 7.888 7.886 20.252 8.597 28.949 2.122a22.643 22.643 0 0 0 2.448-2.122 22.392 22.392 0 0 0 2.121-2.448c6.474-8.698 5.757-21.053-2.13-28.94M146.056 122.995l-.364.364c-2.408 2.408-6.35 2.408-8.758 0l-22.229-22.229 9.122-9.122 22.229 22.228c2.408 2.409 2.408 6.35 0 8.759",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBDCDD",
    fillRule: "evenodd",
    d: "m114.555 87.195 6.568 6.569-4.663 4.662-6.567-6.569a23.13 23.13 0 0 0 2.497-2.165c.795-.795 1.52-1.63 2.165-2.497",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CACD",
    fillRule: "evenodd",
    d: "m145.723 113.963-9.064 9.063-1.632-1.633 9.063-9.063zM124.332 92.323l-9.313 9.312-1.383-1.383 9.312-9.312z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-state_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.793 51.762h24v24h-24z"
  })))));
};

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPageError = function SvgPageError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 250,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED3489",
    d: "M165.286 178.278c-.089.596-.188 1.381-.336 2.146-.109.546-.367 1.062-.427 1.599-.089.933-.555 1.619-1.169 2.274-1.635 1.719-3.241 3.477-4.886 5.205-5.579 5.85-11.218 11.65-16.758 17.53-6.68 7.102-13.409 14.153-19.881 21.454-1.159 1.301-2.438 2.502-3.617 3.784-1.447 1.569-2.983 3.059-3.895 5.045-.158.348-.456.646-.723.944a91.125 91.125 0 0 1-6.997 7.121c-1.09.993-2.289 1.689-3.776 1.798-.852.059-1.635.516-2.557.228-1.338-.417-2.349-1.102-3.161-2.304a6369.331 6369.331 0 0 0-23.835-34.981c-7.135-10.389-14.34-20.729-21.495-31.098-3.33-4.827-6.6-9.693-9.91-14.54-7.949-11.651-15.917-23.301-23.865-34.962-2.943-4.32-5.867-8.66-8.8-12.991-.397-.586-.744-1.251-1.25-1.728-1.585-1.5-2.447-3.496-3.686-5.224-1.02-1.431-.991-3.159-1.19-4.778-.098-.804.258-1.708 1.09-2.254.457-.298.873-.696 1.23-1.103a12.597 12.597 0 0 1 4.32-3.267c2.3-1.063 4.55-2.215 6.839-3.298 2.438-1.162 4.707-2.592 7.056-3.903a424.276 424.276 0 0 1 11.08-5.96 478.021 478.021 0 0 1 10.812-5.433c1.705-.834 3.489-1.5 5.223-2.264a287.886 287.886 0 0 0 13.914-6.645c2.33-1.182 4.668-2.334 6.987-3.516.634-.317 1.259-.655 1.843-1.062 1.001-.696 2.18-.904 3.29-1.292.209-.07.466-.04.694 0 .932.17 1.864.318 2.775.557.486.129.892.208 1.348-.06.872-.507 1.497-.08 2.032.606 1.06 1.38 2.15 2.751 3.171 4.161 8.097 11.065 16.184 22.14 24.281 33.204 5.004 6.843 9.979 13.716 15.024 20.529 3.151 4.271 6.432 8.453 9.395 12.863.743 1.112 1.714 2.066 2.596 3.079a149.33 149.33 0 0 1 8.741 10.965c2.835 3.913 5.63 7.856 8.444 11.789.278.388.575.755.882 1.123 3.122 3.595 5.837 7.498 8.414 11.491.615.904.436 1.977.733 3.168M76.549 71.348c-1.418-.297-2.696.279-3.965.974-.892.497-1.783 1.073-2.755 1.34-1.1.309-2.041.855-2.983 1.401-1.615.944-2.339 2.642-1.893 4.44.159.626.228 1.242.228 1.877.02 1.44-.456 2.593-1.665 3.486-1.15.855-2.279 1.709-3.528 2.414-1.585.894-3.23 1.688-4.786 2.622-3.935 2.364-7.84 4.787-11.764 7.171-.605.368-1.239.705-1.873 1.023-1.497.745-2.973.944-4.43-.11-.575-.416-1.19-.774-1.794-1.161-1.2-.765-2.408-1.52-3.607-2.285-.516-.327-1.011-.387-1.546-.03-1.794 1.172-3.776 1.957-5.689 2.9-2.547 1.272-5.044 2.653-7.512 4.073-1.506.874-2.943 1.877-4.36 2.89-1.2.854-1.438 2.871-.496 4.003 1.685 2.016 3.132 4.191 4.598 6.356 3.36 5.006 6.72 10.002 10.099 14.998 3.38 4.986 6.779 9.962 10.188 14.938 6.263 9.167 12.576 18.305 18.8 27.492 3.201 4.728 6.234 9.565 9.405 14.312 8.721 13.061 17.472 26.092 26.213 39.133 1.814 2.702 3.617 5.403 5.45 8.095.447.655.863 1.4 1.487 1.827 1.318.904 2.835 1.45 4.46 1.371 1.576-.079 3.142-.288 4.043-1.917.219-.397.694-.636 1.021-.993 3.657-3.953 7.869-7.37 10.961-11.849.179-.258.416-.487.625-.715 3.805-4.152 7.571-8.333 11.416-12.435 3.796-4.043 7.721-7.976 11.516-12.028 3.845-4.112 7.611-8.294 11.397-12.455.803-.884 1.546-1.808 2.329-2.702.367-.427.664-.874.714-1.47.138-1.996.257-3.982-1.11-5.681-.248-.308-.416-.675-.615-1.013-2.448-4.291-5.48-8.144-8.542-11.988-1.774-2.225-3.499-4.509-5.233-6.764-.188-.248-.436-.516-.496-.804-.307-1.48-1.318-2.503-2.239-3.576-1.338-1.549-2.874-2.97-3.548-4.996-1.883-2.731-3.717-5.502-5.679-8.184-2.012-2.751-4.143-5.413-6.204-8.124-.377-.497-.743-1.043-.991-1.619-.357-.825-.872-1.5-1.447-2.166a38.122 38.122 0 0 1-1.804-2.205 4266.521 4266.521 0 0 1-12.715-17.222c-5.203-7.101-10.366-14.223-15.569-21.324-2.616-3.586-5.272-7.151-7.909-10.717-.495-1.34-1.615-1.798-2.883-2.145-1.05-.308-2.111-.596-3.32-.457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.549 71.349c1.209-.14 2.27.149 3.35.437 1.268.347 2.388.804 2.883 2.145 2.637 3.576 5.283 7.131 7.909 10.717 5.193 7.101 10.366 14.233 15.569 21.324a3712.561 3712.561 0 0 0 12.715 17.223c.565.764 1.18 1.489 1.804 2.204.575.656 1.09 1.341 1.447 2.166.248.576.604 1.112.991 1.619 2.061 2.711 4.202 5.373 6.204 8.124 1.952 2.682 3.786 5.453 5.679 8.184.664 2.036 2.2 3.447 3.547 4.996.932 1.073 1.933 2.096 2.24 3.576.06.288.298.556.496.804 1.734 2.265 3.458 4.539 5.232 6.764 3.063 3.844 6.105 7.697 8.543 11.988.198.348.367.715.615 1.013 1.357 1.709 1.248 3.685 1.11 5.681-.04.586-.337 1.043-.714 1.47-.773.904-1.526 1.828-2.329 2.702-3.786 4.161-7.552 8.353-11.397 12.455-3.796 4.052-7.72 7.975-11.516 12.028-3.855 4.102-7.621 8.283-11.417 12.435-.218.238-.446.457-.624.715-3.082 4.479-7.304 7.896-10.961 11.849-.327.348-.803.596-1.021.993-.901 1.629-2.467 1.838-4.043 1.917-1.625.089-3.142-.467-4.46-1.371-.624-.427-1.04-1.182-1.486-1.827-1.834-2.692-3.637-5.393-5.451-8.095-8.741-13.041-17.492-26.082-26.213-39.133-3.171-4.747-6.204-9.584-9.405-14.312-6.224-9.187-12.537-18.325-18.8-27.492-3.4-4.976-6.799-9.952-10.188-14.938-3.38-4.986-6.74-9.992-10.099-14.998-1.457-2.175-2.913-4.35-4.598-6.356-.952-1.132-.714-3.149.495-4.003 1.417-1.013 2.855-2.016 4.36-2.89 2.469-1.42 4.966-2.8 7.513-4.072 1.903-.944 3.895-1.728 5.689-2.9.535-.358 1.03-.298 1.546.03 1.199.764 2.408 1.519 3.607 2.284.604.377 1.219.745 1.794 1.162 1.457 1.053 2.943.854 4.43.11a26.294 26.294 0 0 0 1.873-1.024c3.924-2.384 7.82-4.807 11.763-7.171 1.556-.934 3.201-1.728 4.787-2.622 1.239-.705 2.379-1.56 3.528-2.414 1.2-.894 1.685-2.046 1.665-3.486a8.677 8.677 0 0 0-.228-1.877c-.446-1.808.278-3.496 1.893-4.44.952-.556 1.893-1.102 2.983-1.4.972-.268 1.854-.854 2.755-1.34 1.24-.676 2.518-1.252 3.935-.954"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#930C4E",
    d: "M3.17 108.127c.099.109.228.209.307.338.525.785 1.04 1.589 1.566 2.374.842 1.241 1.635 2.532 2.567 3.714 1.268 1.629 2.408 3.338 3.498 5.086.674 1.072 1.298 2.185 2.369 2.94.247.178.436.456.614.715 1.259 1.827 2.507 3.655 3.766 5.482.813 1.172 1.477 2.414 2.101 3.705.823 1.698 1.903 3.297 3.043 4.807 3.25 4.301 6.49 8.601 9.494 13.071.218.328.446.655.624 1.013 1.685 3.248 3.875 6.168 5.887 9.207 1.387 2.106 2.775 4.231 4.578 6.039.942.943 1.715 2.076 2.438 3.208 1.487 2.334 3.033 4.638 4.351 7.091.783 1.46 1.824 2.781 2.805 4.122 1.03 1.411 1.893 2.93 2.894 4.351 2.09 2.979 3.756 6.247 6.134 9.038 1.03 1.202 1.982 2.473 2.963 3.714 1.07 1.371 2.121 2.771 2.765 4.42.09.219.228.417.357.616 2.012 3.039 4.034 6.069 6.046 9.108.218.328.426.685.703.953 1.695 1.609 2.815 3.626 4.034 5.562a161.762 161.762 0 0 0 8.691 12.475c.674.884 1.338 1.748 1.834 2.761.346.705.891 1.311 1.347 1.957.317.457.754.864.932 1.371.614 1.728 1.754 3.158 2.626 4.747.962 1.758 2.14 3.347 4.182 3.993.645.208 1.06.675 1.408 1.212.277.427.317.893.049 1.34a1.486 1.486 0 0 1-1.18.706c-.227.019-.455-.09-.693-.12-.545-.069-1.09-.139-1.645-.178-1.08-.06-2.071.566-3.25.159-.932-.318-2.032-.149-3.063-.209-1.496-.08-2.735-.566-3.578-1.927-.792-1.281-1.714-2.473-2.556-3.724-5.53-8.214-11.07-16.438-16.59-24.662-5.788-8.621-11.556-17.252-17.334-25.873-.525-.785-.961-1.629-1.774-2.205-.307-.219-.555-.586-.723-.924-1.388-2.781-3.36-5.175-5.045-7.767-.168-.268-.347-.526-.505-.804-2.408-4.291-5.233-8.314-7.968-12.396-1.853-2.761-3.736-5.512-5.54-8.313-2.458-3.804-5.381-7.25-7.968-10.955-2.894-4.162-6.293-7.956-8.93-12.316-1.605-2.642-3.29-5.234-4.925-7.856a24.427 24.427 0 0 1-1.239-2.305c-.733-1.499-1.516-2.959-2.457-4.34-1.24-1.818-1.804-3.864-1.824-6.049-.01-.943.139-1.907-.267-2.82-.06-.139-.1-.338-.05-.467.664-1.669.694-3.586 1.893-5.056a.43.43 0 0 0 .238-.129"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C41F69",
    d: "M60.403 79.364c.595 0 1.08.208 1.348.784.278.606.119 1.282-.396 1.719a6.068 6.068 0 0 1-.575.417c-3.39 2.185-6.76 4.4-10.158 6.555-3.489 2.215-7.294 3.754-11.09 5.323-.367.15-.753.229-1.14.308-.595.12-1.268-.238-1.586-.804-.247-.447-.148-1.093.278-1.53.277-.278.565-.556.902-.764 3.151-1.967 6.154-4.172 9.534-5.741.783-.368 1.585-.745 2.289-1.232 2.488-1.708 5.233-2.94 7.869-4.36a5.39 5.39 0 0 1 2.725-.675"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M102.643 248.101c-2.101.139-3.737-.685-5.213-1.758-1.487-1.082-2.755-2.443-3.568-4.092-1.06-2.145-2.517-4.022-3.806-6.009-1.892-2.91-3.954-5.711-5.926-8.581a1333.5 1333.5 0 0 1-6.71-9.813c-1.952-2.881-3.864-5.791-5.827-8.661-4.34-6.337-8.711-12.654-13.062-18.98-1.744-2.543-3.458-5.106-5.222-7.638-2.032-2.92-3.846-5.989-5.986-8.84-1.715-2.274-3.182-4.718-4.767-7.082-1.368-2.036-2.735-4.072-4.113-6.088-2.13-3.139-4.271-6.267-6.422-9.396-2.24-3.267-4.51-6.515-6.73-9.783-3.071-4.519-6.104-9.058-9.156-13.587-.09-.129-.159-.278-.258-.397-3.449-4.549-6.422-9.416-9.683-14.084-.95-1.361-1.902-2.712-2.774-4.132-1.1-1.788-1.07-3.576-.288-5.453 1.13-2.701 3.181-4.509 5.61-5.94 1.565-.923 3.22-1.698 4.865-2.482a70.233 70.233 0 0 0 4.222-2.146c1.586-.884 3.241-1.638 4.866-2.453 5.798-2.89 11.596-5.78 17.393-8.68 2.051-1.024 4.053-2.166 6.135-3.12 3.875-1.777 7.63-3.813 11.446-5.71 5.233-2.602 10.466-5.225 15.649-7.946 2.785-1.47 5.58-1.47 8.493-.675 1.615.447 2.785 1.47 3.746 2.77 2.408 3.249 4.797 6.506 7.175 9.774 1.863 2.552 3.717 5.115 5.58 7.677.188.259.357.527.555.765 2.408 2.83 4.489 5.91 6.719 8.88 3.092 4.112 6.204 8.194 9.276 12.316 1.744 2.343 3.399 4.767 5.154 7.111 2.695 3.615 5.45 7.191 8.176 10.786.287.378.505.805.743 1.212.198.338.307.785.595 1.013 1.02.805 1.605 1.947 2.358 2.96 3.32 4.43 6.71 8.81 10.02 13.239 2.13 2.851 4.093 5.831 6.313 8.602 1.784 2.224 3.171 4.737 5.163 6.803.545.566.951 1.262 1.397 1.917 2.607 3.874 5.6 7.459 8.385 11.204 1.228 1.648 2.477 3.317 2.695 5.472.079.785.179 1.57-.059 2.364a4.81 4.81 0 0 0-.228 1.401c0 1.499-.585 2.79-1.457 3.943-.961 1.261-1.913 2.532-2.983 3.694-1.883 2.027-3.885 3.953-5.808 5.95-1.813 1.877-3.587 3.794-5.381 5.671-1.318 1.371-2.656 2.721-3.964 4.092-1.249 1.321-2.468 2.672-3.717 3.993-1.625 1.728-3.26 3.446-4.875 5.184-.536.576-1.021 1.202-1.556 1.788-3.756 4.072-7.532 8.135-11.298 12.207-3.707 4.012-7.403 8.025-11.1 12.038-2.091 2.264-4.162 4.548-6.303 6.773-1.278 1.272-2.715 2.235-4.489 1.927M78.521 65.568c-.912 0-1.943.03-2.904.477-1.15.526-2.32 1.003-3.449 1.569-5.143 2.602-10.227 5.323-15.42 7.826-2.983 1.44-5.917 2.98-8.89 4.45a1991.542 1991.542 0 0 0-13.805 6.893 2133.256 2133.256 0 0 0-15.024 7.628c-2.884 1.48-5.709 3.069-8.613 4.509-1.883.934-3.439 2.225-4.856 3.735a6.424 6.424 0 0 0-1.496 2.671c-.179.636-.208 1.262.099 1.848.515.983.99 1.996 1.605 2.91 1.784 2.612 3.637 5.174 5.451 7.777.545.774.981 1.629 1.526 2.413 2.111 3.059 4.252 6.099 6.343 9.158 1.566 2.284 3.072 4.618 4.618 6.922.525.785 1.1 1.54 1.635 2.324 1.606 2.354 3.142 4.758 4.817 7.062.981 1.351 1.893 2.722 2.804 4.112.952 1.46 1.933 2.89 2.924 4.321 2.111 3.059 4.252 6.098 6.363 9.167 1.516 2.215 2.973 4.479 4.489 6.694 1.744 2.543 3.568 5.026 5.302 7.579 3.211 4.707 6.363 9.435 9.564 14.153 1.813 2.682 3.666 5.333 5.49 8.015 1.556 2.285 3.082 4.599 4.648 6.883 2.368 3.457 4.787 6.893 7.155 10.359 2.498 3.655 4.956 7.33 7.453 10.985 1.556 2.285 3.24 4.49 4.707 6.834 1.844 2.959 3.925 5.75 5.887 8.621.178.258.337.546.555.775 1.507 1.519 3.241 2.522 5.461 2.433.475-.02.961-.05 1.348-.368.743-.586 1.565-1.112 2.21-1.797 2.111-2.245 4.152-4.569 6.243-6.844 3.36-3.674 6.729-7.359 10.109-11.014 2.358-2.553 4.767-5.066 7.125-7.628 2.359-2.563 4.658-5.185 7.037-7.727 2.695-2.891 5.47-5.711 8.196-8.582 1.744-1.827 3.399-3.744 5.193-5.512 3.617-3.556 7.016-7.3 10.485-10.995.704-.745 1.397-1.5 1.933-2.404 1.387-2.364 1.952-4.866.971-7.479-.644-1.688-1.388-3.367-2.627-4.757-1-1.113-1.912-2.314-2.804-3.516-1.467-1.967-2.864-3.973-4.331-5.94-1.368-1.837-2.795-3.635-4.192-5.442a116.88 116.88 0 0 1-1.566-2.086c-2.497-3.377-4.975-6.754-7.482-10.121-2.131-2.86-4.331-5.661-6.422-8.542-3.073-4.221-6.155-8.422-9.306-12.584-.902-1.192-1.933-2.304-2.577-3.694-.228-.487-.684-.865-1.031-1.302-.446-.556-.901-1.092-1.328-1.668-.842-1.142-1.635-2.324-2.487-3.457-2.468-3.297-4.955-6.575-7.433-9.862-3.568-4.738-7.195-9.436-10.663-14.253-2.31-3.208-4.728-6.327-7.096-9.485-2.419-3.228-4.748-6.525-7.136-9.783-.703-.954-1.397-1.927-2.329-2.692-1.278-1.043-2.676-1.728-4.48-1.57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M157.854 178.397v1.083c.01 1.341-.506 2.463-1.397 3.436-.754.815-1.517 1.619-2.27 2.434-2.369 2.552-4.678 5.165-7.116 7.648-3.27 3.327-6.372 6.803-9.533 10.22-2.468 2.672-5.065 5.224-7.562 7.866-1.685 1.778-3.3 3.635-4.955 5.433-1.814 1.977-3.568 4.023-5.501 5.88-1.655 1.589-2.943 3.536-4.796 4.916-1.517 2.344-3.826 3.993-5.52 6.198-1.1 1.43-2.409 2.721-4.113 3.516-.654.308-1.289.536-2.022.586-2.993.179-5.163-1.142-6.788-3.556-1.507-2.225-3.013-4.459-4.53-6.684-1.466-2.155-2.953-4.301-4.42-6.456-.218-.318-.416-.675-.525-1.053-.05-.169.09-.477.248-.606.148-.129.456-.188.644-.129.466.139.803.477 1.08.884 1.685 2.582 3.32 5.205 5.094 7.717 1.04 1.48 1.923 3.089 3.231 4.38.337.328.555.765.852 1.143.397.496.754 1.023 1.22 1.45 1.892 1.758 3.24 1.976 5.747.377.912-.576 1.794-1.271 2.537-2.115a139.143 139.143 0 0 1 4.371-4.678c4.182-4.311 8.117-8.87 12.328-13.151 2.607-2.651 5.055-5.462 7.602-8.164 2.497-2.642 5.034-5.254 7.552-7.876.327-.348.693-.665.971-1.043 1.239-1.768 2.894-3.129 4.331-4.708 1.169-1.271 2.329-2.552 3.498-3.824 1.496-1.628 2.983-3.277 4.519-4.866 1.16-1.212 2.141-2.563 3.013-3.973 1.001-1.619 1.11-3.447.327-5.244-.248-.576-.595-1.113-.942-1.639a165.855 165.855 0 0 0-2.834-4.102c-1.199-1.659-2.448-3.288-3.667-4.937-1.833-2.473-3.657-4.966-5.49-7.439-2.498-3.367-5.064-6.684-7.483-10.101-2.883-4.062-5.966-7.975-8.83-12.057-2.596-3.685-5.312-7.291-7.978-10.916-2.15-2.93-4.311-5.86-6.481-8.79-2.022-2.731-4.063-5.462-6.085-8.194-.753-1.013-1.526-2.006-2.121-3.138-.287-.557-.743-1.023-1.13-1.52-.872-1.122-1.803-2.205-2.596-3.377-.624-.924-1.2-1.857-1.972-2.672-.278-.288-.496-.645-.456-1.062.02-.209.138-.447.287-.606.169-.18.416-.16.644-.03.506.288.773.784 1.1 1.222 3.152 4.27 6.313 8.521 9.445 12.802 1.685 2.294 3.31 4.638 4.985 6.943.832 1.152 1.724 2.264 2.567 3.416 2.329 3.189 4.539 6.476 7.016 9.555 1.933 2.414 3.439 5.135 5.58 7.39 1.368 2.512 3.399 4.549 4.965 6.942 1.893 2.9 4.252 5.503 6.085 8.472 3.974 4.639 7.126 9.893 11.02 14.591 1.229 2.225 2.894 4.141 4.45 6.118 1.378 1.798 2.101 3.715 1.804 6.088M39.224 99.506c-1.794.07-3.191-.854-4.569-1.768-.723-.477-1.357-1.102-2.09-1.56-1.309-.814-2.548-.853-3.965.06-1.853 1.192-3.855 2.186-5.867 3.09-2.596 1.171-5.044 2.631-7.552 3.972-.485.258-.96.556-1.407.894-1.586 1.172-1.863 2.89-.723 4.559 1.645 2.423 3.35 4.797 4.985 7.231 2.388 3.545 4.737 7.121 7.095 10.677.526.784 1.06 1.569 1.596 2.344 1.893 2.731 3.796 5.442 5.669 8.184 1.605 2.354 3.181 4.727 4.777 7.081 2.12 3.149 4.251 6.297 6.382 9.436 1.377 2.026 2.795 4.022 4.152 6.059 2.24 3.347 4.45 6.724 6.69 10.081.525.784 1.15 1.509 1.685 2.294 1.605 2.354 3.161 4.738 4.776 7.082 2.33 3.387 4.837 6.654 7.017 10.14 1.754 2.821 3.875 5.384 5.5 8.294a10.01 10.01 0 0 0 1.06 1.579c1.884 2.255 3.291 4.837 4.966 7.231.406.586.823 1.162 1.229 1.748 1.784 2.612 3.578 5.224 5.351 7.846.179.258.298.556.427.844.109.249-.228.636-.526.646-.426.02-.802-.119-1.05-.437a55.484 55.484 0 0 1-1.804-2.503c-1.338-1.957-2.656-3.933-3.984-5.9-1.853-2.751-3.746-5.482-5.57-8.253-1.823-2.771-3.746-5.483-5.55-8.264-2.06-3.178-4.34-6.217-6.48-9.336-2.33-3.387-4.688-6.764-6.918-10.22-1.289-1.987-2.716-3.884-3.974-5.88-1.864-2.95-4.034-5.671-5.887-8.621-2.23-3.556-4.767-6.883-7.017-10.429-2.537-4.003-5.4-7.807-8.077-11.73-2.586-3.784-5.114-7.618-7.67-11.422a441.305 441.305 0 0 0-3.875-5.691c-1.576-2.284-3.102-4.589-4.777-6.804-.724-.953-1.388-1.917-1.913-2.989-.842-1.738-.535-3.864.694-5.324.832-.993 1.853-1.788 2.993-2.294 3.825-1.709 7.343-4.003 11.13-5.79 1.139-.537 2.338-.944 3.399-1.68.773-.535 1.674-.466 2.467.04 1.06.686 2.081 1.43 3.122 2.146.842.586 1.665 1.162 2.656 1.52 1.219.447 2.319.387 3.429-.2.486-.257.931-.605 1.427-.833a1.67 1.67 0 0 1 .912-.1c.188.03.386.229.515.407.07.09.01.299-.05.438-.059.139-.148.297-.267.377-1.397.914-2.775 1.857-4.539 1.728M77.676 70.266c2.448-.09 4.47 1.261 6.065 3.625 2.121 3.149 4.43 6.168 6.67 9.227 2.051 2.801 4.142 5.592 6.194 8.403.327.437.594.933.832 1.43.09.199.05.497-.198.616-.198.09-.456.159-.654.119-.208-.04-.436-.189-.585-.358a30.6 30.6 0 0 1-1.318-1.678c-2.21-3.08-4.41-6.178-6.63-9.247-.604-.834-1.288-1.599-1.922-2.413-1.606-2.046-3.182-4.132-4.817-6.158-1.635-2.017-3.469-2.444-5.897-1.709-1.605.487-2.963 1.45-4.43 2.175-1.417.696-2.755 1.54-4.162 2.255-1.02.517-1.288 1.112-.971 2.096.327.993.386 2.026.426 3.049.06 1.718-.624 3.04-2.11 3.973-1.874 1.172-3.668 2.473-5.55 3.635-1.477.904-3.004 1.758-4.58 2.473-1.664.755-3.121 1.847-4.687 2.751a40.98 40.98 0 0 1-2.924 1.54c-.138.07-.475-.09-.594-.249-.12-.149-.159-.476-.07-.645.14-.258.387-.487.635-.666 1.189-.913 2.448-1.748 3.825-2.364 1.953-.874 3.736-2.046 5.58-3.128.545-.318 1.07-.705 1.645-.934 2.002-.814 3.578-2.304 5.44-3.357 1.408-.794 2.003-2.205 1.824-3.853-.089-.785-.188-1.57-.386-2.335-.397-1.579.327-2.602 1.605-3.337.951-.556 1.943-1.043 2.934-1.54 1.754-.883 3.558-1.668 5.193-2.79.941-.676 2.061-.715 3.617-.606"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.51 95.186c-.327 0-.565.03-.802-.01-.902-.14-1.735-.487-2.052-1.381-.337-.954-.129-1.907.595-2.642.376-.387.872-.675 1.348-.953 4.885-2.91 9.751-5.85 14.667-8.691 2.041-1.182 4.153-2.275 6.471-2.89 1.457-.388 2.884.377 3.34 1.807.218.666-.198 1.669-.872 2.026-2.666 1.371-5.114 3.1-7.67 4.649-.942.576-1.923 1.082-2.874 1.639-3.4 1.996-6.809 3.992-10.198 6.018-.645.388-1.338.368-1.953.428m21.843-14.63c-.198-.15-.367-.378-.555-.408a2.03 2.03 0 0 0-.912.08c-1.804.576-3.558 1.29-5.203 2.254-4.846 2.821-9.682 5.672-14.509 8.522-.614.358-1.179.795-1.744 1.232-.377.288-.277.953.159 1.191.684.378 1.338.358 2.011-.05 2.102-1.25 4.222-2.462 6.323-3.704 3.4-1.996 6.799-4.012 10.208-5.999 1.09-.636 2.21-1.222 3.31-1.847.268-.15.515-.358.704-.586.129-.17.138-.427.208-.686M73.288 53.232c-.119.417-.159.775-.555.795-.208.01-.456-.1-.634-.229a1.672 1.672 0 0 1-.664-1.221c-.07-1.053-.565-1.967-.902-2.93-.714-2.096-1.368-4.212-2.022-6.317-.485-1.59-.842-3.218-1.417-4.777-.604-1.64-.932-3.348-1.437-5.006-1.259-4.172-2.864-8.224-4.073-12.396-.793-2.74-1.784-5.393-2.696-8.084-.277-.815-.416-1.689-.594-2.533-.06-.258.307-.725.535-.685.218.04.495.109.624.268.228.308.416.675.535 1.043 1.517 4.489 3.072 8.968 4.5 13.488.901 2.86 1.803 5.72 2.735 8.571.822 2.543 1.477 5.145 2.23 7.717.376 1.282.773 2.563 1.189 3.834.783 2.404 1.596 4.797 2.368 7.19.15.438.209.915.278 1.272M88.778 58.983c-.357-.01-.744-.407-.714-.645.03-.229.04-.487.159-.676.872-1.5 1.774-2.99 2.646-4.49 1.189-2.055 2.329-4.14 3.567-6.167 2.835-4.668 5.441-9.465 8.494-14.004.793-1.182 1.457-2.444 2.22-3.645.763-1.192 1.605-2.344 2.378-3.536.644-.994 1.209-2.036 1.834-3.04.584-.943 1.219-1.847 2.031-2.602.258-.238.585-.218.862-.01.278.209.387.537.218.835-.356.615-.723 1.231-1.159 1.797-1.199 1.57-2.339 3.169-3.251 4.927-.465.913-.941 1.837-1.655 2.592a3.112 3.112 0 0 0-.406.586c-3.003 5.115-6.313 10.041-9.207 15.216-1.813 3.238-3.776 6.406-5.649 9.604-.515.884-.971 1.808-1.486 2.702-.228.338-.555.576-.882.556M83.702 24.786c.228 2.037-.416 4.043-.585 6.089-.138 1.649-.535 3.278-.703 4.926-.258 2.593-.426 5.205-.625 7.807-.178 2.443-.337 4.887-.515 7.33-.02.238-.09.467-.139.695-.109.427-.515.735-.852.646a.783.783 0 0 1-.595-.666 2.798 2.798 0 0 1-.01-.705c.308-2.592.12-5.204.615-7.797.317-1.698.287-3.456.436-5.184.188-2.205.337-4.42.644-6.605.198-1.41.347-2.82.555-4.221.208-1.42.357-2.821.367-4.251.01-.656.139-1.262.604-1.748.09-.1.288-.16.417-.14.138.02.287.15.366.269.228.337.268.725.228 1.132-.089.794-.138 1.59-.208 2.423M95.704 64.158c-.298-.01-.605-.407-.496-.666.119-.288.228-.606.416-.834.407-.487.833-.944 1.308-1.37 3.34-2.98 6.7-5.95 10.05-8.92.366-.318.713-.616 1.238-.566.278.02.645.437.526.656-.189.337-.367.705-.645.973a165.881 165.881 0 0 1-3.617 3.397c-2.497 2.284-5.014 4.549-7.522 6.823-.367.328-.733.606-1.258.507M64.308 56.35c-.178.22-.297.468-.475.537-.189.08-.526.06-.654-.07a3.07 3.07 0 0 1-.684-.943 538.972 538.972 0 0 1-2.835-6.515c-.089-.209-.178-.467-.148-.676.03-.198.198-.467.366-.546.169-.07.545-.02.625.11.594.923 1.189 1.856 1.675 2.84.654 1.35 1.219 2.741 1.803 4.122.149.367.218.764.327 1.142M58.134 8.398c-.139-.06-.337-.089-.407-.188-.218-.318-.446-.656-.574-1.023a437.139 437.139 0 0 1-2.17-6.03c-.05-.148-.1-.317-.08-.456.06-.318.208-.636.555-.695.198-.03.466.06.634.179.179.129.347.347.416.566.803 2.234 1.586 4.47 2.36 6.714.177.477-.278 1.033-.734.933M111.192 50.113c-.525.05-.971-.536-.822-.824.099-.209.188-.447.357-.596a182.174 182.174 0 0 1 3.954-3.297c.129-.11.436-.06.634-.01.228.06.347.605.208.834-.039.07-.059.149-.109.209-1.159 1.152-2.21 2.433-3.558 3.386-.247.18-.565.249-.664.298"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#930C4E",
    d: "M61.355 80.556c-.08.258-.08.516-.208.685a2.492 2.492 0 0 1-.704.586c-1.1.626-2.22 1.212-3.31 1.847-3.41 1.987-6.798 4.003-10.208 6-2.11 1.241-4.221 2.463-6.322 3.704-.684.407-1.338.427-2.012.05-.426-.239-.535-.904-.159-1.192.565-.427 1.13-.864 1.744-1.232 4.827-2.85 9.663-5.7 14.51-8.521 1.635-.954 3.389-1.679 5.202-2.255.288-.09.625-.13.912-.08.188.03.357.259.555.408"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M125.109 147.598c.168 1.559-.516 2.969-.714 4.459-.119.934-.426 1.848-.624 2.781-.199.884-.139 1.033.832 1.341 2.032.636 4.073 1.232 6.105 1.848.912.278 1.794.635 2.715.824 1.229.248 1.487.943 1.16 1.867-.545 1.559-.694 3.258-1.685 4.648-.347.497-.723.735-1.387.606-2.854-.576-5.719-1.102-8.583-1.648-.228-.04-.466-.06-.703-.08-.436-.04-.793.109-.892.566a400.357 400.357 0 0 0-1.526 6.953c-.169.774-.288 1.559-.674 2.264-.238.447-.605.725-1.13.735-.238 0-.476 0-.714-.03-1.407-.188-2.824-.337-4.222-.596-1.318-.238-1.813-1.052-1.645-2.403.327-2.672.862-5.314 1.447-7.936.07-.308.139-.616.179-.924.069-.486-.129-.774-.555-.884-2.815-.764-5.63-1.539-8.434-2.304a3.97 3.97 0 0 1-.446-.159c-1.179-.427-1.556-.993-1.328-2.135.188-.934.426-1.857.704-2.761.485-1.53 1.308-2.046 2.864-1.788 1.704.278 3.439.497 5.094.953 1.308.358 2.675.239 3.964.676.337.119.614-.139.763-.427.139-.278.218-.586.297-.894.654-2.602 1.279-5.215 1.953-7.817.247-.943.644-1.271 1.496-1.142 1.714.258 3.379.755 5.005 1.361.386.149.634.486.684.904.029.357 0 .754 0 1.142M92.82 169.707c.129 1.768-.496 3.436-.723 5.164-.04.308-.169.616-.218.924-.209 1.401-.179 1.718 1.337 1.728 2.696.01 5.352.417 7.988.924.159.03.317.03.466.06.773.168 1.14.586 1.06 1.311a123.703 123.703 0 0 1-.584 4.708c-.129.874-.585 1.271-1.437 1.261-1.338-.03-2.696-.06-4.024-.199-1.566-.179-3.112-.476-4.668-.725-.802-.129-1.219.08-1.417.864-.396 1.53-.803 3.059-1.12 4.599-.158.785-.396 1.529-.624 2.284-.317 1.053-.486 2.156-.743 3.228-.387 1.629-1.299 2.285-2.884 1.937-1.001-.218-2.052-.089-3.033-.487-1.15-.466-1.377-.695-1.417-1.897-.04-1.271.02-2.532.258-3.784.475-2.483.941-4.976 1.397-7.459.089-.457-.12-.745-.634-.794-1.725-.169-3.41-.557-5.154-.656-2.12-.119-4.222-.516-6.323-.814-.356-.05-.743-.547-.654-.874.347-1.172.208-2.364.258-3.546.01-.318.04-.636.109-.934.228-.874.803-1.331 1.714-1.361.476-.01.952-.01 1.418.07 3.28.516 6.58.824 9.9.953.456.02 1.001.239 1.358.07.525-.248.456-.963.585-1.48.664-2.682 1.288-5.383 1.942-8.065.208-.854.743-1.202 1.586-.973.773.208 1.536.318 2.319.427.456.059.882.308 1.318.496.386.179.614.517.624.934.04.685.02 1.401.02 2.106M142.632 180.096c-.01.993-.327 1.579-1.11 1.847-.376.129-.743.288-1.12.378-2.259.516-4.331 1.47-6.303 2.661-3.191 1.927-6.045 4.291-8.79 6.804-3.033 2.781-5.847 5.78-8.612 8.81-2.567 2.811-4.539 6.078-5.669 9.773-.228.755-.486 1.51-.773 2.245-.189.486-.625.695-1.14.695-.238 0-.486-.01-.704-.079-1.228-.408-2.487-.408-3.756-.368-.901.03-1.238-.328-1.377-1.261-.06-.368.039-.775.129-1.152.535-2.275 1.754-4.222 2.943-6.178 2.636-4.361 5.946-8.184 9.395-11.889.961-1.043 2.042-1.987 3.142-2.89 2.13-1.758 4.231-3.576 6.481-5.175 4.45-3.148 8.999-6.158 14.301-7.767 1.526-.467 2.061-.228 2.448 1.222.208.814.366 1.668.515 2.324M93.415 249.979c-1.952.119-3.776-.249-5.43-1.341-.536-.358-1.002-.755-1.448-1.212-2.051-2.106-3.815-4.44-5.45-6.863-3.598-5.314-7.176-10.637-10.763-15.951-2.032-3.02-4.073-6.019-6.085-9.048-2.012-3.03-3.974-6.099-6.016-9.108-2.745-4.072-5.55-8.105-8.325-12.157-.584-.854-1.09-1.748-1.665-2.602-2.665-3.924-5.351-7.837-7.997-11.77-3.27-4.867-6.492-9.763-9.752-14.63a8081.9 8081.9 0 0 0-10.188-15.186c-1.853-2.761-3.687-5.532-5.55-8.284-2.18-3.208-4.39-6.396-6.57-9.594a261.734 261.734 0 0 1-3.152-4.748 3.382 3.382 0 0 1-.446-1.092c-.03-.169.178-.427.337-.576.188-.179.446-.149.654-.01.188.139.377.298.515.486 1.05 1.48 2.16 2.93 3.122 4.47 1.338 2.155 2.775 4.231 4.242 6.297.456.645.822 1.361 1.258 2.016 1.418 2.096 2.865 4.182 4.282 6.277a1228.81 1228.81 0 0 1 3.994 5.91c1.328 1.976 2.656 3.943 3.964 5.919 1.754 2.632 3.478 5.284 5.242 7.906 2.597 3.864 5.243 7.708 7.84 11.571 2.864 4.271 5.678 8.582 8.532 12.853 2.111 3.148 4.252 6.277 6.393 9.415 1.823 2.682 3.676 5.344 5.48 8.045 1.318 1.967 2.488 4.053 3.895 5.95 2.497 3.367 4.539 7.052 7.086 10.389.961 1.261 1.744 2.642 2.626 3.963 1.992 2.95 4.014 5.88 5.996 8.829 1.1 1.639 2.101 3.357 3.24 4.966 1.051 1.49 2.23 2.881 3.34 4.331 1.626 2.115 3.836 2.87 6.412 2.989 1.685.08 3.29-.278 4.916-.526 2.101-.328 4.232-.546 6.283-1.162.199-.06.466.04.684.099.357.1.476.706.228.984-.386.437-.882.665-1.437.754-2.567.437-5.124.904-7.7 1.302-.833.129-1.715.099-2.587.139M59.622 162.566c-1.814-2.493-3.657-4.967-5.451-7.479-2.835-3.983-15.213-20.937-17.898-25.019-1.517-2.305-3.231-4.47-4.708-6.814-1.338-2.125-2.795-4.191-4.182-6.297-.04-.069-.09-.129-.129-.199-.327-.615-.248-1.231.317-1.708a14.52 14.52 0 0 1 1.923-1.371c2.983-1.787 5.936-3.625 8.979-5.293 3.38-1.858 6.59-3.993 10-5.801 2.854-1.509 5.688-3.039 8.473-4.688 3.121-1.847 6.392-3.436 9.593-5.154.832-.447 1.625-.964 2.448-1.44.753-.438 1.496-.885 2.26-1.302 1.793-.983 3.666-1.837 5.37-2.99 1.041-.704 2.201-1.24 3.32-1.827.734-.377 1.081-.189 1.329.705.04.15-.545.537-.813.686a384.327 384.327 0 0 0-5.59 3.128c-2.933 1.699-5.807 3.506-8.79 5.115-4.578 2.473-9.216 4.817-13.726 7.42-1.367.784-2.755 1.549-4.123 2.324-2.12 1.211-4.241 2.433-6.362 3.645-.416.238-.842.437-1.249.685-2.636 1.599-5.213 3.288-7.928 4.758-1.318.705-2.527 1.609-3.786 2.423.426 1.55 1.526 2.712 2.379 4.013 1.466 2.254 3.19 4.34 4.45 6.734.188.347.416.675.683.973 2.25 2.563 13.41 18.553 15.46 21.255 2.914 3.844 5.68 7.797 8.504 11.71.327.447.634.914.961 1.361.396.516-1.279 1.052-1.715.447M83.1 86.585a73.861 73.861 0 0 1 1.863 2.741c2.576 3.883 5.113 7.787 7.71 11.66 1.843 2.752 13.211 18.494 15.133 21.186 1.051 1.48 2.22 2.87 3.33 4.3.188.249.396.507.486.795.099.298.059.665-.228.864-.585.397-1.19.755-1.794 1.112-1.576.934-2.805 2.305-4.212 3.447-4.053 3.277-8.315 6.267-12.636 9.197-2.418 1.639-4.836 3.278-7.155 5.055-3.191 2.444-6.283 5.026-9.425 7.539-1.05.834-2.15 1.609-3.201 2.443-3.42 2.682-6.818 5.374-10.237 8.055a4.793 4.793 0 0 1-.595.388c-.406.238-1.05-.13-1.02-.616.019-.388.93-1.222 1.238-1.5.466-.427.912-.874 1.407-1.261 4.103-3.218 8.216-6.426 12.329-9.635 1.992-1.559 3.954-3.158 5.996-4.658 3.31-2.423 6.67-4.777 10-7.171 3.27-2.354 6.6-4.628 9.781-7.121 2.358-1.847 4.806-3.576 7.036-5.592.476-.437.545-.705.228-1.231a16.794 16.794 0 0 0-1.06-1.57c-2.656-3.536-14.796-20.083-17.215-23.797-3.022-4.639-6.095-9.237-9.157-13.846-.228-.337.852-1.55 1.398-.784M.049 116.123c.099-.705.158-1.252.248-1.798.564-3.516 1.387-6.972 2.566-10.329.13-.378.238-.765.595-.994.119-.079.327-.159.426-.109.188.089.426.258.466.437.06.288.05.636-.05.914-1.01 3.009-1.625 6.118-2.23 9.217-.654 3.357-.108 6.456 1.963 9.227.188.248.386.506.515.794.149.318.04.626-.228.835-.267.208-.565.228-.872.039-.644-.387-1.05-1.013-1.318-1.648-.714-1.669-1.546-3.298-1.893-5.095-.109-.527-.139-1.093-.188-1.49"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85.695 98.394c-.149-.03-.337-.02-.446-.11-.248-.188-.506-.397-.674-.655-.892-1.4-1.764-2.81-2.636-4.221-.248-.407-.417-.884-.724-1.222-1.407-1.54-.823-1.957-2.963-.626-3.697 2.295-7.383 4.609-11.07 6.903-.327.209-.684.408-1.05.507-.169.05-.447-.11-.615-.248-.208-.17-.168-.418-.03-.626.526-.844 1.378-1.311 2.17-1.808 3.34-2.096 6.71-4.151 10.07-6.217.604-.368 1.239-.686 1.873-1.023.495-.269.931-.1 1.278.268.426.467.853.943 1.2 1.47 1.218 1.847 2.398 3.724 3.587 5.592.297.466.594.943.485 1.539-.049.258-.188.427-.455.477M62.396 159.358c-.486 0-.882-.05-1.16-.378-.882-1.023-1.645-2.115-1.982-3.446-.03-.11.07-.348.169-.388.198-.089.535-.198.644-.099.476.407.912.854 1.318 1.341.307.357.516.794.793 1.172.208.278.505.377.813.149 2.07-1.569 4.132-3.149 6.213-4.708 2.141-1.599 4.292-3.178 6.442-4.767.317-.239.644-.457.981-.666.308-.189.605-.119.863.09.287.238.297.784-.04 1.052-1.11.874-2.24 1.719-3.37 2.583-2.884 2.195-5.758 4.39-8.651 6.575-.565.427-1.18.784-1.765 1.192-.406.278-.872.317-1.268.298M32.445 116.351c.406.03.664.318.892.656.931 1.37 1.873 2.731 2.765 4.122 1.318 2.056 2.606 4.141 3.904 6.217.248.397.555.785.446 1.301a.693.693 0 0 1-.237.378.544.544 0 0 1-.427.069c-.535-.218-.872-.675-1.189-1.122-.624-.914-1.219-1.847-1.823-2.771-1.418-2.185-2.825-4.38-4.262-6.555-.347-.537-.733-1.023-.714-1.709.02-.298.357-.655.645-.586M98.698 134.04c-.16-.119-.407-.218-.516-.397-.099-.179-.148-.486-.06-.655.14-.268.367-.517.625-.696a503.04 503.04 0 0 1 6.372-4.529c.516-.357 1.101-.605 1.685-.834.288-.109.654-.05.853.238.218.318.049.606-.209.815-.862.695-1.704 1.41-2.606 2.046-1.863 1.321-3.756 2.602-5.649 3.893-.119.09-.297.08-.495.119M58.986 153.567c-.04.278-.495.507-.723.368-.961-.616-1.457-1.629-2.022-2.553-.168-.268.04-.635.317-.814.169-.119.535-.209.635-.119.882.784 1.595 1.698 1.853 2.89.02.069-.04.159-.06.228"
  })));
};

var Container$o = styled.div(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n  ", "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: ", ";\n"], ["\n  ", "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme, type = _a.type;
    if (type === 'error') {
        return "\n      height: 100%;\n    ";
    }
    return "\n    height: 400px;\n    background: ".concat(theme.colors.neutral[95], ";\n    border: 1px solid ").concat(theme.colors.neutral[90], ";\n    border-radius: ").concat(theme.borders.radius.m, ";\n  ");
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
});
var ButtonCTA = styled(Button$4)(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n  margin: 0 auto;\n"], ["\n  margin: 0 auto;\n"])));
var templateObject_1$R, templateObject_2$z;

var EmptyState = function (_a) {
    var buttonProps = _a.buttonProps, buttonText = _a.buttonText, description = _a.description, _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.type, type = _c === void 0 ? 'empty' : _c, _d = _a.withoutButton, withoutButton = _d === void 0 ? false : _d;
    var colors = useTheme().colors;
    return (React__default.createElement(Container$o, { type: type },
        type === 'empty' ? React__default.createElement(SvgEmptyState, null) : React__default.createElement(SvgPageError, null),
        title && (React__default.createElement(Typography, { variant: "headline6", weight: 700, variantColor: colors.neutral[20] }, title)),
        React__default.createElement(Typography, { variantColor: colors.neutral[30], variant: "body3" }, description),
        !withoutButton && (React__default.createElement(ButtonCTA, __assign({ size: "large", variant: "primary" }, buttonProps), buttonText))));
};

var GenerateXLSXFile = function (_a) {
    var fileName = _a.fileName, sheetName = _a.sheetName, _b = _a.data, data = _b === void 0 ? [] : _b, buttonTitle = _a.buttonTitle, style = _a.style, classes = _a.classes, customButton = _a.customButton, _c = _a.icon, icon = _c === void 0 ? 'IconCloudDownload' : _c, docIconSize = _a.docIconSize;
    var generateFile = useCallback(function () {
        var arr = fileName.split('.');
        var extension = arr.pop();
        if (extension === 'xlsx' || extension === 'xls') {
            var wb = utils.book_new();
            var ws = utils.aoa_to_sheet(data);
            utils.book_append_sheet(wb, ws, sheetName || fileName);
            writeFile(wb, fileName);
        }
        if (extension === 'csv' || extension === 'txt') {
            var fileBody = data === null || data === void 0 ? void 0 : data.join('\n');
            var blob = new Blob([fileBody], {
                type: "text/".concat(extension, ";charset=utf-8"),
            });
            var creatDocument = document.createElement('a');
            creatDocument.href = window.URL.createObjectURL(blob);
            creatDocument.download = fileName;
            creatDocument.click();
        }
    }, [data]);
    return (React__default.createElement(React__default.Fragment, null, customButton ? (React__default.cloneElement(customButton, { onClick: generateFile })) : (React__default.createElement(DownloadButton, { title: buttonTitle || 'Download', fileName: fileName, onClick: generateFile, style: style, classes: classes, icon: icon, docIconSize: docIconSize }))));
};

var css_248z$o = ".select-custom .select-field-custom-theme{border-radius:12px}.select-custom .select-field-custom-theme input{color:var(--color-neutral-40);font-family:var(--font-family-secondary);font-weight:600}.select-custom .select-field-custom-theme div.MuiFilledInput-root{background-color:transparent;border:1px solid var(--color-neutral-light2);border-radius:12px}.select-custom .select-field-custom-theme div.MuiFilledInput-root:hover{border:2px solid var(--color-neutral-dark5)}.select-custom .select-field-custom-theme div.MuiFilledInput-root:after,.select-custom .select-field-custom-theme div.MuiFilledInput-root:before{content:none}.select-custom .select-field-custom-theme div.MuiFilledInput-root div:focus{background-color:transparent!important}.select-custom .select-field-custom-theme div.Mui-focused{border:2px solid var(--color-secondary-light5)}.select-custom .select-field-custom-theme div.Mui-error{background:var(--color-feedback-error-light1);border:2px solid var(--color-feedback-error-pure)}.select-custom .select-field-custom-theme div.Mui-disabled{background:var(--color-neutral-light1);border:1px solid var(--color-neutral-light3)}.select-custom .select-field-custom-theme label{font-family:var(--font-family-secondary);font-weight:600;padding-top:4px}.select-custom .select-field-custom-theme label.Mui-error,.select-custom .select-field-custom-theme label.Mui-focused,.select-custom .select-field-custom-theme p.Mui-error{color:var(--color-neutral-dark5)}.select-custom .warning svg{stroke:var(--color-feedback-error-pure)}.select-custom .select-field-icon{fill:transparent;left:20px;position:relative;top:30px;z-index:1}.select-custom .select-field-icon circle,.select-custom .select-field-icon line{stroke:var(--color-neutral-light4)}.select-custom .Mui-focused .search-field-icon circle,.select-custom .Mui-focused .search-field-icon line{stroke:var(--color-secondary-light5)}.select-custom .Mui-disabled .search-field-icon circle,.select-custom .Mui-disabled .search-field-icon line{stroke:var(--color-neutral-light3)}.select-custom .Mui-error .search-field-icon circle,.select-custom .Mui-error .search-field-icon line{stroke:var(--color-feedback-error-pure)}.check-icon-select svg,.check-icon-select svg path,.select-custom .helperText{fill:transparent}.select-field-popper-custom{z-index:1300}.select-field-popper-custom .MuiAutocomplete-listbox{margin:6px 0}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option{border-radius:8px;margin:6px 12px;padding:16px;text-align:left}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true]{color:var(--color-secondary-40);font-weight:700}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true] .select-field-option-custom{color:var(--color-secondary-40)}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true] .select-field-option-custom .select-field-option-icon{fill:var(--color-secondary-40)}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true] .select-field-option-custom .select-field-option-caption{color:var(--color-neutral-60)}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true] .select-field-option-custom .select-field-option-label--disabled{color:var(--color-neutral-70)}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option .select-field-option-custom{align-items:flex-start;color:var(--color-neutral-30);display:flex;font-size:16px;font-weight:600;justify-content:flex-start;line-height:22px;width:100%}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option .select-field-option-custom .select-field-option-icon{align-items:center;display:flex;height:-moz-min-content;height:min-content;margin-right:8px}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option .select-field-option-custom .select-field-option-tip{align-items:flex-end;align-self:flex-end;display:flex;flex:1;height:-moz-min-content;height:min-content;justify-content:flex-end;justify-self:flex-end;margin-left:8px}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option .select-field-option-custom .select-field-option-caption{color:var(--color-neutral-60);font-family:var(--font-family-secondary);font-size:16px;font-weight:600;line-height:22px}.select-field-popper-custom .MuiAutocomplete-listbox .MuiAutocomplete-option .select-field-option-custom .select-field-option-label--disabled{color:var(--color-neutral-70)}";
styleInject(css_248z$o);

var Tooltip$1 = styled(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React__default.createElement(Tooltip$2, __assign({}, props, { classes: { tooltip: className } })));
})(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n  background-color: ", ";\n\n  span::before {\n    background-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n\n  span::before {\n    background-color: ", ";\n  }\n"])), colors.get('neutral.0'), colors.get('neutral.0'));
var templateObject_1$Q;

var Tooltip = forwardRef(function (props, ref) {
    return (React__default.createElement(Tooltip$1, { className: props.className, title: props.title, arrow: props.arrow, placement: props.placement, ref: ref }, props.children ? (props.children) : (React__default.createElement(Icons, { size: props.iconSize, name: "IconInfoCircle" }))));
});
Tooltip.displayName = 'Tooltip';

var SelectFieldMultipleOption = function (_a) {
    var option = _a.option, props = _a.props, selected = _a.selected;
    return (React__default.createElement("li", __assign({ className: "select-field-option" }, props, { key: option === null || option === void 0 ? void 0 : option.value }),
        React__default.createElement(Checkbox$1, { icon: React__default.createElement(Icons, { name: "IconSquare", size: 18 }), checkedIcon: React__default.createElement(Icons, { name: "IconSquareCheck", size: 18 }), style: { marginRight: 8 }, checked: selected, className: "check-icon-select" }), option === null || option === void 0 ? void 0 :
        option.label));
};
var SelectFieldSingleOption = function (_a) {
    var props = _a.props, option = _a.option;
    var OptionIcon = function (_a) {
        var option = _a.option;
        if (!option || !option.icon)
            return React__default.createElement(React__default.Fragment, null);
        return React__default.createElement("div", { className: "select-field-option-icon" }, option.icon);
    };
    var OptionCaption = function (_a) {
        var option = _a.option;
        if (!option || !option.caption)
            return React__default.createElement(React__default.Fragment, null);
        return React__default.createElement("div", { className: "select-field-option-caption" }, option === null || option === void 0 ? void 0 : option.caption);
    };
    var OptionTip = function (_a) {
        var option = _a.option;
        if (!option || !option.tip)
            return React__default.createElement(React__default.Fragment, null);
        return (React__default.createElement("div", { className: "select-field-option-tip" },
            React__default.createElement(Tooltip, { title: option === null || option === void 0 ? void 0 : option.tip, arrow: true },
                React__default.createElement("div", null,
                    React__default.createElement(Icons, { name: "IconInfoCircle", fill: "transparent", color: "#83727D" })))));
    };
    return (React__default.createElement("li", __assign({ className: "select-field-option" }, props, { key: option === null || option === void 0 ? void 0 : option.value }),
        React__default.createElement("div", { className: "select-field-option-custom" },
            React__default.createElement(OptionIcon, { option: option }),
            React__default.createElement("div", { className: "select-field-option-label".concat(option.disabled ? '--disabled' : '') },
                React__default.createElement("div", null, option === null || option === void 0 ? void 0 : option.label),
                React__default.createElement(OptionCaption, { option: option })),
            React__default.createElement(OptionTip, { option: option }))));
};
var SelectField = function (_a) {
    var error = _a.error, helperText = _a.helperText, onError = _a.onError, onBlur = _a.onBlur, onSelectChange = _a.onSelectChange, onFocus = _a.onFocus, value = _a.value, defaultValue = _a.defaultValue, label = _a.label, InputProps = _a.InputProps, onChange = _a.onChange, disabled = _a.disabled, fullWidth = _a.fullWidth, _b = _a.options, options = _b === void 0 ? [{}] : _b, className = _a.className, _c = _a.multiple, multiple = _c === void 0 ? false : _c, disableClearable = _a.disableClearable, searchable = _a.searchable, name = _a.name, noOptionsText = _a.noOptionsText, filterOptions = _a.filterOptions, focused = _a.focused, style = _a.style;
    return (React__default.createElement(Autocomplete, { fullWidth: fullWidth, filterOptions: filterOptions, className: "select-custom ".concat(className), value: value, style: style, defaultValue: defaultValue, noOptionsText: noOptionsText, isOptionEqualToValue: function (option, value) {
            return (option === null || option === void 0 ? void 0 : option.value) === value || option === value;
        }, getOptionLabel: function (option) {
            var foundOptions = options.find(function (o) { return o.value === option || o.value === (option === null || option === void 0 ? void 0 : option.value); });
            return (foundOptions === null || foundOptions === void 0 ? void 0 : foundOptions.label) || '';
        }, disableClearable: disableClearable || (!searchable && !multiple), multiple: multiple, options: options, disabled: disabled, onChange: onSelectChange, popupIcon: React__default.createElement(Icons, { name: "IconChevronDown", fill: "transparent" }), PopperComponent: function (props) { return (React__default.createElement(Popper, __assign({}, props, { className: 'select-field-popper-custom' }))); }, disableCloseOnSelect: multiple, renderOption: function (props, option, _a) {
            var selected = _a.selected;
            if (option.disabled)
                delete props.onClick;
            if (multiple)
                return (React__default.createElement(SelectFieldMultipleOption, { props: props, option: option, selected: selected, key: option.value }));
            return React__default.createElement(SelectFieldSingleOption, { option: option, props: props });
        }, renderInput: function (params) { return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(TextField$2, __assign({}, params, { onBlur: onBlur, onChange: onChange, onError: onError, onFocus: onFocus, disabled: disabled, name: name, focused: focused, value: value, defaultValue: defaultValue, InputProps: __assign(__assign({}, params.InputProps), InputProps), inputProps: __assign(__assign({}, params.inputProps), { readOnly: multiple || searchable ? false : true }), error: error, label: label, helperText: false, variant: "filled", className: "select-field-custom-theme ".concat(error && 'warning'), fullWidth: fullWidth })),
            helperText && (React__default.createElement("p", { className: "helperText ".concat(error && 'warning') },
                error && React__default.createElement(Icons, { name: "IconInfoCircle", size: 18 }),
                helperText)))); } }));
};

var css_248z$n = ".associate-fields-table{width:100%}.associate-fields-table>thead{border-bottom:1px solid rgba(74,78,87,.1);color:var(--color-neutral-dark2);font-weight:700}.associate-fields-table>thead>tr{text-align:left}.associate-fields-table>thead>tr>th{padding:10px 0}.associate-fields-table>thead>tr :nth-child(2){width:40%}.associate-fields-table>thead>tr :last-child{text-align:right}.associate-fields-table>tbody td>.associate-fields-table-select label{color:var(--color-neutral-dark4)!important;font-size:16px!important;font-weight:400!important}.associate-fields-table>tbody>tr{color:var(--color-neutral-dark2);font-size:16px;font-weight:400}.associate-fields-table>tbody>tr>td{padding:10px}.associate-fields-table>tbody>tr>td>.associate-fields-table-data-container{align-items:flex-start;display:flex;flex-wrap:wrap;justify-content:flex-end}.associate-fields-table>tbody>tr>td>.associate-fields-table-data-container>span{padding:5px}";
styleInject(css_248z$n);

var AssociateFields = function (_a) {
    var fields = _a.fields, rows = _a.rows, columns = _a.columns, setFields = _a.setFields;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("table", { className: "associate-fields-table" },
            React__default.createElement("thead", null,
                React__default.createElement("tr", null,
                    React__default.createElement("th", null, "Coluna da tabela"),
                    React__default.createElement("th", null, "Campo cadastrado"),
                    React__default.createElement("th", null, "Conte\u00FAdo da coluna selecionada"))),
            React__default.createElement("tbody", null, ((columns === null || columns === void 0 ? void 0 : columns.length) &&
                (fields === null || fields === void 0 ? void 0 : fields.map(function (_a, fieldIndex) {
                    var _b;
                    var key = _a.key, label = _a.label, value = _a.value, error = _a.error, helperText = _a.helperText;
                    return (React__default.createElement("tr", { key: fieldIndex },
                        React__default.createElement("td", null, label),
                        React__default.createElement("td", null,
                            React__default.createElement(SelectField, { helperText: error && !value ? helperText : '', error: error && !value ? true : false, className: "associate-fields-table-select", value: value, label: label, options: (columns === null || columns === void 0 ? void 0 : columns.map(function (column) { return ({
                                    label: column,
                                    value: column,
                                }); })) || [], onSelectChange: function (_, _a) {
                                    var props = _a.props;
                                    var value = props.value;
                                    var updatedFields = fields.map(function (field) {
                                        if (field.key === key)
                                            field.value = value;
                                        return field;
                                    });
                                    setFields(__spreadArray([], updatedFields, true));
                                } })),
                        React__default.createElement("td", null,
                            React__default.createElement("div", { className: "associate-fields-table-data-container" }, value ? (React__default.createElement(React__default.Fragment, null, (_b = rows.slice(0, 4)) === null || _b === void 0 ? void 0 :
                                _b.map(function (row, rowIndex) {
                                    var _a;
                                    var columnIndex = ((_a = columns === null || columns === void 0 ? void 0 : columns.map(function (c, i) { return (c === value ? i : undefined); })) === null || _a === void 0 ? void 0 : _a.filter(function (a) { return a; })[0]) || 0;
                                    return (React__default.createElement("span", { key: rowIndex }, "".concat(row[columnIndex]).concat((rows === null || rows === void 0 ? void 0 : rows.length) > rowIndex + 1 ? ',' : '')));
                                }),
                                ' ',
                                (rows === null || rows === void 0 ? void 0 : rows.length) > 4 ? React__default.createElement("span", null, "...") : '')) : null))));
                }))) ||
                null))));
};

var ExcelDropzone = function (_a) {
    var setColumns = _a.setColumns, setData = _a.setData, setArrayBuffer = _a.setArrayBuffer, setFileName = _a.setFileName, setFileType = _a.setFileType;
    var getBase64File = function (file) {
        var reader = new FileReader();
        reader.onload = function () {
            setFileType(file.type);
            setArrayBuffer(reader.result);
        };
        reader.readAsArrayBuffer(file);
    };
    var getDataFile = function (file) {
        var reader = new FileReader();
        reader.onload = function (evt) {
            var _a, _b, _c, _d;
            var bstr = (_a = evt === null || evt === void 0 ? void 0 : evt.target) === null || _a === void 0 ? void 0 : _a.result;
            var wb = XLSX === null || XLSX === void 0 ? void 0 : XLSX.read(bstr, { type: 'binary' });
            var wsname = wb === null || wb === void 0 ? void 0 : wb.SheetNames[0];
            var ws = wb === null || wb === void 0 ? void 0 : wb.Sheets[wsname];
            var data = ((_d = (_c = (_b = XLSX.utils) === null || _b === void 0 ? void 0 : _b.sheet_to_csv(ws)) === null || _c === void 0 ? void 0 : _c.split('\n')) === null || _d === void 0 ? void 0 : _d.map(function (rowValues) { return rowValues.split(','); })) || [];
            var employeeColumns = data.shift() || [];
            setColumns(__spreadArray([], employeeColumns, true));
            setData(__spreadArray([], data, true));
            setFileName((file === null || file === void 0 ? void 0 : file.name) || '');
        };
        reader.readAsBinaryString(file);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Dropzone, { accept: ['xlsx', 'xls', 'csv'], onChange: function (files) {
                var _a, _b;
                getBase64File((_a = files[0]) === null || _a === void 0 ? void 0 : _a.file);
                getDataFile((_b = files[0]) === null || _b === void 0 ? void 0 : _b.file);
            } })));
};

var css_248z$m = ".excel-upload-container .excel-upload-h1{color:var(--color-neutral-dark1);font-size:32px;font-weight:700;margin:25px 0}.excel-upload-container .excel-upload-h2{color:var(--color-neutral-dark3);font-size:20px;font-weight:700}.excel-upload-container .excel-upload-text{color:var(--color-neutral-dark5);font-size:16px;font-weight:400}.excel-upload-container .excel-upload-generate-xlsx-file{margin:40px 0}.excel-upload-container .excel-upload-dropzone-container{align-items:stretch;display:flex;justify-content:flex-start;margin-top:20px}@media screen and (max-width:600px){.excel-upload-container .excel-upload-dropzone-container{align-items:stretch;flex-direction:column;justify-content:center}}.excel-upload-container .excel-upload-dropzone-container .excel-upload-dropzone-info{align-items:flex-start;border:1px solid var(--color-neutral-light2);border-radius:10px;color:var(--color-neutral-dark5);display:inline-flex;flex-direction:column;font-size:14px;font-weight:500;justify-content:center;margin-left:20px;padding:25px}@media screen and (max-width:600px){.excel-upload-container .excel-upload-dropzone-container .excel-upload-dropzone-info{margin-left:0;margin-top:20px}}.excel-upload-container .excel-upload-dropzone-container .excel-upload-dropzone-info p{align-items:center;display:inline-flex;justify-content:center}.excel-upload-container .excel-upload-dropzone-container .excel-upload-dropzone-info p svg{fill:#fff;margin-right:5px}.excel-upload-container .excel-upload-dropzone-container .excel-upload-dropzone-info p:first-child{color:var(--color-neutral-dark3);font-weight:600;margin-bottom:20px}.excel-upload-container .excel-upload-dropzone-container .excel-upload-dropzone-info p:last-child{font-size:12px;margin-top:10px}.excel-upload-container .excel-upload-dropzone-container .excel-upload-dropzone-info>p{margin-bottom:10px}.excel-upload-container .excel-upload-submit-button-container{align-items:center;display:inline-flex;justify-content:flex-end;margin-top:20px;width:100%}.excel-upload-container .excel-upload-step-name-container{align-items:center;display:flex;justify-content:flex-start}.excel-upload-container .excel-upload-step-name-container button{color:var(--color-neutral-dark5);font-size:12px;font-weight:600;margin:0 25px;position:relative}.excel-upload-container .excel-upload-step-name-container button:after{background-color:var(--color-neutral-dark5);border-radius:100%;content:\"\";height:8px;left:-15px;position:absolute;top:5px;width:8px}.excel-upload-container .excel-upload-step-name-container button:before{background-color:var(--color-neutral-dark5);content:\"\";display:inline-flex;height:2px;position:absolute;right:-26px;top:7px;width:20px}.excel-upload-container .excel-upload-step-name-container button:last-child:before{display:none}.excel-upload-container .excel-upload-step-name-container .excel-upload-selected-step{color:var(--color-primary)!important}.excel-upload-container .excel-upload-step-name-container .excel-upload-selected-step:after,.excel-upload-container .excel-upload-step-name-container .excel-upload-selected-step:before{background-color:var(--color-primary)!important}";
styleInject(css_248z$m);

var ExcelUpload = function (_a) {
    var fieldsData = _a.fields, onSubmit = _a.onSubmit;
    var _b = useState(0), step = _b[0], setStep = _b[1];
    var _c = useState([]), columns = _c[0], setColumns = _c[1];
    var _d = useState([]), data = _d[0], setData = _d[1];
    var _e = useState(fieldsData), fields = _e[0], setFields = _e[1];
    var _f = useState(''), arrayBuffer = _f[0], setArrayBuffer = _f[1];
    var _g = useState(''), fileName = _g[0], setFileName = _g[1];
    var _h = useState(''), fileType = _h[0], setFileType = _h[1];
    var resetFieldValues = function () {
        setFields(__spreadArray([], fieldsData.map(function (field) {
            field.value = '';
            field.error = false;
            return field;
        }), true));
    };
    var resetFieldsError = function () {
        setFields(__spreadArray([], fieldsData.map(function (field) {
            field.error = false;
            return field;
        }), true));
    };
    var showEmptyFieldsError = function () {
        setFields(__spreadArray([], fieldsData.map(function (field) {
            if (field === null || field === void 0 ? void 0 : field.value)
                return field;
            field.error = true;
            field.helperText = 'Campo obrigátório';
            return field;
        }), true));
    };
    var onSubmitForm = function () {
        var _a;
        var emptyFields = fields === null || fields === void 0 ? void 0 : fields.filter(function (_a) {
            var value = _a.value;
            return !value;
        });
        if (emptyFields === null || emptyFields === void 0 ? void 0 : emptyFields.length) {
            if (!((emptyFields === null || emptyFields === void 0 ? void 0 : emptyFields.length) === 1 &&
                (emptyFields === null || emptyFields === void 0 ? void 0 : emptyFields.find(function (_a) {
                    var label = _a.label;
                    return ['TELEFONE', 'PHONE', 'EMAIL', 'E-MAIL'].includes(label === null || label === void 0 ? void 0 : label.toUpperCase());
                })))) {
                showEmptyFieldsError();
                return;
            }
            else {
                resetFieldsError();
            }
        }
        (_a = onSubmit({
            name: fileName,
            fields: fields,
            arrayBuffer: arrayBuffer,
            type: fileType,
        })) === null || _a === void 0 ? void 0 : _a.then(function () {
            setStep(0);
        });
    };
    useEffect(function () {
        if (!(data === null || data === void 0 ? void 0 : data.length) && step === 1) {
            setStep(0);
            return;
        }
        if ((data === null || data === void 0 ? void 0 : data.length) && (columns === null || columns === void 0 ? void 0 : columns.length)) {
            resetFieldValues();
            setStep(1);
            return;
        }
    }, [data, columns]);
    var renderFirstStep = function () { return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("h1", { className: "excel-upload-h1" }, "Cadastro de colaboradores"),
        React__default.createElement("h2", { className: "excel-upload-h2" }, "Baixe o modelo de planilha"),
        React__default.createElement("p", { className: "excel-upload-text" },
            "Voc\u00EA pode usar o modelo de planilha da Flash para acelerar",
            React__default.createElement("br", null),
            " seu processo, ou o seu pr\u00F3prio modelo. Fique \u00E0 vontade!"),
        React__default.createElement(GenerateXLSXFile, { fileName: "modelo_de_planilha.xlsx", sheetName: "employees", data: [['Nome', 'Número do documento', 'Email', 'Telefone']], buttonTitle: "Baixar modelo", classes: "excel-upload-generate-xlsx-file", docIconSize: 24 }),
        React__default.createElement("h2", { className: "excel-upload-h2" }, "Envie a sua planilha"),
        React__default.createElement("p", { className: "excel-upload-text" },
            "Com a planilha em m\u00E3os, agora \u00E9 s\u00F3 anexar abaixo! Nos pr\u00F3ximos ",
            React__default.createElement("br", null),
            ' ',
            "passos voc\u00EA vai poder conferir tudo e corrigir poss\u00EDveis erros."),
        React__default.createElement("div", { className: "excel-upload-dropzone-container" },
            React__default.createElement(ExcelDropzone, { setColumns: function (e) { return setColumns(e); }, setData: function (e) { return setData(e); }, setArrayBuffer: function (e) { return setArrayBuffer(e); }, setFileName: function (e) { return setFileName(e); }, setFileType: function (e) { return setFileType(e); } }),
            React__default.createElement("div", { className: "excel-upload-dropzone-info" },
                React__default.createElement("p", null,
                    "Crie as colunas da sua planilha",
                    React__default.createElement("br", null),
                    " usando os dados de cadastro b\u00E1sicos."),
                React__default.createElement("p", null,
                    React__default.createElement(Icons, { name: "IconUser", size: 20, className: "dropzone-icon" }),
                    "Nome completo"),
                React__default.createElement("p", null,
                    React__default.createElement(Icons, { name: "IconFileDescription", size: 20, className: "dropzone-icon" }),
                    "CPF"),
                React__default.createElement("p", null,
                    React__default.createElement(Icons, { name: "IconMail", size: 20, className: "dropzone-icon" }),
                    "E-mail*"),
                React__default.createElement("p", null,
                    React__default.createElement(Icons, { name: "IconPhone", size: 20, className: "dropzone-icon" }),
                    "Celular*"),
                React__default.createElement("p", null, "*Voc\u00EA pode informar apenas um dos dois."))))); };
    var renderSecondStep = function () { return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("h1", { className: "excel-upload-h1" }, "Cadastro de colaboradores em lote"),
        React__default.createElement("h2", { className: "excel-upload-h2" }, "Associe colunas e campos"),
        React__default.createElement("p", { className: "excel-upload-text" }, "Relacione as colunas da planilha importada com os campos do seu formul\u00E1rio de cadastro de colaborador."),
        React__default.createElement(AssociateFields, { columns: columns, rows: data, fields: fields, setFields: function (e) { return setFields(e); } }),
        React__default.createElement("div", { className: "excel-upload-submit-button-container" },
            React__default.createElement(Button$4, { type: "button", size: "large", variant: "primary", onClick: onSubmitForm }, "Concluir")))); };
    return (React__default.createElement("div", { className: "excel-upload-container" },
        React__default.createElement("div", { className: "excel-upload-step-name-container" },
            React__default.createElement("button", { className: "excel-upload-selected-step", onClick: function () { return setStep(0); } }, "Envie a planilha"),
            React__default.createElement("button", { className: step === 1 ? 'excel-upload-selected-step' : '', onClick: function () {
                    if (data === null || data === void 0 ? void 0 : data.length)
                        setStep(1);
                } }, "Associe as colunas")),
        step === 0 ? renderFirstStep() : null,
        step === 1 ? renderSecondStep() : null));
};

var ImageWrapper = styled.div(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: transparent;\n  width: ", "px;\n  height: ", "px;\n  min-height: ", "px;\n  min-width: ", "px;\n\n  border: 1px solid var(--color-neutral-light2);\n  border-radius: 50%;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: transparent;\n  width: ", "px;\n  height: ", "px;\n  min-height: ", "px;\n  min-width: ", "px;\n\n  border: 1px solid var(--color-neutral-light2);\n  border-radius: 50%;\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
});
var NameWrapper = styled.div(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: var(--color-secondary-95);\n  width: ", "px;\n  height: ", "px;\n  min-height: ", "px;\n  min-width: ", "px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: var(--color-secondary-95);\n  width: ", "px;\n  height: ", "px;\n  min-height: ", "px;\n  min-width: ", "px;\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
});
var NameInitials = styled.span(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  color: var(--color-primary);\n  font-size: ", "px;\n  font-weight: 700;\n"], ["\n  color: var(--color-primary);\n  font-size: ", "px;\n  font-weight: 700;\n"])), function (_a) {
    var size = _a.size;
    return size / 2.5;
});
var EditButtonsWrapper = styled.div(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n  display: none;\n  color: #fff;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n"], ["\n  display: none;\n  color: #fff;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n"])));
var ProfilePictureHover = styled.div(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  :hover {\n    background: rgba(21, 25, 28, 0.68);\n    backdrop-filter: blur(3px);\n    border-radius: 50%;\n\n    ", " {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n      justify-content: space-evenly;\n    }\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  :hover {\n    background: rgba(21, 25, 28, 0.68);\n    backdrop-filter: blur(3px);\n    border-radius: 50%;\n\n    ", " {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n      justify-content: space-evenly;\n    }\n  }\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, EditButtonsWrapper);
var EditCircle = styled.button(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  background-color: transparent;\n  border: 1px solid #fff;\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n  display: flex;\n  place-content: center;\n  align-items: center;\n  justify-content: center;\n"], ["\n  background-color: transparent;\n  border: 1px solid #fff;\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n  display: flex;\n  place-content: center;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
});
var templateObject_1$P, templateObject_2$y, templateObject_3$m, templateObject_4$k, templateObject_5$f, templateObject_6$a;

var GenericProfilePicture = function (_a) {
    var name = _a.name, size = _a.size, source = _a.source, enableEdit = _a.enableEdit, editCallback = _a.editCallback, deleteCallback = _a.deleteCallback;
    return (React__default.createElement("div", null,
        enableEdit && (React__default.createElement(ProfilePictureHover, { size: size },
            React__default.createElement(EditButtonsWrapper, null,
                React__default.createElement(EditCircle, { size: size * (1 / 3), onClick: editCallback },
                    React__default.createElement(Icons, { name: "IconPencil", fill: "transparent", size: size * 0.25 })),
                !!source && (React__default.createElement(EditCircle, { size: size * (1 / 3), onClick: deleteCallback },
                    React__default.createElement(Icons, { name: "IconTrash", fill: "transparent", size: size * 0.25 })))))),
        source ? (React__default.createElement(ImageWrapper, { size: size },
            React__default.createElement("img", { src: source, alt: "profile" }))) : (React__default.createElement(NameWrapper, { size: size },
            React__default.createElement(NameInitials, { size: size }, name ? nameInitials(name) : '')))));
};

var MainContainer$1 = styled.div(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  background: ", ";\n\n  border-radius: 8px;\n  overflow: hidden;\n  width: 100%;\n\n  border: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  background: ", ";\n\n  border-radius: 8px;\n  overflow: hidden;\n  width: 100%;\n\n  border: ", ";\n"])), function (_a) {
    var variant = _a.variant;
    return (variant === 'soft' ? 'none' : '#f8f6f8');
}, function (_a) {
    var error = _a.error, variant = _a.variant, theme = _a.theme;
    return error &&
        variant != 'soft' &&
        "1px solid ".concat(theme.colors.feedback.error[50]);
});
var GradesContainer = styled.div(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  background: ", ";\n  gap: 20px;\n  overflow-x: auto;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  background: ", ";\n  gap: 20px;\n  overflow-x: auto;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])), function (_a) {
    var variant = _a.variant;
    return (variant === 'soft' ? 'none' : '#f8f6f8');
});
var GradeContainer = styled.div(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: 100%;\n  cursor: pointer;\n  overscroll-behavior-x: contain;\n\n  :hover {\n    > div {\n      background: ", ";\n      color: ", ";\n      border: ", ";\n    }\n    > span {\n      p {\n        color: ", " !important;\n      }\n    }\n    > div {\n      p {\n        color: ", " !important;\n      }\n    }\n  }\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: 100%;\n  cursor: pointer;\n  overscroll-behavior-x: contain;\n\n  :hover {\n    > div {\n      background: ", ";\n      color: ", ";\n      border: ", ";\n    }\n    > span {\n      p {\n        color: ", " !important;\n      }\n    }\n    > div {\n      p {\n        color: ", " !important;\n      }\n    }\n  }\n  ", "\n"])), function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? '' : theme.colors.secondary[95];
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return (disabled ? '' : theme.colors.primary);
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? '' : theme.colors.primary;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? '' : theme.colors.primary;
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return disabled ? '' : theme.colors.primary;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "pointer-events: none";
});
var LabelContainer = styled.div(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  border-radius: 4px;\n  padding: 16px;\n\n  width: ", ";\n  height: ", ";\n\n  background: ", ";\n\n  border: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  border-radius: 4px;\n  padding: 16px;\n\n  width: ", ";\n  height: ", ";\n\n  background: ", ";\n\n  border: ", ";\n"])), function (_a) {
    var variant = _a.variant;
    return (variant === 'soft' ? '100%' : '64px');
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'soft' ? '40px' : '64px');
}, function (_a) {
    var _b, _c;
    var selected = _a.selected, disabled = _a.disabled, error = _a.error, theme = _a.theme, variant = _a.variant;
    if (disabled)
        return theme.colors.neutral[95];
    if (error)
        return theme.colors.feedback.error[90];
    if (selected)
        return theme.colors.secondary[99];
    if (variant === 'soft')
        return 'none';
    else
        return (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral) === null || _c === void 0 ? void 0 : _c[90];
}, function (_a) {
    var _b;
    var selected = _a.selected, disabled = _a.disabled, error = _a.error, theme = _a.theme, variant = _a.variant;
    if (error)
        return "1px solid ".concat(theme.colors.feedback.error[50]);
    if (selected)
        return "1px solid ".concat((_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.primary);
    if (disabled || variant === 'soft')
        return "1px solid ".concat(theme.colors.neutral[90]);
    return 'none';
});
var StyledPOneLine = styled.p(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n  max-width: 200px;\n  text-align: center;\n  margin-top: ", ";\n\n  ", "\n"], ["\n  max-width: 200px;\n  text-align: center;\n  margin-top: ", ";\n\n  ", "\n"])), function (_a) {
    var variant = _a.variant;
    return (variant === 'soft' ? '8px' : '0px');
}, function (_a) {
    var selected = _a.selected, disabled = _a.disabled, theme = _a.theme;
    return disabled
        ? "color: ".concat(theme.colors.neutral[70], ";")
        : selected
            ? "color: ".concat(theme.colors.secondary[50], ";")
            : "color: ".concat(theme.colors.neutral[20], ";");
});
var LabelText = styled(Typography)(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var selected = _a.selected, disabled = _a.disabled, error = _a.error, theme = _a.theme;
    if (disabled)
        return "color: ".concat(theme.colors.neutral[70], ";");
    if (error)
        return "color: ".concat(theme.colors.feedback.error[40], ";");
    if (selected)
        return "color: ".concat(theme.colors.secondary[50], ";");
    return "color: ".concat(theme.colors.neutral[20], ";");
});
// // ------------------ TITLE
var TitleText = styled(Typography)(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  margin-top: 8px;\n  text-align: center;\n  ", "\n"], ["\n  margin-top: 8px;\n  text-align: center;\n  ", "\n"])), function (_a) {
    var selected = _a.selected, disabled = _a.disabled, error = _a.error, theme = _a.theme;
    if (disabled)
        return "color: ".concat(theme.colors.neutral[70], ";");
    if (error)
        return "color: ".concat(theme.colors.feedback.error[40], ";");
    if (selected)
        return "color: ".concat(theme.colors.secondary[50], ";");
    return "color: ".concat(theme.colors.neutral[20], ";");
});
// // ------------------ SUBTITLE
var SubtitleContainer = styled.div(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  text-align: center;\n  font-style: italic;\n  color: var(--color-neutral-dark5);\n"], ["\n  text-align: center;\n  font-style: italic;\n  color: var(--color-neutral-dark5);\n"])));
var templateObject_1$O, templateObject_2$x, templateObject_3$l, templateObject_4$j, templateObject_5$e, templateObject_6$9, templateObject_7$6, templateObject_8$2;

var Grades = function (_a) {
    var contentArray = _a.contentArray, onChange = _a.onChange, value = _a.value, error = _a.error, showTooltip = _a.showTooltip, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, mainContainerClassName = _a.mainContainerClassName, labelContainerClassName = _a.labelContainerClassName, titleContainerClassName = _a.titleContainerClassName;
    var _c = useState(), selected = _c[0], setSelected = _c[1];
    var _d = useState(value), handleValue = _d[0], setHandleValue = _d[1];
    useEffect(function () {
        if (value)
            setHandleValue(value);
    }, [value]);
    var gradesRender = function () {
        var grades = contentArray.map(function (e, index) {
            var label = e === null || e === void 0 ? void 0 : e.label;
            var title = e === null || e === void 0 ? void 0 : e.title;
            var isSelected = false;
            if (handleValue === (e === null || e === void 0 ? void 0 : e.value)) {
                isSelected = true;
            }
            else {
                index === selected ? (isSelected = true) : (isSelected = false);
            }
            return (React__default.createElement(Tooltip$2, { enterNextDelay: 200, title: showTooltip ? e.subtitle : '', TransitionProps: { timeout: 300 }, key: index },
                React__default.createElement(GradeContainer, { className: mainContainerClassName, error: error, disabled: e === null || e === void 0 ? void 0 : e.disabled, key: index, onClick: function () {
                        setHandleValue(undefined);
                        if (onChange)
                            onChange(e);
                        setSelected(index);
                    } },
                    React__default.createElement(LabelContainer, { className: labelContainerClassName, disabled: e === null || e === void 0 ? void 0 : e.disabled, selected: isSelected, error: error, variant: variant },
                        React__default.createElement(StyledPOneLine, null,
                            React__default.createElement(LabelText, { disabled: e === null || e === void 0 ? void 0 : e.disabled, variant: variant === 'soft' ? 'body3' : 'body1', tag: "span", selected: isSelected, error: error, style: { fontWeight: 700 } }, label))),
                    React__default.createElement(StyledPOneLine, { disabled: e === null || e === void 0 ? void 0 : e.disabled, selected: isSelected, variant: variant },
                        React__default.createElement(TitleText, { disabled: e === null || e === void 0 ? void 0 : e.disabled, variant: "body4", tag: "span", selected: isSelected, error: error, style: { fontWeight: 400 } }, title)))));
        });
        return grades;
    };
    var renderSubtitle = function () {
        var grades = contentArray.map(function (e, index) {
            var subtitle = e === null || e === void 0 ? void 0 : e.subtitle;
            var isSelected = false;
            if (handleValue === (e === null || e === void 0 ? void 0 : e.value)) {
                isSelected = true;
            }
            else {
                index === selected ? (isSelected = true) : (isSelected = false);
            }
            var subtitleDiv = subtitle !== undefined && isSelected ? (React__default.createElement("div", { key: e.value, style: { marginTop: '20px' } },
                React__default.createElement(Typography, { variant: "body4", style: { fontStyle: 'italic' } }, subtitle))) : (React__default.createElement(React__default.Fragment, null));
            return subtitleDiv;
        });
        return grades;
    };
    return (React__default.createElement(MainContainer$1, { error: error, variant: variant },
        React__default.createElement(GradesContainer, { variant: variant }, gradesRender()),
        React__default.createElement(SubtitleContainer, { className: titleContainerClassName }, renderSubtitle())));
};

var css_248z$l = ".lds-dual-ring-primary{animation:lds-dual-ring 1.2s linear infinite;border:6px solid var(--color-secondary-light2);border-color:var(--color-primary) var(--color-secondary-light2) var(--color-secondary-light2) var(--color-secondary-light2);border-radius:50%}.lds-dual-ring-primary.size-extraSmall{height:24px;width:24px}.lds-dual-ring-primary.size-small{height:32px;width:32px}.lds-dual-ring-primary.size-medium{height:48px;width:48px}.lds-dual-ring-primary.size-large{height:64px;width:64px}.lds-dual-ring-secondary{animation:lds-dual-ring 1.2s linear infinite;border:6px solid var(--color-secondary-light4);border-color:var(--color-neutral-pureLight) var(--color-secondary-light4) var(--color-secondary-light4) var(--color-secondary-light4);border-radius:50%}.lds-dual-ring-secondary.size-extraSmall{height:24px;width:24px}.lds-dual-ring-secondary.size-small{height:32px;width:32px}.lds-dual-ring-secondary.size-medium{height:48px;width:48px}.lds-dual-ring-secondary.size-large{height:64px;width:64px}@keyframes lds-dual-ring{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
styleInject(css_248z$l);

/**
 * @deprecated - use Spinner
 * https://github.com/flash-tecnologia/hros-web-ui-v2/blob/main/src/components/Spinner/index.tsx
 */
var Loader = function (_a) {
    var size = _a.size, variant = _a.variant;
    return React__default.createElement("div", { className: "lds-dual-ring-".concat(variant, " size-").concat(size) });
};

var sizes = {
    xs: '40.375rem', // 646px
    sm: '54.5rem', // 872px
    md: '58.625rem', // 938px
    full: '100%',
};
var px = '112px'; // padding-left and padding-right
var ModalStyled = styled(Modal$1)(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n  &.MuiModal-root {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    outline: none;\n  }\n"], ["\n  &.MuiModal-root {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    outline: none;\n  }\n"])));
var ModalContainerStyled = styled.div(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  background-color: ", ";\n\n  border-radius: ", ";\n\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  width: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  background-color: ", ";\n\n  border-radius: ", ";\n\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  width: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral100;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.l;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
}, function (_a) {
    var size = _a.size;
    return sizes[size];
});
var ModalWrapperButtonCloseStyled = styled.div(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  padding-right: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  padding-right: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var ModalHeaderStyled = styled.header(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  row-gap: ", ";\n\n  margin-bottom: ", ";\n\n  .content-footer {\n    display: flex;\n    flex-direction: column;\n\n    row-gap: ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n\n    p {\n      color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  row-gap: ", ";\n\n  margin-bottom: ", ";\n\n  .content-footer {\n    display: flex;\n    flex-direction: column;\n\n    row-gap: ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n\n    p {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.m;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.m;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
}, px, px, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral50;
});
var ModalContentStyled = styled.div(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  min-height: 100px;\n\n  padding-left: ", ";\n  padding-right: ", ";\n"], ["\n  min-height: 100px;\n\n  padding-left: ", ";\n  padding-right: ", ";\n"])), px, px);
var ModalFooterStyled = styled.div(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  row-gap: ", ";\n\n  margin-top: ", ";\n\n  .content-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  row-gap: ", ";\n\n  margin-top: ", ";\n\n  .content-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.m;
}, px, px);
var ModalLegacyStyled = styled.div(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  position: relative;\n  border-radius: 8px;\n  background: #ffffff;\n  outline: 0;\n  outline: none;\n  max-height: 80vh;\n  max-width: 80vw;\n  display: flex;\n  flex-direction: column;\n\n  .modal-content-area {\n    padding: 56px 72px;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    word-wrap: break-word;\n  }\n\n  .modal-icon-container {\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    top: -20px;\n    left: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 995;\n  }\n"], ["\n  position: relative;\n  border-radius: 8px;\n  background: #ffffff;\n  outline: 0;\n  outline: none;\n  max-height: 80vh;\n  max-width: 80vw;\n  display: flex;\n  flex-direction: column;\n\n  .modal-content-area {\n    padding: 56px 72px;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    word-wrap: break-word;\n  }\n\n  .modal-icon-container {\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    top: -20px;\n    left: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 995;\n  }\n"])));
var templateObject_1$N, templateObject_2$w, templateObject_3$k, templateObject_4$i, templateObject_5$d, templateObject_6$8, templateObject_7$5;

function Content$5(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(ModalContentStyled, __assign({}, props), children);
}

var ModalRootContext = createContext({});
function Root$4(_a) {
    var children = _a.children, open = _a.open, onClose = _a.onClose, _b = _a.showClose, showClose = _b === void 0 ? true : _b, icon = _a.icon, header = _a.header, footer = _a.footer, style = _a.style, _c = _a.size, size = _c === void 0 ? 'xs' : _c;
    return (React__default.createElement(ModalRootContext.Provider, { value: { onClose: onClose } },
        React__default.createElement(ModalStyled, { open: open, onClose: onClose, style: style }, icon || header || footer ? (React__default.createElement(ModalLegacyStyled, null,
            icon && React__default.createElement("div", { className: "modal-icon-container" }, icon),
            header && React__default.createElement(React__default.Fragment, null, header),
            React__default.createElement("div", { className: "modal-content-area" }, children),
            footer && React__default.createElement(React__default.Fragment, null, footer))) : (React__default.createElement(ModalContainerStyled, { size: size },
            showClose && (React__default.createElement(ModalWrapperButtonCloseStyled, null,
                React__default.createElement(IconButton, { variant: "line", size: "small", icon: "IconX", onClick: onClose }))),
            children)))));
}
var useModalContext = function () {
    var context = useContext(ModalRootContext);
    if (!context) {
        throw new Error('useModalContext must be used within a RootProvider');
    }
    return context;
};

function Footer$1(props) {
    var _a = props, children = _a.children, _b = _a.cancelText, cancelText = _b === void 0 ? 'Cancelar' : _b, _c = _a.confirmText, confirmText = _c === void 0 ? 'Confirmar' : _c, onConfirm = _a.onConfirm, onCancel = _a.onCancel, restProps = __rest(_a, ["children", "cancelText", "confirmText", "onConfirm", "onCancel"]);
    var onClose = useModalContext().onClose;
    var render = useMemo(function () {
        if (props.children) {
            return children;
        }
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(LinkButton, { variant: "neutral", onClick: onCancel ? onCancel : onClose }, cancelText),
            React__default.createElement(Button$4, { variant: "primary", size: "large", onClick: onConfirm }, confirmText)));
    }, [
        children,
        onClose,
        onConfirm,
        props.children,
        cancelText,
        confirmText,
        onCancel,
    ]);
    return (React__default.createElement(ModalFooterStyled, __assign({}, restProps),
        React__default.createElement(Divider, { orientation: "horizontal" }),
        React__default.createElement("div", { className: "content-footer" }, render)));
}

function Header$4(_a) {
    var title = _a.title, description = _a.description, props = __rest(_a, ["title", "description"]);
    return (React__default.createElement(ModalHeaderStyled, __assign({}, props),
        React__default.createElement("div", { className: "content-footer" },
            React__default.createElement(Typography, { variant: "headline6" }, title),
            description && React__default.createElement(Typography, { variant: "body3" }, description)),
        React__default.createElement(Divider, { orientation: "horizontal" })));
}

var Modal = { Root: Root$4, Header: Header$4, Footer: Footer$1, Content: Content$5 };

var css_248z$k = ".multi-select-custom-theme input{color:var(--color-neutral-dark3);font-family:var(--font-family-secondary);font-weight:600;padding-left:7px!important;transform:translateY(10px)}.multi-select-custom-theme input.MuiFilledInput-input{padding:6px 5px!important}.multi-select-custom-theme div.MuiFilledInput-root{background-color:transparent;border:1px solid var(--color-neutral-light2);border-radius:10px;padding:10px 0 10px 15px!important}.multi-select-custom-theme div.MuiFilledInput-root:after,.multi-select-custom-theme div.MuiFilledInput-root:before{content:none}.multi-select-custom-theme div.multi-select-tag{background-color:var(--color-tertiary-1);color:var(--color-secondary-dark1);font-family:var(--font-family-secondary);font-size:12px;font-weight:600;height:24px;line-height:18px}.multi-select-custom-theme div.MuiInputBase-root .MuiAutocomplete-tag{transform:translateY(10px)}.multi-select-custom-theme div.MuiInputBase-root .MuiChip-deleteIcon{margin-right:10px}.multi-select-custom-theme div.Mui-focused{border:2px solid var(--color-secondary-light5)}.multi-select-custom-theme div.Mui-error{background:var(--color-feedback-error-light1);border:2px solid var(--color-feedback-error-pure)}.multi-select-custom-theme div.Mui-disabled{background:var(--color-neutral-light1);border:1px solid var(--color-neutral-light3)}.multi-select-custom-theme label{font-family:var(--font-family-secondary);font-weight:600;padding-left:12px;padding-top:1px}.multi-select-custom-theme label.Mui-error,.multi-select-custom-theme label.Mui-focused,.multi-select-custom-theme p.Mui-error{color:var(--color-neutral-dark5)}.multi-select-custom-theme .warning svg{stroke:var(--color-feedback-error-pure)}.search-field-icon{fill:transparent;left:20px;position:relative;top:30px;z-index:1}.search-field-icon circle,.search-field-icon line{stroke:var(--color-neutral-light4)}.Mui-focused .search-field-icon circle,.Mui-focused .search-field-icon line{stroke:var(--color-secondary-light5)}.Mui-disabled .search-field-icon circle,.Mui-disabled .search-field-icon line{stroke:var(--color-neutral-light3)}.Mui-error .search-field-icon circle,.Mui-error .search-field-icon line{stroke:var(--color-feedback-error-pure)}.helperText{fill:transparent}";
styleInject(css_248z$k);

var MultiSelect = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, disabled = _a.disabled, value = _a.value, onChange = _a.onChange, onSelectChange = _a.onSelectChange, helperText = _a.helperText, error = _a.error, ref = _a.ref, style = _a.style, label = _a.label, onBlur = _a.onBlur, className = _a.className, limitTags = _a.limitTags, defaultValue = _a.defaultValue, getOptionLabel = _a.getOptionLabel, placeholder = _a.placeholder, props = __rest(_a, ["options", "disabled", "value", "onChange", "onSelectChange", "helperText", "error", "ref", "style", "label", "onBlur", "className", "limitTags", "defaultValue", "getOptionLabel", "placeholder"]);
    return (React__default.createElement(Autocomplete, __assign({}, props, { ref: ref, className: error
            ? "Mui-error ".concat(className)
            : "multi-select-custom-theme ".concat(className), options: options, multiple: true, onChange: onSelectChange, value: value, defaultValue: defaultValue, getOptionLabel: getOptionLabel, readOnly: disabled, disabled: disabled, style: style, limitTags: limitTags, renderTags: function (values, getTagProps) {
            return values.map(function (option, index) {
                var _a = getTagProps({ index: index }), className = _a.className, key = _a.key;
                return (React__default.createElement(Chip, __assign({}, getTagProps({ index: index }), { key: key, label: option.label, className: "".concat(className, " multi-select-tag"), deleteIcon: React__default.createElement(Icons, { name: "IconX", className: 'multi-select-tag', size: 18 }) })));
            });
        }, renderInput: function (params) { return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(TextField$2, __assign({}, params, { onBlur: onBlur, onChange: onChange, disabled: disabled, label: label, helperText: false, variant: "filled", className: "multi-select-custom-theme", placeholder: placeholder, error: error })),
            helperText && (React__default.createElement("p", { className: "helperText ".concat(error && 'warning') },
                error && React__default.createElement(Icons, { name: "IconInfoCircle", size: 18 }),
                helperText)))); } })));
};

var MainContainer = styled.div(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  border-radius: ", ";\n  padding: ", ";\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  border-radius: ", ";\n  padding: ", ";\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
}, function (_a) {
    var type = _a.type, variant = _a.variant, theme = _a.theme;
    switch (type) {
        case 'error':
            return "\n          background-color: ".concat(variant === 'contained'
                ? theme.colors.feedback.error[90]
                : theme.colors.neutral[100], ";\n          border: ").concat(theme.borders.width.xs2, " solid ").concat(theme.colors.feedback.error[70], ";\n        ");
        case 'success':
            return "\n          background-color: ".concat(variant === 'contained'
                ? theme.colors.feedback.success[90]
                : theme.colors.neutral[100], ";\n          border: ").concat(theme.borders.width.xs2, " solid ").concat(theme.colors.feedback.success[70], ";\n        ");
        case 'gray':
            return "\n          background-color: ".concat(variant === 'contained'
                ? theme.colors.neutral[90]
                : theme.colors.neutral[100], ";\n          border: ").concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[70], ";\n        ");
        case 'primary':
            return "\n            background-color: ".concat(variant === 'contained'
                ? theme.colors.secondary[99]
                : theme.colors.neutral[100], ";\n            border: ").concat(theme.borders.width.xs2, " solid ").concat(theme.colors.primary, ";\n          ");
        default:
            return "\n          background-color: ".concat(variant === 'contained'
                ? theme.colors.feedback.info[90]
                : theme.colors.neutral[100], ";\n          border: ").concat(theme.borders.width.xs2, " solid ").concat(theme.colors.feedback.info[70], ";\n        ");
    }
});
var IconContainer$2 = styled.div(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", ";\n\n  background: ", ";\n  border-radius: 200px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", ";\n\n  background: ", ";\n  border-radius: 200px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
}, function (_a) {
    var type = _a.type, variant = _a.variant, theme = _a.theme;
    switch (type) {
        case 'error':
            return variant === 'contained'
                ? theme.colors.feedback.error[70]
                : theme.colors.feedback.error[90];
        case 'success':
            return variant === 'contained'
                ? theme.colors.feedback.success[70]
                : theme.colors.feedback.success[90];
        case 'gray':
            return variant === 'contained'
                ? theme.colors.neutral[70]
                : theme.colors.neutral[90];
        case 'primary':
            return variant === 'contained'
                ? theme.colors.secondary[90]
                : theme.colors.secondary[90];
        default:
            return variant === 'contained'
                ? theme.colors.feedback.info[70]
                : theme.colors.feedback.info[90];
    }
});
var StyledIcon = styled(Icons)(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var type = _a.type, theme = _a.theme;
    switch (type) {
        case 'error':
            return theme.colors.feedback.error[40];
        case 'success':
            return theme.colors.feedback.success[40];
        case 'gray':
            return theme.colors.neutral[40];
        case 'primary':
            return theme.colors.primary;
        default:
            return theme.colors.feedback.info[40];
    }
});
var ContentContainer$2 = styled.div(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  display: flex;\n  align-items: ", ";\n\n  flex-direction: ", ";\n\n  column-gap: ", ";\n  row-gap: ", ";\n"], ["\n  display: flex;\n  align-items: ", ";\n\n  flex-direction: ", ";\n\n  column-gap: ", ";\n  row-gap: ", ";\n"])), function (_a) {
    var isVertical = _a.isVertical;
    return (isVertical ? 'flex-start' : 'center');
}, function (_a) {
    var isVertical = _a.isVertical;
    return (isVertical ? 'column' : 'row');
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var StyledText = styled(Typography)(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var type = _a.type, theme = _a.theme;
    switch (type) {
        case 'error':
            return theme.colors.feedback.error[10];
        case 'success':
            return theme.colors.feedback.success[10];
        case 'gray':
            return theme.colors.neutral[10];
        case 'primary':
            return theme.colors.secondary[10];
        default:
            return theme.colors.feedback.info[10];
    }
});
var WrapperTexts = styled.div(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var WrapperIconWithText = styled.div(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  column-gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  column-gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var ButtonContainer = styled.button(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  cursor: pointer;\n\n  align-self: flex-start;\n"], ["\n  cursor: pointer;\n\n  align-self: flex-start;\n"])));
var CloseButton = styled(Icons)(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n\n  color: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var type = _a.type, theme = _a.theme;
    switch (type) {
        case 'error':
            return theme.colors.feedback.error[40];
        case 'success':
            return theme.colors.feedback.success[40];
        case 'gray':
            return theme.colors.neutral[40];
        case 'primary':
            return theme.colors.primary;
        default:
            return theme.colors.feedback.info[40];
    }
});
var templateObject_1$M, templateObject_2$v, templateObject_3$j, templateObject_4$h, templateObject_5$c, templateObject_6$7, templateObject_7$4, templateObject_8$1, templateObject_9$1;

var NotificationCardContext = createContext({});
function Root$3(_a) {
    var _b = _a.type, type = _b === void 0 ? 'info' : _b, _c = _a.variant, variant = _c === void 0 ? 'outlined' : _c, children = _a.children, _d = _a.isVertical, isVertical = _d === void 0 ? false : _d, autoClose = _a.autoClose, showCloseButton = _a.showCloseButton, onClose = _a.onClose;
    var _e = useState(false), hide = _e[0], setHide = _e[1];
    var handleClose = function () {
        onClose && onClose();
        autoClose && setHide(true);
    };
    return (React__default.createElement(NotificationCardContext.Provider, { value: { type: type, variant: variant } }, !hide && (React__default.createElement(MainContainer, { type: type, variant: variant },
        React__default.createElement(ContentContainer$2, { isVertical: isVertical }, children),
        showCloseButton && (React__default.createElement(ButtonContainer, { onClick: handleClose },
            React__default.createElement(CloseButton, { type: type, name: "IconX" })))))));
}
var useNotificationCardContext = function () {
    var context = useContext(NotificationCardContext);
    if (!context) {
        throw new Error('useNoticationCardContext must be used within a Root');
    }
    return context;
};

function Icon$1(_a) {
    var iconName = _a.iconName, _b = _a.size, size = _b === void 0 ? 24 : _b;
    var _c = useNotificationCardContext(), type = _c.type, variant = _c.variant;
    return (React__default.createElement(IconContainer$2, { type: type, variant: variant },
        React__default.createElement(StyledIcon, { size: size, stroke: '2px', name: iconName, type: type, fill: "none" })));
}

function Subtitle(_a) {
    var children = _a.children;
    var type = useNotificationCardContext().type;
    return (React__default.createElement(StyledText, { type: type, variant: "body4", style: { fontWeight: '400' } }, children));
}

function Title$2(_a) {
    var children = _a.children;
    var type = useNotificationCardContext().type;
    return (React__default.createElement(StyledText, { type: type, variant: "body3", style: { fontWeight: '600' } }, children));
}

var NotificationCard = {
    Icon: Icon$1,
    Root: Root$3,
    Subtitle: Subtitle,
    Title: Title$2,
    WrapperIconWithText: WrapperIconWithText,
    WrapperTexts: WrapperTexts,
};

var Container$n = styled.div(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  width: 48px;\n  height: 56px;\n\n  &[data-size='medium'] {\n    width: 60px;\n    height: 80px;\n  }\n"], ["\n  width: 48px;\n  height: 56px;\n\n  &[data-size='medium'] {\n    width: 60px;\n    height: 80px;\n  }\n"])));
var TextField = styled(TextFieldStyled)(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n\n  .MuiInputBase-root {\n    flex: 1;\n  }\n\n  .MuiInputBase-input {\n    color: ", ";\n    font-weight: 600;\n    line-height: 22px;\n\n    padding: 0;\n\n    text-align: center;\n\n    &::placeholder {\n      font-size: 16px;\n      font-weight: 600;\n      line-height: 22px;\n\n      color: ", ";\n    }\n  }\n\n  .Mui-focused {\n    input::placeholder {\n      color: transparent;\n    }\n  }\n\n  &[data-size='medium'] {\n    .MuiInputLabel-root,\n    .MuiInputBase-input {\n      font-size: 1.5rem;\n\n      &::placeholder {\n        font-size: 1.5rem;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n\n  .MuiInputBase-root {\n    flex: 1;\n  }\n\n  .MuiInputBase-input {\n    color: ", ";\n    font-weight: 600;\n    line-height: 22px;\n\n    padding: 0;\n\n    text-align: center;\n\n    &::placeholder {\n      font-size: 16px;\n      font-weight: 600;\n      line-height: 22px;\n\n      color: ", ";\n    }\n  }\n\n  .Mui-focused {\n    input::placeholder {\n      color: transparent;\n    }\n  }\n\n  &[data-size='medium'] {\n    .MuiInputLabel-root,\n    .MuiInputBase-input {\n      font-size: 1.5rem;\n\n      &::placeholder {\n        font-size: 1.5rem;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[30];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[80];
});
var templateObject_1$L, templateObject_2$u;

var Field = function (_a) {
    var error = _a.error, inputProps = _a.inputProps, onError = _a.onError, ref = _a.ref, onChange = _a.onChange, value = _a.value, onClick = _a.onClick, onBlur = _a.onBlur, onFocus = _a.onFocus, onPaste = _a.onPaste, style = _a.style, _b = _a.multiline, multiline = _b === void 0 ? false : _b, rows = _a.rows, disabled = _a.disabled, maxRows = _a.maxRows, onKeyDown = _a.onKeyDown, focused = _a.focused, fieldId = _a.fieldId, _c = _a.size, size = _c === void 0 ? 'small' : _c;
    var _d = useState(false), isHovered = _d[0], setIsHovered = _d[1];
    useEffect(function () {
        if (focused) {
            var $input = document.getElementById(fieldId);
            $input.setSelectionRange(1, 1);
            $input.focus();
            IMask($input, {
                mask: Number,
                min: 0,
                max: 9,
            });
        }
    }, [fieldId, focused]);
    return (React__default.createElement(Container$n, { "data-size": size },
        React__default.createElement(TextField, __assign({ id: fieldId, ref: ref, onError: onError, onFocus: function (e) { return onFocus && onFocus(e); }, onBlur: onBlur, onChange: onChange, value: value, onClick: onClick, helperText: false, error: error, inputProps: __assign({}, inputProps), style: style, multiline: multiline, rows: rows, disabled: disabled, onKeyDown: onKeyDown, maxRows: maxRows, variant: "filled" }, (error && { className: 'warning' }), { hiddenLabel: true, autoComplete: "off", placeholder: "\u2022", onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); }, onPaste: onPaste, "data-hovered": isHovered, "data-size": size }))));
};

var Container$m = styled.div(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n  display: inline-flex;\n\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  row-gap: ", ";\n"], ["\n  display: inline-flex;\n\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  row-gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var LabelStyled = styled.label(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  color: ", ";\n\n  font-weight: 600;\n  line-height: 22px;\n\n  &[data-disabled='true'] {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n\n  font-weight: 600;\n  line-height: 22px;\n\n  &[data-disabled='true'] {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[40];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[80];
});
var HelperTextStyled = styled.p(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 18px;\n\n  color: ", ";\n\n  fill: transparent;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 18px;\n\n  color: ", ";\n\n  fill: transparent;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[50];
});
var BoxStyled = styled.div(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  display: inline-flex;\n\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n\n  column-gap: ", ";\n"], ["\n  display: inline-flex;\n\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n\n  column-gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var templateObject_1$K, templateObject_2$t, templateObject_3$i, templateObject_4$g;

var OTPField = function (_a) {
    var ref = _a.ref, onError = _a.onError, error = _a.error, helperText = _a.helperText, InputProps = _a.InputProps, style = _a.style, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, numInputs = _a.numInputs, label = _a.label, onChange = _a.onChange, _c = _a.size, size = _c === void 0 ? 'small' : _c, className = _a.className;
    var theme = useTheme();
    var _d = useState(null), inputIndexFocus = _d[0], setInputIndexFocus = _d[1];
    var _e = useState([]), inputValues = _e[0], setInputValues = _e[1];
    var emptyDigits = useMemo(function () { return Array(numInputs).fill(''); }, [numInputs]);
    var changeInputFocus = useCallback(function (index) {
        if (index < numInputs) {
            setInputIndexFocus(index + 1);
        }
    }, [numInputs]);
    var handleInputChange = useCallback(function (event, index) {
        var newValue = event.target.value;
        setInputValues(function (oldValues) {
            var updatedValues = [];
            var isValueMissing = isUndefined(oldValues[index]) || isNull(oldValues[index]);
            if (isValueMissing) {
                updatedValues = __spreadArray(__spreadArray([], oldValues, true), [newValue], false);
            }
            else {
                updatedValues = oldValues.map(function (val, i) {
                    return i === index ? newValue : val;
                });
            }
            if (onChange) {
                onChange(updatedValues.join(''));
            }
            return updatedValues;
        });
        if (newValue) {
            changeInputFocus(index);
        }
    }, [changeInputFocus, onChange]);
    var handleKeyDown = useCallback(function (event, currentIndex) {
        var key = event.key;
        var currentValue = inputValues[currentIndex];
        if (key === 'Backspace' && !currentValue) {
            changeInputFocus(currentIndex - 2);
            return;
        }
        if (key === 'ArrowLeft') {
            changeInputFocus(currentIndex - 2);
            return;
        }
        if (key === 'ArrowRight') {
            changeInputFocus(currentIndex);
            return;
        }
    }, [changeInputFocus, inputValues]);
    var handleOnPaste = useCallback(function (event) {
        event.preventDefault();
        var pastedData = event.clipboardData.getData('text/plain');
        setInputValues(pastedData.split(''));
        onChange === null || onChange === void 0 ? void 0 : onChange(pastedData);
    }, []);
    useEffect(function () {
        if (value && value.length) {
            setInputValues(value.split(''));
        }
    }, [value]);
    return (React__default.createElement(Container$m, { className: className },
        label ? (React__default.createElement(LabelStyled, { "data-disabled": disabled }, label)) : null,
        React__default.createElement(BoxStyled, null, emptyDigits.map(function (_, i) { return (React__default.createElement(Field, __assign({ fieldId: "web-ui-otp-field-".concat(i), key: i, ref: ref, onError: onError, onFocus: function () { return setInputIndexFocus(i); }, onPaste: handleOnPaste, value: inputValues[i] || '', onKeyDown: function (event) { return handleKeyDown(event, i); }, onChange: function (event) { return handleInputChange(event, i); }, error: error, InputProps: InputProps, style: style, variant: "filled" }, (error && { className: 'warning' }), { hiddenLabel: true, focused: i === inputIndexFocus ? true : false, disabled: disabled, size: size }))); })),
        !disabled && helperText ? (React__default.createElement(HelperTextStyled, { className: "".concat(error && 'warning') },
            error && (React__default.createElement(Icons, { color: theme.colors.feedback.error[50], name: "IconInfoCircle", size: 18 })),
            helperText)) : null));
};

var css_248z$j = ".page-container-container{display:flex;flex-direction:column;flex-grow:1;margin:0 auto;max-width:1440px;padding:0 37px;width:100%}";
styleInject(css_248z$j);

var PageContainer = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style;
    return (React__default.createElement("div", { className: "page-container-container ".concat(className), style: style }, children));
};

var css_248z$i = ".page-header-container{display:flex;justify-content:flex-start;margin:0 auto;max-width:1440px;padding:32px 37px;width:100%}";
styleInject(css_248z$i);

var PageHeader = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, children = _a.children, className = _a.className, style = _a.style;
    return (React__default.createElement("div", { className: "page-header-container ".concat(className), style: style }, children || React__default.createElement(Typography, { variant: "headline6" }, title)));
};

var css_248z$h = ".show-password-input-adornment svg{fill:transparent;stroke:var(--color-neutral-40)}.show-password-icon-button.MuiIconButton-root{padding:0}.size-medium .show-password-icon-button,.size-small .show-password-icon-button{height:16px;width:16px}.Mui-focused .show-password-input-adornment svg{fill:transparent;stroke:var(--color-secondary-light5)}.Mui-disabled .show-password-input-adornment svg{fill:transparent;stroke:var(--color-neutral-light3)}.Mui-error .show-password-input-adornment svg{fill:transparent;stroke:var(--color-feedback-error-pure)}.new-password-errors-area{margin-left:16px}.new-password-errors-area div{align-items:center;display:flex;margin-top:8px}.new-password-errors-area div svg{fill:transparent;stroke:var(--color-neutral-40);margin-right:4px}.new-password-errors-area .disabled{color:var(--color-neutral-80)}.new-password-errors-area .disabled svg{stroke:var(--color-neutral-80)}.new-password-errors-area .success{color:var(--color-feedback-success-40)}.new-password-errors-area .success svg{stroke:var(--color-feedback-success-40)}.new-password-errors-area .warning{color:var(--color-feedback-error-50)}.new-password-errors-area .warning svg{stroke:var(--color-feedback-error-50)}";
styleInject(css_248z$h);

var PasswordField = forwardRef(function (_a, ref) {
    var id = _a.id, name = _a.name, autoComplete = _a.autoComplete, isCreatePassword = _a.isCreatePassword, disabled = _a.disabled, value = _a.value, error = _a.error, label = _a.label, style = _a.style, helperText = _a.helperText, fullWidth = _a.fullWidth, onError = _a.onError, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onClick = _a.onClick, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, size = _a.size;
    var _b = useState(false), showPassword = _b[0], setShowPassword = _b[1];
    var renderIcon = useCallback(function (variable) {
        if (disabled || (value === null || value === void 0 ? void 0 : value.length) === 0)
            return React__default.createElement(Icons, { name: "IconInfoCircle", size: 16 });
        if (variable)
            return React__default.createElement(Icons, { name: "IconCircleCheck", size: 16 });
        return React__default.createElement(Icons, { name: "IconCircleX", size: 16 });
    }, [disabled, value]);
    var renderClass = useCallback(function (variable) {
        if (disabled)
            return 'disabled';
        if ((value === null || value === void 0 ? void 0 : value.length) === 0)
            return '';
        return variable ? 'success' : 'warning';
    }, [disabled, value]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TextField$1, { id: id, name: name, autoComplete: autoComplete, inputRef: ref, label: label, type: disabled ? 'password' : showPassword ? 'text' : 'password', disabled: disabled, value: value, helperText: helperText, error: error, style: style, size: size, fullWidth: fullWidth, onChange: onChange, onBlur: onBlur, onError: onError, onFocus: onFocus, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, InputProps: {
                endAdornment: (React__default.createElement(InputAdornment, { className: "show-password-input-adornment", position: "end" },
                    React__default.createElement(IconButton$1, { className: "show-password-icon-button", onClick: function () { return setShowPassword(!showPassword); }, onMouseDown: function (e) { return e.preventDefault(); } }, disabled ? null : showPassword ? (React__default.createElement(Icons, { name: "IconEye" })) : (React__default.createElement(Icons, { name: "IconEyeOff" }))))),
            } }),
        isCreatePassword && (React__default.createElement("div", { className: "new-password-errors-area" },
            React__default.createElement("div", { className: renderClass((value === null || value === void 0 ? void 0 : value.length) >= 8) },
                renderIcon((value === null || value === void 0 ? void 0 : value.length) >= 8),
                React__default.createElement(Typography.Caption, { color: "neutral.40" }, "M\u00EDnimo 8 caracteres")),
            React__default.createElement("div", { className: renderClass(value === null || value === void 0 ? void 0 : value.match('(?=.*[a-z])(?=.*[A-Z])')) },
                renderIcon(value === null || value === void 0 ? void 0 : value.match('(?=.*[a-z])(?=.*[A-Z])')),
                React__default.createElement(Typography.Caption, { color: "neutral.40" }, "Letras mai\u00FAsculas e min\u00FAsculas (Aa)")),
            React__default.createElement("div", { className: renderClass(value === null || value === void 0 ? void 0 : value.match(/\d/)) },
                renderIcon(value === null || value === void 0 ? void 0 : value.match(/\d/)),
                React__default.createElement(Typography.Caption, { color: "neutral.40" }, "Ao menos 1 n\u00FAmero (123)")),
            React__default.createElement("div", { className: renderClass(
                // eslint-disable-next-line no-useless-escape
                value === null || value === void 0 ? void 0 : value.match(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/)) },
                renderIcon(
                // eslint-disable-next-line no-useless-escape
                value === null || value === void 0 ? void 0 : value.match(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/)),
                React__default.createElement(Typography.Caption, { color: "neutral.40" }, "Ao menos 1 caractere especial (@#$)"))))));
});
PasswordField.displayName = 'PasswordField';

var PDFViewer = forwardRef(function (_a, ref) {
    var src = _a.src, options = _a.options, width = _a.width, height = _a.height, rest = __rest(_a, ["src", "options", "width", "height"]);
    var ApplySrcProps = useCallback(function (src) {
        var keyparams = Object.keys(options) ? '#' : '';
        var sourceUpdated = '';
        Object.keys(options).map(function (key, index) {
            keyparams += "".concat(index ? '&' : '');
            switch (key) {
                case 'showToolbar':
                    keyparams += "toolbar=".concat(options['showToolbar'] ? 1 : 0);
                    return '';
                case 'fit':
                    keyparams += "view=".concat(options['fit'] === 'vertical'
                        ? 'FitV'
                        : options['fit'] === 'height'
                            ? 'FitH'
                            : 'Fit');
                    return '';
                case 'zoom':
                    keyparams += "zoom=".concat(options['zoom']);
                    return '';
                case 'page':
                    keyparams += "page=".concat(options['page']);
                    return '';
            }
            return '';
        });
        sourceUpdated = src + keyparams;
        return sourceUpdated;
    }, [options]);
    return (React__default.createElement("iframe", __assign({ width: width, height: height, ref: ref, src: ApplySrcProps(src), scrolling: "auto", frameBorder: 0, title: "iframePDF" }, rest)));
});
PDFViewer.displayName = 'PDFViewer';

var css_248z$g = ".radio-custom-styles.MuiRadio-root{color:var(--color-neutral-light4)}.radio-custom-styles.MuiRadio-root:focus,.radio-custom-styles.MuiRadio-root:hover{background-color:transparent;color:var(--color-neutral-dark3)}.radio-custom-styles.Mui-checked:focus,.radio-custom-styles.Mui-checked:hover{padding:5px}.radio-custom-styles.Mui-checked:focus>span:first-of-type,.radio-custom-styles.Mui-checked:hover>span:first-of-type{background-color:var(--color-secondary-light4);border:4px solid var(--color-secondary-light4);border-radius:50%}.radio-custom-styles.Mui-checked.disabled{color:#000}.radio-custom-styles.Mui-checked .MuiSvgIcon-root:first-child{background-color:var(--color-primary);border-radius:50%;color:var(--color-primary);z-index:1}.radio-custom-styles.Mui-checked .MuiSvgIcon-root:last-child{color:#fff;z-index:2}.radio-custom-styles.Mui-disabled{color:transparent!important}.radio-custom-styles.Mui-disabled .MuiSvgIcon-root{background-color:var(--color-neutral-light1);border:2px solid var(--color-neutral-light3);border-radius:50%;height:20px;width:20px}.radio-error{color:var(--color-feedback-error-pure)!important}.radio-error.Mui-checked:focus>span:first-of-type,.radio-error.Mui-checked:hover>span:first-of-type{background-color:var(--color-feedback-error-light1);border-color:var(--color-feedback-error-light1)}.radio-error.Mui-checked .MuiSvgIcon-root:first-child{background-color:var(--color-feedback-error-pure)!important;color:var(--color-feedback-error-pure)!important}";
styleInject(css_248z$g);

var Radio = function (_a) {
    var _b = _a.error, error = _b === void 0 ? false : _b, disabled = _a.disabled, checked = _a.checked, className = _a.className, style = _a.style, value = _a.value, name = _a.name, onChange = _a.onChange;
    var getClasses = function () {
        var radioClasses = [className, 'radio-custom-styles'];
        if (error)
            radioClasses.push('radio-error');
        return radioClasses.join(' ');
    };
    return (React.createElement(Radio$1, { className: getClasses(), disabled: disabled, checked: checked, style: style, value: value, name: name, onChange: onChange }));
};

var Button$2 = styled(ButtonBase)(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  align-items: flex-start;\n  border: ", " solid\n    ", ";\n  border-radius: ", "\n    ", "\n    ", "\n    ", ";\n  display: flex;\n  flex-direction: column;\n  height: 262px;\n  justify-content: flex-start;\n  padding: ", ";\n  width: 311px;\n"], ["\n  align-items: flex-start;\n  border: ", " solid\n    ", ";\n  border-radius: ", "\n    ", "\n    ", "\n    ", ";\n  display: flex;\n  flex-direction: column;\n  height: 262px;\n  justify-content: flex-start;\n  padding: ", ";\n  width: 311px;\n"])), function (props) { return props.theme.borders.width.xs2; }, function (props) { return props.theme.colors.neutral[80]; }, function (props) { return props.theme.borders.radius.m; }, function (props) { return props.theme.borders.radius.xl2; }, function (props) { return props.theme.borders.radius.m; }, function (props) { return props.theme.borders.radius.m; }, function (props) { return props.theme.spacings.s; });
var Title$1 = styled(Typography)(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  font-weight: 700;\n  margin: ", " 0\n    ", ";\n"], ["\n  font-weight: 700;\n  margin: ", " 0\n    ", ";\n"])), function (props) { return props.theme.spacings.xs2; }, function (props) { return props.theme.spacings.xs4; });
var Description = styled(Typography)(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  color: ", ";\n  text-align: left;\n"], ["\n  color: ", ";\n  text-align: left;\n"])), function (props) { return props.theme.colors.neutral[50]; });
var IconContainer$1 = styled.div(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  align-items: center;\n  aspect-ratio: 1 / 1;\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n"], ["\n  align-items: center;\n  aspect-ratio: 1 / 1;\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n"])), function (props) { return props.theme.colors.secondary[95]; }, function (props) { return props.theme.borders.radius.circular; });
var Icon = styled(Icons)(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  fill: transparent;\n\n  svg {\n    stroke: ", ";\n  }\n"], ["\n  fill: transparent;\n\n  svg {\n    stroke: ", ";\n  }\n"])), function (props) { return props.theme.colors.primary; });
var TopContainer = styled.div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"], ["\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"])));
var RadioButton = styled(Radio)(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  padding: 0;\n\n  &.Mui-checked:hover {\n    padding: 0;\n\n    & > span:first-of-type {\n      border-width: ", ";\n    }\n  }\n"], ["\n  padding: 0;\n\n  &.Mui-checked:hover {\n    padding: 0;\n\n    & > span:first-of-type {\n      border-width: ", ";\n    }\n  }\n"])), function (props) { return props.theme.borders.width.xs2; });
var templateObject_1$J, templateObject_2$s, templateObject_3$h, templateObject_4$f, templateObject_5$b, templateObject_6$6, templateObject_7$3;

var RadioButtonCard = function (_a) {
    var icon = _a.icon, title = _a.title, description = _a.description, onClick = _a.onClick, checked = _a.checked;
    var ref = useRef();
    return (React__default.createElement(Button$2, { onClick: onClick },
        React__default.createElement(TopContainer, null,
            React__default.createElement(IconContainer$1, null,
                React__default.createElement(Icon, { name: icon, size: 24 })),
            React__default.createElement(RadioButton, { inputRef: ref, onChange: onClick, checked: checked })),
        React__default.createElement(Title$1, { variant: "body3" }, title),
        description && (React__default.createElement(Description, { variant: "body4" }, description))));
};

var Container$l = styled.label(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        width: '32px',
        height: '32px',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
        border: "".concat(theme.borders.width.xs2, " solid transparent"),
        borderRadius: theme.borders.radius.pill,
        cursor: 'pointer',
        '> input': {
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
        },
        '> svg': {
            width: '16px',
            height: '16px',
            pointerEvents: 'none',
        },
        '&:hover': {
            backgroundColor: theme.colors.neutral[90],
        },
        ':has(input:checked)': {
            color: theme.colors.secondary[50],
            fontWeight: 700,
            background: theme.colors.secondary[95],
            borderColor: theme.colors.secondary[95],
        },
        ':has(span)': {
            width: 'auto',
            gap: theme.spacings.xs4,
            padding: "".concat(theme.spacings.xs4, " ").concat(theme.spacings.xs3),
            fontSize: '14px',
            fontFamily: 'var(--font-family-secondary)',
            fontWeight: 600,
            color: theme.colors.neutral[40],
            cursor: 'pointer',
            whiteSpace: 'nowrap',
        },
    });
});

function RadioVisionItem(props) {
    return (React__default.createElement(Container$l, null,
        React__default.createElement("input", { id: props.id, type: "radio", checked: props.checked, onChange: function () { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, props.id); } }),
        props.label && React__default.createElement("span", null, props.label),
        props.icon && React__default.createElement(Icons, { name: props.icon, size: 16 })));
}

var Container$k = styled.div(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  width: max-content;\n  padding: ", ";\n  gap: 2px;\n  outline: ", ";\n  border-radius: ", ";\n  display: flex;\n"], ["\n  width: max-content;\n  padding: ", ";\n  gap: 2px;\n  outline: ", ";\n  border-radius: ", ";\n  display: flex;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.pill;
});
var templateObject_1$I;

function RadioVision(props) {
    return (React__default.createElement(Container$k, null, props.views.map(function (view) { return (React__default.createElement(RadioVisionItem, __assign({ key: view.id, checked: props.value === view.id, onChange: props.onChangeView }, view))); })));
}

var ToogleIcon = styled(Switch)(function (_a) {
    var theme = _a.theme, showIcon = _a.showIcon, status = _a.status, disabled = _a.disabled;
    var switchTrackColor = function () {
        var _a;
        if (!status || status === 'default')
            return theme.colors.brand[50];
        return (_a = theme.colors.status[status]) === null || _a === void 0 ? void 0 : _a[40];
    };
    return {
        padding: 9,
        '&:hover': {
            '& .MuiSwitch-track': {
                backgroundColor: theme.colors.neutral[30],
                transition: 'none',
                opacity: 1,
            },
        },
        '& .MuiSwitch-track': __assign({ borderRadius: 22 / 2, position: 'relative', backgroundColor: theme.colors.neutral[disabled ? 80 : 60], transition: 'background-color 0.3s ease', opacity: 1, '&::before, &::after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                width: 13,
                height: 13,
            } }, (showIcon && {
            '&::before': {
                content: "''",
                backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"13\" width=\"13\" viewBox=\"0 0 24 24\"><path fill=\"".concat(encodeURIComponent(theme.colors.neutral[100]), "\" d=\"M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z\"/></svg>')"),
                left: 4,
                position: 'absolute',
                transform: 'translateY(-50%)',
            },
            '&::after': {
                content: "''",
                backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"15\" width=\"15\" viewBox=\"0 0 24 24\"><path fill=\"".concat(encodeURIComponent(theme.colors.neutral[100]), "\" d=\"M18.3 5.71L13.59 10.41L18.3 15.11L16.88 16.53L12.18 11.83L7.48 16.53L6.06 15.11L10.77 10.41L6.06 5.71L7.48 4.29L12.18 8.99L16.88 4.29L18.3 5.71Z\"/></svg>')"),
                right: 5,
                position: 'absolute',
                transform: 'translateY(-50%)',
            },
        })),
        '.Mui-checked': {
            '& + .MuiSwitch-track': {
                backgroundColor: switchTrackColor(),
                opacity: 1,
            },
        },
        '.MuiSwitch-switchBase': {
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
        '.Mui-disabled': {
            '& + .MuiSwitch-track': {
                backgroundColor: theme.colors.neutral[80],
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxShadow: 'none',
            width: 16,
            height: 16,
            margin: 2,
            backgroundColor: theme.colors.neutral[100],
            transition: 'background-color 0.3s ease',
        },
    };
});

var css_248z$f = ".toggle-custom-theme.MuiSwitch-root{height:20px;padding:0;width:36px}.toggle-custom-theme .MuiSwitch-switchBase{color:var(--color-neutral-pureLight);margin:2px;padding:0;transition-duration:.3s}.toggle-custom-theme .MuiSwitch-switchBase.Mui-checked{color:var(--color-neutral-pureLight);transform:translateX(16px)}.toggle-custom-theme .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track{background-color:var(--color-primary);border:0;opacity:1}.toggle-custom-theme .MuiSwitch-switchBase.Mui-checked.Mui-disabled+.MuiSwitch-track{opacity:.5}.toggle-custom-theme .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb{color:var(--color-neutral-pureLight)}.toggle-custom-theme .MuiSwitch-switchBase.Mui-disabled+.MuiSwitch-track{opacity:.2}.toggle-custom-theme .MuiSwitch-thumb{box-sizing:border-box;height:16px;width:16px}.toggle-custom-theme .MuiSwitch-track{background-color:var(--color-neutral-light3);border-radius:12px;opacity:1}";
styleInject(css_248z$f);

var Toggle = function (props) {
    var _a = useState(props.defaultChecked || false), isChecked = _a[0], setIsChecked = _a[1];
    var toggleSwitch = useCallback(function (e) {
        if (props.disabled)
            return;
        setIsChecked(!e.target.checked);
    }, [isChecked, props.onChange, props.disabled]);
    useEffect(function () {
        if (props.checked === undefined)
            return;
        setIsChecked(props.checked);
    }, [props.checked, setIsChecked]);
    return React__default.createElement(ToogleIcon, __assign({}, props, { onClick: toggleSwitch, disableTouchRipple: true }));
};

var defaultFields = [
    {
        key: 'name',
        label: 'Nome completo',
        type: 'text',
        value: '',
        required: true,
        disabled: false,
        error: false,
        helperText: 'Campo obrigatório',
    },
    {
        key: 'documentNumber',
        label: 'CPF',
        type: 'text',
        value: '',
        required: true,
        disabled: false,
        error: false,
        helperText: 'Campo obrigatório',
    },
    {
        key: 'email',
        label: 'E-mail',
        type: 'text',
        value: '',
        required: true,
        disabled: false,
        error: false,
        helperText: 'Campo obrigatório',
        sideTip: 'Você deve preencher ao menos um dado de contato.',
    },
    {
        key: 'phone',
        label: 'Celular',
        type: 'text',
        value: '',
        required: true,
        disabled: false,
        error: false,
        helperText: 'Campo obrigatório',
        sideTip: 'Você deve preencher ao menos um dado de contato.',
    },
    {
        key: 'administrator',
        label: 'Tornar esse colaborador administrador',
        type: 'checkbox',
        value: false,
        required: false,
        disabled: false,
        error: false,
        helperText: 'Administradores possuem acesso a todos os recursos e informações da conta.',
    },
    {
        key: 'scheduleInvite',
        label: 'Enviar convite de acesso à plataforma imediatamente',
        description: 'Para enviar o link de acesso depois, desmarque essa opção.',
        type: 'toggle',
        value: false,
        required: false,
        disabled: false,
        error: false,
        helperText: '',
    },
];

var validateEmail = function (value) {
    if (value.includes('@') && value.includes('.'))
        return true;
    return false;
};
var validatePhone = function (value) {
    if (value.length === 15)
        return true;
    return false;
};
var cpfMask = function (cpfValue) {
    return cpfValue
        .replace(/\D+/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};
var phoneMask = function (phoneValue) {
    if (phoneValue.replace(/\D+/g, '').length <= 10) {
        return phoneValue
            .replace(/\D+/g, '')
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{4})(\d)/, '$1-$2');
    }
    if (phoneValue.replace(/\D+/g, '').length > 10) {
        return phoneValue
            .replace(/\D+/g, '')
            .replace(/(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{5})(\d)/, '$1-$2');
    }
    return '';
};
var removeSpecialCharacters = function (value) {
    value = value.replaceAll('.', '');
    value = value.replaceAll('-', '');
    value = value.replaceAll('(', '');
    value = value.replaceAll(')', '');
    value = value.replaceAll(' ', '');
    return value;
};

var css_248z$e = ".register-employee-form-container{align-items:flex-start;display:flex;flex-direction:column;justify-content:center;padding:25px}.register-employee-form-container .register-employee-form-title{color:var(--color-neutral-dark1);margin-bottom:5px}.register-employee-form-container .register-employee-form-subtitle{color:var(--color-neutral-dark5);margin-bottom:25px}.register-employee-form-container .register-employee-form-button{margin-left:auto;margin-right:175px}.register-employee-form-container .register-employee-form-end-adorment{align-items:center;color:var(--color-neutral-dark4);cursor:pointer;display:inline-flex;justify-content:flex-end;min-width:140px}@media only screen and (max-width:500px){.register-employee-form-container .register-employee-form-end-adorment p{display:none}}.register-employee-form-container .register-employee-form-end-adorment-disabled{color:var(--color-neutral-light3)}.register-employee-form-container .register-employee-form-row{align-items:center;display:flex;justify-content:space-between}.register-employee-form-container .register-employee-form-checkbox-field-container{align-items:center;border:1px solid var(--color-neutral-light3);border-radius:8px;display:flex;justify-content:flex-start;padding:20px 10px}.register-employee-form-container .register-employee-form-checkbox-field-container .register-employee-form-toggle-texts-wrapper{margin-left:5px;text-align:left}.register-employee-form-container .register-employee-form-checkbox-field-container .register-employee-form-toggle-texts-wrapper b{color:var(--color-neutral-dark3);font-weight:600}.register-employee-form-container .register-employee-form-checkbox-field-container .register-employee-form-toggle-texts-wrapper p{color:var(--color-neutral-dark5);max-width:390px}.register-employee-form-container .register-employee-form-checkbox-field-container .register-employee-form-toggle-texts-wrapper .date-picker{margin-top:15px}.register-employee-form-container .register-employee-form-side-tip{border-left:1px solid var(--color-neutral-light3);color:var(--color-neutral-dark5);font-weight:600;margin-left:50px;padding-left:10px;text-align:left;width:140px}.register-employee-form-container .register-employee-form-link-container{background-color:var(--color-secondary-light2);border:1px solid var(--color-secondary-dark5);border-radius:92px;cursor:pointer;padding:16px 24px;text-align:left}.register-employee-form-container .register-employee-form-link-container p{border-bottom:1px solid var(--color-secondary-dark5);color:var(--color-secondary-dark5);display:inline;font-weight:700}.register-employee-form-container .register-employee-form-checkbox-field-container,.register-employee-form-container .register-employee-form-field-container{margin-bottom:15px}.register-employee-form-container .register-employee-form-checkbox-field-container,.register-employee-form-container .register-employee-form-field,.register-employee-form-container .register-employee-form-field-container,.register-employee-form-container .register-employee-form-link-container,.register-employee-form-container .register-employee-form-row{min-width:200px;width:100%}.register-employee-form-container .clipboard{margin-bottom:15px;width:calc(100% - 175px)}";
styleInject(css_248z$e);

var RegisterEmployee = function (_a) {
    var _b, _c;
    var onError = _a.onError, onSubmit = _a.onSubmit, blur = _a.blur;
    var _d = useState(defaultFields), formFields = _d[0], setFormFields = _d[1];
    var resetFields = function () {
        var newFormFieldsValues = formFields === null || formFields === void 0 ? void 0 : formFields.map(function (field) {
            field = __assign({}, defaultFields.find(function (_a) {
                var key = _a.key;
                return key === field.key;
            }));
            return field;
        });
        setFormFields(__spreadArray([], newFormFieldsValues, true));
    };
    var hasContactField = function (fieldKey) {
        return ['email', 'phone'].includes(fieldKey);
    };
    var getRequiredFieldsWithEmptyValue = function () {
        return formFields === null || formFields === void 0 ? void 0 : formFields.filter(function (_a) {
            var value = _a.value, required = _a.required;
            return required && !value;
        });
    };
    var formatErrors = function (fields) {
        return fields.map(function (_a) {
            var key = _a.key, label = _a.label, helperText = _a.helperText, value = _a.value;
            return ({
                key: key,
                field: label,
                value: ['documentNumber', 'phone'].includes(key)
                    ? removeSpecialCharacters(value)
                    : value,
                error: helperText,
            });
        });
    };
    var formatData = function (fields) {
        var data = {};
        fields.forEach(function (_a) {
            var key = _a.key, value = _a.value;
            if (!value)
                return;
            data[key] = ['documentNumber', 'phone'].includes(key)
                ? removeSpecialCharacters(value)
                : value;
        });
        return data;
    };
    var getFieldMaxLength = function (fieldKey) {
        if (fieldKey === 'documentNumber')
            return 14;
        if (fieldKey === 'phone')
            return 15;
        if (fieldKey === 'name')
            return 40;
        if (fieldKey === 'email')
            return 50;
        return 99;
    };
    var showEmptyFieldsError = function () {
        return setFormFields(__spreadArray([], formFields === null || formFields === void 0 ? void 0 : formFields.map(function (field) {
            if (field.required && !field.value) {
                field.error = true;
                field.helperText = 'Campo obrigatório';
            }
            return field;
        }), true));
    };
    var showFieldError = function (fieldKey, errorMessage) {
        return setFormFields(__spreadArray([], formFields === null || formFields === void 0 ? void 0 : formFields.map(function (field) {
            if (field.key === fieldKey) {
                field.error = true;
                field.helperText = errorMessage;
            }
            return field;
        }), true));
    };
    var setRequired = function (fieldKey) {
        return setFormFields(__spreadArray([], formFields === null || formFields === void 0 ? void 0 : formFields.map(function (field) {
            if (field.key !== fieldKey)
                return field;
            field.value = '';
            field.error = false;
            field.required = !field.required;
            field.disabled = !field.required;
            return field;
        }), true));
    };
    var renderSideTip = function (fieldKey, fieldSideTip) {
        var _a;
        return (React__default.createElement(Typography, { variant: "caption", tag: "span", className: "register-employee-form-side-tip" }, ((_a = formFields.find(function (_a) {
            var key = _a.key;
            return key === (fieldKey === 'email' ? 'phone' : 'email');
        })) === null || _a === void 0 ? void 0 : _a.disabled)
            ? fieldSideTip
            : ''));
    };
    var renderAdorment = function (fieldKey) {
        var _a, _b, _c, _d, _e;
        var disabledField = !!((_a = formFields === null || formFields === void 0 ? void 0 : formFields.filter(function (_a) {
            var key = _a.key, required = _a.required;
            return key !== fieldKey && hasContactField(key) && !required;
        })) === null || _a === void 0 ? void 0 : _a.length) ||
            !!(((_b = formFields.find(function (_a) {
                var key = _a.key;
                return key === 'administrator';
            })) === null || _b === void 0 ? void 0 : _b.value) &&
                fieldKey === 'email');
        return (React__default.createElement("button", { type: "button", onClick: function () { return !disabledField && setRequired(fieldKey); }, className: "register-employee-form-end-adorment ".concat(!((_c = formFields.find(function (_a) {
                var key = _a.key;
                return key !== fieldKey && hasContactField(key);
            })) === null || _c === void 0 ? void 0 : _c.required) ||
                (((_d = formFields.find(function (_a) {
                    var key = _a.key;
                    return key === 'administrator';
                })) === null || _d === void 0 ? void 0 : _d.value) &&
                    fieldKey === 'email')
                ? 'register-employee-form-end-adorment-disabled'
                : '') },
            React__default.createElement(Typography, { variant: "body3" }, "N\u00E3o informar"),
            React__default.createElement(Checkbox$1, { checked: !((_e = formFields.find(function (_a) {
                    var key = _a.key;
                    return key === fieldKey;
                })) === null || _e === void 0 ? void 0 : _e.required), disabled: disabledField })));
    };
    var handleAndAddMask = function (fieldKey, fieldValue) {
        if (typeof fieldValue !== 'string')
            return fieldValue;
        if (fieldKey === 'phone')
            return phoneMask(fieldValue);
        if (fieldKey === 'documentNumber')
            return cpfMask(fieldValue);
        return fieldValue;
    };
    var onFieldValueChange = function (value, fieldIndex) {
        var newFormFieldsValues = formFields === null || formFields === void 0 ? void 0 : formFields.map(function (field, index) {
            if (index !== fieldIndex)
                return field;
            field.error = false;
            field.value = handleAndAddMask(field.key, value);
            return field;
        });
        setFormFields(__spreadArray([], newFormFieldsValues, true));
    };
    var onSubmitForm = function (e) {
        e.preventDefault();
        var errors = [];
        var requiredFieldsWithEmptyValue = getRequiredFieldsWithEmptyValue();
        var emailField = formFields.find(function (_a) {
            var key = _a.key;
            return key === 'email';
        });
        var phoneField = formFields.find(function (_a) {
            var key = _a.key;
            return key === 'phone';
        });
        var scheduleField = formFields.find(function (_a) {
            var key = _a.key;
            return key === 'scheduleInvite';
        });
        var email = typeof (emailField === null || emailField === void 0 ? void 0 : emailField.value) === 'string' ? emailField.value : '';
        var phone = typeof (phoneField === null || phoneField === void 0 ? void 0 : phoneField.value) === 'string' ? phoneField.value : '';
        if (requiredFieldsWithEmptyValue === null || requiredFieldsWithEmptyValue === void 0 ? void 0 : requiredFieldsWithEmptyValue.length) {
            showEmptyFieldsError();
            requiredFieldsWithEmptyValue.forEach(function (error) { return errors.push(error); });
        }
        if (!validateEmail(email) && email !== '') {
            showFieldError('email', 'E-mail inválido');
            errors.push(emailField);
        }
        if (!validatePhone(phone) && phone !== '') {
            showFieldError('phone', 'Celular inválido');
            errors.push(phoneField);
        }
        if ((scheduleField === null || scheduleField === void 0 ? void 0 : scheduleField.value) === false) {
            showFieldError('scheduleInvite', 'Selecione uma data');
            errors.push(scheduleField);
        }
        if (errors.length) {
            if (onError)
                onError(formatErrors(errors));
            return;
        }
        if (onSubmit)
            onSubmit(formatData(formFields));
    };
    if (((_b = formFields.find(function (_a) {
        var key = _a.key;
        return key === 'administrator';
    })) === null || _b === void 0 ? void 0 : _b.value) &&
        !((_c = formFields.find(function (_a) {
            var key = _a.key;
            return key === 'email';
        })) === null || _c === void 0 ? void 0 : _c.required))
        setRequired('email');
    useEffect(function () {
        resetFields();
        return function () {
            resetFields();
        };
    }, [onSubmit]);
    return (React__default.createElement("form", { onSubmit: onSubmitForm, className: "register-employee-form-container" },
        React__default.createElement(Typography, { variant: "headline6", className: "register-employee-form-title" }, "Cadastro de colaborador"),
        React__default.createElement(Typography, { variant: "body3", className: "register-employee-form-subtitle" },
            "Deixe seus talentos voarem na velocidade da luz",
            ' ',
            React__default.createElement("span", { role: "img", "aria-label": "strike" }, "\u26A1")), formFields === null || formFields === void 0 ? void 0 :
        formFields.map(function (field, i) {
            if (field.type === 'text') {
                return (React__default.createElement("div", { key: i, className: "register-employee-form-row" },
                    React__default.createElement("div", { className: "register-employee-form-field-container" },
                        React__default.createElement(TextField$1, __assign({}, field, { disabled: field.disabled, className: "register-employee-form-field", helperText: (field === null || field === void 0 ? void 0 : field.error) ? field === null || field === void 0 ? void 0 : field.helperText : '', onChange: function (e) { return onFieldValueChange(e.target.value, i); }, InputProps: hasContactField(field.key)
                                ? {
                                    endAdornment: renderAdorment(field.key),
                                }
                                : {}, inputProps: {
                                maxLength: getFieldMaxLength(field.key),
                            }, onBlur: function (e) {
                                var _a, _b;
                                if (e &&
                                    (blur === null || blur === void 0 ? void 0 : blur.onBlur) &&
                                    ((_a = blur === null || blur === void 0 ? void 0 : blur.affectedFields) === null || _a === void 0 ? void 0 : _a.includes(field === null || field === void 0 ? void 0 : field.key))) {
                                    blur
                                        .onBlur({
                                        key: field === null || field === void 0 ? void 0 : field.key,
                                        value: ((_b = ['documentNumber', 'phone']) === null || _b === void 0 ? void 0 : _b.includes(field === null || field === void 0 ? void 0 : field.key)) &&
                                            typeof (field === null || field === void 0 ? void 0 : field.value) === 'string'
                                            ? removeSpecialCharacters(field === null || field === void 0 ? void 0 : field.value)
                                            : field === null || field === void 0 ? void 0 : field.value,
                                    })
                                        .then(function (_a) {
                                        var error = _a.error, helperText = _a.helperText;
                                        if (error && helperText && !(field === null || field === void 0 ? void 0 : field.disabled))
                                            showFieldError(field === null || field === void 0 ? void 0 : field.key, helperText);
                                    });
                                }
                            } }))),
                    renderSideTip(field.key, field.sideTip)));
            }
            if (field.type === 'checkbox') {
                return (React__default.createElement("div", { key: i, className: "register-employee-form-row" },
                    React__default.createElement("div", { className: "register-employee-form-checkbox-field-container" },
                        React__default.createElement(Checkbox$1, { onChange: function () { return onFieldValueChange(!field.value, i); }, checked: !!field.value }),
                        React__default.createElement("div", null,
                            React__default.createElement(Typography, { variant: "body3", tag: "b" }, field.label),
                            React__default.createElement(Typography, { variant: "body4", tag: "p" }, field.helperText))),
                    renderSideTip(field.key, field.sideTip)));
            }
            if (field.type === 'toggle') {
                return (React__default.createElement("div", { key: i, className: "register-employee-form-row" },
                    React__default.createElement("div", { className: "register-employee-form-checkbox-field-container" },
                        React__default.createElement(Toggle, { size: "medium", checked: field.value === true, onChange: function () {
                                onFieldValueChange(!field.value, i);
                            } }),
                        React__default.createElement("div", { className: "register-employee-form-toggle-texts-wrapper" },
                            React__default.createElement(Typography, { variant: "body3", tag: "b" }, field.label),
                            React__default.createElement(Typography, { variant: "body4", tag: "p" }, field.description),
                            field.key === 'scheduleInvite' && field.value !== true && (React__default.createElement(DatePicker, { className: "date-picker", error: field === null || field === void 0 ? void 0 : field.error, fromDate: dayjs(new Date()).add(1, 'day'), helperText: (field === null || field === void 0 ? void 0 : field.error) ? field === null || field === void 0 ? void 0 : field.helperText : '', label: "Selecionar data", onDateChange: function (value) {
                                    onFieldValueChange(value ? value.toDate() : false, i);
                                }, value: typeof (field === null || field === void 0 ? void 0 : field.value) !== 'boolean'
                                    ? new Date(field === null || field === void 0 ? void 0 : field.value)
                                    : undefined })))),
                    renderSideTip(field.key, field.sideTip)));
            }
            return React__default.createElement(React__default.Fragment, null);
        }),
        React__default.createElement(Button$4, { type: "submit", size: "large", variant: "primary", className: "register-employee-form-button" }, "Cadastrar")));
};

var SelectFieldOption = styled.div(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: flex-start;\n  color: ", ";\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n"], ["\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: flex-start;\n  color: ", ";\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[30];
});
var SelectFieldOptionIcon = styled.div(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  margin-right: 8px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  height: min-content;\n  fill: ", ";\n"], ["\n  margin-right: 8px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  height: min-content;\n  fill: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary[40];
});
var SelectFieldOptionCaption = styled.div(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[60];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.secondary;
});
var StyledPopper = styled(Popper)(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  z-index: 3;\n  padding-top: 5px;\n\n  .MuiAutocomplete-listbox {\n    margin: 10px 0;\n\n    .MuiAutocomplete-option {\n      border-radius: 8px;\n      margin: 6px 12px;\n      padding: 16px;\n      text-align: left;\n\n      &[aria-selected='true'] {\n        color: ", ";\n        font-weight: 700;\n\n        .select-field-option {\n          color: ", ";\n\n          .select-field-option-icon {\n            fill: ", ";\n          }\n\n          .select-field-option-caption {\n            color: ", ";\n          }\n        }\n      }\n    }\n  }\n"], ["\n  z-index: 3;\n  padding-top: 5px;\n\n  .MuiAutocomplete-listbox {\n    margin: 10px 0;\n\n    .MuiAutocomplete-option {\n      border-radius: 8px;\n      margin: 6px 12px;\n      padding: 16px;\n      text-align: left;\n\n      &[aria-selected='true'] {\n        color: ", ";\n        font-weight: 700;\n\n        .select-field-option {\n          color: ", ";\n\n          .select-field-option-icon {\n            fill: ", ";\n          }\n\n          .select-field-option-caption {\n            color: ", ";\n          }\n        }\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary[40];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary[40];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary[40];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[60];
});
var SearchFieldIcon = styled(InputAdornment)(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  position: relative;\n  fill: transparent;\n  z-index: 1;\n  .iconSearch {\n    ", ";\n    stroke: ", ";\n  }\n  ", ";\n"], ["\n  position: relative;\n  fill: transparent;\n  z-index: 1;\n  .iconSearch {\n    ", ";\n    stroke: ", ";\n  }\n  ", ";\n"])), function (_a) {
    var inputSize = _a.inputSize;
    switch (inputSize) {
        case 'sm':
            return 'width: 16px; height: 16px';
        case 'md':
            return 'width: 16px; height: 16px';
        default:
            return 'width: 24px; height: 24px';
    }
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[50];
}, function (_a) {
    var inputSize = _a.inputSize;
    switch (inputSize) {
        case 'sm':
            return 'top: 20px; left: 12px;';
        case 'md':
            return 'top: 23px; left: 16px;';
        default:
            return 'top: 30px; left: 16px;';
    }
});
var StyledTextField = styled(TextField$1)(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  .MuiInputLabel-root {\n    transition: 0.3s;\n    padding-left: 38px;\n  }\n\n  .MuiFilledInput-root {\n    border-radius: ", ";\n\n    ", "\n\n    .MuiFilledInput-input {\n      ", "\n    }\n\n    input {\n      margin-left: 40px;\n    }\n\n    &.Mui-disabled {\n      background-color: ", ";\n      cursor: not-allowed;\n      color: ", ";\n    }\n\n    &.Mui-error {\n      .MuiAutocomplete-clearIndicator {\n        svg {\n          fill: ", ";\n        }\n      }\n    }\n  }\n\n  &.size-sm {\n    .MuiInputLabel-root {\n      padding-left: 20px;\n    }\n\n    .MuiFilledInput-root input {\n      margin-left: 22px;\n    }\n  }\n\n  &.size-md {\n    .MuiInputLabel-root {\n      padding-left: 30px;\n    }\n\n    .MuiFilledInput-root input {\n      margin-left: 32px;\n    }\n  }\n\n  .Mui-focused {\n    .MuiAutocomplete-clearIndicator {\n      svg {\n        fill: ", ";\n        stroke: none;\n      }\n    }\n  }\n"], ["\n  .MuiInputLabel-root {\n    transition: 0.3s;\n    padding-left: 38px;\n  }\n\n  .MuiFilledInput-root {\n    border-radius: ", ";\n\n    ", "\n\n    .MuiFilledInput-input {\n      ", "\n    }\n\n    input {\n      margin-left: 40px;\n    }\n\n    &.Mui-disabled {\n      background-color: ", ";\n      cursor: not-allowed;\n      color: ", ";\n    }\n\n    &.Mui-error {\n      .MuiAutocomplete-clearIndicator {\n        svg {\n          fill: ", ";\n        }\n      }\n    }\n  }\n\n  &.size-sm {\n    .MuiInputLabel-root {\n      padding-left: 20px;\n    }\n\n    .MuiFilledInput-root input {\n      margin-left: 22px;\n    }\n  }\n\n  &.size-md {\n    .MuiInputLabel-root {\n      padding-left: 30px;\n    }\n\n    .MuiFilledInput-root input {\n      margin-left: 32px;\n    }\n  }\n\n  .Mui-focused {\n    .MuiAutocomplete-clearIndicator {\n      svg {\n        fill: ", ";\n        stroke: none;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.pill;
}, function (_a) {
    var inputSize = _a.inputSize;
    switch (inputSize) {
        case 'sm':
            return 'padding-top: 1px; padding-bottom: 1px;';
        case 'md':
            return 'padding-top: 10px;';
        case 'lg':
            return 'padding-top: 22px;';
        default:
            return 'padding-top: 20px; padding-bottom: 2px;';
    }
}, function (_a) {
    var inputSize = _a.inputSize;
    return (inputSize === 'md' ? 'padding: 10px 4px 4px;' : '');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[95];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[70];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.error50;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary[70];
});
var Wrapper$1 = styled.div(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  width: 100%;\n\n  .Mui-focused {\n    :not(.Mui-error) {\n      .iconSearch {\n        stroke: ", ";\n      }\n    }\n  }\n\n  .Mui-disabled {\n    .iconSearch {\n      stroke: ", ";\n    }\n  }\n\n  .Mui-error {\n    .iconSearch {\n      stroke: ", ";\n    }\n  }\n"], ["\n  width: 100%;\n\n  .Mui-focused {\n    :not(.Mui-error) {\n      .iconSearch {\n        stroke: ", ";\n      }\n    }\n  }\n\n  .Mui-disabled {\n    .iconSearch {\n      stroke: ", ";\n    }\n  }\n\n  .Mui-error {\n    .iconSearch {\n      stroke: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary[70];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[80];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.feedback.error[50];
});
var templateObject_1$H, templateObject_2$r, templateObject_3$g, templateObject_4$e, templateObject_5$a, templateObject_6$5, templateObject_7$2;

var mapInputSizeToTextFieldSize = function (inputSize) {
    switch (inputSize) {
        case 'sm':
            return 'small';
        case 'md':
            return 'medium';
        case 'lg':
        default:
            return 'large';
    }
};
var SearchField = function (_a) {
    var _b;
    var _c = _a.options, options = _c === void 0 ? [] : _c, disabled = _a.disabled, _d = _a.multiple, multiple = _d === void 0 ? false : _d, value = _a.value, onChange = _a.onChange, onSearchChange = _a.onSearchChange, onInputChange = _a.onInputChange, helperText = _a.helperText, error = _a.error, ref = _a.ref, label = _a.label, onBlur = _a.onBlur, className = _a.className, onKeyDown = _a.onKeyDown, onClear = _a.onClear, props = __rest(_a, ["options", "disabled", "multiple", "value", "onChange", "onSearchChange", "onInputChange", "helperText", "error", "ref", "label", "onBlur", "className", "onKeyDown", "onClear"]);
    var size = (_b = props.inputSize) !== null && _b !== void 0 ? _b : 'legacy';
    return (React__default.createElement(Wrapper$1, null,
        React__default.createElement(Autocomplete, __assign({}, props, { ref: ref, className: error ? "Mui-error ".concat(className) : "".concat(className), options: options, multiple: multiple, onChange: onSearchChange, value: value, readOnly: disabled, disabled: disabled, freeSolo: true, onInputChange: function (event, newValue, reason) {
                onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(event, newValue, reason);
                if (newValue === '' && onClear) {
                    onClear();
                }
            }, popupIcon: React__default.createElement(Icons, { name: "IconChevronDown", fill: "transparent" }), PopperComponent: function (props) { return React__default.createElement(StyledPopper, __assign({}, props)); }, renderInput: function (params) { return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(SearchFieldIcon, { position: "start", inputSize: size },
                    React__default.createElement(Icons, { className: "iconSearch", name: "IconSearch" })),
                React__default.createElement(StyledTextField, __assign({}, params, { className: "size-".concat(size), onBlur: function (e) {
                        onBlur && onBlur(e);
                        onChange && onChange(e);
                    }, onChange: onChange, error: error, onKeyDown: onKeyDown, disabled: disabled, label: label, helperText: helperText, variant: "filled", inputSize: size, size: mapInputSizeToTextFieldSize(size) })))); }, renderOption: function (props, option) {
                return (React__default.createElement("li", __assign({}, props),
                    React__default.createElement(SelectFieldOption, { className: "select-field-option" },
                        Boolean(option === null || option === void 0 ? void 0 : option.icon) && (React__default.createElement(SelectFieldOptionIcon, null, option === null || option === void 0 ? void 0 : option.icon)),
                        React__default.createElement("div", null,
                            React__default.createElement("div", null, option === null || option === void 0 ? void 0 : option.label),
                            Boolean(option === null || option === void 0 ? void 0 : option.caption) && (React__default.createElement(SelectFieldOptionCaption, null, option === null || option === void 0 ? void 0 : option.caption))))));
            } }))));
};

var Skeleton$1 = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'rectangular' : _b, width = _a.width, height = _a.height, style = _a.style, className = _a.className, animation = _a.animation, props = __rest(_a, ["variant", "width", "height", "style", "className", "animation"]);
    return (React__default.createElement(Skeleton$2, __assign({}, props, { variant: variant, width: width, height: height, style: style, className: className, animation: animation })));
};

var css_248z$d = ".stepper-container-custom-theme-horizontal{align-items:center;display:flex}.stepper-container-custom-theme-horizontal .disable-click{cursor:default;pointer-events:none}.stepper-container-custom-theme-horizontal .step-container,.stepper-container-custom-theme-horizontal .step-flex{align-items:center;display:flex}.stepper-container-custom-theme-horizontal .selected .step-label-container{color:var(--color-primary)}.stepper-container-custom-theme-horizontal .selected .step-circle{background-color:var(--color-primary);border:none}.stepper-container-custom-theme-horizontal .divider-active .step-divider-dotted,.stepper-container-custom-theme-horizontal .divider-active .step-divider-numbered,.stepper-container-custom-theme-horizontal .selected .step-numbered-circle{background-color:var(--color-primary)}.stepper-container-custom-theme-horizontal .step-divider-dotted,.stepper-container-custom-theme-horizontal .step-divider-numbered{background-color:var(--color-neutral-light3);height:1px;margin-left:16px;margin-right:16px;width:16px}.stepper-container-custom-theme-horizontal .step-label-container{-webkit-line-clamp:1;-webkit-box-orient:vertical;color:var(--color-neutral-dark5);cursor:pointer;display:inline-block;display:-webkit-box;line-height:1;overflow:hidden;text-overflow:ellipsis}.stepper-container-custom-theme-horizontal .step-container:last-child .step-divider-dotted:last-child,.stepper-container-custom-theme-horizontal .step-container:last-child .step-divider-numbered:last-child{display:none}.stepper-container-custom-theme-horizontal .step-circle{border:1px solid var(--color-neutral-light3);border-radius:50%;height:8px;margin-right:4px;width:8px}.stepper-container-custom-theme-horizontal .step-numbered-circle{align-items:center;background-color:var(--color-neutral-light4);border-radius:50%;color:var(--color-neutral-pureLight);display:flex;height:24px;justify-content:center;margin-right:8px;width:24px}.stepper-container-custom-theme-vertical{display:flex;flex-direction:column}.stepper-container-custom-theme-vertical .disable-click{cursor:default;pointer-events:none}.stepper-container-custom-theme-vertical .step-container{display:flex;flex-direction:column}.stepper-container-custom-theme-vertical .step-flex{align-items:center;display:flex}.stepper-container-custom-theme-vertical .selected .step-label-container{color:var(--color-primary)}.stepper-container-custom-theme-vertical .selected .step-circle{background-color:var(--color-primary);border:none}.stepper-container-custom-theme-vertical .divider-active .step-divider-dotted,.stepper-container-custom-theme-vertical .divider-active .step-divider-numbered,.stepper-container-custom-theme-vertical .selected .step-numbered-circle{background-color:var(--color-primary)}.stepper-container-custom-theme-vertical .step-divider-dotted{background-color:var(--color-neutral-light3);height:16px;margin-left:4px;width:1px}.stepper-container-custom-theme-vertical .step-divider-numbered{background-color:var(--color-neutral-light3);height:16px;margin-bottom:4px;margin-left:12px;margin-top:4px;width:1px}.stepper-container-custom-theme-vertical .step-numbered-circle{align-items:center;background-color:var(--color-neutral-light4);border-radius:50%;color:var(--color-neutral-pureLight);display:flex;height:24px;justify-content:center;margin-right:8px;width:24px}.stepper-container-custom-theme-vertical .step-label-container{-webkit-line-clamp:1;-webkit-box-orient:vertical;color:var(--color-neutral-dark5);cursor:pointer;display:inline-block;display:-webkit-box;line-height:1;overflow:hidden;text-overflow:ellipsis}.stepper-container-custom-theme-vertical .step-circle{border:1px solid var(--color-neutral-light3);border-radius:50%;height:8px;margin-right:4px;width:8px}.stepper-container-custom-theme-vertical .step-container:last-child .step-divider-dotted:last-child,.stepper-container-custom-theme-vertical .step-container:last-child .step-divider-numbered:last-child{display:none}";
styleInject(css_248z$d);

var Stepper = function (_a) {
    var _b = _a.activeStep, activeStep = _b === void 0 ? 0 : _b, _c = _a.type, type = _c === void 0 ? 'numbered' : _c, _d = _a.direction, direction = _d === void 0 ? 'horizontal' : _d, _e = _a.disableClick, disableClick = _e === void 0 ? false : _e, _f = _a.steps, steps = _f === void 0 ? [] : _f, setActiveStep = _a.setActiveStep, _g = _a.style, style = _g === void 0 ? {} : _g, className = _a.className;
    var renderComponent = useMemo(function () {
        if (!steps.length)
            return React__default.createElement(React__default.Fragment, null);
        return steps.map(function (label, index) {
            var increaseIndex = index + 1;
            var isLastItem = steps.length === increaseIndex;
            var stepValidation = activeStep !== undefined && index <= activeStep;
            var stepDivider = activeStep !== undefined && index < activeStep;
            return (React__default.createElement("button", { type: "button", key: label, onClick: function () {
                    if (!disableClick && setActiveStep)
                        setActiveStep(index);
                }, className: "".concat(className, " step-container ").concat(stepValidation && "selected", " ").concat(stepDivider && "divider-active", " ").concat(disableClick && "disable-click") },
                React__default.createElement("div", { className: "step-flex" },
                    React__default.createElement("div", null, type === 'dotted' ? (React__default.createElement("div", { className: "step-circle" })) : (React__default.createElement("div", { className: "step-numbered-circle" },
                        React__default.createElement(Typography, { variant: "caption" }, increaseIndex)))),
                    React__default.createElement("div", { className: "step-label-container" },
                        React__default.createElement(Typography, { variant: "caption", style: { fontWeight: 600 } }, label))),
                React__default.createElement("div", { className: "step-divider-".concat(type, " ").concat(isLastItem && 'noShow') })));
        });
    }, [activeStep, setActiveStep, disableClick, type, steps]);
    return (React__default.createElement("div", { className: "stepper-container-custom-theme-".concat(direction, " ").concat(direction), style: style }, renderComponent));
};

var Container$j = styled.div(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  display: grid;\n  justify-items: center;\n  gap: ", ";\n"], ["\n  display: grid;\n  justify-items: center;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var Content$4 = styled.div(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  display: grid;\n  justify-items: center;\n  gap: ", ";\n  text-align: center;\n"], ["\n  display: grid;\n  justify-items: center;\n  gap: ", ";\n  text-align: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var templateObject_1$G, templateObject_2$q;

function SurveyFeedback(_a) {
    var title = _a.title, description = _a.description, hasError = _a.hasError, onRetry = _a.onRetry;
    var colors = useTheme().colors;
    return (React__default.createElement(Container$j, null,
        hasError ? (React__default.createElement(ShapeIcon, { name: "IconMessageReport", variant: "error", color: colors.error40, size: 33 })) : (React__default.createElement(ShapeIcon, { name: "IconMessageChatbot", variant: "default", color: colors.secondary50, size: 33 })),
        React__default.createElement(Content$4, null,
            React__default.createElement(Typography, { variant: "headline9", variantColor: colors.neutral30 }, title),
            description && (React__default.createElement(Typography, { variant: "body4", variantColor: colors.neutral40 }, description))),
        hasError && (React__default.createElement(LinkButton, { onClick: onRetry, variant: "error" }, "Tentar novamente"))));
}

var Container$i = styled.div(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  font-family: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.secondary;
});
var Label = styled.label(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  position: absolute;\n  font-weight: 600;\n  font-size: ", ";\n  color: ", ";\n  top: ", ";\n  left: ", ";\n  transition: 0.3s ease all;\n  background: ", ";\n"], ["\n  position: absolute;\n  font-weight: 600;\n  font-size: ", ";\n  color: ", ";\n  top: ", ";\n  left: ", ";\n  transition: 0.3s ease all;\n  background: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral40;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var $hasError = _a.$hasError, theme = _a.theme;
    return $hasError ? theme.colors.error90 : 'transparent';
});
var SpanLabelRequired = styled.span(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n  margin-left: ", ";\n  color: ", ";\n"], ["\n  margin-left: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.error40;
});
var InfoWrapper = styled.div(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  margin-top: ", ";\n  padding: 0px ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  margin-top: ", ";\n  padding: 0px ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
});
var StyledTextArea = styled.textarea(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  padding-top: ", ";\n  overflow: auto !important;\n  resize: ", ";\n  width: 100%;\n  min-height: ", ";\n  color: ", ";\n  transition: 0.3s ease border-color;\n  font-weight: 600;\n\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n\n  &::-webkit-scrollbar {\n    background: transparent;\n    width: 6px;\n    height: 48px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  &:hover:not(:active):not(:focus):not(:disabled) {\n    border: 2px solid\n      ", ";\n    + ", " {\n      height: 18px;\n      top: ", ";\n    }\n  }\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: ", ";\n  }\n\n  &:active&:focus {\n    border: 2px solid\n      ", ";\n  }\n\n  &:focus::-webkit-scrollbar-thumb {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    border: 1px solid ", ";\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:disabled + ", ", &:disabled ~ ", " {\n    cursor: not-allowed;\n    color: ", ";\n    font-weight: 600;\n  }\n\n  &:focus + ", ", &:not(:placeholder-shown) + ", " {\n    height: 18.6px;\n    left: ", ";\n    right: ", ";\n    font-size: ", ";\n    background-color: ", ";\n    font-weight: 600;\n    color: ", ";\n    display: flex;\n    align-items: flex-end;\n  }\n\n  &:not(:placeholder-shown) + ", " {\n    transition: 0s ease all;\n    top: ", ";\n  }\n\n  &:disabled + ", " {\n    cursor: not-allowed;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    outline: ", ";\n  }\n\n  &:focus-visible + ", " {\n    height: 18px;\n    top: ", ";\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  padding-top: ", ";\n  overflow: auto !important;\n  resize: ", ";\n  width: 100%;\n  min-height: ", ";\n  color: ", ";\n  transition: 0.3s ease border-color;\n  font-weight: 600;\n\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n\n  &::-webkit-scrollbar {\n    background: transparent;\n    width: 6px;\n    height: 48px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  &:hover:not(:active):not(:focus):not(:disabled) {\n    border: 2px solid\n      ", ";\n    + ", " {\n      height: 18px;\n      top: ", ";\n    }\n  }\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: ", ";\n  }\n\n  &:active&:focus {\n    border: 2px solid\n      ", ";\n  }\n\n  &:focus::-webkit-scrollbar-thumb {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    border: 1px solid ", ";\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:disabled + ", ", &:disabled ~ ", " {\n    cursor: not-allowed;\n    color: ", ";\n    font-weight: 600;\n  }\n\n  &:focus + ", ", &:not(:placeholder-shown) + ", " {\n    height: 18.6px;\n    left: ", ";\n    right: ", ";\n    font-size: ", ";\n    background-color: ", ";\n    font-weight: 600;\n    color: ", ";\n    display: flex;\n    align-items: flex-end;\n  }\n\n  &:not(:placeholder-shown) + ", " {\n    transition: 0s ease all;\n    top: ", ";\n  }\n\n  &:disabled + ", " {\n    cursor: not-allowed;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:focus-visible {\n    outline: ", ";\n  }\n\n  &:focus-visible + ", " {\n    height: 18px;\n    top: ", ";\n  }\n"])), function (_a) {
    var $hasError = _a.$hasError, theme = _a.theme;
    return $hasError ? theme.colors.error90 : 'transparent';
}, function (_a) {
    var theme = _a.theme, $hasError = _a.$hasError;
    return $hasError
        ? "2px solid ".concat(theme.colors.error50)
        : "1px solid ".concat(theme.colors.neutral90);
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.m;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.s;
}, function (_a) {
    var resizable = _a.resizable;
    return (resizable ? 'vertical' : 'none');
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral40;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral70;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.m;
}, function (_a) {
    var theme = _a.theme, $hasError = _a.$hasError;
    return $hasError ? theme.colors.error50 : theme.colors.neutral70;
}, Label, function (_a) {
    var theme = _a.theme;
    return theme.borders.width.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral50;
}, function (_a) {
    var theme = _a.theme, $hasError = _a.$hasError;
    return $hasError ? theme.colors.error50 : theme.colors.secondary70;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary70;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral80;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral95;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral70;
}, Label, InfoWrapper, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral70;
}, Label, Label, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
}, function (_a) {
    var $hasError = _a.$hasError, theme = _a.theme;
    return $hasError ? theme.colors.error90 : 'white';
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral50;
}, Label, function (_a) {
    var theme = _a.theme, $hasError = _a.$hasError;
    return $hasError ? theme.borders.width.s : '1.4px';
}, Label, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral70;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral95;
}, function (_a) {
    var $hasError = _a.$hasError, theme = _a.theme;
    return $hasError ? 'none' : "".concat(theme.colors.primary, " auto 1px");
}, Label, function (_a) {
    var theme = _a.theme;
    return theme.borders.width.s;
});
var ErrorMessageStyled = styled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  fill: transparent;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  fill: transparent;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var templateObject_1$F, templateObject_2$p, templateObject_3$f, templateObject_4$d, templateObject_5$9, templateObject_6$4;

var ErrorMessage = function (_a) {
    var errorMessage = _a.errorMessage;
    var theme = useTheme();
    return (React__default.createElement(ErrorMessageStyled, null,
        React__default.createElement(Icons, { color: theme.colors.error50, name: "IconInfoCircle", size: 18 }),
        React__default.createElement(Typography, { variant: "caption" }, errorMessage)));
};
var HelperText = function (_a) {
    var errorMessage = _a.errorMessage, customInfo = _a.customInfo, maxLength = _a.maxLength;
    if (errorMessage) {
        return React__default.createElement(ErrorMessage, { errorMessage: errorMessage });
    }
    if (customInfo) {
        return customInfo;
    }
    return (React__default.createElement(Typography, { variant: "caption" }, "M\u00E1ximo ".concat(maxLength, " caracteres")));
};
var convertNumberToPixelString = function (value) {
    if (typeof value === 'number')
        return value.toString() + 'px';
    return value;
};
var TextArea = function (_a) {
    var id = _a.id, _b = _a.maxLength, maxLength = _b === void 0 ? 10000 : _b, placeholder = _a.placeholder, _c = _a.resizable, resizable = _c === void 0 ? false : _c, _d = _a.height, height = _d === void 0 ? 50 : _d, _e = _a.width, width = _e === void 0 ? '100%' : _e, customInfo = _a.customInfo, errorMessage = _a.errorMessage, onChange = _a.onChange, style = _a.style, onBlur = _a.onBlur, onFocus = _a.onFocus, disabled = _a.disabled, value = _a.value, _f = _a.required, required = _f === void 0 ? false : _f, props = __rest(_a, ["id", "maxLength", "placeholder", "resizable", "height", "width", "customInfo", "errorMessage", "onChange", "style", "onBlur", "onFocus", "disabled", "value", "required"]);
    var _g = useState(0), counter = _g[0], setCounter = _g[1];
    var textAreaIdRef = useRef(id || uniqueId('prefix-'));
    var handleChange = function (e) {
        var _a;
        setCounter((_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    var handleFocus = function (e) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    };
    var handleBlur = function (e) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    useEffect(function () {
        if (value === null || value === void 0 ? void 0 : value.length)
            setCounter(value === null || value === void 0 ? void 0 : value.length);
    }, [value]);
    return (React__default.createElement(Container$i, null,
        React__default.createElement(StyledTextArea, __assign({ id: textAreaIdRef.current, maxLength: maxLength, onChange: handleChange, placeholder: " ", height: convertNumberToPixelString(height), width: convertNumberToPixelString(width), resizable: resizable, onFocus: handleFocus, onBlur: handleBlur, required: required, style: style, disabled: disabled, value: value, "$hasError": !!errorMessage }, props)),
        React__default.createElement(Label, { htmlFor: textAreaIdRef.current, "$hasError": !!errorMessage },
            placeholder,
            required && React__default.createElement(SpanLabelRequired, null, "*")),
        React__default.createElement(InfoWrapper, null,
            React__default.createElement(HelperText, { maxLength: maxLength, errorMessage: errorMessage, customInfo: customInfo }),
            React__default.createElement(Typography, { variant: "caption" },
                counter,
                "/",
                maxLength))));
};

var Container$h = styled.label(function (_a) {
    var selected = _a.selected, isDisabled = _a.isDisabled, theme = _a.theme;
    return ({
        display: 'grid',
        gap: '2px',
        cursor: 'pointer',
        textAlign: 'center',
        color: isDisabled
            ? theme.colors.neutral[60]
            : selected
                ? theme.colors.secondary[50]
                : theme.colors.neutral[40],
        '& :hover': {
            '> svg': {
                height: '24px',
            },
        },
        '&:focus-visible': {
            outline: 'none',
            '> div': {
                outline: "".concat(theme.borders.width.s, " solid ").concat(theme.colors.secondary[80]),
                '> svg': {
                    height: '24px',
                },
            },
        },
    });
});
var IconContainer = styled.div(function (_a) {
    var selected = _a.selected, isDisabled = _a.isDisabled, theme = _a.theme;
    return ({
        width: '64px',
        height: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: theme.borders.radius.s,
        borderColor: theme.colors.secondary[50],
        border: selected ? "solid ".concat(theme.borders.width.xs2) : 'none',
        backgroundColor: selected ? theme.colors.secondary[99] : 'transparent',
        '> svg': {
            height: '18px',
            transition: '150ms linear',
            stroke: isDisabled
                ? theme.colors.neutral[80]
                : selected
                    ? theme.colors.secondary[50]
                    : 'currentColor',
        },
    });
});

function RatingButton(_a) {
    var onClick = _a.onClick, value = _a.value, isDisabled = _a.isDisabled, variant = _a.variant, label = _a.label;
    var rating = useMemo(function () {
        var rattingLabel = {
            'too-bad': {
                label: 'Péssimo',
                icon: 'IconMoodWrrr',
                value: 1,
            },
            bad: {
                label: 'Ruim',
                icon: 'IconMoodSad',
                value: 2,
            },
            regular: {
                label: 'Regular',
                icon: 'IconMoodEmpty',
                value: 3,
            },
            good: {
                label: 'Boa',
                icon: 'IconMoodSmileBeam',
                value: 4,
            },
            'very-good': {
                label: 'Ótima',
                icon: 'IconMoodHappy',
                value: 5,
            },
        };
        return rattingLabel[variant];
    }, [variant]);
    var selected = value === rating.value;
    return (React__default.createElement(Container$h, { id: "rating-button-".concat(variant), selected: selected, isDisabled: isDisabled, onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(rating.value); } },
        React__default.createElement(IconContainer, { selected: selected, isDisabled: isDisabled },
            React__default.createElement(Icons, { name: rating.icon })),
        React__default.createElement(Typography, { variant: "caption", weight: selected ? 700 : 400 }, label === null ? '' : label !== null && label !== void 0 ? label : rating.label)));
}

var Container$g = styled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ", ";\n  text-align: center;\n"], ["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ", ";\n  text-align: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var RattingContainer = styled.div(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(5, 64px);\n  gap: ", ";\n  margin: auto;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(5, 64px);\n  gap: ", ";\n  margin: auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
});
var TeamEvaluationCheck = styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
var Submit = styled(Button$4)(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  margin: auto;\n  width: 100%;\n  max-width: 160px;\n"], ["\n  margin: auto;\n  width: 100%;\n  max-width: 160px;\n"])));
var templateObject_1$E, templateObject_2$o, templateObject_3$e, templateObject_4$c;

function SurveyForm(_a) {
    var isLoading = _a.isLoading, questions = _a.questions, onSubmit = _a.onSubmit, showTeamEvaluation = _a.showTeamEvaluation, showMessage = _a.showMessage;
    var _b = useState({}), answers = _b[0], setAnswers = _b[1];
    var _c = useState(''), message = _c[0], setMessage = _c[1];
    var _d = useState(), acceptedTeamEvaluation = _d[0], setAcceptedTeamEvaluation = _d[1];
    function handleMessage(e) {
        var _a;
        setMessage((_a = e.target.value) !== null && _a !== void 0 ? _a : '');
    }
    var isAllRated = questions.every(function (question) { return answers[question.id] !== undefined; });
    function handleSubmit() {
        if (isAllRated) {
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
                rating: answers[questions[0].id],
                message: message,
                answers: answers,
                acceptedTeamEvaluation: acceptedTeamEvaluation,
            });
        }
    }
    function handleAnswer(question, answer) {
        setAnswers(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[question.id] = answer, _a)));
        });
    }
    function isPreviousRated(index) {
        if (index === 0)
            return true;
        return questions
            .slice(0, index)
            .every(function (question) { return answers[question.id] !== undefined; });
    }
    function getRatingProps(question, score) {
        var _a;
        return {
            onClick: function (value) { return handleAnswer(question, value); },
            value: answers[question.id],
            label: (_a = question.scores) === null || _a === void 0 ? void 0 : _a[score],
        };
    }
    return (React__default.createElement(Container$g, null,
        questions.map(function (question, index) {
            var _a = question.type, type = _a === void 0 ? 'score' : _a;
            return (isPreviousRated(index) && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Typography, { color: 'neutral.30', weight: 700, variant: "body4" }, question.title),
                type === 'text' && (React__default.createElement(TextArea, { width: "100%", placeholder: "Por favor, escreva aqui", onChange: function (e) {
                        var _a;
                        return handleAnswer(question, (_a = e
                            .target.value) !== null && _a !== void 0 ? _a : '');
                    }, value: answers[question.id], maxLength: 200 })),
                type === 'score' && (React__default.createElement(RattingContainer, null,
                    React__default.createElement(RatingButton, __assign({}, getRatingProps(question, 0), { variant: "too-bad" })),
                    React__default.createElement(RatingButton, __assign({}, getRatingProps(question, 1), { variant: "bad" })),
                    React__default.createElement(RatingButton, __assign({}, getRatingProps(question, 2), { variant: "regular" })),
                    React__default.createElement(RatingButton, __assign({}, getRatingProps(question, 3), { variant: "good" })),
                    React__default.createElement(RatingButton, __assign({}, getRatingProps(question, 4), { variant: "very-good" })))))));
        }),
        isAllRated && (React__default.createElement(React__default.Fragment, null,
            showMessage && (React__default.createElement(TextArea, { width: "100%", placeholder: "Fale mais sobre a sua experi\u00EAncia (opcional)", onChange: function (e) {
                    return handleMessage(e);
                }, value: message, maxLength: 200 })),
            showTeamEvaluation && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Typography, { color: 'neutral.30', weight: 700, variant: "body4" }, "Para terminar, aceita participar de uma conversa com a equipe Flash sobre a sua avalia\u00E7\u00E3o?"),
                React__default.createElement(TeamEvaluationCheck, null,
                    React__default.createElement("div", null,
                        React__default.createElement(Radio, { checked: acceptedTeamEvaluation === true, onChange: function () { return setAcceptedTeamEvaluation(true); } }),
                        React__default.createElement("label", { onClick: function () { return setAcceptedTeamEvaluation(true); } }, "Sim, aceito!")),
                    React__default.createElement("div", null,
                        React__default.createElement(Radio, { checked: acceptedTeamEvaluation === false, onChange: function () { return setAcceptedTeamEvaluation(false); } }),
                        React__default.createElement("label", { onClick: function () { return setAcceptedTeamEvaluation(false); } }, "Fica para a pr\u00F3xima"))))),
            React__default.createElement(Submit, { variant: "secondary", onClick: handleSubmit, loading: isLoading, size: "small" }, "Enviar")))));
}

var Container$f = styled.div(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  width: auto;\n  max-width: 590px;\n  border-radius: ", ";\n  padding: ", ";\n  border: ", ";\n"], ["\n  width: auto;\n  max-width: 590px;\n  border-radius: ", ";\n  padding: ", ";\n  border: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.m;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return "solid ".concat(theme.borders.width.xs2, " ").concat(theme.colors.neutral[90]);
});
var templateObject_1$D;

function SurveyStore(_a) {
    var _b, _c, _d, _e;
    var title = _a.title, isLoading = _a.isLoading, onSubmit = _a.onSubmit, feedback = _a.feedback, questions = _a.questions, showTeamEvaluation = _a.showTeamEvaluation, _f = _a.showMessage, showMessage = _f === void 0 ? true : _f;
    var _g = useState(), feedbackStatus = _g[0], setFeedbackStatus = _g[1];
    var feedbackContent = useMemo(function () {
        var _a, _b, _c, _d;
        if (feedbackStatus === 'error') {
            return {
                title: ((_a = feedback === null || feedback === void 0 ? void 0 : feedback.error) === null || _a === void 0 ? void 0 : _a.title) || 'Não foi possível enviar a sua avaliação',
                description: (_b = feedback === null || feedback === void 0 ? void 0 : feedback.error) === null || _b === void 0 ? void 0 : _b.description,
            };
        }
        return {
            title: ((_c = feedback === null || feedback === void 0 ? void 0 : feedback.success) === null || _c === void 0 ? void 0 : _c.title) || 'Agradecemos sua avaliação!',
            description: ((_d = feedback === null || feedback === void 0 ? void 0 : feedback.success) === null || _d === void 0 ? void 0 : _d.description) ||
                'Suas respostas nos ajudarão a melhorar ainda mais nosso produto!',
        };
    }, [
        (_b = feedback === null || feedback === void 0 ? void 0 : feedback.error) === null || _b === void 0 ? void 0 : _b.description,
        (_c = feedback === null || feedback === void 0 ? void 0 : feedback.error) === null || _c === void 0 ? void 0 : _c.title,
        (_d = feedback === null || feedback === void 0 ? void 0 : feedback.success) === null || _d === void 0 ? void 0 : _d.description,
        (_e = feedback === null || feedback === void 0 ? void 0 : feedback.success) === null || _e === void 0 ? void 0 : _e.title,
        feedbackStatus,
    ]);
    function handleSubmit(value) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, onSubmit(value)];
                    case 1:
                        response = _b.sent();
                        setFeedbackStatus(response ? 'success' : 'error');
                        return [3 /*break*/, 3];
                    case 2:
                        _b.sent();
                        setFeedbackStatus('error');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function retry() {
        setFeedbackStatus(undefined);
    }
    var surveyQuestions = questions || [
        { id: 'rating', title: title || '' },
    ];
    return (React__default.createElement(Container$f, null, feedbackStatus !== undefined ? (React__default.createElement(SurveyFeedback, { title: feedbackContent.title, description: feedbackContent.description, onRetry: retry, hasError: feedbackStatus === 'error' })) : (React__default.createElement(SurveyForm, { questions: surveyQuestions, onSubmit: handleSubmit, isLoading: isLoading, showTeamEvaluation: showTeamEvaluation !== null && showTeamEvaluation !== void 0 ? showTeamEvaluation : !!questions, showMessage: showMessage }))));
}

function useManagementTabs(_a) {
    var defaultTab = _a.defaultTab, externalSelectedTab = _a.externalSelectedTab, onTabChanged = _a.onTabChanged;
    var _b = useState(defaultTab), currentTab = _b[0], setSelectedTab = _b[1];
    function onExternalSelectedTabIsValid() {
        return (externalSelectedTab != null &&
            externalSelectedTab != undefined &&
            externalSelectedTab != currentTab);
    }
    function onSelectedTab(selectedTab) {
        setSelectedTab(selectedTab);
        onTabChanged === null || onTabChanged === void 0 ? void 0 : onTabChanged(selectedTab);
    }
    function handleChange(selectedTab) {
        if (onExternalSelectedTabIsValid()) {
            onSelectedTab(Number(externalSelectedTab));
        }
        else
            onSelectedTab(selectedTab);
    }
    useEffect(function () {
        onExternalSelectedTabIsValid() &&
            setSelectedTab(Number(externalSelectedTab));
    }, [externalSelectedTab]);
    return {
        currentTab: currentTab,
        handleChange: handleChange,
    };
}

var TabsGroup$1 = styled(Tabs)(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n  .MuiTabs-flexContainer {\n    gap: ", ";\n  }\n\n  min-height: 40px;\n  margin-bottom: ", ";\n\n  span.MuiTabs-indicator {\n    background-color: ", ";\n  }\n"], ["\n  .MuiTabs-flexContainer {\n    gap: ", ";\n  }\n\n  min-height: 40px;\n  margin-bottom: ", ";\n\n  span.MuiTabs-indicator {\n    background-color: ", ";\n  }\n"])), function (props) { return props.theme.spacings.s; }, function (props) { return props.theme.spacings.xs2; }, function (props) { return props.theme.colors.primary; });
var TabItem = styled(Tab$1)(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", "!important;\n  text-transform: none;\n  min-height: 40px;\n\n  &.MuiButtonBase-root {\n    padding: ", "!important;\n  }\n\n  &.Mui-selected {\n    color: ", ";\n    font-weight: 700;\n  }\n\n  &.Mui-disabled {\n    color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  padding: ", "!important;\n  text-transform: none;\n  min-height: 40px;\n\n  &.MuiButtonBase-root {\n    padding: ", "!important;\n  }\n\n  &.Mui-selected {\n    color: ", ";\n    font-weight: 700;\n  }\n\n  &.Mui-disabled {\n    color: ", ";\n  }\n"])), function (props) { return props.theme.colors.neutral[100]; }, function (props) { return "".concat(props.theme.spacings.xs4, " 0"); }, function (props) { return "".concat(props.theme.spacings.xs4, " 0"); }, function (props) { return props.theme.colors.primary; }, function (props) { return props.theme.colors.neutral[70]; });
var templateObject_1$C, templateObject_2$n;

var TabLabelContainer$1 = styled.div(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n  cursor: ", ";\n  pointer-events: ", ";\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  opacity: ", ";\n\n  &:hover {\n    color: ", ";\n\n    .tab-counter {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  cursor: ", ";\n  pointer-events: ", ";\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  opacity: ", ";\n\n  &:hover {\n    color: ", ";\n\n    .tab-counter {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"])), function (props) { return (!props.isDisabled ? 'pointer' : 'not-allowed'); }, function (props) { return (props.isDisabled ? 'none' : 'all'); }, function (props) { return props.theme.spacings.xs4; }, function (props) { return (props.isDisabled ? 0.65 : 1); }, function (props) { return props.theme.colors.primary; }, function (props) { return props.theme.colors.primary; }, function (props) { return props.theme.colors.neutral[100]; });
var TabLabel$3 = styled(Typography)(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  color: ", ";\n\n  font-weight: ", " !important;\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n\n  font-weight: ", " !important;\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) {
    return props.isSelected
        ? props.theme.colors.primary
        : props.theme.colors.neutral[50];
}, function (props) { return (props.isSelected ? '700' : '600'); }, function (props) { return props.theme.colors.primary; });
var Counter$1 = styled.div(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  padding: 0 ", ";\n  border-radius: 50%;\n  background-color: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  padding: 0 ", ";\n  border-radius: 50%;\n  background-color: ", ";\n"])), function (props) { return props.theme.spacings.xs4; }, function (props) {
    return props.isSelected
        ? props.theme.colors.secondary[95]
        : props.theme.colors.neutral[90];
});
var CounterLabel$1 = styled(Typography)(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", " !important;\n  line-height: 12px;\n  font-size: 10px;\n"], ["\n  color: ", ";\n  font-weight: ", " !important;\n  line-height: 12px;\n  font-size: 10px;\n"])), function (props) { return props.theme.colors.brand; }, function (props) { return (props.isSelected ? '700' : '600'); });
var LabelDescriptionContainer$1 = styled.div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) { return props.theme.spacings.xs4; }, function (props) { return props.theme.colors.primary; });
var templateObject_1$B, templateObject_2$m, templateObject_3$d, templateObject_4$b, templateObject_5$8;

var TabLabel$2 = function (_a) {
    var label = _a.label, counter = _a.counter, icon = _a.icon, isDisabled = _a.isDisabled, isSelected = _a.isSelected;
    return (React__default.createElement(TabLabelContainer$1, { isDisabled: isDisabled },
        React__default.createElement(LabelDescriptionContainer$1, null,
            icon && React__default.createElement(Icons, { name: icon || '', size: 16, fill: "transparent" }),
            React__default.createElement(TabLabel$3, { isSelected: isSelected, variant: "body4" }, label)),
        (counter !== null && counter !== void 0 ? counter : 0) > 0 && (React__default.createElement(Counter$1, { className: "tab-counter", isSelected: isSelected },
            React__default.createElement(CounterLabel$1, { variant: "body4" }, counter)))));
};

var TabPrimary = function (_a) {
    var id = _a.id, tabItems = _a.tabItems, currentTab = _a.currentTab, className = _a.className, handleChange = _a.handleChange, variant = _a.variant, children = _a.children;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TabsGroup$1, { id: id, className: "tabs-container ".concat(className), value: currentTab, onChange: function (_, currentTab) { return handleChange(currentTab); }, variant: variant }, tabItems.map(function (tab, index) {
            return (React__default.createElement(TabItem, { disabled: tab.disabled, disableRipple: true, disableTouchRipple: true, key: index, value: index, label: React__default.createElement(TabLabel$2, { label: tab.label, counter: tab.counterLabel, icon: tab.iconLabel, isDisabled: tab.disabled, isSelected: index == currentTab }) }));
        })),
        children));
};

var Container$e = styled.div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n"], ["\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n"])));
var TabsGroup = styled.div(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  min-width: 200px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  min-width: 200px;\n"])), function (props) { return props.theme.spacings.xs2; });
var templateObject_1$A, templateObject_2$l;

var TabLabelContainer = styled.div(function (props) {
    var _a, _b, _c;
    return (__assign(__assign(__assign({ backgroundColor: props.theme.colors.neutral[100], color: props.theme.colors.neutral[50], display: 'flex', alignItems: 'center', gap: props.theme.spacings.xs4, borderRadius: props.theme.borders.radius.s, padding: "".concat(props.theme.spacings.xs4, " ").concat(props.theme.spacings.xs2), marginRight: props.theme.spacings.xs2, border: "1px solid ".concat(props.theme.colors.neutral[90]), cursor: 'pointer' }, (props.isSelected && {
        cursor: 'pointer',
        pointerEvents: 'all',
        backgroundColor: props.theme.colors.secondary[95],
        color: props.theme.colors.primary,
        opacity: 1,
        borderColor: props.theme.colors.primary,
    })), (props.isDisabled && {
        cursor: 'none',
        pointerEvents: 'all',
        backgroundColor: props.theme.colors.secondary[90],
        opacity: 0.65,
    })), (_a = {}, _a["&:hover"] = (_b = {
            color: props.theme.colors.primary,
            borderColor: props.theme.colors.secondary[95],
            backgroundColor: props.theme.colors.secondary[95],
            fill: props.theme.colors.primary
        },
        _b["p"] = {
            color: props.theme.colors.primary,
        },
        _b[".tab-counter"] = (_c = {
                backgroundColor: props.theme.colors.primary
            },
            _c["p"] = {
                color: props.theme.colors.neutral[100],
            },
            _c),
        _b), _a)));
});
var TabLabel$1 = styled(Typography)(function (props) {
    var _a;
    return (__assign(__assign({ color: props.theme.colors.neutral[50], fontWeight: 600 }, (props.isSelected && {
        color: props.theme.colors.primary,
    })), (_a = {}, _a["&:hover"] = {
        color: props.theme.colors.primary,
    }, _a)));
});
var Counter = styled.div(function (props) { return (__assign({ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '15px', height: '15px', padding: "0 ".concat(props.theme.spacings.xs4, "px"), borderRadius: props.theme.borders.radius.xs, backgroundColor: props.theme.colors.neutral[50] }, (props.isSelected && {
    backgroundColor: props.theme.colors.primary,
}))); });
var CounterLabel = styled(Typography)(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 600;\n  line-height: 12px;\n  font-size: 10px;\n"], ["\n  color: ", ";\n  font-weight: 600;\n  line-height: 12px;\n  font-size: 10px;\n"])), function (props) { return props.theme.colors.neutral[100]; });
var LabelDescriptionContainer = styled.div(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) { return props.theme.spacings.xs4; }, function (props) { return props.theme.colors.primary; });
var templateObject_1$z, templateObject_2$k;

var TabLabel = function (_a) {
    var label = _a.label, counter = _a.counter, icon = _a.icon, isDisabled = _a.isDisabled, isSelected = _a.isSelected;
    return (React__default.createElement(TabLabelContainer, { isSelected: isSelected, isDisabled: isDisabled },
        React__default.createElement(LabelDescriptionContainer, null,
            icon && React__default.createElement(Icons, { name: icon || '', size: 16, fill: "transparent" }),
            React__default.createElement(TabLabel$1, { isSelected: isSelected, variant: "body4" }, label)),
        counter && (React__default.createElement(Counter, { className: "tab-counter", isSelected: isSelected },
            React__default.createElement(CounterLabel, { variant: "body4" }, counter)))));
};

var TabSecondary = function (_a) {
    var id = _a.id, tabItems = _a.tabItems, currentTab = _a.currentTab, className = _a.className, handleChange = _a.handleChange, children = _a.children;
    return (React__default.createElement(Container$e, { id: id, className: "vertical-tab-container ".concat(className) },
        React__default.createElement(TabsGroup, null, tabItems.map(function (tab, index) { return (React__default.createElement("button", { type: "button", key: typeof tab.label === 'string' ? tab.label : index, onClick: function () { return !tab.disabled && handleChange(index); } },
            React__default.createElement(TabLabel, { label: tab.label, counter: tab.counterLabel, icon: tab.iconLabel, isDisabled: tab.disabled, isSelected: index == currentTab }))); }, [])),
        children));
};

var Tab = function (_a) {
    var _b;
    var id = _a.id, tabItens = _a.tabItens, _c = _a.defaultTab, defaultTab = _c === void 0 ? 0 : _c, className = _a.className, selected = _a.selected, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, type = _a.type, onTabChanged = _a.onTabChanged, children = _a.children;
    var _e = useManagementTabs({
        defaultTab: defaultTab,
        externalSelectedTab: selected,
        onTabChanged: onTabChanged,
    }), currentTab = _e.currentTab, handleChange = _e.handleChange;
    var TabVariant = {
        primary: TabPrimary,
        secondary: TabSecondary,
    }[variant];
    return (React__default.createElement(TabVariant, { id: id, className: className, handleChange: handleChange, tabItems: tabItens, currentTab: currentTab, variant: type }, ((_b = tabItens[currentTab]) === null || _b === void 0 ? void 0 : _b.component) || children || null));
};

var Button$1 = styled(ButtonBase)(function (props) {
    var _a;
    return (__assign(__assign((_a = { background: getVariantColor$1(props.theme.colors, props.variant, 'background'), borderRadius: props.theme.borders.radius.xl, display: 'flex', justifyContent: 'center', alignItems: 'center', alignSelf: 'flex-start', color: getVariantColor$1(props.theme.colors, props.variant, 'color'), fontWeight: 600, fontSize: '12px', lineHeight: '18px', textAlign: 'center', padding: props.theme.spacings.xs4 + ' ' + props.theme.spacings.xs2, cursor: 'pointer' }, _a["&:hover"] = {
        backgroundColor: props.theme.colors.neutral[90],
    }, _a["> svg"] = {
        backgroundColor: props.theme.colors.neutral[90],
    }, _a[".typography--variant-body3"] = {
        fontWeight: 600,
    }, _a), ((props.variant == 'tertiary' || props.variant == 'secondary') && {
        border: "".concat(props.theme.borders.width.xs2, " solid ").concat(getVariantColor$1(props.theme.colors, props === null || props === void 0 ? void 0 : props.variant, 'borderColor')),
    })), (props.active && {
        backgroundColor: props.theme.colors.tertiary[90],
        color: props.theme.colors.secondary[50],
    })));
});
var BadgeNumber$1 = styled.div(function (props) {
    var _a;
    return (__assign((_a = { width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: props.theme.borders.radius.circular, marginLeft: props.theme.spacings.xs4, backgroundColor: getVariantColor$1(props.theme.colors, props.variant, 'badgeBackgroundColor'), color: getVariantColor$1(props.theme.colors, props.variant, 'badgeColor') }, _a['.typography--variant-caption'] = {
        fontWeight: 700,
    }, _a), (props.active && {
        backgroundColor: props.theme.colors.primary,
        color: props.theme.colors.neutral[100],
    })));
});
var ClearButtonContainer = styled.div(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n  padding: ", ";\n  border-top: 1px solid ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding: ", ";\n  border-top: 1px solid ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
    return "".concat(props.theme.spacings.xs, " ").concat(props.theme.spacings.xs2);
}, function (props) { return props.theme.colors.neutral['90']; });
var MenuItem$3 = styled.button(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n"])), function (props) { return props.theme.spacings.xs3; }, function (props) { return props.theme.spacings.xs2; }, function (props) { return props.theme.colors.neutral[95]; }, function (props) { return props.theme.borders.radius.xl; });
var MenuContainer = styled.ul(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  list-style-type: none;\n  max-height: 300px;\n  width: 320px;\n  padding: 0px ", ";\n  margin: ", " 0px;\n  overflow: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"], ["\n  list-style-type: none;\n  max-height: 300px;\n  width: 320px;\n  padding: 0px ", ";\n  margin: ", " 0px;\n  overflow: ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n"])), function (props) { return props.theme.spacings.xs3; }, function (props) { return props.theme.spacings.xs5; }, function (_a) {
    var showClearButton = _a.showClearButton;
    return (showClearButton ? 'auto' : 'visible');
});
var SearchInput = styled(TextField$2)(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  padding-left: 40px !important;\n  border: none !important;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  padding-left: 40px !important;\n  border: none !important;\n"])), function (props) { return props.theme.colors.neutral[30]; }, function (props) { return props.theme.typography.fontFamily; });
var SearchInputContainer = styled.div(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  padding: ", ";\n  width: 100%;\n  &:before,\n  &:after {\n    content: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  padding: ", ";\n  width: 100%;\n  &:before,\n  &:after {\n    content: none;\n  }\n"])), function (props) { return props.theme.spacings.xs3; });
var SearchInputBorder = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  padding: ", ";\n  height: 60px;\n  width: 100%;\n  border: ", " solid\n    ", ";\n  border-radius: 150px;\n  &:before,\n  &:after {\n    content: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  padding: ", ";\n  height: 60px;\n  width: 100%;\n  border: ", " solid\n    ", ";\n  border-radius: 150px;\n  &:before,\n  &:after {\n    content: none;\n  }\n"])), function (props) { return props.theme.spacings.xs3; }, function (props) { return props.theme.borders.width.xs2; }, function (props) { return props.theme.colors.neutral[70]; });
var SearchIcon = styled(Icons)(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  position: relative;\n  left: 20px;\n  fill: transparent;\n  z-index: 1;\n  circle,\n  line {\n    stroke: ", ";\n  }\n"], ["\n  position: relative;\n  left: 20px;\n  fill: transparent;\n  z-index: 1;\n  circle,\n  line {\n    stroke: ", ";\n  }\n"])), function (props) { return props.theme.colors.neutral[70]; });
var SelectAllContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: ", ";\n  align-items: center;\n  background-color: transparent;\n  gap: ", ";\n  padding: 0px ", ";\n  width: 100%;\n  border-top: ", " solid\n    ", ";\n  border-bottom: ", " solid\n    ", ";\n"], ["\n  display: ", ";\n  align-items: center;\n  background-color: transparent;\n  gap: ", ";\n  padding: 0px ", ";\n  width: 100%;\n  border-top: ", " solid\n    ", ";\n  border-bottom: ", " solid\n    ", ";\n"])), function (_a) {
    var showSelectAllButton = _a.showSelectAllButton;
    return showSelectAllButton ? 'flex' : 'none';
}, function (props) { return props.theme.spacings.xs; }, function (props) { return props.theme.spacings.xs3; }, function (props) { return props.theme.borders.width.xs2; }, function (props) { return props.theme.colors.neutral[90]; }, function (props) { return props.theme.borders.width.xs2; }, function (props) { return props.theme.colors.neutral[90]; });
var SelectAllItem = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  background-color: transparent;\n  gap: ", ";\n  padding: ", ";\n"], ["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  background-color: transparent;\n  gap: ", ";\n  padding: ", ";\n"])), function (props) { return props.theme.spacings.xs3; }, function (props) { return props.theme.spacings.xs2; });
var getVariantColor$1 = function (colors, variant, key) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var variantColors = {
        primary: {
            background: (_a = colors === null || colors === void 0 ? void 0 : colors.tertiary) === null || _a === void 0 ? void 0 : _a[90],
            color: (_b = colors === null || colors === void 0 ? void 0 : colors.secondary) === null || _b === void 0 ? void 0 : _b[50],
            badgeColor: (_c = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _c === void 0 ? void 0 : _c[100],
            badgeBackgroundColor: colors === null || colors === void 0 ? void 0 : colors.primary,
        },
        secondary: {
            borderColor: (_d = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _d === void 0 ? void 0 : _d[90],
            color: (_e = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _e === void 0 ? void 0 : _e[40],
            badgeColor: (_f = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _f === void 0 ? void 0 : _f[40],
            stroke: (_g = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _g === void 0 ? void 0 : _g[40],
        },
        tertiary: {
            borderColor: (_h = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _h === void 0 ? void 0 : _h[90],
            color: (_j = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _j === void 0 ? void 0 : _j[40],
            badgeColor: (_k = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _k === void 0 ? void 0 : _k[40],
            stroke: (_l = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _l === void 0 ? void 0 : _l[40],
        },
        disabled: {
            background: (_m = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _m === void 0 ? void 0 : _m[90],
            color: (_o = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _o === void 0 ? void 0 : _o[80],
            badgeColor: (_p = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _p === void 0 ? void 0 : _p[80],
            stroke: (_q = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _q === void 0 ? void 0 : _q[80],
        },
        error: {
            background: (_r = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _r === void 0 ? void 0 : _r[90],
            color: (_s = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _s === void 0 ? void 0 : _s[80],
            badgeColor: (_t = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _t === void 0 ? void 0 : _t[80],
        },
    };
    return variantColors[variant][key];
};
var templateObject_1$y, templateObject_2$j, templateObject_3$c, templateObject_4$a, templateObject_5$7, templateObject_6$3, templateObject_7$1, templateObject_8, templateObject_9;

var TagCheckboxFilterPopover = function (_a) {
    var anchorEl = _a.anchorEl, setAnchorEl = _a.setAnchorEl, children = _a.children, _b = _a.options, options = _b === void 0 ? [] : _b, onClick = _a.onClick, placeholder = _a.placeholder, showClearButton = _a.showClearButton, showSelectAllButton = _a.showSelectAllButton;
    var optionsState = options.map(function (option) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var _a = useState(false), checked = _a[0], setChecked = _a[1];
        return __assign(__assign({}, option), { checked: option.checked || checked, setChecked: option.setChecked || setChecked });
    });
    var _c = useState(''), search = _c[0], setSearch = _c[1];
    var _d = useState(false), checkedAll = _d[0], setCheckedAll = _d[1];
    var handleClick = function (newState, option) {
        var index = optionsState === null || optionsState === void 0 ? void 0 : optionsState.findIndex(function (item) { return item == option; });
        optionsState[index].setChecked(newState);
    };
    var handleSelectAll = function () {
        var filteredOptions = optionsState.filter(function (option) {
            return option.label.toLowerCase().includes(search.toLowerCase());
        });
        var anyUnchecked = filteredOptions.some(function (option) { return !option.checked; });
        filteredOptions.forEach(function (option) { return option.setChecked(anyUnchecked); });
        setCheckedAll(!anyUnchecked);
    };
    var handleClear = function () {
        optionsState.forEach(function (option) { return option.setChecked(false); });
        setCheckedAll(false);
    };
    var filteredOptions = useMemo(function () {
        return optionsState.filter(function (option) {
            return option.label.toLowerCase().includes(search.toLowerCase());
        });
    }, [optionsState, search]);
    var mappedCheckedOptions = optionsState.map(function (_a) {
        var checked = _a.checked;
        return checked;
    });
    useEffect(function () {
        var optionsChecked = optionsState.reduce(function (labelOptions, _a) {
            var checked = _a.checked, value = _a.value;
            if (checked) {
                labelOptions.push(value);
            }
            return labelOptions;
        }, []);
        onClick(optionsChecked);
        var anyUnchecked = optionsState.some(function (option) { return !option.checked; });
        setCheckedAll(!anyUnchecked);
        var allChecked = optionsState
            .filter(function (option) {
            return option.label.toLowerCase().includes(search.toLowerCase());
        })
            .every(function (option) { return option.checked; });
        if (allChecked) {
            setCheckedAll(true);
        }
    }, __spreadArray(__spreadArray([], mappedCheckedOptions, true), [search], false));
    return (React__default.createElement(Popover, { open: !!anchorEl, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, PaperProps: {
            style: {
                marginTop: '8px',
            },
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        } }, children ? (children) : (React__default.createElement("div", { className: "tag-checkbox-filter-menu" },
        React__default.createElement(SearchInputContainer, null,
            React__default.createElement(SearchInputBorder, null,
                React__default.createElement(SearchIcon, { name: "IconSearch" }),
                React__default.createElement(SearchInput, { placeholder: placeholder || 'Buscar', variant: 'standard', InputProps: {
                        disableUnderline: true,
                    }, onChange: function (e) { return setSearch(e.target.value); }, value: search }))),
        React__default.createElement(SelectAllContainer, { showSelectAllButton: showSelectAllButton && !!filteredOptions.length },
            React__default.createElement(SelectAllItem, null,
                React__default.createElement(Checkbox, { checked: checkedAll, onChange: function () { return handleSelectAll(); } }),
                React__default.createElement(Typography, { variant: "body3" }, "Selecionar todos"))),
        React__default.createElement(MenuContainer, { showClearButton: showClearButton }, filteredOptions.map(function (option, index) { return (React__default.createElement(MenuItem$3, { key: index, onClick: function () { return handleClick(!option.checked, option); } },
            React__default.createElement(Checkbox, { checked: option.checked }),
            React__default.createElement(Typography, { variant: "body3" }, option.label))); })),
        showClearButton && (React__default.createElement(ClearButtonContainer, null,
            React__default.createElement(LinkButton, { variant: "default", onClick: handleClear }, "Limpar sele\u00E7\u00E3o")))))));
};

var TagCheckboxFilter = function (_a) {
    var variant = _a.variant, options = _a.options, style = _a.style, onClick = _a.onClick, onFocus = _a.onFocus, onSubmit = _a.onSubmit, onError = _a.onError, type = _a.type, classes = _a.classes, id = _a.id, _b = _a.hasLeftIcon, hasLeftIcon = _b === void 0 ? true : _b, _c = _a.hasRightIcon, hasRightIcon = _c === void 0 ? true : _c, filterLabel = _a.filterLabel, className = _a.className, badgeNumber = _a.badgeNumber, showClearButton = _a.showClearButton, showSelectAllButton = _a.showSelectAllButton, children = _a.children;
    var disabled = variant === 'disabled';
    var _d = useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var buttonRef = useRef(null);
    var spacings = useTheme().spacings;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button$1, { active: Boolean(badgeNumber), id: id, variant: variant, className: "loading ".concat(className, " "), style: style, classes: classes, ref: buttonRef, type: type, onClick: function (e) {
                var _a;
                (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                setAnchorEl === null || setAnchorEl === void 0 ? void 0 : setAnchorEl(e.currentTarget);
            }, onFocus: onFocus, onSubmit: onSubmit, onError: onError, disabled: disabled },
            hasLeftIcon ? (React__default.createElement(Icons, { name: "IconSquareDot", fill: "transparent", style: { marginRight: spacings.xs4, background: 'transparent' } })) : (React__default.createElement(React__default.Fragment, null)),
            React__default.createElement(Typography, { variant: "body3" }, filterLabel),
            hasRightIcon ? (React__default.createElement(Icons, { name: "IconChevronDown", fill: "transparent", style: { marginLeft: '8px', background: 'transparent' } })) : (React__default.createElement(React__default.Fragment, null)),
            Boolean(badgeNumber) && (React__default.createElement(BadgeNumber$1, { variant: variant, active: Boolean(badgeNumber) },
                React__default.createElement(Typography, { variant: "caption" }, badgeNumber)))),
        React__default.createElement(TagCheckboxFilterPopover, { anchorEl: anchorEl, onClick: onClick, options: options, setAnchorEl: setAnchorEl, showClearButton: showClearButton, showSelectAllButton: showSelectAllButton }, children)));
};

var TagFilterStyled = styled(ButtonBase)(function (props) {
    var _a, _b, _c;
    var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    return (__assign(__assign((_a = { display: 'flex', justifyContent: 'center', alignItems: 'center', alignSelf: 'flex-start', fontWeight: 600, fontSize: '12px', lineHeight: '18px', textAlign: 'center', padding: props.theme.spacings.xs4 + ' ' + props.theme.spacings.xs2, cursor: 'pointer', background: getVariantColor(props.theme.colors, props.variant, 'background'), color: getVariantColor(props.theme.colors, props.variant, 'color'), border: "".concat(props.theme.borders.width.xs2, " solid"), borderColor: (_f = (_e = (_d = props === null || props === void 0 ? void 0 : props.theme) === null || _d === void 0 ? void 0 : _d.colors) === null || _e === void 0 ? void 0 : _e.neutral) === null || _f === void 0 ? void 0 : _f[80], borderRadius: props.theme.borders.radius.xl }, _a["&:hover"] = {
        borderColor: 'transparent',
        backgroundColor: props.theme.colors.neutral[90],
    }, _a["> svg"] = {
        backgroundColor: props.theme.colors.neutral[90],
    }, _a[".typography--variant-body3"] = {
        fontWeight: 600,
    }, _a), (props.active && (_b = {
            borderColor: 'transparent',
            backgroundColor: (_j = (_h = (_g = props === null || props === void 0 ? void 0 : props.theme) === null || _g === void 0 ? void 0 : _g.colors) === null || _h === void 0 ? void 0 : _h.secondary) === null || _j === void 0 ? void 0 : _j[95],
            color: (_m = (_l = (_k = props === null || props === void 0 ? void 0 : props.theme) === null || _k === void 0 ? void 0 : _k.colors) === null || _l === void 0 ? void 0 : _l.secondary) === null || _m === void 0 ? void 0 : _m[50]
        },
        _b["&:hover"] = {
            borderColor: 'transparent',
            backgroundColor: props.theme.colors.secondary[90],
        },
        _b))), (props.disabled && (_c = {
            borderColor: 'transparent',
            backgroundColor: (_q = (_p = (_o = props === null || props === void 0 ? void 0 : props.theme) === null || _o === void 0 ? void 0 : _o.colors) === null || _p === void 0 ? void 0 : _p.neutral) === null || _q === void 0 ? void 0 : _q[90],
            color: (_t = (_s = (_r = props === null || props === void 0 ? void 0 : props.theme) === null || _r === void 0 ? void 0 : _r.colors) === null || _s === void 0 ? void 0 : _s.neutral) === null || _t === void 0 ? void 0 : _t[80]
        },
        _c["&:hover"] = {
            borderColor: 'transparent',
            backgroundColor: (_w = (_v = (_u = props === null || props === void 0 ? void 0 : props.theme) === null || _u === void 0 ? void 0 : _u.colors) === null || _v === void 0 ? void 0 : _v.neutral) === null || _w === void 0 ? void 0 : _w[90],
        },
        _c))));
});
var BadgeNumber = styled.div(function (props) {
    var _a;
    return (__assign(__assign((_a = { width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: props.theme.borders.radius.circular, marginLeft: props.theme.spacings.xs4, backgroundColor: getVariantColor(props.theme.colors, props.variant, 'badgeBackgroundColor'), color: getVariantColor(props.theme.colors, props.variant, 'badgeColor') }, _a['.typography--variant-caption'] = {
        fontWeight: 700,
    }, _a), (props.active && {
        backgroundColor: props.theme.colors.primary,
        color: props.theme.colors.neutral[100],
    })), (props.disabled && {
        backgroundColor: props.theme.colors.neutral[80],
        color: props.theme.colors.neutral[90],
    })));
});
styled.div(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (props) { return props.theme.spacings.xs3; });
styled.button(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n"])), function (props) { return props.theme.spacings.xs3; }, function (props) { return props.theme.spacings.xs2; }, function (props) { return props.theme.colors.neutral[95]; }, function (props) { return props.theme.borders.radius.xl; });
styled.ul(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  list-style-type: none;\n  width: 320px;\n"], ["\n  list-style-type: none;\n  width: 320px;\n"])));
styled(TextField$2)(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  padding-left: 40px !important;\n  border: none !important;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  padding-left: 40px !important;\n  border: none !important;\n"])), function (props) { return props.theme.colors.neutral[30]; }, function (props) { return props.theme.typography.fontFamily; });
styled.div(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  height: 60px;\n  width: 296px;\n  border: ", " solid\n    ", ";\n  border-radius: 150px;\n  &:before,\n  &:after {\n    content: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  height: 60px;\n  width: 296px;\n  border: ", " solid\n    ", ";\n  border-radius: 150px;\n  &:before,\n  &:after {\n    content: none;\n  }\n"])), function (props) { return props.theme.borders.width.xs2; }, function (props) { return props.theme.colors.neutral[70]; });
styled(Icons)(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  position: relative;\n  left: 20px;\n  fill: transparent;\n  z-index: 1;\n  circle,\n  line {\n    stroke: ", ";\n  }\n"], ["\n  position: relative;\n  left: 20px;\n  fill: transparent;\n  z-index: 1;\n  circle,\n  line {\n    stroke: ", ";\n  }\n"])), function (props) { return props.theme.colors.neutral[70]; });
var getVariantColor = function (colors, variant, key) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var variantColors = {
        primary: {
            background: (_a = colors === null || colors === void 0 ? void 0 : colors.tertiary) === null || _a === void 0 ? void 0 : _a[90],
            color: (_b = colors === null || colors === void 0 ? void 0 : colors.secondary) === null || _b === void 0 ? void 0 : _b[50],
            badgeColor: (_c = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _c === void 0 ? void 0 : _c[100],
            badgeBackgroundColor: colors === null || colors === void 0 ? void 0 : colors.primary,
        },
        secondary: {
            borderColor: (_d = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _d === void 0 ? void 0 : _d[90],
            color: (_e = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _e === void 0 ? void 0 : _e[40],
            badgeColor: (_f = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _f === void 0 ? void 0 : _f[40],
            stroke: (_g = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _g === void 0 ? void 0 : _g[40],
        },
        tertiary: {
            borderColor: (_h = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _h === void 0 ? void 0 : _h[90],
            color: (_j = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _j === void 0 ? void 0 : _j[40],
            badgeColor: (_k = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _k === void 0 ? void 0 : _k[40],
            stroke: (_l = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _l === void 0 ? void 0 : _l[40],
        },
        disabled: {
            background: (_m = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _m === void 0 ? void 0 : _m[90],
            color: (_o = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _o === void 0 ? void 0 : _o[80],
            badgeColor: (_p = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _p === void 0 ? void 0 : _p[80],
            stroke: (_q = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _q === void 0 ? void 0 : _q[80],
        },
        error: {
            background: (_r = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _r === void 0 ? void 0 : _r[90],
            color: (_s = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _s === void 0 ? void 0 : _s[80],
            badgeColor: (_t = colors === null || colors === void 0 ? void 0 : colors.neutral) === null || _t === void 0 ? void 0 : _t[80],
        },
    };
    return variantColors[variant][key];
};
var templateObject_1$x, templateObject_2$i, templateObject_3$b, templateObject_4$9, templateObject_5$6, templateObject_6$2;

var SearchInputStyled = styled(SearchField)(function (props) { return ({
    padding: "".concat(props.theme.spacings.xs3),
}); });
var Menu$1 = styled.div(function (props) { return ({
    padding: "".concat(props.theme.spacings.xs3),
}); });
var MenuItem$2 = styled.button(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 54px;\n  gap: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 54px;\n  gap: ", ";\n  padding: ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n"])), function (props) { return props.theme.spacings.xs3; }, function (props) { return props.theme.spacings.xs4; }, function (props) { return props.theme.colors.neutral[95]; }, function (props) { return props.theme.borders.radius.m; });
var ItemListContainer = styled.ul(function (props) { return ({
    display: 'flex',
    flexDirection: 'column',
    listStyleType: 'none',
    width: '296px',
    gap: "".concat(props.theme.spacings.xs5),
    padding: "".concat(props.theme.spacings.xs3),
    overflow: 'auto',
    maxHeight: '270px',
}); });
var FooterContainer$1 = styled.div(function (props) { return ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: "".concat(props.theme.spacings.xs3),
    padding: "".concat(props.theme.spacings.xs3),
}); });
var ApplyButton = styled(Button$4)(function () { return ({}); });
var ClearButton = styled(LinkButton)(function () { return ({}); });
var IconsStyled = styled(Icons)(function (props) {
    var _a, _b, _c;
    return (__assign({}, ((props === null || props === void 0 ? void 0 : props.checked) && {
        color: (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.secondary) === null || _c === void 0 ? void 0 : _c[50],
    })));
});
var TypographyStyled = styled(Typography)(function (props) {
    var _a, _b, _c;
    return (__assign(__assign({}, ((props === null || props === void 0 ? void 0 : props.checked) && {
        color: (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b.secondary) === null || _c === void 0 ? void 0 : _c[50],
    })), { textAlign: 'initial' }));
});
var templateObject_1$w;

var TagFilterPopover = function (_a) {
    var anchorEl = _a.anchorEl, setAnchorEl = _a.setAnchorEl, children = _a.children, _b = _a.options, options = _b === void 0 ? [] : _b, onApply = _a.onApply, onClear = _a.onClear, onClick = _a.onClick, onClose = _a.onClose, placeholder = _a.placeholder, _c = _a.disableFooter, disableFooter = _c === void 0 ? false : _c, _d = _a.disableSearch, disableSearch = _d === void 0 ? false : _d, type = _a.type, _e = _a.selectedValues, selectedValues = _e === void 0 ? [] : _e;
    var _f = useState(''), search = _f[0], setSearch = _f[1];
    var getRenderedItem = function (type, item) {
        switch (type) {
            case 'checkbox':
                return React__default.createElement(Checkbox, { checked: selectedValues.includes(item.value) });
            case 'radio':
                return React__default.createElement(Radio, { checked: selectedValues.includes(item.value) });
            case 'custom':
                return (React__default.createElement(IconsStyled, __assign({ checked: selectedValues.includes(item.value) }, item.icon)));
            case 'none':
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    var itemList = options
        .filter(function (option) {
        return option.label.toLowerCase().includes(search.toLowerCase());
    })
        .map(function (option, index) {
        return (React__default.createElement(MenuItem$2, { onClick: function () { return onClick && onClick(option.value); }, key: index },
            getRenderedItem(type, option),
            React__default.createElement(TypographyStyled, { variant: "body3", checked: selectedValues.includes(option.value) }, option.label)));
    });
    var handleOnClose = function () {
        setAnchorEl(null);
        setSearch('');
        if (onClose) {
            onClose();
        }
    };
    var handleOnClear = function () {
        setAnchorEl(null);
        setSearch('');
        if (onClear) {
            onClear();
        }
    };
    var handleOnApply = function () {
        setAnchorEl(null);
        setSearch('');
        if (onApply) {
            onApply();
        }
    };
    var handleSearchChange = function (event) {
        switch (event.type) {
            case 'click':
                setSearch('');
                return;
            default:
                setSearch(event.target.value);
                return;
        }
    };
    return (React__default.createElement(Popover, { open: !!anchorEl, anchorEl: anchorEl, onClose: handleOnClose, PaperProps: {
            style: {
                marginTop: '8px',
            },
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        } },
        React__default.createElement(Menu$1, null,
            children || (React__default.createElement(React__default.Fragment, null,
                !disableSearch && (React__default.createElement(SearchInputStyled, { label: placeholder || 'Buscar', onChange: function (e) { return setSearch(e.target.value); }, onSearchChange: handleSearchChange, value: search })),
                React__default.createElement(ItemListContainer, null, itemList))),
            !disableFooter && (React__default.createElement(FooterContainer$1, null,
                React__default.createElement(ClearButton, { variant: "default", onClick: handleOnClear }, "Limpar"),
                React__default.createElement(ApplyButton, { variant: 'primary', size: 'medium', onClick: handleOnApply }, "Aplicar"))))));
};

var TagFilter = forwardRef(function (_a, ref) {
    var badgeNumber = _a.badgeNumber, children = _a.children, classes = _a.classes, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.disableOptionsFooter, disableOptionsFooter = _c === void 0 ? false : _c, _d = _a.disableOptionsSearch, disableOptionsSearch = _d === void 0 ? false : _d, filterLabel = _a.filterLabel, _e = _a.hasLeftIcon, hasLeftIcon = _e === void 0 ? true : _e, _f = _a.hasRightIcon, hasRightIcon = _f === void 0 ? true : _f, onApply = _a.onApply, onChange = _a.onChange, onClear = _a.onClear, onClick = _a.onClick, _g = _a.optionIconType, optionIconType = _g === void 0 ? 'custom' : _g, options = _a.options, selectedOptions = _a.selectedOptions, variant = _a.variant, isActive = _a.isActive, props = __rest(_a, ["badgeNumber", "children", "classes", "className", "disabled", "disableOptionsFooter", "disableOptionsSearch", "filterLabel", "hasLeftIcon", "hasRightIcon", "onApply", "onChange", "onClear", "onClick", "optionIconType", "options", "selectedOptions", "variant", "isActive"]);
    var _h = useState(null), anchorEl = _h[0], setAnchorEl = _h[1];
    var buttonRef = useRef(null);
    var spacings = useTheme().spacings;
    var _j = useState(selectedOptions || []), checkedValues = _j[0], setCheckedValues = _j[1];
    var _k = useState(selectedOptions || []), selectedValues = _k[0], setSelectedValues = _k[1];
    var handleOnApply = function () {
        setCheckedValues(selectedValues);
        onApply === null || onApply === void 0 ? void 0 : onApply(selectedValues);
    };
    useImperativeHandle(ref, function () { return ({ setAnchorEl: setAnchorEl }); }, []);
    useEffect(function () {
        setNumber(badgeNumber || checkedValues.length);
    }, [badgeNumber, checkedValues]);
    useEffect(function () {
        setSelectedValues(selectedOptions || []);
        setCheckedValues(selectedOptions || []);
    }, [selectedOptions]);
    var handleOnClick = function (value) {
        if (onClick) {
            onClick(value);
        }
        if (optionIconType === 'radio') {
            var radioUpdatedValue = selectedValues.includes(value) ? [] : [value];
            setSelectedValues(radioUpdatedValue);
        }
        else {
            var updatedValues = selectedValues.includes(value)
                ? __spreadArray([], selectedValues.filter(function (item) { return item !== value; }), true) : __spreadArray([], selectedValues, true);
            if (!selectedValues.includes(value)) {
                updatedValues.push(value);
            }
            setSelectedValues(updatedValues);
        }
    };
    var handleOnClear = function () {
        if (onClear) {
            onClear();
        }
        setSelectedValues([]);
        setCheckedValues([]);
    };
    var handleOnClose = function () {
        setSelectedValues(checkedValues);
    };
    useEffect(function () {
        if (onChange) {
            onChange(selectedValues);
        }
    }, [selectedValues, onChange]);
    var _l = useState(badgeNumber || checkedValues.length), number = _l[0], setNumber = _l[1];
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TagFilterStyled, __assign({}, props, { active: isActive !== undefined ? isActive : Boolean(number), variant: variant, className: "loading ".concat(className, " "), classes: classes, ref: buttonRef, onClick: function (event) {
                var _a;
                (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                setAnchorEl === null || setAnchorEl === void 0 ? void 0 : setAnchorEl(event.currentTarget);
            }, disabled: disabled || variant === 'disabled' }),
            hasLeftIcon && (React__default.createElement(Icons, { name: "IconSquareDot", fill: "transparent", style: { marginRight: spacings.xs4, background: 'transparent' } })),
            React__default.createElement(Typography, { variant: "body3" }, filterLabel),
            hasRightIcon && (React__default.createElement(Icons, { name: "IconChevronDown", fill: "transparent", style: { marginLeft: '8px', background: 'transparent' } })),
            Boolean(number) && (React__default.createElement(BadgeNumber, { variant: variant, active: Boolean(number), disabled: disabled },
                React__default.createElement(Typography, { variant: "caption" }, number)))),
        React__default.createElement(TagFilterPopover, { anchorEl: anchorEl, onClick: handleOnClick, onApply: handleOnApply, onClear: handleOnClear, onClose: handleOnClose, options: options, selectedValues: selectedValues, setAnchorEl: setAnchorEl, type: optionIconType, disableFooter: disableOptionsFooter, disableSearch: disableOptionsSearch }, children)));
});
TagFilter.displayName = 'TagFilter';

var DateRangeContainer = styled.div(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  padding: 0 ", ";\n"], ["\n  padding: 0 ", ";\n"])), function (props) { return props.theme.spacings.xs; });
var templateObject_1$v;

var TagDateFilter = function (_a) {
    var disabledDate = _a.disabledDate, options = _a.options, style = _a.style, onFocus = _a.onFocus, onSubmit = _a.onSubmit, onError = _a.onError, type = _a.type, classes = _a.classes, id = _a.id, hasLeftIcon = _a.hasLeftIcon, hasRightIcon = _a.hasRightIcon, filterLabel = _a.filterLabel, className = _a.className, badgeNumber = _a.badgeNumber, disabled = _a.disabled, isActive = _a.isActive, variant = _a.variant, initialDateRange = _a.initialDateRange;
    var _b = useState(initialDateRange !== null && initialDateRange !== void 0 ? initialDateRange : {
        from: undefined,
        to: undefined,
    }), selectedRange = _b[0], setSelectedRange = _b[1];
    var ref = useRef(null);
    function handleSubmit(range) {
        var _a;
        setSelectedRange(range);
        onSubmit(range);
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setAnchorEl(null);
    }
    useEffect(function () {
        var newDate = {
            from: undefined,
            to: undefined,
        };
        if (initialDateRange === null || initialDateRange === void 0 ? void 0 : initialDateRange.from) {
            newDate.from = new Date(initialDateRange === null || initialDateRange === void 0 ? void 0 : initialDateRange.from);
        }
        if (initialDateRange === null || initialDateRange === void 0 ? void 0 : initialDateRange.to) {
            newDate.to = new Date(initialDateRange.to);
        }
        setSelectedRange(newDate);
    }, [initialDateRange === null || initialDateRange === void 0 ? void 0 : initialDateRange.from, initialDateRange === null || initialDateRange === void 0 ? void 0 : initialDateRange.to]);
    return (React__default.createElement(TagFilter, { variant: variant, options: options, ref: ref, filterLabel: filterLabel, id: id, className: "loading ".concat(className, " "), style: style, classes: classes, type: type, onFocus: onFocus, onError: onError, disabled: disabled, isActive: isActive !== undefined
            ? isActive
            : Boolean(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from) || undefined, badgeNumber: badgeNumber, hasLeftIcon: hasLeftIcon, hasRightIcon: hasRightIcon, disableOptionsFooter: true },
        React__default.createElement(DateRangeContainer, null,
            React__default.createElement(DateRangePicker, { disabled: disabledDate, onSubmit: handleSubmit, initialRange: selectedRange }))));
};

var Container$d = styled.div(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  padding-top: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  width: 300px;\n"], ["\n  padding-top: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  width: 300px;\n"])), function (props) { return props.theme.spacings.xs; }, function (props) { return props.theme.spacings.m; }, function (props) { return props.theme.spacings.m; }, function (props) { return props.theme.spacings.xs2; });
var templateObject_1$u;

var TagSliderRangeFilter = function (_a) {
    var min = _a.min, max = _a.max, fieldMask = _a.fieldMask, _b = _a.variant, variant = _b === void 0 ? 'secondary' : _b, handler = _a.handler, step = _a.step, className = _a.className, disabled = _a.disabled, onApply = _a.onApply, initialValues = _a.initialValues, onClear = _a.onClear, _c = _a.valueLabelDisplay, valueLabelDisplay = _c === void 0 ? 'auto' : _c, props = __rest(_a, ["min", "max", "fieldMask", "variant", "handler", "step", "className", "disabled", "onApply", "initialValues", "onClear", "valueLabelDisplay"]);
    var _d = useState([
        min,
        max,
    ]), sliderValues = _d[0], setSliderValues = _d[1];
    var _e = useState([
        min,
        max,
    ]), selectedValues = _e[0], setSelectedValues = _e[1];
    var _f = useState(false), isSelectedValues = _f[0], setIsSelectedValues = _f[1];
    function handleOnApply() {
        var isSelectedValues = checkSelectedValues(selectedValues);
        setIsSelectedValues(isSelectedValues);
        onApply === null || onApply === void 0 ? void 0 : onApply(isSelectedValues ? selectedValues : []);
    }
    function handleOnClear() {
        setIsSelectedValues(false);
        setSelectedValues === null || setSelectedValues === void 0 ? void 0 : setSelectedValues([]);
        onApply === null || onApply === void 0 ? void 0 : onApply([]);
        onClear === null || onClear === void 0 ? void 0 : onClear();
    }
    function checkSelectedValues(_selectedValues) {
        var currentValues = _selectedValues || selectedValues || [];
        if (!currentValues || !(currentValues === null || currentValues === void 0 ? void 0 : currentValues.length))
            return false;
        return (sliderValues === null || sliderValues === void 0 ? void 0 : sliderValues.toString()) !== (currentValues === null || currentValues === void 0 ? void 0 : currentValues.toString());
    }
    useEffect(function () {
        setSelectedValues(initialValues || []);
        setIsSelectedValues(initialValues && initialValues.length === 2
            ? checkSelectedValues(initialValues)
            : false);
    }, [initialValues]);
    useEffect(function () {
        if (min !== undefined && max !== undefined)
            setSliderValues([min, max]);
    }, [min, max]);
    return (React__default.createElement(TagFilter, __assign({ isActive: isSelectedValues, variant: variant, hasLeftIcon: false, className: "loading ".concat(className, " "), disabled: disabled ||
            min === undefined ||
            max === undefined ||
            variant === 'disabled' }, props, { onApply: handleOnApply, onClear: handleOnClear }),
        React__default.createElement(Container$d, null, min !== undefined && max !== undefined && (React__default.createElement(SliderField, { fieldMask: fieldMask, type: "range", value: selectedValues.length ? selectedValues : sliderValues, step: step, onChange: function (_, value) { return setSelectedValues(value); }, onTransitionEnd: function () {
                handler === null || handler === void 0 ? void 0 : handler(selectedValues);
            }, min: sliderValues[0], max: sliderValues[1], valueLabelDisplay: valueLabelDisplay })))));
};

var GlobalStyle = createGlobalStyle(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  :root {\n    --font-family-primary: Cabinet Grotesk, Verdana;\n    --font-family-secondary: Nunito, sans-serif;\n    --color-primary: ", ";\n    --color-secondary-dark1: ", ";\n    --color-secondary-dark2: ", ";\n    --color-secondary-dark3: ", ";\n    --color-secondary-dark4: ", ";\n    --color-secondary-dark5: ", ";\n    --color-secondary-light1: ", ";\n    --color-secondary-light2: ", ";\n    --color-secondary-light3: ", ";\n    --color-secondary-light4: ", ";\n    --color-secondary-light5: ", ";\n    --color-tertiary-1: ", ";\n    --color-tertiary-2: ", ";\n    --color-tertiary-3: ", ";\n    --color-tertiary-4: ", ";\n    --color-neutral-pureDark: ", ";\n    --color-neutral-dark1: ", ";\n    --color-neutral-dark2: ", ";\n    --color-neutral-dark3: ", ";\n    --color-neutral-dark4: ", ";\n    --color-neutral-dark5: ", ";\n    --color-neutral-pureLight: ", ";\n    --color-neutral-light1: ", ";\n    --color-neutral-light2: ", ";\n    --color-neutral-light3: ", ";\n    --color-neutral-light4: ", ";\n    --color-neutral-light5: ", ";\n    --color-feedback-success-pure: ", ";\n    --color-feedback-success-light1: ", ";\n    --color-feedback-success-light2: ", ";\n    --color-feedback-success-dark1: ", ";\n    --color-feedback-success-dark2: ", ";\n    --color-feedback-error-pure: ", ";\n    --color-feedback-error-light1: ", ";\n    --color-feedback-error-light2: ", ";\n    --color-feedback-error-dark1: ", ";\n    --color-feedback-error-dark2: ", ";\n    --color-feedback-info-pure: ", ";\n    --color-feedback-info-light1: ", ";\n    --color-feedback-info-light2: ", ";\n    --color-feedback-info-dark1: ", ";\n    --color-feedback-info-dark2: ", ";\n    --color-feedback-negative-pure: ", ";\n    --color-feedback-negative-light1: ", ";\n    --color-feedback-negative-light2: ", ";\n    --color-feedback-negative-dark1: ", ";\n    --color-feedback-negative-dark2: ", ";\n    --color-feedback-progress-pure: ", ";\n    --color-feedback-progress-light1: ", ";\n    --color-feedback-progress-light2: ", ";\n    --color-feedback-progress-dark1: ", ";\n    --color-feedback-progress-dark2: ", ";\n\n    --color-secondary-10: ", ";\n    --color-secondary-20: ", ";\n    --color-secondary-30: ", ";\n    --color-secondary-40: ", ";\n    --color-secondary-50: ", ";\n    --color-secondary-99: ", ";\n    --color-secondary-95: ", ";\n    --color-secondary-90: ", ";\n    --color-secondary-80: ", ";\n    --color-secondary-70: ", ";\n    --color-tertiary-90: ", ";\n    --color-tertiary-80: ", ";\n    --color-tertiary-70: ", ";\n    --color-tertiary-40: ", ";\n    --color-neutral-0: ", ";\n    --color-neutral-10: ", ";\n    --color-neutral-20: ", ";\n    --color-neutral-30: ", ";\n    --color-neutral-40: ", ";\n    --color-neutral-50: ", ";\n    --color-neutral-100: ", ";\n    --color-neutral-95: ", ";\n    --color-neutral-90: ", ";\n    --color-neutral-80: ", ";\n    --color-neutral-70: ", ";\n    --color-neutral-60: ", ";\n    --color-feedback-success-50: ", ";\n    --color-feedback-success-90: ", ";\n    --color-feedback-success-70: ", ";\n    --color-feedback-success-40: ", ";\n    --color-feedback-success-10: ", ";\n    --color-feedback-error-50: ", ";\n    --color-feedback-error-90: ", ";\n    --color-feedback-error-70: ", ";\n    --color-feedback-error-40: ", ";\n    --color-feedback-error-10: ", ";\n    --color-feedback-info-50: ", ";\n    --color-feedback-info-90: ", ";\n    --color-feedback-info-70: ", ";\n    --color-feedback-info-40: ", ";\n    --color-feedback-info-10: ", ";\n\n    --color-feedback-progress-50: ", ";\n    --color-feedback-progress-90: ", ";\n    --color-feedback-progress-70: ", ";\n    --color-feedback-progress-40: ", ";\n    --color-feedback-progress-10: ", ";\n    \n    --color-feedback-negative-50: ", ";\n    --color-feedback-negative-90: ", ";\n    --color-feedback-negative-70: ", ";\n    --color-feedback-negative-40: ", ";\n    --color-feedback-negative-10: ", ";\n\n    --color-feedback-attention-10: ", ";\n    --color-feedback-attention-40: ", ";\n    --color-feedback-attention-50: ", ";\n    --color-feedback-attention-70: ", ";\n    --color-feedback-attention-90: ", ";\n\n    --color-glow-pink: ", ";\n    --color-glow-green: ", ";\n    --color-glow-yellow: ", ";\n    --color-glow-blue: ", ";\n    --color-shadow: ", ";\n\n    --light-shadow-level-1: 0px 2px 24px 0px;\n    --light-shadow-level-2: 0px 4px 28px 0px;\n    --light-shadow-level-3: 0px 8px 32px 0px;\n    --light-shadow-level-4: 0px 16px 40px 0px;\n\n    --opacity-level-opaque: 100%;\n    --opacity-level-semiopaque: 80%;\n    --opacity-level-intense: 64%;\n    --opacity-level-medium: 56%;\n    --opacity-level-light: 40%;\n    --opacity-level-lighest: 24%;\n    --opacity-level-weak: 16%;\n    --opacity-level-weakest: 8%;\n  }\n"], ["\n  :root {\n    --font-family-primary: Cabinet Grotesk, Verdana;\n    --font-family-secondary: Nunito, sans-serif;\n    --color-primary: ", ";\n    --color-secondary-dark1: ", ";\n    --color-secondary-dark2: ", ";\n    --color-secondary-dark3: ", ";\n    --color-secondary-dark4: ", ";\n    --color-secondary-dark5: ", ";\n    --color-secondary-light1: ", ";\n    --color-secondary-light2: ", ";\n    --color-secondary-light3: ", ";\n    --color-secondary-light4: ", ";\n    --color-secondary-light5: ", ";\n    --color-tertiary-1: ", ";\n    --color-tertiary-2: ", ";\n    --color-tertiary-3: ", ";\n    --color-tertiary-4: ", ";\n    --color-neutral-pureDark: ", ";\n    --color-neutral-dark1: ", ";\n    --color-neutral-dark2: ", ";\n    --color-neutral-dark3: ", ";\n    --color-neutral-dark4: ", ";\n    --color-neutral-dark5: ", ";\n    --color-neutral-pureLight: ", ";\n    --color-neutral-light1: ", ";\n    --color-neutral-light2: ", ";\n    --color-neutral-light3: ", ";\n    --color-neutral-light4: ", ";\n    --color-neutral-light5: ", ";\n    --color-feedback-success-pure: ", ";\n    --color-feedback-success-light1: ", ";\n    --color-feedback-success-light2: ", ";\n    --color-feedback-success-dark1: ", ";\n    --color-feedback-success-dark2: ", ";\n    --color-feedback-error-pure: ", ";\n    --color-feedback-error-light1: ", ";\n    --color-feedback-error-light2: ", ";\n    --color-feedback-error-dark1: ", ";\n    --color-feedback-error-dark2: ", ";\n    --color-feedback-info-pure: ", ";\n    --color-feedback-info-light1: ", ";\n    --color-feedback-info-light2: ", ";\n    --color-feedback-info-dark1: ", ";\n    --color-feedback-info-dark2: ", ";\n    --color-feedback-negative-pure: ", ";\n    --color-feedback-negative-light1: ", ";\n    --color-feedback-negative-light2: ", ";\n    --color-feedback-negative-dark1: ", ";\n    --color-feedback-negative-dark2: ", ";\n    --color-feedback-progress-pure: ", ";\n    --color-feedback-progress-light1: ", ";\n    --color-feedback-progress-light2: ", ";\n    --color-feedback-progress-dark1: ", ";\n    --color-feedback-progress-dark2: ", ";\n\n    --color-secondary-10: ", ";\n    --color-secondary-20: ", ";\n    --color-secondary-30: ", ";\n    --color-secondary-40: ", ";\n    --color-secondary-50: ", ";\n    --color-secondary-99: ", ";\n    --color-secondary-95: ", ";\n    --color-secondary-90: ", ";\n    --color-secondary-80: ", ";\n    --color-secondary-70: ", ";\n    --color-tertiary-90: ", ";\n    --color-tertiary-80: ", ";\n    --color-tertiary-70: ", ";\n    --color-tertiary-40: ", ";\n    --color-neutral-0: ", ";\n    --color-neutral-10: ", ";\n    --color-neutral-20: ", ";\n    --color-neutral-30: ", ";\n    --color-neutral-40: ", ";\n    --color-neutral-50: ", ";\n    --color-neutral-100: ", ";\n    --color-neutral-95: ", ";\n    --color-neutral-90: ", ";\n    --color-neutral-80: ", ";\n    --color-neutral-70: ", ";\n    --color-neutral-60: ", ";\n    --color-feedback-success-50: ", ";\n    --color-feedback-success-90: ", ";\n    --color-feedback-success-70: ", ";\n    --color-feedback-success-40: ", ";\n    --color-feedback-success-10: ", ";\n    --color-feedback-error-50: ", ";\n    --color-feedback-error-90: ", ";\n    --color-feedback-error-70: ", ";\n    --color-feedback-error-40: ", ";\n    --color-feedback-error-10: ", ";\n    --color-feedback-info-50: ", ";\n    --color-feedback-info-90: ", ";\n    --color-feedback-info-70: ", ";\n    --color-feedback-info-40: ", ";\n    --color-feedback-info-10: ", ";\n\n    --color-feedback-progress-50: ", ";\n    --color-feedback-progress-90: ", ";\n    --color-feedback-progress-70: ", ";\n    --color-feedback-progress-40: ", ";\n    --color-feedback-progress-10: ", ";\n    \n    --color-feedback-negative-50: ", ";\n    --color-feedback-negative-90: ", ";\n    --color-feedback-negative-70: ", ";\n    --color-feedback-negative-40: ", ";\n    --color-feedback-negative-10: ", ";\n\n    --color-feedback-attention-10: ", ";\n    --color-feedback-attention-40: ", ";\n    --color-feedback-attention-50: ", ";\n    --color-feedback-attention-70: ", ";\n    --color-feedback-attention-90: ", ";\n\n    --color-glow-pink: ", ";\n    --color-glow-green: ", ";\n    --color-glow-yellow: ", ";\n    --color-glow-blue: ", ";\n    --color-shadow: ", ";\n\n    --light-shadow-level-1: 0px 2px 24px 0px;\n    --light-shadow-level-2: 0px 4px 28px 0px;\n    --light-shadow-level-3: 0px 8px 32px 0px;\n    --light-shadow-level-4: 0px 16px 40px 0px;\n\n    --opacity-level-opaque: 100%;\n    --opacity-level-semiopaque: 80%;\n    --opacity-level-intense: 64%;\n    --opacity-level-medium: 56%;\n    --opacity-level-light: 40%;\n    --opacity-level-lighest: 24%;\n    --opacity-level-weak: 16%;\n    --opacity-level-weakest: 8%;\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.primary;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary10;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary20;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary30;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary50;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary99;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary95;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary80;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.tertiary90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.tertiary80;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.tertiary70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.tertiary40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral0;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral10;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral20;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral30;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral50;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral100;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral95;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral80;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral60;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.success10;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.success90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.success70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.success40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.success10;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.error50;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.error90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.error70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.error40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.error10;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.info50;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.info90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.info70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.info40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.info40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.negative50;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.negative90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.negative70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.negative40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.negative40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.progress50;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.progress90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.progress70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.progress40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.progress40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary10;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary20;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary30;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary50;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary99;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary95;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary80;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.secondary70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.tertiary90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.tertiary80;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.tertiary70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.tertiary40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral0;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral10;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral20;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral30;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral40;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral50;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral100;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral95;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral90;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral80;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral70;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.neutral60;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.success50;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.success90;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.success70;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.success40;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.success10;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.error50;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.error90;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.error70;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.error40;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.error10;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.info50;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.info90;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.info70;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.info40;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.info10;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.progress50;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.progress90;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.progress70;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.progress40;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.progress10;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.negative50;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.negative90;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.negative70;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.negative40;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.negative10;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.status.attention[10];
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.status.attention[40];
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.status.attention[50];
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.status.attention[70];
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.status.attention[90];
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.glowPink;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.glowGreen;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.glowYellow;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.glowBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.shadow;
});
var templateObject_1$t;

var ResetCSS = createGlobalStyle(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\nhtml {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    font-family: system-ui, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    touch-action: manipulation;\n  }\n  body {\n    position: relative;\n    min-height: 100%;\n    font-feature-settings: 'kern';\n  }\n  *,\n  *::before,\n  *::after {\n    border-width: 0;\n    border-style: solid;\n    box-sizing: border-box;\n  }\n  main {\n    display: block;\n  }\n  hr {\n    border-top-width: 1px;\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n  }\n  pre,\n  code,\n  kbd,\n  samp {\n    font-family: SFMono-Regular,  Menlo, Monaco, Consolas, monospace;\n    font-size: 1em;\n  }\n  a {\n    background-color: transparent;\n    color: inherit;\n    text-decoration: inherit;\n  }\n  abbr[title] {\n    border-bottom: none;\n    text-decoration: underline;\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n  b,\n  strong {\n    font-weight: bold;\n  }\n  small {\n    font-size: 80%;\n  }\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  sub {\n    bottom: -0.25em;\n  }\n  sup {\n    top: -0.5em;\n  }\n  img {\n    border-style: none;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n  }\n  button,\n  input {\n    overflow: visible;\n  }\n  button,\n  select {\n    text-transform: none;\n  }\n  button::-moz-focus-inner,\n  [type=\"button\"]::-moz-focus-inner,\n  [type=\"reset\"]::-moz-focus-inner,\n  [type=\"submit\"]::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n  legend {\n    box-sizing: border-box;\n    color: inherit;\n    display: table;\n    max-width: 100%;\n    padding: 0;\n    white-space: normal;\n  }\n  progress {\n    vertical-align: baseline;\n  }\n  textarea {\n    overflow: auto;\n  }\n  [type=\"checkbox\"],\n  [type=\"radio\"] {\n    box-sizing: border-box;\n    padding: 0;\n  }\n  [type=\"number\"]::-webkit-inner-spin-button,\n  [type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none !important;\n  }\n  input[type=\"number\"] {\n    -moz-appearance: textfield;\n  }\n  [type=\"search\"] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px;\n  }\n  [type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none !important;\n  }\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit;\n  }\n  details {\n    display: block;\n  }\n  summary {\n    display: list-item;\n  }\n  template {\n    display: none;\n  }\n  [hidden] {\n    display: none !important;\n  }\n  body,\n  blockquote,\n  dl,\n  dd,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  hr,\n  figure,\n  p,\n  pre {\n    margin: 0;\n  }\n  button {\n    background: transparent;\n    padding: 0;\n  }\n  fieldset {\n    margin: 0;\n    padding: 0;\n  }\n  ol,\n  ul {\n    margin: 0;\n    padding: 0;\n  }\n  textarea {\n    resize: vertical;\n  }\n  button,\n  [role=\"button\"] {\n    cursor: pointer;\n  }\n  button::-moz-focus-inner {\n    border: 0 !important;\n  }\n  table {\n    border-collapse: collapse;\n  }\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    padding: 0;\n    line-height: inherit;\n    color: inherit;\n  }\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block;\n  }\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n  [data-js-focus-visible] :focus:not([data-focus-visible-added]):not([data-focus-visible-disabled]) {\n    outline: none;\n    box-shadow: none;\n  }\n  select::-ms-expand {\n    display: none;\n  }\n"], ["\nhtml {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    font-family: system-ui, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    text-rendering: optimizeLegibility;\n    -moz-osx-font-smoothing: grayscale;\n    touch-action: manipulation;\n  }\n  body {\n    position: relative;\n    min-height: 100%;\n    font-feature-settings: 'kern';\n  }\n  *,\n  *::before,\n  *::after {\n    border-width: 0;\n    border-style: solid;\n    box-sizing: border-box;\n  }\n  main {\n    display: block;\n  }\n  hr {\n    border-top-width: 1px;\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n  }\n  pre,\n  code,\n  kbd,\n  samp {\n    font-family: SFMono-Regular,  Menlo, Monaco, Consolas, monospace;\n    font-size: 1em;\n  }\n  a {\n    background-color: transparent;\n    color: inherit;\n    text-decoration: inherit;\n  }\n  abbr[title] {\n    border-bottom: none;\n    text-decoration: underline;\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n  b,\n  strong {\n    font-weight: bold;\n  }\n  small {\n    font-size: 80%;\n  }\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  sub {\n    bottom: -0.25em;\n  }\n  sup {\n    top: -0.5em;\n  }\n  img {\n    border-style: none;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit;\n    font-size: 100%;\n    line-height: 1.15;\n    margin: 0;\n  }\n  button,\n  input {\n    overflow: visible;\n  }\n  button,\n  select {\n    text-transform: none;\n  }\n  button::-moz-focus-inner,\n  [type=\"button\"]::-moz-focus-inner,\n  [type=\"reset\"]::-moz-focus-inner,\n  [type=\"submit\"]::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n  legend {\n    box-sizing: border-box;\n    color: inherit;\n    display: table;\n    max-width: 100%;\n    padding: 0;\n    white-space: normal;\n  }\n  progress {\n    vertical-align: baseline;\n  }\n  textarea {\n    overflow: auto;\n  }\n  [type=\"checkbox\"],\n  [type=\"radio\"] {\n    box-sizing: border-box;\n    padding: 0;\n  }\n  [type=\"number\"]::-webkit-inner-spin-button,\n  [type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none !important;\n  }\n  input[type=\"number\"] {\n    -moz-appearance: textfield;\n  }\n  [type=\"search\"] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px;\n  }\n  [type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none !important;\n  }\n  ::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit;\n  }\n  details {\n    display: block;\n  }\n  summary {\n    display: list-item;\n  }\n  template {\n    display: none;\n  }\n  [hidden] {\n    display: none !important;\n  }\n  body,\n  blockquote,\n  dl,\n  dd,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  hr,\n  figure,\n  p,\n  pre {\n    margin: 0;\n  }\n  button {\n    background: transparent;\n    padding: 0;\n  }\n  fieldset {\n    margin: 0;\n    padding: 0;\n  }\n  ol,\n  ul {\n    margin: 0;\n    padding: 0;\n  }\n  textarea {\n    resize: vertical;\n  }\n  button,\n  [role=\"button\"] {\n    cursor: pointer;\n  }\n  button::-moz-focus-inner {\n    border: 0 !important;\n  }\n  table {\n    border-collapse: collapse;\n  }\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    padding: 0;\n    line-height: inherit;\n    color: inherit;\n  }\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block;\n  }\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n  [data-js-focus-visible] :focus:not([data-focus-visible-added]):not([data-focus-visible-disabled]) {\n    outline: none;\n    box-shadow: none;\n  }\n  select::-ms-expand {\n    display: none;\n  }\n"])));
var templateObject_1$s;

var themeBorders = {
    width: {
        xs2: '1px',
        xs: '1.5px',
        s: '2px',
        m: '2.5px',
        l: '4px',
        xl: '8px',
    },
    radius: {
        xs: '4px',
        s: '8px',
        m: '12px',
        l: '16px',
        xl: '24px',
        xl2: '32px',
        pill: '500px',
        circular: '100%',
    },
};

var fonts = {
    primary: 'Cabinet Grotesk, Verdana',
    secondary: 'Nunito, Verdana',
};

var themeIcons = {
    sizes: {
        xs3: '12px',
        xs2: '16px',
        xs: '24px',
        s: '32px',
        m: '40px',
        l: '48px',
        xl: '56px',
        xl2: '64px',
        xl3: '72px',
        xl4: '96px',
    },
};

var themeSpacings = {
    xs5: '4px',
    xs4: '8px',
    xs3: '12px',
    xs2: '16px',
    xs1: '20px',
    xs: '24px',
    s: '32px',
    m: '40px',
    l: '64px',
    xl5: '80px',
    xl4: '96px',
    xl3: '120px',
    xl2: '144px',
    xl: '160px',
};

var LightTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
        },
    },
    palette: {
        mode: 'light',
        primary: {
            main: '#FE2B8F',
        },
        secondary: {
            main: '#FFE0EF',
        },
    },
    colors: __assign(__assign({}, deprecatedColors), colors),
    borders: themeBorders,
    icons: themeIcons,
    spacings: themeSpacings,
    fonts: fonts,
});
var DarkTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
        },
    },
    palette: {
        mode: 'light',
        primary: {
            main: '#FE2B8F',
        },
        secondary: {
            main: '#FFE0EF',
        },
    },
    colors: __assign(__assign({}, deprecatedColors), colors),
    borders: themeBorders,
    icons: themeIcons,
    spacings: themeSpacings,
    fonts: fonts,
});

var ThemeProvider = function (_a) {
    var children = _a.children, mode = _a.mode, _b = _a.overrides, overrides = _b === void 0 ? {} : _b;
    var prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    var themeMode = mode || (prefersDarkMode ? 'dark' : 'light');
    var theme = useMemo(function () { return (themeMode === 'dark' ? DarkTheme : LightTheme); }, [themeMode]);
    theme = useMemo(function () { return overrideTheme({ overrides: overrides, theme: theme }); }, [themeMode, overrides]);
    return (React__default.createElement(ThemeProvider$1, { theme: theme },
        React__default.createElement(ResetCSS, null),
        React__default.createElement(GlobalStyle, null),
        children));
};

var css_248z$c = ".time-picker-custom-theme input{color:var(--color-neutral-dark3);font-family:var(--font-family-secondary);font-weight:600}.time-picker-custom-theme div.MuiInputBase-root{padding-right:20px}.time-picker-custom-theme div.MuiFilledInput-root{background-color:transparent;border:2px solid var(--color-neutral-light4);border-radius:12px}.time-picker-custom-theme div.MuiFilledInput-root:after,.time-picker-custom-theme div.MuiFilledInput-root:before{content:none}.time-picker-custom-theme label{font-family:var(--font-family-secondary);font-weight:600}.time-picker-custom-theme label.Mui-error,.time-picker-custom-theme label.Mui-focused{color:var(--color-neutral-dark5)}.time-picker-custom-theme div.Mui-focused{border:2px solid var(--color-secondary-light5)}.time-picker-custom-theme .Mui-focused svg{fill:var(--color-secondary-light5)}.time-picker-custom-theme div.Mui-error{background:var(--color-feedback-error-light1);border:2px solid var(--color-feedback-error-pure)}.time-picker-custom-theme div.Mui-error svg{fill:var(--color-feedback-error-light2)}.time-picker-custom-theme .warning svg{stroke:var(--color-feedback-error-pure)}.helperText{fill:transparent;align-items:center;color:var(--color-neutral-dark5);display:flex;font-family:var(--font-family-secondary);font-size:12px;font-weight:600;margin:6px 0 0 16px}";
styleInject(css_248z$c);

var TimePicker = function (_a) {
    var value = _a.value, label = _a.label, disabled = _a.disabled, onChange = _a.onChange, error = _a.error, helperText = _a.helperText, className = _a.className, style = _a.style, _b = _a.ampmClock, ampmClock = _b === void 0 ? true : _b;
    return (React__default.createElement("div", { style: style },
        React__default.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
            React__default.createElement(TimePicker$1, { ampm: ampmClock, label: label, value: value, onChange: onChange, renderInput: function (params) { return (React__default.createElement(TextField$2, __assign({ variant: 'filled', fullWidth: true }, params, { error: error }))); }, disabled: disabled, className: "time-picker-custom-theme ".concat(className) }),
            helperText && (React__default.createElement("p", { className: "helperText ".concat(error && 'warning') },
                error && React__default.createElement(Icons, { name: "IconInfoCircle", size: 18 }),
                helperText)))));
};
TimePicker.displayName = 'TimePicker';

var css_248z$b = ".toast-custom-theme{display:inline-flex;flex-direction:row;max-width:430px;padding:24px}.toast-custom-theme .toast-subcontainer{align-items:center;display:flex}.toast-custom-theme svg{fill:transparent}.toast-custom-theme .toast-icon-area{align-items:center;border-radius:100%;display:flex;justify-content:center;margin-right:20px;padding:12px}.toast-custom-theme .toast-icon-area svg{stroke:var(--color-feedback-success-light1)}.toast-custom-theme .without-description-toast-icon-area{display:flex;margin-right:12px}.toast-custom-theme .without-description-toast-icon-area svg{stroke:var(--color-feedback-success-light1)}.toast-custom-theme .toast-content-area{font-family:var(--font-family-secondary);max-width:278px;width:100%;word-break:break-word}.toast-custom-theme .toast-children-area{margin-top:8px}.toast-custom-warning{background-color:var(--color-feedback-info-light1);border:1px solid var(--color-feedback-info-light2);border-radius:8px}.toast-custom-warning p{color:var(--color-feedback-info-dark2)}.toast-custom-warning .toast-icon-warning{background:var(--color-feedback-info-pure)}.toast-custom-warning .toast-close-button{align-self:flex-start;margin-left:20px}.toast-custom-warning .toast-close-button.without-description{align-self:center}.toast-custom-warning .without-description-toast-icon-area{display:flex;margin-right:12px}.toast-custom-warning .without-description-toast-icon-area svg{stroke:var(--color-feedback-info-pure)}.toast-custom-success{background-color:var(--color-feedback-success-light1);border:1px solid var(--color-feedback-success-light2);border-radius:8px}.toast-custom-success p{color:var(--color-feedback-success-dark2)}.toast-custom-success .toast-icon-success{background:var(--color-feedback-success-pure)}.toast-custom-success .toast-close-button{align-self:flex-start;margin-left:8px}.toast-custom-success .toast-close-button.without-description{align-self:center;margin-left:20px}.toast-custom-success .without-description-toast-icon-area{display:flex;margin-right:12px}.toast-custom-success .without-description-toast-icon-area svg{stroke:var(--color-feedback-success-pure)}.toast-custom-error{background-color:var(--color-feedback-error-light1);border:1px solid var(--color-feedback-error-light2);border-radius:8px}.toast-custom-error p{color:var(--color-feedback-error-dark2)}.toast-custom-error .toast-icon-error{background:var(--color-feedback-error-pure)}.toast-custom-error .toast-icon-error svg{stroke:var(--color-feedback-error-light1)}.toast-custom-error .toast-close-button{align-self:flex-start;margin-left:8px;margin-top:-8px}.toast-custom-error .toast-close-button svg{stroke:var(--color-feedback-error-pure)}.toast-custom-error .toast-close-button.without-description{align-self:center;margin-left:20px;margin-top:0}.toast-custom-error .without-description-toast-icon-area{display:flex;margin-right:12px}.toast-custom-error .without-description-toast-icon-area svg{stroke:var(--color-feedback-error-pure)}.toast-custom-theme-without-description{display:inline-flex;flex-direction:row;max-width:364px;padding:20px 24px}";
styleInject(css_248z$b);

var Toast = function (_a) {
    var _b = _a.id, id = _b === void 0 ? '0' : _b, _c = _a.title, title = _c === void 0 ? 'teste' : _c, _d = _a.type, type = _d === void 0 ? 'error' : _d, content = _a.content, description = _a.description;
    var parseTitle = title || content;
    var closeToast = useToasts().closeToast;
    var handleClose = function (id) { return closeToast(id); };
    return (React__default.createElement("div", { key: id, className: "toast-custom-theme ".concat(!description && 'toast-custom-theme-without-description', " ").concat(type === 'error'
            ? 'toast-custom-error'
            : type === 'warning'
                ? 'toast-custom-warning'
                : 'toast-custom-success') },
        React__default.createElement("div", { className: 'toast-subcontainer' },
            type === 'success' && (React__default.createElement("div", { className: description
                    ? 'toast-icon-area toast-icon-success'
                    : 'without-description-toast-icon-area' },
                React__default.createElement(Icons, { name: "IconCircleCheck", size: 24 }))),
            type === 'error' && (React__default.createElement("div", { className: description
                    ? 'toast-icon-area toast-icon-error'
                    : 'without-description-toast-icon-area' },
                React__default.createElement(Icons, { name: "IconCircleX", size: 24 }))),
            type === 'warning' && (React__default.createElement("div", { className: description
                    ? 'toast-icon-area toast-icon-warning'
                    : 'without-description-toast-icon-area' },
                React__default.createElement(Icons, { name: "IconAlertCircle", size: 24 }))),
            React__default.createElement("div", { className: "toast-content-area" },
                parseTitle && (React__default.createElement(Typography, { variant: "body3", style: { fontWeight: '600', userSelect: 'none' } }, parseTitle)),
                description && (React__default.createElement(Typography, { variant: "body4", style: { userSelect: 'none' } }, description)))),
        React__default.createElement("div", null,
            React__default.createElement(IconButton$1, { className: "toast-close-button ".concat(!description && 'without-description'), onClick: function () { return handleClose(id); } },
                React__default.createElement(Icons, { name: "IconX", size: 16 })))));
};

var css_248z$a = ".transfer-list-empty-data-message-container{align-items:center;color:var(--color-neutral-dark5);display:flex;flex-direction:column;height:100%;justify-content:center;padding:20px 0;text-align:center;width:100%}";
styleInject(css_248z$a);

var EmptyDataMessage = function (_a) {
    var message = _a.message;
    return (React__default.createElement("div", { className: "transfer-list-empty-data-message-container" },
        React__default.createElement(Icons, { name: "TransferListIcon", size: 169 }),
        message ? (typeof message === 'string' ? (React__default.createElement(Typography, { variant: "body3" }, message)) : (message)) : null));
};

var css_248z$9 = ".transfer-list-section-container{align-items:flex-start;border:1px solid var(--color-neutral-light2);border-radius:12px;display:flex;flex-direction:column;justify-content:center;margin-bottom:20px;padding:20px;width:100%}.transfer-list-section-container .transfer-list-section-search-field{margin-top:15px;width:100%}.transfer-list-section-container .transfer-list-section-overflow{margin-top:15px;max-height:150px;overflow-x:scroll;width:100%}.transfer-list-section-container .transfer-list-section-overflow .transfer-list-section-options-container{align-items:flex-start;display:flex;flex-direction:column;justify-content:center;padding:10px 0;width:100%}.transfer-list-section-container .transfer-list-section-overflow .transfer-list-section-options-container .transfer-list-section-option-checked{background-color:var(--color-secondary-light2);color:var(--color-secondary-dark4)}.transfer-list-section-container .transfer-list-section-overflow .transfer-list-section-options-container .transfer-list-section-option{align-items:center;border-radius:8px;cursor:pointer;display:flex;justify-content:space-between;margin-bottom:5px;padding:5px 10px 5px 5px;width:100%}";
styleInject(css_248z$9);

var Section = function (_a) {
    var _b;
    var id = _a.id, title = _a.title, options = _a.options, onCheck = _a.onCheck, onSearch = _a.onSearch;
    return (React__default.createElement("div", { className: "transfer-list-section-container" },
        React__default.createElement(Typography, { variant: "headline8" }, title),
        onSearch ? (React__default.createElement(SearchField, { label: "Buscar", onInputChange: function (event, value, reason) {
                if (event && !value && reason === 'clear')
                    onSearch({ text: '', sectionId: id });
            }, onChange: function (e) {
                var _a;
                return onSearch &&
                    onSearch({
                        text: ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || '',
                        sectionId: id,
                    });
            }, className: "transfer-list-section-search-field", fullWidth: true })) : null,
        React__default.createElement("div", { className: "transfer-list-section-overflow" },
            React__default.createElement("div", { className: "transfer-list-section-options-container" }, (_b = options === null || options === void 0 ? void 0 : options.filter(function (_a) {
                var hidden = _a.hidden;
                return !hidden;
            })) === null || _b === void 0 ? void 0 : _b.map(function (_a, i) {
                var key = _a.key, label = _a.label, asideText = _a.asideText, checked = _a.checked;
                return (React__default.createElement("button", { type: "button", className: "transfer-list-section-option ".concat(checked ? 'transfer-list-section-option-checked' : ''), key: i, onClick: function () {
                        return onCheck({
                            sectionId: id,
                            title: title,
                            options: options === null || options === void 0 ? void 0 : options.map(function (option) {
                                return key === (option === null || option === void 0 ? void 0 : option.key)
                                    ? __assign(__assign({}, option), { checked: !checked }) : option;
                            }),
                        });
                    } },
                    React__default.createElement("div", null,
                        React__default.createElement(Checkbox, { id: "transfer-list-checkbox-".concat(i), checked: checked }),
                        label),
                    asideText ? (React__default.createElement(Typography, { variant: "body4" }, asideText)) : null));
            })))));
};

var css_248z$8 = ".transfer-list-menu-container{background-color:var(--color-neutral-pureLight);box-shadow:0 12px 24px rgba(21,25,28,.1);height:100vh;max-width:100%;overflow-y:auto;padding-bottom:40px;position:fixed;right:0;top:0;transition:.4s;width:592px;word-break:break-all;z-index:4}.transfer-list-menu-container .transfer-list-menu-header{padding:50px 50px 30px;position:relative;width:100%}.transfer-list-menu-container .transfer-list-menu-header :first-child{color:var(--color-neutral-dark1)}.transfer-list-menu-container .transfer-list-menu-header .transfer-list-menu-icon{align-items:center;background-color:var(--color-neutral-pureLight);border:1px solid var(--color-neutral-light2);border-radius:100%;cursor:pointer;display:inline-flex;justify-content:center;padding:8px;position:absolute;right:15px;top:15px}.transfer-list-menu-container .transfer-list-menu-sections-container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:0 50px 50px}.transfer-list-menu-container .transfer-list-menu-button-container{align-items:center;background-color:var(--color-neutral-pureLight);border-top:1px solid var(--color-neutral-light2);bottom:0;box-shadow:0 4px 26px rgba(0,0,0,.1);display:flex;justify-content:space-between;padding:20px 50px;position:fixed;right:0;transition:.4s;width:592px;z-index:4}.transfer-list-menu-container-visible{margin-right:0}.transfer-list-menu-container-not-visible{margin-right:-593px}";
styleInject(css_248z$8);

var Menu = function (_a) {
    var title = _a.title, description = _a.description, sections = _a.sections, visible = _a.visible, labels = _a.labels, onClose = _a.onClose, onFilter = _a.onFilter, onCheck = _a.onCheck, onClear = _a.onClear, onSearch = _a.onSearch;
    return (React__default.createElement("div", { className: "transfer-list-menu-container ".concat(visible
            ? 'transfer-list-menu-container-visible'
            : 'transfer-list-menu-container-not-visible') },
        React__default.createElement("div", { className: "transfer-list-menu-header" },
            React__default.createElement(Typography, { variant: "headline7" }, title),
            description ? (React__default.createElement(Typography, { variant: "body3" }, description)) : null,
            React__default.createElement("button", { className: "transfer-list-menu-icon", onClick: onClose, type: "button" },
                React__default.createElement(Icons, { name: "IconX", color: "var(--color-neutral-dark4)" }))),
        React__default.createElement("div", { className: "transfer-list-menu-sections-container" }, sections === null || sections === void 0 ? void 0 : sections.map(function (props, i) { return (React__default.createElement(Section, __assign({ key: i }, props, { onCheck: onCheck, onSearch: onSearch }))); })),
        React__default.createElement("div", { className: "transfer-list-menu-button-container ".concat(visible
                ? 'transfer-list-menu-container-visible'
                : 'transfer-list-menu-container-not-visible') },
            React__default.createElement(Button$4, { variant: "secondary", size: "medium", onClick: onClear }, (labels === null || labels === void 0 ? void 0 : labels.clearButton) || 'Limpar'),
            React__default.createElement(Button$4, { variant: "primary", size: "medium", onClick: function () {
                    onFilter(sections === null || sections === void 0 ? void 0 : sections.map(function (_a) {
                        var id = _a.id, title = _a.title, options = _a.options;
                        return ({
                            id: id,
                            title: title,
                            options: options,
                        });
                    }));
                    onClose();
                } }, (labels === null || labels === void 0 ? void 0 : labels.submitButton) || 'Filtrar'))));
};

var css_248z$7 = ".transfer-list-filter{color:var(--color-neutral-dark3);width:100%}.transfer-list-filter .transfer-list-filter-search-field-container{align-items:center;display:flex;gap:15px;justify-content:space-between;margin:20px 0;width:100%}.transfer-list-filter .transfer-list-filter-search-field-container .transfer-list-list-search-field{margin-right:20px;width:100%}.transfer-list-filter .transfer-list-filter-search-field-container .transfer-list-filter-icon-container{align-items:center;border:1px solid var(--color-neutral-light2);border-radius:100%;cursor:pointer;display:flex;justify-content:center;padding:15px;position:relative}.transfer-list-filter .transfer-list-filter-search-field-container .transfer-list-filter-icon-container .transfer-list-filter-total-filters{align-items:center;background-color:var(--color-primary);border-radius:100%;color:var(--color-neutral-light1);display:flex;font-weight:700;height:15px;justify-content:center;padding:8px;position:absolute;right:0;top:0;width:15px}.transfer-list-filter .transfer-list-filter-search-field-container .transfer-list-filter-has-filter{background-color:var(--color-secondary-light2);border-color:var(--color-secondary-light2)}";
styleInject(css_248z$7);

var Filter = function (_a) {
    var title = _a.title, disabled = _a.disabled, onSearch = _a.onSearch, customFilters = _a.customFilters, totalFilers = _a.totalFilers;
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    return (React__default.createElement("div", { className: "transfer-list-filter" },
        customFilters ? (React__default.createElement(Menu, __assign({ visible: visible, onClose: function () { return setVisible(!visible); } }, customFilters))) : null,
        title ? React__default.createElement(Typography, { variant: "headline8" }, title) : null,
        customFilters || onSearch ? (React__default.createElement("div", { className: "transfer-list-filter-search-field-container" },
            onSearch ? (React__default.createElement(SearchField, { className: "transfer-list-list-search-field", label: "Buscar", onInputChange: function (event, value, reason) {
                    if (event && !value && reason === 'clear')
                        onSearch('');
                }, onChange: function (e) { var _a, _b; return onSearch && onSearch((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ''); }, disabled: !!disabled })) : null,
            customFilters ? (React__default.createElement(Tooltip, { title: "Filtrar lista", placement: "top" },
                React__default.createElement("button", { type: "button", className: "transfer-list-filter-icon-container ".concat(totalFilers > 0 ? 'transfer-list-filter-has-filter' : ''), onClick: function () { return setVisible(!visible); } },
                    totalFilers > 0 ? (React__default.createElement(Typography, { className: "transfer-list-filter-total-filters", variant: "caption" },
                        ' ',
                        totalFilers)) : null,
                    React__default.createElement(Icons, { name: "IconAdjustmentsHorizontal", color: totalFilers > 0
                            ? 'var(--color-primary)'
                            : 'var(--color-neutral-dark3)', fill: totalFilers
                            ? 'var(--color-secondary-light2)'
                            : 'var(--color-neutral-light2)', size: 26 })))) : null)) : null));
};

var css_248z$6 = ".transfer-list-container{border:1px solid var(--color-neutral-light2);border-radius:10px;height:100%;overflow:scroll;width:100%}.transfer-list-container .transfer-list-loading{align-items:center;display:flex;justify-content:center;padding:20px 0;width:100%}.transfer-list-container .data-grid-table-border{border:none}.transfer-list-container .data-grid-table-header-container>tr>th:first-child{width:100px!important}.transfer-list-container .data-grid-empty-table-container,.transfer-list-container .data-grid-table-border{min-height:100%}.transfer-list-container .data-grid-table-body-subcontainer:last-child .data-grid-table-body-td{border-bottom:none!important}";
styleInject(css_248z$6);

var List$2 = function (_a) {
    var _b, _c;
    var id = _a.id, columns = _a.columns, total = _a.total, data = _a.data, checkedAll = _a.checkedAll, disabled = _a.disabled, loading = _a.loading, onCheck = _a.onCheck, onCheckAll = _a.onCheckAll, onScroll = _a.onScroll, emptyStageMessage = _a.emptyStageMessage, rest = __rest(_a, ["id", "columns", "total", "data", "checkedAll", "disabled", "loading", "onCheck", "onCheckAll", "onScroll", "emptyStageMessage"]);
    var _d = useState(20), limit = _d[0], setLimit = _d[1];
    var _e = useState(0), scrollTop = _e[0], setScrollTop = _e[1];
    var _f = useState(false), hasReachedEnd = _f[0], setHasReachedEnd = _f[1];
    useEffect(function () {
        if (data === null || data === void 0 ? void 0 : data.length) {
            setLimit(limit + 20);
            if (onScroll)
                onScroll(hasReachedEnd);
        }
    }, [scrollTop, hasReachedEnd]);
    var handleScroll = function (e) {
        var hasReachedEnd = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        setHasReachedEnd(hasReachedEnd);
        if (onScroll && !loading) {
            var $list = document === null || document === void 0 ? void 0 : document.getElementById(id);
            var currentScrollTop = ($list === null || $list === void 0 ? void 0 : $list.scrollTop) || 0;
            if (currentScrollTop === 0)
                return;
            if (total > limit || total > (data === null || data === void 0 ? void 0 : data.length)) {
                if (currentScrollTop > scrollTop + 200 ||
                    scrollTop === currentScrollTop) {
                    setScrollTop(currentScrollTop);
                }
            }
        }
    };
    if (loading && !(data === null || data === void 0 ? void 0 : data.length))
        return (React__default.createElement("div", { className: "transfer-list-container " },
            React__default.createElement("div", { className: "transfer-list-loading" },
                React__default.createElement(Loader, { size: "small", variant: "primary" }))));
    if (!(data === null || data === void 0 ? void 0 : data.length) && !loading)
        return (React__default.createElement("div", { className: "transfer-list-container" },
            React__default.createElement(EmptyDataMessage, { message: emptyStageMessage || 'Nenhum registro encontrado.' })));
    if (!((_b = data === null || data === void 0 ? void 0 : data.filter(function (_a) {
        var hidden = _a.hidden;
        return !hidden;
    })) === null || _b === void 0 ? void 0 : _b.length) && !loading)
        return (React__default.createElement("div", { className: "transfer-list-container" },
            React__default.createElement(EmptyDataMessage, { message: emptyStageMessage || 'O filtro aplicado não apresenta resultados.' })));
    return (React__default.createElement("div", { id: id, className: "transfer-list-container", onScroll: function (e) { return handleScroll(e); } },
        React__default.createElement(DataGrid, __assign({ initialState: {
                pageSize: 9999,
            }, hasPagination: false, columns: __spreadArray(__spreadArray([], [
                {
                    disableSortBy: true,
                    accessor: 'CheckBoxColumn',
                    Header: (React__default.createElement(Checkbox, { checked: checkedAll || false, onChange: function () { return onCheckAll(!checkedAll); }, disabled: disabled })),
                    Cell: function (info) {
                        var _a, _b, _c, _d;
                        var _id = (_b = (_a = info === null || info === void 0 ? void 0 : info.row) === null || _a === void 0 ? void 0 : _a.original) === null || _b === void 0 ? void 0 : _b._id;
                        var checked = ((_d = (_c = info === null || info === void 0 ? void 0 : info.row) === null || _c === void 0 ? void 0 : _c.original) === null || _d === void 0 ? void 0 : _d.checked) || false;
                        return (React__default.createElement(Checkbox, { checked: checked, onChange: function () { return onCheck(_id); }, disabled: disabled }));
                    },
                },
            ], false), columns, true), data: (_c = data === null || data === void 0 ? void 0 : data.filter(function (_a) {
                var hidden = _a.hidden;
                return !hidden;
            })) === null || _c === void 0 ? void 0 : _c.slice(0, limit) }, rest)),
        loading ? (React__default.createElement("div", { className: "transfer-list-loading" },
            React__default.createElement(Loader, { size: "small", variant: "primary" }))) : null));
};

var css_248z$5 = ".transfer-area-container{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;width:200px}.transfer-area-container .transfer-area-line{background-color:var(--color-neutral-light2);height:100%;width:1px}.transfer-area-container .transfer-area-line:first-child{margin-bottom:10px}.transfer-area-container .transfer-area-line:last-child{margin-top:10px}.transfer-area-container .transfer-area-icon-container{align-items:center;border:1px solid var(--color-neutral-light3);border-radius:100%;cursor:pointer;display:flex;justify-content:center;padding:15px}.transfer-area-container .transfer-area-icon-container:nth-child(2){margin-bottom:10px}.transfer-area-container .transfer-area-icon-disabled{background-color:var(--color-neutral-light1);border-color:var(--color-neutral-light1);cursor:auto}";
styleInject(css_248z$5);

var TransferArea = function (_a) {
    var arrowLeftDisabled = _a.arrowLeftDisabled, arrowRightDisabled = _a.arrowRightDisabled, customTransferLabel = _a.customTransferLabel, onPreviousClick = _a.onPreviousClick, onNextClick = _a.onNextClick;
    return (React__default.createElement("div", { className: "transfer-area-container" },
        React__default.createElement("div", { className: "transfer-area-line" }),
        React__default.createElement(Tooltip, { title: arrowRightDisabled
                ? customTransferLabel
                    ? customTransferLabel
                    : 'Selecione 1 ou mais colaboradores para movimentar'
                : '', placement: "top" },
            React__default.createElement("button", { type: "button", className: "transfer-area-icon-container ".concat(arrowRightDisabled ? 'transfer-area-icon-disabled' : ''), onClick: function () { return (arrowRightDisabled ? null : onNextClick()); } },
                React__default.createElement(Icons, { name: "IconArrowRight", color: arrowRightDisabled
                        ? 'var(--color-neutral-light3)'
                        : 'var(--color-neutral-dark4)' }))),
        React__default.createElement(Tooltip, { title: arrowLeftDisabled
                ? customTransferLabel
                    ? customTransferLabel
                    : 'Selecione 1 ou mais colaboradores para movimentar'
                : '', placement: "top" },
            React__default.createElement("button", { type: "button", className: "transfer-area-icon-container ".concat(arrowLeftDisabled ? 'transfer-area-icon-disabled' : ''), onClick: function () { return (arrowLeftDisabled ? null : onPreviousClick()); } },
                React__default.createElement(Icons, { name: "IconArrowLeft", color: arrowLeftDisabled
                        ? 'var(--color-neutral-light3)'
                        : 'var(--color-neutral-dark4)' }))),
        React__default.createElement("div", { className: "transfer-area-line" })));
};

var getRowById = function (_a) {
    var rowId = _a.rowId, data = _a.data;
    var left = data.left, right = data.right;
    var rightRow = right === null || right === void 0 ? void 0 : right.find(function (_a) {
        var _id = _a._id;
        return _id === rowId;
    });
    if (rightRow === null || rightRow === void 0 ? void 0 : rightRow._id)
        return {
            list: 'right',
            row: rightRow,
        };
    return {
        list: 'left',
        row: left === null || left === void 0 ? void 0 : left.find(function (_a) {
            var _id = _a._id;
            return _id === rowId;
        }),
    };
};
var setRow = function (_a) {
    var data = _a.data, rowId = _a.rowId, field = _a.field;
    var key = field.key, newValue = field.newValue;
    return data === null || data === void 0 ? void 0 : data.map(function (row) {
        if (rowId === (row === null || row === void 0 ? void 0 : row._id))
            row[key] = newValue;
        return row;
    });
};

var css_248z$4 = ".transfer-list{height:100%;width:100%}.transfer-list *{font-family:var(--font-family-primary)}.transfer-list .transfer-list-list-container{align-items:flex-start;display:flex;height:calc(100% - 122px);justify-content:space-between}.transfer-list .transfer-list-list-filter-container{align-items:center;display:flex;justify-content:space-between}.transfer-list .transfer-list-list-filter-separator{height:50px;width:200px}.transfer-list-disabled{opacity:.3}";
styleInject(css_248z$4);

var TransferList = function (_a) {
    var _b, _c, _d, _e;
    var title = _a.title, columns = _a.columns, description = _a.description, leftList = _a.leftList, rightList = _a.rightList, disabled = _a.disabled, customTransferLabel = _a.customTransferLabel, customRightColumns = _a.customRightColumns, onTransfer = _a.onTransfer;
    var _f = useState(false), leftAllChecked = _f[0], setLeftAllChecked = _f[1];
    var _g = useState(false), rightAllChecked = _g[0], setRightAllChecked = _g[1];
    useEffect(function () {
        var _a;
        var visibleData = (_a = leftList === null || leftList === void 0 ? void 0 : leftList.data) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
            var hidden = _a.hidden;
            return !hidden;
        });
        if (visibleData === null || visibleData === void 0 ? void 0 : visibleData.length) {
            if (visibleData === null || visibleData === void 0 ? void 0 : visibleData.find(function (_a) {
                var checked = _a.checked;
                return !checked;
            })) {
                setLeftAllChecked(false);
                return;
            }
            if (!(visibleData === null || visibleData === void 0 ? void 0 : visibleData.find(function (_a) {
                var checked = _a.checked;
                return !checked;
            })) &&
                (leftList === null || leftList === void 0 ? void 0 : leftList.total) === (visibleData === null || visibleData === void 0 ? void 0 : visibleData.length))
                setLeftAllChecked(true);
        }
    }, [leftList === null || leftList === void 0 ? void 0 : leftList.data]);
    useEffect(function () {
        var _a;
        var visibleData = (_a = rightList === null || rightList === void 0 ? void 0 : rightList.data) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
            var hidden = _a.hidden;
            return !hidden;
        });
        if (visibleData === null || visibleData === void 0 ? void 0 : visibleData.length) {
            if (visibleData === null || visibleData === void 0 ? void 0 : visibleData.find(function (_a) {
                var checked = _a.checked;
                return !checked;
            })) {
                setRightAllChecked(false);
                return;
            }
            if (!(visibleData === null || visibleData === void 0 ? void 0 : visibleData.find(function (_a) {
                var checked = _a.checked;
                return !checked;
            })) &&
                (rightList === null || rightList === void 0 ? void 0 : rightList.total) === (visibleData === null || visibleData === void 0 ? void 0 : visibleData.length))
                setRightAllChecked(true);
        }
    }, [rightList === null || rightList === void 0 ? void 0 : rightList.data]);
    var check = function (rowId) {
        var _a = getRowById({
            rowId: rowId,
            data: {
                left: leftList === null || leftList === void 0 ? void 0 : leftList.data,
                right: rightList === null || rightList === void 0 ? void 0 : rightList.data,
            },
        }), list = _a.list, row = _a.row;
        return setRow({
            data: list === 'left' ? leftList === null || leftList === void 0 ? void 0 : leftList.data : rightList === null || rightList === void 0 ? void 0 : rightList.data,
            rowId: rowId,
            field: {
                key: 'checked',
                newValue: !(row === null || row === void 0 ? void 0 : row.checked),
            },
        });
    };
    var getTotalFilters = function (sections) {
        return (sections === null || sections === void 0 ? void 0 : sections.reduce(function (currentResult, _a) {
            var options = _a.options;
            var filterCount = (options === null || options === void 0 ? void 0 : options.find(function (_a) {
                var checked = _a.checked;
                return checked;
            })) ? 1 : 0;
            return currentResult + filterCount;
        }, 0)) || 0;
    };
    var transferData = function (action) {
        var _a, _b, _c, _d;
        var leftDataChecked = (_a = leftList === null || leftList === void 0 ? void 0 : leftList.data) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
            var checked = _a.checked;
            return checked;
        });
        var rightDataChecked = (_b = rightList === null || rightList === void 0 ? void 0 : rightList.data) === null || _b === void 0 ? void 0 : _b.filter(function (_a) {
            var checked = _a.checked;
            return checked;
        });
        if (action === 'remove') {
            if (rightAllChecked)
                setRightAllChecked(false);
            return {
                rightList: {
                    data: (_c = rightList === null || rightList === void 0 ? void 0 : rightList.data) === null || _c === void 0 ? void 0 : _c.filter(function (_a) {
                        var checked = _a.checked;
                        return !checked;
                    }),
                    allChecked: rightAllChecked,
                },
                leftList: {
                    data: __spreadArray(__spreadArray([], leftList === null || leftList === void 0 ? void 0 : leftList.data, true), rightDataChecked === null || rightDataChecked === void 0 ? void 0 : rightDataChecked.map(function (row) { return (__assign(__assign({}, row), { checked: false, hidden: false })); }), true),
                    allChecked: leftAllChecked,
                },
            };
        }
        if (leftAllChecked)
            setLeftAllChecked(false);
        return {
            rightList: {
                data: __spreadArray(__spreadArray([], rightList === null || rightList === void 0 ? void 0 : rightList.data, true), leftDataChecked === null || leftDataChecked === void 0 ? void 0 : leftDataChecked.map(function (row) { return (__assign(__assign({}, row), { checked: false, hidden: false })); }), true),
                allChecked: rightAllChecked,
            },
            leftList: {
                data: (_d = leftList === null || leftList === void 0 ? void 0 : leftList.data) === null || _d === void 0 ? void 0 : _d.filter(function (_a) {
                    var checked = _a.checked;
                    return !checked;
                }),
                allChecked: leftAllChecked,
            },
        };
    };
    return (React__default.createElement("div", { className: "transfer-list ".concat(disabled ? 'transfer-list-disabled' : '') },
        title,
        description,
        React__default.createElement("div", { className: "transfer-list-list-filter-container" },
            React__default.createElement(Filter, { title: leftList === null || leftList === void 0 ? void 0 : leftList.title, disabled: disabled, onSearch: leftList === null || leftList === void 0 ? void 0 : leftList.onSearch, customFilters: leftList === null || leftList === void 0 ? void 0 : leftList.customFilters, totalFilers: getTotalFilters(((_b = leftList === null || leftList === void 0 ? void 0 : leftList.customFilters) === null || _b === void 0 ? void 0 : _b.sections) || []) }),
            React__default.createElement("div", { className: "transfer-list-list-filter-separator" }),
            React__default.createElement(Filter, { title: rightList === null || rightList === void 0 ? void 0 : rightList.title, disabled: disabled, onSearch: rightList === null || rightList === void 0 ? void 0 : rightList.onSearch, customFilters: rightList === null || rightList === void 0 ? void 0 : rightList.customFilters, totalFilers: getTotalFilters(((_c = rightList === null || rightList === void 0 ? void 0 : rightList.customFilters) === null || _c === void 0 ? void 0 : _c.sections) || []) })),
        React__default.createElement("div", { className: "transfer-list-list-container" },
            React__default.createElement(List$2, { id: "left-transfer-list", columns: columns, total: leftList === null || leftList === void 0 ? void 0 : leftList.total, data: leftList === null || leftList === void 0 ? void 0 : leftList.data, disabled: disabled, loading: leftList === null || leftList === void 0 ? void 0 : leftList.loading, onCheck: function (rowId) { return leftList === null || leftList === void 0 ? void 0 : leftList.onCheck({ data: check(rowId) }); }, onCheckAll: function (checked) {
                    leftList === null || leftList === void 0 ? void 0 : leftList.onCheck({
                        allChecked: checked,
                        data: leftList === null || leftList === void 0 ? void 0 : leftList.data,
                    });
                    setLeftAllChecked(checked);
                }, checkedAll: leftAllChecked, onScroll: function (hasReachedEnd) {
                    (leftList === null || leftList === void 0 ? void 0 : leftList.onScroll) &&
                        (leftList === null || leftList === void 0 ? void 0 : leftList.onScroll(leftAllChecked, hasReachedEnd));
                }, emptyStageMessage: leftList === null || leftList === void 0 ? void 0 : leftList.emptyStageMessage }),
            React__default.createElement(TransferArea, { arrowLeftDisabled: !((_d = rightList === null || rightList === void 0 ? void 0 : rightList.data) === null || _d === void 0 ? void 0 : _d.find(function (_a) {
                    var checked = _a.checked;
                    return checked;
                })), arrowRightDisabled: !((_e = leftList === null || leftList === void 0 ? void 0 : leftList.data) === null || _e === void 0 ? void 0 : _e.find(function (_a) {
                    var checked = _a.checked;
                    return checked;
                })), customTransferLabel: customTransferLabel, onPreviousClick: function () {
                    onTransfer(transferData('remove'));
                }, onNextClick: function () {
                    onTransfer(transferData('add'));
                } }),
            React__default.createElement(List$2, { id: "right-transfer-list", columns: customRightColumns || columns, total: rightList === null || rightList === void 0 ? void 0 : rightList.total, data: rightList === null || rightList === void 0 ? void 0 : rightList.data, disabled: disabled, loading: rightList === null || rightList === void 0 ? void 0 : rightList.loading, onCheck: function (rowId) {
                    return rightList === null || rightList === void 0 ? void 0 : rightList.onCheck({
                        data: check(rowId),
                    });
                }, onCheckAll: function (checked) {
                    rightList === null || rightList === void 0 ? void 0 : rightList.onCheck({
                        allChecked: checked,
                        data: rightList === null || rightList === void 0 ? void 0 : rightList.data,
                    });
                    setRightAllChecked(checked);
                }, checkedAll: rightAllChecked, onScroll: function (hasReachedEnd) {
                    return (rightList === null || rightList === void 0 ? void 0 : rightList.onScroll) &&
                        (rightList === null || rightList === void 0 ? void 0 : rightList.onScroll(rightAllChecked, hasReachedEnd));
                }, emptyStageMessage: rightList === null || rightList === void 0 ? void 0 : rightList.emptyStageMessage }))));
};

var StyledDrawer = styled(Drawer$1)(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  &.MuiModal-root {\n    div {\n      &.MuiPaper-root {\n        width: 50%;\n        padding: ", "\n          ", " 0\n          ", ";\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n      }\n    }\n  }\n"], ["\n  &.MuiModal-root {\n    div {\n      &.MuiPaper-root {\n        width: 50%;\n        padding: ", "\n          ", " 0\n          ", ";\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
});
var TitleWrapper = styled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"])));
var StyledSubtitle = styled(Typography)(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[50];
});
var HeaderContainer$1 = styled.div(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: ", ";\n  gap: ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: ", ";\n  gap: ", ";\n"])), function (_a) {
    var hasSubtitle = _a.hasSubtitle;
    return (hasSubtitle ? 'flex-start' : 'center');
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var templateObject_1$r, templateObject_2$h, templateObject_3$a, templateObject_4$8;

var Drawer = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, open = _a.open, tabs = _a.tabs, children = _a.children, onClose = _a.onClose, props = __rest(_a, ["title", "subtitle", "open", "tabs", "children", "onClose"]);
    return (React__default.createElement(StyledDrawer, __assign({ anchor: 'right', open: open, onClose: onClose }, props),
        React__default.createElement(HeaderContainer$1, { hasSubtitle: Boolean(subtitle) },
            React__default.createElement(TitleWrapper, null,
                React__default.createElement(Typography, { variant: "headline7" }, title),
                subtitle && (React__default.createElement(StyledSubtitle, { variant: "body3" }, subtitle))),
            React__default.createElement("div", null,
                React__default.createElement(PillButton, { size: "small", variant: "default", icon: "IconX", type: "secondary", onClick: onClose }))),
        tabs ? React__default.createElement(Tab, { tabItens: tabs }) : children));
};

var Unstable = { Drawer: Drawer, Carousel: Carousel };

var css_248z$3 = ".video-js .vjs-big-play-button,.video-js .vjs-play-progress{background-color:var(--color-primary)!important}";
styleInject(css_248z$3);

// @ts-nocheck
var VideoPlayer = function (_a) {
    var _b, _c, _d;
    var options = _a.options, onReady = _a.onReady, _e = _a.getCurrentTime, getCurrentTime = _e === void 0 ? function () { return null; } : _e;
    var videoRef = useRef(null);
    var playerRef = useRef();
    var getMediaType = useCallback(function (src) {
        var _a, _b, _c, _d;
        switch (src) {
            case (_a = src.match('youtube')) === null || _a === void 0 ? void 0 : _a.input:
                return 'video/youtube';
            case (_b = src.match('vimeo')) === null || _b === void 0 ? void 0 : _b.input:
                return 'video/vimeo';
            case (_c = src.match('.mp4')) === null || _c === void 0 ? void 0 : _c.input:
                return 'video/mp4';
            case (_d = src.match('.mp3')) === null || _d === void 0 ? void 0 : _d.input:
                return 'audio/mp3';
            default:
                return 'application/x-mpegURL';
        }
    }, []);
    useEffect(function () {
        if (!playerRef.current) {
            var videoElement = videoRef.current;
            if (!videoElement)
                return;
            var player_1 = (playerRef.current = videojs(videoElement, options, function () {
                onReady && onReady(player_1);
                player_1.on('ended', function () {
                    getCurrentTime(player_1.duration());
                });
                player_1.on('timeupdate', function () {
                    var _a, _b;
                    if (((_a = playerRef === null || playerRef === void 0 ? void 0 : playerRef.current) === null || _a === void 0 ? void 0 : _a.ended()) || ((_b = playerRef === null || playerRef === void 0 ? void 0 : playerRef.current) === null || _b === void 0 ? void 0 : _b.paused()))
                        return;
                    getCurrentTime(player_1.currentTime());
                });
            }));
            videojs.Hls.xhr.beforeRequest = function (requestOptions) {
                if (options === null || options === void 0 ? void 0 : options.signature) {
                    requestOptions.uri = requestOptions.uri + (options === null || options === void 0 ? void 0 : options.signature);
                }
                return requestOptions;
            };
        }
        else {
            var player = playerRef.current;
            player.autoplay((options === null || options === void 0 ? void 0 : options.autoplay) || false);
            player.src({
                src: options === null || options === void 0 ? void 0 : options.src,
                type: getMediaType((options === null || options === void 0 ? void 0 : options.src) || ''),
            });
        }
    }, [options, videoRef]);
    useEffect(function () {
        var player = playerRef.current;
        return function () {
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [playerRef]);
    return (React__default.createElement("div", { "data-vjs-player": true }, ((_b = options === null || options === void 0 ? void 0 : options.src) === null || _b === void 0 ? void 0 : _b.match('youtube')) || ((_c = options === null || options === void 0 ? void 0 : options.src) === null || _c === void 0 ? void 0 : _c.match('vimeo')) ? (React__default.createElement("video", { 
        // @todo: MUST have <track> tag and subtitles
        ref: videoRef, className: "vjs-matrix video-js vjs-big-play-centered", "data-setup": "{ \"techOrder\": [".concat(((_d = options === null || options === void 0 ? void 0 : options.src) === null || _d === void 0 ? void 0 : _d.match('youtube')) ? '"youtube"' : '"vimeo"', "  ], \"sources\": [{ \"type\": ").concat(getMediaType(options === null || options === void 0 ? void 0 : options.src), ", \"src\": \"").concat(options === null || options === void 0 ? void 0 : options.src, "\"}] }") })) : (React__default.createElement("video", { ref: videoRef, className: "video-js vjs-big-play-centered" },
        React__default.createElement("source", { src: options === null || options === void 0 ? void 0 : options.src, type: getMediaType(options === null || options === void 0 ? void 0 : options.src) })))));
};

var css_248z$2 = ".warning-custom-theme{background-color:#fff;display:inline-flex;flex-direction:row;max-width:800px;padding:24px}.warning-custom-theme .warning-subcontainer{align-items:center;display:flex}.warning-custom-theme svg{fill:transparent}.warning-custom-theme .warning-icon-area{align-items:center;border-radius:100%;display:flex;justify-content:center;margin-right:20px;padding:12px}.warning-custom-theme .warning-icon-area svg{stroke:var(--color-feedback-success-light1)}.warning-custom-theme .warning-content-area{font-family:var(--font-family-secondary);max-width:600px;width:100%;word-break:break-word}.warning-custom-theme .warning-content-area p:first-child{margin-bottom:4px}.warning-custom-theme .warning-children-area{margin-top:8px}.warning-custom-error{border:1px solid var(--color-feedback-error-light2);border-radius:8px}.warning-custom-error p{color:var(--color-feedback-error-dark2)}.warning-custom-error .warning-icon-error{background:var(--color-feedback-error-pure)}.warning-custom-error .warning-close-button{align-self:flex-start;margin-left:-8px}.warning-custom-error .warning-close-button svg{stroke:var(--color-feedback-error-pure)}.warning-custom-success{border:1px solid var(--color-feedback-success-light2);border-radius:8px}.warning-custom-success p{color:var(--color-feedback-success-dark2)}.warning-custom-success .warning-icon-success{background:var(--color-feedback-success-pure)}.warning-custom-success .warning-close-button{align-self:flex-start;margin-left:-8px}.warning-custom-success .warning-close-button svg{stroke:var(--color-feedback-success-pure)}.warning-custom-warning{border:1px solid var(--color-feedback-info-light2);border-radius:8px}.warning-custom-warning p{color:var(--color-feedback-info-dark2)}.warning-custom-warning .warning-icon-warning{background:var(--color-feedback-info-pure)}.warning-custom-warning .warning-close-button{align-self:flex-start;margin-left:-8px;margin-top:-8px}.warning-custom-warning .warning-close-button svg{stroke:var(--color-feedback-info-pure)}";
styleInject(css_248z$2);

var Warning = function (_a) {
    var _b = _a.id, id = _b === void 0 ? '0' : _b, title = _a.title, description = _a.description, children = _a.children, _c = _a.type, type = _c === void 0 ? 'error' : _c;
    var closeToast = useToasts().closeToast;
    var handleClose = function (id) { return closeToast(id); };
    return (React__default.createElement("div", { key: id, className: "warning-custom-theme ".concat(type === 'error'
            ? 'warning-custom-error'
            : type === 'warning'
                ? 'warning-custom-warning'
                : 'warning-custom-success') },
        React__default.createElement("div", { className: 'warning-subcontainer' },
            type === 'success' && (React__default.createElement("div", { className: "warning-icon-area warning-icon-success" },
                React__default.createElement(Icons, { name: "IconCircleCheck", size: 30 }))),
            type === 'error' && (React__default.createElement("div", { className: "warning-icon-area warning-icon-error" },
                React__default.createElement(Icons, { name: "IconCircleX", size: 30 }))),
            type === 'warning' && (React__default.createElement("div", { className: "warning-icon-area warning-icon-warning" },
                React__default.createElement(Icons, { name: "IconAlertCircle", size: 30 }))),
            React__default.createElement("div", { className: "warning-content-area" },
                title && (React__default.createElement(Typography, { variant: "body3", style: { fontWeight: '600', userSelect: 'none' } }, title)),
                description && (React__default.createElement(Typography, { variant: "body4", style: { userSelect: 'none' } }, description)),
                children && React__default.createElement("div", { className: "warning-children-area" }, children))),
        React__default.createElement("div", { style: { marginLeft: '10px' } },
            React__default.createElement(IconButton$1, { className: "warning-close-button", onClick: function () { return handleClose(id); } },
                React__default.createElement(Icons, { name: "IconX", size: 16 })))));
};

var tableContext = React__default.createContext({
    variant: 'modest',
    bulkActions: {
        visible: false,
        ref: { current: null },
        show: function () { },
    },
});
function TableProvider(props) {
    var _a;
    var _b = useState(false), showBulkActions = _b[0], setShowBulkActions = _b[1];
    var bulkActionsRef = useRef(null);
    return (React__default.createElement(tableContext.Provider, { value: {
            variant: (_a = props.variant) !== null && _a !== void 0 ? _a : 'modest',
            bulkActions: {
                ref: bulkActionsRef,
                show: setShowBulkActions,
                visible: showBulkActions,
            },
        } }, props.children));
}

function useTableContext() {
    return useContext(tableContext);
}

var Container$c = styled.nav(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: auto max-content;\n\n  position: sticky;\n\n  bottom: 0px;\n\n  background-color: ", ";\n\n  border-top: ", ";\n\n  border-bottom: ", ";\n\n  padding: ", ";\n\n  margin-top: -17px; // 1px da borda\n\n  @media screen and (max-width: 600px) {\n    row-gap: 16px;\n    grid-template-columns: 100%;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: auto max-content;\n\n  position: sticky;\n\n  bottom: 0px;\n\n  background-color: ", ";\n\n  border-top: ", ";\n\n  border-bottom: ", ";\n\n  padding: ", ";\n\n  margin-top: -17px; // 1px da borda\n\n  @media screen and (max-width: 600px) {\n    row-gap: 16px;\n    grid-template-columns: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[100];
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacings.xs2, " ").concat(theme.spacings.xs, " ").concat(theme.spacings.xs1);
});
var SelectionGroup = styled.div(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var SelectionInfo = styled.div(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  color: ", ";\n\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n\n  color: ", ";\n\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[50];
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var Content$3 = styled.div(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  overflow-x: auto;\n"], ["\n  display: flex;\n  gap: ", ";\n  overflow-x: auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var templateObject_1$q, templateObject_2$g, templateObject_3$9, templateObject_4$7;

function BulkActions(props) {
    var bulkActions = useTableContext().bulkActions;
    useEffect(function () {
        bulkActions.show(props.open);
    }, [bulkActions, props.open]);
    if (!props.open) {
        return null;
    }
    return (React__default.createElement(Container$c, { ref: bulkActions.ref, position: props.position },
        React__default.createElement(SelectionGroup, null,
            React__default.createElement(SelectionInfo, null,
                React__default.createElement(Icons, { name: "IconSquareCheck", size: 16 }),
                React__default.createElement(Typography.Body4, { weight: 600, color: "neutral.30" },
                    props.totalSelected,
                    " de ",
                    props.total,
                    " selecionados")),
            props.onSelectAll && (React__default.createElement(LinkButton, { variant: "default", onClick: props.onSelectAll, disabled: props.totalSelected === props.total, underlined: false },
                "Selecionar todos os ",
                props.total)),
            props.onClearSelection && (React__default.createElement(LinkButton, { variant: "neutral", onClick: props.onClearSelection, underlined: false }, "Limpar"))),
        React__default.createElement(Content$3, null, props.children)));
}

var Content$2 = styled.div(function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (__assign({ display: 'grid', border: "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]), borderRadius: theme.borders.radius.m, gap: variant === 'soft' ? theme.spacings.xs2 : theme.spacings.s }, (variant === 'soft'
        ? {
            padding: "".concat(theme.spacings.xs2, " 0px"),
            '> div': {
                ':not(.table-grid)': {
                    padding: "0px ".concat(theme.spacings.xs2),
                },
            },
        }
        : {
            padding: "".concat(theme.spacings.xs, " ").concat(theme.spacings.xs),
        })));
});

function Content$1(props) {
    var context = useTableContext();
    return React__default.createElement(Content$2, __assign({ variant: context.variant }, props));
}

var Container$b = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: ", ";\n  width: 100%;\n  height: ", ";\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: ", ";\n  width: 100%;\n  height: ", ";\n  align-items: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.m;
});
var AdditionalFiltersWrapper = styled.div(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: ", ";\n  align-items: center;\n  margin-left: auto;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: ", ";\n  align-items: center;\n  margin-left: auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
});
var templateObject_1$p, templateObject_2$f;

function Filters$1(_a) {
    var filters = _a.filters, onChange = _a.onChange, props = __rest(_a, ["filters", "onChange"]);
    var initialFiltersState = filters.reduce(function (acc, field) {
        if (!!field && 'options' in field && field.initialSelectedOption) {
            acc.push({
                name: field.name,
                values: [field.initialSelectedOption],
            });
        }
        return acc;
    }, []);
    var _b = React__default.useState(initialFiltersState), allFiltersState = _b[0], setAllFiltersState = _b[1];
    var handleFiltersChange = React__default.useCallback(function (name, values) {
        var filtersChangeCallbackHandler = createFiltersChangeCallbackHandler(allFiltersState, setAllFiltersState, onChange);
        filtersChangeCallbackHandler(name, values);
    }, [allFiltersState, onChange]);
    return (React__default.createElement(Container$b, __assign({}, props),
        React__default.createElement(Typography, { variant: "body3" }, props.label),
        React__default.useMemo(function () {
            return filters.map(function (field) {
                if (!!field && 'options' in field) {
                    var currentFilterState = allFiltersState.find(function (_a) {
                        var name = _a.name;
                        return name === field.name;
                    });
                    var selectedOptions = currentFilterState === null || currentFilterState === void 0 ? void 0 : currentFilterState.values.map(function (value) { return "".concat(value); });
                    return (React__default.createElement(TagFilter, { hasLeftIcon: false, key: field.name, onApply: function (value) { return handleFiltersChange(field.name, value); }, onClear: function () { return handleFiltersChange(field.name, []); }, options: field.options, optionIconType: 'radio', selectedOptions: selectedOptions, variant: 'secondary', filterLabel: field.label }));
                }
                return React__default.createElement(React__default.Fragment, null, field);
            });
        }, [allFiltersState, filters, handleFiltersChange]),
        React__default.createElement(AdditionalFiltersWrapper, null, props.additionalFilters)));
}
function createFiltersChangeCallbackHandler(allFiltersState, setAllFiltersState, onChange) {
    return function (name, values) {
        var updatedFilters = allFiltersState.filter(function (field) { return field.name !== name; });
        if (values.length > 0) {
            updatedFilters.push({ name: name, values: values });
        }
        setAllFiltersState(updatedFilters);
        if (onChange) {
            onChange(updatedFilters);
        }
    };
}

function Search(_a) {
    var onChange = _a.onChange, props = __rest(_a, ["onChange"]);
    var handleOnChange = function (e) {
        onChange && onChange(e);
    };
    return (React__default.createElement(SearchField, __assign({ onChange: function (e) { return handleOnChange(e); }, onSearchChange: function (_, value) { return handleOnChange(value); }, onClear: props.onClearFilter }, props)));
}

var Container$a = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  gap: ", ";\n\n  @media screen and (max-width: 800px) {\n    display: grid;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  gap: ", ";\n\n  @media screen and (max-width: 800px) {\n    display: grid;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var Filters = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  display: ", ";\n  gap: ", ";\n  overflow-x: auto;\n  padding: 1px;\n"], ["\n  display: ", ";\n  gap: ", ";\n  overflow-x: auto;\n  padding: 1px;\n"])), function (_a) {
    var open = _a.open;
    return (open ? 'flex' : 'none');
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
function getSearchGrid(hasSelection, hasFilters) {
    var columns = 'auto';
    if (hasSelection) {
        columns = 'max-content ' + columns;
    }
    if (hasFilters) {
        columns = columns + ' max-content';
    }
    return columns;
}
var SearchContainer = styled.div(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: ", ";\n  gap: ", ";\n"], ["\n  width: 100%;\n  display: grid;\n  grid-template-columns: ", ";\n  gap: ", ";\n"])), function (_a) {
    var hasSelection = _a.hasSelection, hasFilters = _a.hasFilters;
    return getSearchGrid(hasSelection, hasFilters);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var templateObject_1$o, templateObject_2$e, templateObject_3$8;

function FilterSearch(props) {
    var _a;
    var isMobile = useMediaQuery('screen and (max-width: 800px)');
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var hasFilters = props.visions || props.showListType || props.children;
    function renderContent() {
        var _a, _b;
        return (React__default.createElement(React__default.Fragment, null,
            props.visions && (React__default.createElement(RadioVision, { views: props.visions, onChangeView: props.onChangeVision, value: (_a = props.vision) !== null && _a !== void 0 ? _a : '' })),
            props.children,
            props.showListType && (React__default.createElement(RadioVision, { views: [
                    { id: 'line', icon: 'IconMenu2' },
                    { id: 'grid', icon: 'IconLayoutGrid' },
                ], onChangeView: props.onChangeListType, value: (_b = props.listType) !== null && _b !== void 0 ? _b : '' }))));
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Container$a, null,
            React__default.createElement(SearchContainer, { hasSelection: !!props.toggleAllSelection, hasFilters: !!hasFilters },
                props.toggleAllSelection && (React__default.createElement(Checkbox, { sx: { marginLeft: '10px' }, onChange: props.toggleAllSelection, checked: props.checked, indeterminate: props.indeterminateSelection })),
                React__default.createElement(Search, { label: (_a = props.labelSearch) !== null && _a !== void 0 ? _a : 'Buscar', onChange: props.onSearch, onClearFilter: props.onClear, inputSize: "sm", defaultValue: props.searchDefaultValue }),
                isMobile && hasFilters && (React__default.createElement(PillButton, { icon: "IconFilter", onClick: function () { return setIsOpen(!isOpen); }, variant: "default", type: "primary", size: "small" }))),
            isMobile ? (React__default.createElement(Filters, { open: isOpen }, renderContent())) : (renderContent()))));
}

var GridEmptyChildren = styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  padding: ", " 0px;\n"], ["\n  padding: ", " 0px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
});
var EmptyGrid = styled.div(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  display: flex;\n  min-height: ", ";\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  display: flex;\n  min-height: ", ";\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[95];
}, function (props) {
    return typeof props.minHeight === 'number'
        ? "".concat(props.minHeight, "px")
        : props.minHeight;
});
var templateObject_1$n, templateObject_2$d;

function Empty(props) {
    var _a;
    return (React__default.createElement(EmptyGrid, { minHeight: props.minHeight },
        props.isFiltered ? React__default.createElement(SvgEmptyFilteredTable, null) : React__default.createElement(SvgEmptyTable, null),
        React__default.createElement(Typography, { variant: "body3" }, (_a = props.message) !== null && _a !== void 0 ? _a : 'Lista vazia'),
        props.children && (React__default.createElement(GridEmptyChildren, null, props.children))));
}

var Header$3 = styled.thead(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Th = styled.th(function (_a) {
    var isSelection = _a.isSelection, sticky = _a.sticky, width = _a.width, maxWidth = _a.maxWidth, minWidth = _a.minWidth, variant = _a.variant, theme = _a.theme;
    return (__assign({ position: sticky ? 'sticky' : 'unset', backgroundColor: theme.colors.neutral[95], width: width, maxWidth: maxWidth && !width ? "".concat(maxWidth, "px") : 'unset', minWidth: minWidth && !width ? "".concat(minWidth, "px") : 'unset', padding: theme.spacings.xs, textAlign: 'left', '&:after': {
            top: 0,
            left: '-30px',
            width: '30px',
            height: '100%',
            content: '',
            position: 'absolute',
            boxShadow: 'inset -10px 0 8px -8px rgba(5, 5, 5, 0.06)',
            pointerEvents: 'none',
        }, '@media screen and (max-width: 600px)': {
            position: isSelection && sticky ? 'sticky' : 'unset',
        } }, (variant === 'soft' && {
        padding: isSelection
            ? "0px ".concat(theme.spacings.xs5, " 0px ").concat(theme.spacings.xs1)
            : "".concat(theme.spacings.xs3, " ").concat(theme.spacings.xs1),
    })));
});
var templateObject_1$m;

function Header$2(props) {
    var context = useTableContext();
    var _a = React__default.useState(false), isCollapsed = _a[0], setIsCollapsed = _a[1];
    var toggleAllRows = function () {
        setIsCollapsed(!isCollapsed);
        props.toggleAllRowsExpanded && props.toggleAllRowsExpanded();
    };
    if ('children' in props) {
        return React__default.createElement(React__default.Fragment, null, props.children);
    }
    var _b = props._cellWidthList, _cellWidthList = _b === void 0 ? [] : _b;
    return (React__default.createElement(Header$3, null, props.getHeaderGroups().map(function (headerGroup) { return (React__default.createElement("tr", { key: headerGroup.id }, headerGroup.headers.map(function (header, index) { return (React__default.createElement(Th, { isSelection: header.column.id === 'selection', sticky: !!header.column.getIsPinned(), width: header.column.columnDef.size, minWidth: header.column.columnDef.minSize, maxWidth: header.column.columnDef.maxSize, variant: context.variant, ref: function (element) {
            var _a;
            if (element) {
                if (header.column.getIsPinned()) {
                    var newCellsWidthList = getAllElementsWidth(element);
                    var shouldUpdate = newCellsWidthList.some(function (cellWidth, index) { return cellWidth !== _cellWidthList[index]; });
                    if (shouldUpdate) {
                        (_a = props._setCellWidthList) === null || _a === void 0 ? void 0 : _a.call(props, newCellsWidthList);
                    }
                    var _b = calculateStickyColumn$1(index, headerGroup.headers.length, _cellWidthList
                        .slice(0, index)
                        .reduce(function (offset, width) { return offset + width; }, 0), _cellWidthList
                        .slice(index + 1)
                        .reverse()
                        .reduce(function (offset, width) { return offset + width; }, 0)), left = _b[0], right = _b[1];
                    element.style.left = "".concat(left, "px");
                    element.style.right = "".concat(right, "px");
                }
            }
        }, key: header.id }, cellRender$1(header, toggleAllRows, isCollapsed, context.variant))); }))); })));
}
function cellRender$1(header, toggleAllRows, isCollapsed, variant) {
    if (header.isPlaceholder) {
        return null;
    }
    if (header.id === 'selection' && header.setSelected) {
        return (React__default.createElement(Checkbox, { onChange: function () {
                var _a;
                (_a = header.setSelected) === null || _a === void 0 ? void 0 : _a.call(header, !header.selected);
            }, checked: header.selected, indeterminate: header.hasSomeSelected }));
    }
    if (header.id === 'actions') {
        return 'Ações';
    }
    if (header.id === 'expander') {
        return (React__default.createElement(PillButton, { onClick: toggleAllRows, icon: isCollapsed ? 'IconChevronsUp' : 'IconChevronsDown', size: variant === 'soft' ? 'extra-small' : 'small', variant: "default" }));
    }
    return flexRender(header.column.columnDef.header, header.getContext());
}
function getAllElementsWidth(element) {
    var elements = Array.prototype.slice.call(element.parentElement.children);
    return elements.map(function (_a) {
        var clientWidth = _a.clientWidth;
        return clientWidth;
    });
}
function calculateStickyColumn$1(index, rowsLength, offsetLeft, offsetRight) {
    var element = { left: 0, right: 0 };
    if (index <= rowsLength / 2 - 1) {
        element.left = offsetLeft;
    }
    if (index >= rowsLength / 2 + 1) {
        element.right = offsetRight;
    }
    return [element.left, element.right];
}

var TRow = styled.tr(function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (__assign({}, (variant === 'soft' && {
        '&:hover': {
            '> td': {
                backgroundColor: theme.colors.neutral[95],
            },
        },
    })));
});
var Cell = styled.td(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  padding: ", ";\n  position: ", ";\n\n  text-align: left;\n  max-width: ", ";\n  min-width: ", ";\n  border-bottom: 1px solid ", ";\n  background-color: ", ";\n\n  &:after {\n    top: 0;\n    left: -30px;\n    width: 30px;\n    height: 100%;\n    content: '';\n    position: absolute;\n    box-shadow: inset -10px 0 8px -8px rgba(5, 5, 5, 0.06);\n    pointer-events: none;\n  }\n  @media screen and (max-width: 600px) {\n    position: ", ";\n  }\n"], ["\n  padding: ", ";\n  position: ", ";\n\n  text-align: left;\n  max-width: ", ";\n  min-width: ", ";\n  border-bottom: 1px solid ", ";\n  background-color: ", ";\n\n  &:after {\n    top: 0;\n    left: -30px;\n    width: 30px;\n    height: 100%;\n    content: '';\n    position: absolute;\n    box-shadow: inset -10px 0 8px -8px rgba(5, 5, 5, 0.06);\n    pointer-events: none;\n  }\n  @media screen and (max-width: 600px) {\n    position: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant, isSelection = _a.isSelection;
    return variant === 'soft'
        ? isSelection
            ? "".concat(theme.spacings.xs1, " ").concat(theme.spacings.xs5, " ").concat(theme.spacings.xs1, " ").concat(theme.spacings.xs1)
            : theme.spacings.xs1
        : theme.spacings.xs;
}, function (_a) {
    var sticky = _a.sticky;
    return (sticky ? 'sticky' : 'unset');
}, function (_a) {
    var maxWidth = _a.maxWidth, width = _a.width;
    return maxWidth && !width ? "".concat(maxWidth, "px") : 'unset';
}, function (_a) {
    var width = _a.width, minWidth = _a.minWidth;
    return minWidth && !width ? "".concat(minWidth, "px") : 'unset';
}, function (p) { return p.theme.colors.neutral[90]; }, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return selected ? theme.colors.secondary[99] : theme.colors.neutral[100];
}, function (_a) {
    var sticky = _a.sticky, isSelection = _a.isSelection;
    return sticky && isSelection ? 'sticky' : 'unset';
});
var ExpandedCell = styled.td(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  padding: ", ";\n  position: ", ";\n  text-align: left;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  &:after {\n    top: 0;\n    left: -30px;\n    width: 30px;\n    height: 100%;\n    content: '';\n    position: absolute;\n    box-shadow: inset -10px 0 8px -8px rgba(5, 5, 5, 0.06);\n  }\n  @media screen and (max-width: 600px) {\n    position: unset;\n  }\n"], ["\n  padding: ", ";\n  position: ", ";\n  text-align: left;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  &:after {\n    top: 0;\n    left: -30px;\n    width: 30px;\n    height: 100%;\n    content: '';\n    position: absolute;\n    box-shadow: inset -10px 0 8px -8px rgba(5, 5, 5, 0.06);\n  }\n  @media screen and (max-width: 600px) {\n    position: unset;\n  }\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'soft' ? theme.spacings.xs1 : theme.spacings.xs;
}, function (_a) {
    var sticky = _a.sticky;
    return (sticky ? 'sticky' : 'unset');
}, function (p) { return p.theme.colors.neutral[95]; }, function (p) { return p.theme.colors.neutral[90]; });
styled.span(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  width: 88px;\n"], ["\n  width: 88px;\n"])));
var Container$9 = styled.div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  gap: 16px;\n  align-items: center;\n  max-width: fit-content;\n  margin: auto;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  gap: 16px;\n  align-items: center;\n  max-width: fit-content;\n  margin: auto;\n"])));
var MenuOption$1 = styled.button(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n"])));
var templateObject_1$l, templateObject_2$c, templateObject_3$7, templateObject_4$6, templateObject_5$5;

function Row(props) {
    var _a;
    var row = props.row, _b = props._cellWidthList, _cellWidthList = _b === void 0 ? [] : _b;
    var firstColumn = row.getVisibleCells()[0];
    var selected = (_a = (firstColumn.column.id === 'selection' && firstColumn.selected)) !== null && _a !== void 0 ? _a : false;
    return (React__default.createElement(TRow, { key: row.id, variant: props._variant }, row.getVisibleCells().map(function (cell, index) {
        return cell.row.depth === 0 ? (React__default.createElement(Cell, { selected: selected, isSelection: cell.column.id === 'selection', variant: props._variant, sticky: !!cell.column.getIsPinned(), width: cell.column.columnDef.size, minWidth: cell.column.columnDef.minSize, maxWidth: cell.column.columnDef.maxSize, ref: function (element) {
                if (element) {
                    if (cell.column.getIsPinned()) {
                        var rowsLength = row.getVisibleCells().length;
                        var _a = calculateStickyColumn(index, rowsLength, _cellWidthList
                            .slice(0, index)
                            .reduce(function (offset, width) { return offset + width; }, 0), _cellWidthList
                            .slice(index + 1)
                            .reverse()
                            .reduce(function (offset, width) { return offset + width; }, 0)), left = _a[0], right = _a[1];
                        element.style.left = "".concat(left, "px");
                        element.style.right = "".concat(right, "px");
                    }
                }
            }, key: cell.row.index + cell.id }, cellRender(cell, row, props.actionMenuOnClick, props._variant))) : (React__default.createElement(ExpandedCell, { variant: props._variant, sticky: !!cell.column.getIsPinned(), ref: function (element) {
                if (element) {
                    if (cell.column.getIsPinned()) {
                        var rowsLength = row.getVisibleCells().length;
                        var _a = calculateStickyColumn(index, rowsLength, _cellWidthList
                            .slice(0, index)
                            .reduce(function (offset, width) { return offset + width; }, 0), _cellWidthList
                            .slice(index + 1)
                            .reverse()
                            .reduce(function (offset, width) { return offset + width; }, 0)), left = _a[0], right = _a[1];
                        element.style.left = "".concat(left, "px");
                        element.style.right = "".concat(right, "px");
                    }
                }
            }, key: cell.row.index + cell.id }, cellRender(cell, row, props.actionMenuOnClick, props._variant)));
    })));
}
function cellRender(cell, row, actionMenuOnClick, variant) {
    if (cell.column.id === 'expander' && cell.row.depth === 0) {
        return cell.row.getCanExpand() ? (React__default.createElement(PillButton, { key: cell.row.index + cell.row.id + cell.id, onClick: function () { return cell.row.toggleExpanded(); }, variant: "default", type: "secondary", size: variant === 'soft' ? 'extra-small' : 'small', icon: row.getIsExpanded() ? 'IconChevronUp' : 'IconChevronDown' })) : null;
    }
    if (cell.column.id === 'selection' && cell.setSelected) {
        return cell.row.depth === 0 ? (React__default.createElement(Checkbox, { onChange: function () {
                var _a;
                (_a = cell.setSelected) === null || _a === void 0 ? void 0 : _a.call(cell, row);
            }, checked: cell.selected })) : null;
    }
    if (cell.column.id === 'actions' && cell.actions) {
        var actions = typeof cell.actions === 'function'
            ? cell.actions(cell.getContext())
            : cell.actions;
        return (React__default.createElement(Container$9, null,
            React__default.createElement(Menu$2, { type: 'select', options: actions.map(function (option) { return ({
                    key: option.key,
                    onClick: function () { return option.onClick(cell.row.original); },
                    children: (React__default.createElement(MenuOption$1, null,
                        option.icon && React__default.createElement(Icons, { name: option.icon, fill: "transparent" }),
                        option.label)),
                }); }), disableAutoFocusItem: true, anchorOrigin: { vertical: 50, horizontal: -150 } },
                React__default.createElement(PillButton, { variant: "default", type: "secondary", size: variant === 'soft' ? 'extra-small' : 'small', icon: "IconDotsVertical", onClick: function () { return actionMenuOnClick === null || actionMenuOnClick === void 0 ? void 0 : actionMenuOnClick(cell.getContext()); } }))));
    }
    return flexRender(cell.column.columnDef.cell, cell.getContext());
}
function calculateStickyColumn(index, rowsLength, offsetLeft, offsetRight) {
    var element = { left: 0, right: 0 };
    if (index <= rowsLength / 2 - 1) {
        element.left = offsetLeft;
    }
    if (index >= rowsLength / 2 + 1) {
        element.right = offsetRight;
    }
    return [element.left, element.right];
}

var Skeleton = styled(Skeleton$1)(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  margin-bottom: 0;\n  border-radius: ", ";\n  min-height: ", "px;\n  display: flex;\n  flex-grow: 1;\n  cursor: wait;\n"], ["\n  margin-bottom: 0;\n  border-radius: ", ";\n  min-height: ", "px;\n  display: flex;\n  flex-grow: 1;\n  cursor: wait;\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'rounded' ? theme.spacings.xs1 : 0;
}, function (props) { return props.height; });
var CustomScrollbar = styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 24px;\n  margin-top: -17px;\n  background-color: ", ";\n  border: ", ";\n\n  padding: 0 16px;\n\n  .track {\n    background-color: ", ";\n    border-radius: ", ";\n    width: calc(100% - 32px);\n    height: 8px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .thumb {\n    background-color: ", ";\n    height: 8px;\n    border-radius: ", ";\n    cursor: pointer;\n    position: relative;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 24px;\n  margin-top: -17px;\n  background-color: ", ";\n  border: ", ";\n\n  padding: 0 16px;\n\n  .track {\n    background-color: ", ";\n    border-radius: ", ";\n    width: calc(100% - 32px);\n    height: 8px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .thumb {\n    background-color: ", ";\n    height: 8px;\n    border-radius: ", ";\n    cursor: pointer;\n    position: relative;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[100];
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[90];
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.xl2;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[80];
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.xl2;
});
var Container$8 = styled.div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  font-family: 'Nunito';\n  color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  width: 100%;\n  position: relative;\n  overflow: ", ";\n"], ["\n  font-family: 'Nunito';\n  color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  width: 100%;\n  position: relative;\n  overflow: ", ";\n"])), function (p) { return p.theme.colors.neutral[40]; }, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'soft'
        ? 'none'
        : "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'soft' ? 0 : theme.borders.radius.m;
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'soft' ? 'hidden' : 'auto');
});
var Grid$1 = styled.table(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
styled.thead(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
styled.th(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  position: ", ";\n  background-color: ", ";\n  padding: 24px;\n  text-align: left;\n  &:after {\n    top: 0;\n    left: -30px;\n    width: 30px;\n    height: 100%;\n    content: '';\n    position: absolute;\n    box-shadow: inset -10px 0 8px -8px rgba(5, 5, 5, 0.06);\n  }\n"], ["\n  position: ", ";\n  background-color: ", ";\n  padding: 24px;\n  text-align: left;\n  &:after {\n    top: 0;\n    left: -30px;\n    width: 30px;\n    height: 100%;\n    content: '';\n    position: absolute;\n    box-shadow: inset -10px 0 8px -8px rgba(5, 5, 5, 0.06);\n  }\n"])), function (_a) {
    var sticky = _a.sticky;
    return (sticky ? 'sticky' : 'unset');
}, function (p) { return p.theme.colors.neutral[95]; });
styled.td(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding: 24px;\n  position: ", ";\n  text-align: left;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  &:after {\n    top: 0;\n    left: -30px;\n    width: 30px;\n    height: 100%;\n    content: '';\n    position: absolute;\n    box-shadow: inset -10px 0 8px -8px rgba(5, 5, 5, 0.06);\n  }\n"], ["\n  padding: 24px;\n  position: ", ";\n  text-align: left;\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  &:after {\n    top: 0;\n    left: -30px;\n    width: 30px;\n    height: 100%;\n    content: '';\n    position: absolute;\n    box-shadow: inset -10px 0 8px -8px rgba(5, 5, 5, 0.06);\n  }\n"])), function (_a) {
    var sticky = _a.sticky;
    return (sticky ? 'sticky' : 'unset');
}, function (p) { return p.theme.colors.neutral[100]; }, function (p) { return p.theme.colors.neutral[90]; });
var templateObject_1$k, templateObject_2$b, templateObject_3$6, templateObject_4$5, templateObject_5$4, templateObject_6$1, templateObject_7;

function Root$2(_a) {
    var _b;
    var loading = _a.loading, props = __rest(_a, ["loading"]);
    var _c = useTableContext(), variant = _c.variant, bulkActions = _c.bulkActions;
    var _d = React__default.useState([]), cellWidthList = _d[0], setCellWidthList = _d[1];
    var minHeight = (_b = props.minHeight) !== null && _b !== void 0 ? _b : 400;
    var tableGridRef = useRef(null);
    var thumbRef = useRef(null);
    var scrollBarRef = useRef(null);
    useEffect(function () {
        var tableGrid = tableGridRef.current;
        var thumb = thumbRef.current;
        var scrollbar = scrollBarRef.current;
        if (!tableGrid || !thumb || !scrollbar || loading) {
            return;
        }
        var padding = 32;
        var resizeObserver = new ResizeObserver(function () {
            return updateThumb(tableGrid, scrollbar, thumb, padding);
        });
        resizeObserver.observe(tableGrid);
        var mutationObserver = new MutationObserver(function () {
            updateThumb(tableGrid, scrollbar, thumb, padding);
        });
        mutationObserver.observe(tableGrid, { childList: true, subtree: true });
        var onScroll = function () { return syncThumb(tableGrid, scrollbar, thumb, padding); };
        var onWhell = function (event) {
            return handleTableGridWhellScroll(event, tableGrid);
        };
        var onDrag = function (event) {
            return handleThumbDrag(event, tableGrid, scrollbar, thumb, padding);
        };
        tableGrid.addEventListener('scroll', onScroll);
        tableGrid.addEventListener('wheel', onWhell);
        thumb.addEventListener('mousedown', onDrag);
        window.addEventListener('resize', function () {
            return updateThumbWidth(tableGrid, thumb, padding);
        });
        updateThumb(tableGrid, scrollbar, thumb, padding);
        return function () {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            tableGrid.removeEventListener('scroll', onScroll);
            tableGrid.removeEventListener('wheel', onWhell);
            thumb.removeEventListener('mousedown', onDrag);
            window.removeEventListener('resize', function () {
                return updateThumbWidth(tableGrid, thumb, padding);
            });
        };
    }, [loading]);
    useEffect(function () {
        var scrollbar = scrollBarRef.current;
        var bulkActionsRef = bulkActions.ref.current;
        if (scrollbar && !loading) {
            scrollbar.style.bottom =
                bulkActions.visible && bulkActionsRef
                    ? "".concat(bulkActionsRef.clientHeight, "px")
                    : '0px';
        }
    }, [loading, bulkActions.ref, bulkActions.visible]);
    if (loading) {
        return (React__default.createElement(Skeleton, { height: minHeight, variant: variant === 'soft' ? 'rectangular' : 'rounded' }));
    }
    if (!props.children) {
        return null;
    }
    var _e = React__default.Children.map(props.children, function (child) {
        return React__default.cloneElement(child, {
            _cellWidthList: cellWidthList,
            _setCellWidthList: setCellWidthList,
            _variant: variant,
        });
    }), header = _e[0], rows = _e.slice(1);
    if (rows.length === 0) {
        return React__default.createElement(Empty, __assign({ minHeight: minHeight }, props.empty));
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Container$8, { ref: tableGridRef, className: "table-grid", variant: variant },
            React__default.createElement(Grid$1, null,
                header,
                React__default.createElement("tbody", null, rows))),
        variant === 'soft' && (React__default.createElement(CustomScrollbar, { ref: scrollBarRef },
            React__default.createElement("div", { className: "track" }),
            React__default.createElement("div", { ref: thumbRef, className: "thumb" })))));
}
function toggleScrollbarDisplay(scrollbar, isVisible) {
    scrollbar.style.display = isVisible ? 'flex' : 'none';
}
function updateThumbWidth(tableGrid, thumb, padding) {
    var visibleRatio = tableGrid.clientWidth / tableGrid.scrollWidth;
    var thumbWidth = visibleRatio * tableGrid.clientWidth - padding;
    thumb.style.width = "".concat(thumbWidth, "px");
}
function syncThumb(tableGrid, scrollbar, thumb, padding) {
    var scrollRatio = tableGrid.scrollLeft / (tableGrid.scrollWidth - tableGrid.clientWidth);
    var availableTrackWidth = scrollbar.clientWidth - padding;
    var maxThumbPosition = availableTrackWidth - thumb.offsetWidth;
    var thumbPosition = scrollRatio * maxThumbPosition;
    thumb.style.transform = "translateX(".concat(thumbPosition, "px)");
}
function handleThumbDrag(event, tableGrid, scrollbar, thumb, padding) {
    var startX = event.clientX;
    var initialScrollLeft = tableGrid.scrollLeft;
    document.body.style.userSelect = 'none';
    var onMouseMove = function (moveEvent) {
        var deltaX = moveEvent.clientX - startX;
        var scrollRatio = (tableGrid.scrollWidth - tableGrid.clientWidth) /
            (scrollbar.clientWidth - thumb.offsetWidth - padding);
        tableGrid.scrollLeft = initialScrollLeft + deltaX * scrollRatio;
    };
    var onMouseUp = function () {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        document.body.style.userSelect = '';
    };
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
}
function handleTableGridWhellScroll(event, tableGrid) {
    if (event.shiftKey) {
        event.preventDefault();
        tableGrid.scrollLeft += event.deltaY;
    }
    else if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        event.preventDefault();
        tableGrid.scrollLeft += event.deltaX;
    }
}
function updateThumb(tableGrid, scrollbar, thumb, padding) {
    var needsScroll = tableGrid.clientWidth !== tableGrid.scrollWidth;
    if (needsScroll) {
        updateThumbWidth(tableGrid, thumb, padding);
        syncThumb(tableGrid, scrollbar, thumb, padding);
        toggleScrollbarDisplay(scrollbar, true);
    }
    else {
        toggleScrollbarDisplay(scrollbar, false);
    }
}

var Grid = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Header: Header$2,
    Root: Root$2,
    Row: Row
});

var Container$7 = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: ", ";\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: ", ";\n  align-items: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var Title = styled(Typography)(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  color: ", ";\n  margin-bottom: ", ";\n"], ["\n  color: ", ";\n  margin-bottom: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[30];
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var templateObject_1$j, templateObject_2$a;

function Header$1(_a) {
    var tagLabel = _a.tagLabel, tag = _a.tag, props = __rest(_a, ["tagLabel", "tag"]);
    var context = useTableContext();
    return (React__default.createElement(Container$7, __assign({}, props),
        React__default.createElement(Title, { variant: context.variant === 'soft' ? 'headline9' : 'headline8' }, props.title),
        tagLabel && tag && (React__default.createElement(Tag, { variant: tag, size: context.variant === 'soft' ? 'extra-small' : 'small' }, tagLabel))));
}

var MenuOption = styled.button(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: ", ";\n  gap: ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: ", ";\n  gap: ", ";\n  color: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant, disabled = _a.disabled;
    if (disabled)
        return theme.colors.neutral[70];
    switch (variant) {
        case 'success':
            return theme.colors.success40;
        case 'error':
            return theme.colors.error40;
        case 'info':
            return theme.colors.info40;
        case 'pink':
            return theme.colors.secondary50;
        default:
            return theme.colors.neutral40;
    }
});
var templateObject_1$i;

function MenuItem$1(props) {
    function renderItem() {
        return (React__default.createElement(MenuOption, { variant: props.variant, disabled: props.disabled },
            props.icon && props.iconPosition === 'left' && (React__default.createElement(Icons, { name: props.icon })),
            props.label,
            props.icon && props.iconPosition !== 'left' && (React__default.createElement(Icons, { name: props.icon }))));
    }
    return props.tooltip ? (React__default.createElement(Tooltip, { title: props.tooltip, placement: "left" }, renderItem())) : (renderItem());
}

function RowMenu(props) {
    function renderOptions() {
        if (props.loading) {
            return [
                {
                    key: 'action-loader',
                    onClick: function () { return null; },
                    children: (React__default.createElement(MenuOption, null,
                        React__default.createElement(Spinner, null))),
                },
            ];
        }
        return props.actions.map(function (action) {
            var _a;
            return ({
                key: action.key,
                onClick: action.disabled ? undefined : action.onClick,
                disabled: action.disabled,
                children: (_a = action.children) !== null && _a !== void 0 ? _a : React__default.createElement(MenuItem$1, __assign({}, action)),
            });
        });
    }
    return (React__default.createElement(Menu$2, { type: "select", options: renderOptions(), disableAutoFocusItem: true, anchorOrigin: { vertical: 50, horizontal: 0 } },
        React__default.createElement(PillButton, { variant: "default", type: "secondary", size: "extra-small", icon: "IconDotsVertical", onClick: props.onOpen })));
}

var ActionsContainer = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var templateObject_1$h;

function RowActions(props) {
    var rowActions = props.row.getActions();
    var rowQuickActions = props.row.getQuickActions();
    var quickActions = typeof rowQuickActions === 'function'
        ? rowQuickActions(getCellContext())
        : rowQuickActions;
    var actionsMenu = typeof rowActions === 'function'
        ? rowActions(getCellContext())
        : rowActions;
    function getCellContext() {
        return props.row.getVisibleCells()[0].getContext();
    }
    if (!(rowActions === null || rowActions === void 0 ? void 0 : rowActions.length) && !quickActions.length) {
        return null;
    }
    return (React__default.createElement(ActionsContainer, null,
        quickActions.map(function (action) {
            var _a;
            return (React__default.createElement(PillButton, __assign({}, action, { key: action.key, size: "extra-small", variant: (_a = action.variant) !== null && _a !== void 0 ? _a : 'default', onClick: function () { return action.onClick(props.row.original); } })));
        }),
        (actionsMenu.length || typeof rowActions === 'function') && (React__default.createElement(RowMenu, { loading: props.actionsLoading, onOpen: function () { var _a; return (_a = props.onClickAction) === null || _a === void 0 ? void 0 : _a.call(props, props.row.original); }, actions: actionsMenu === null || actionsMenu === void 0 ? void 0 : actionsMenu.map(function (action) { return (__assign(__assign({}, action), { onClick: function () { return action.onClick(props.row.original); } })); }) }))));
}

var Container$6 = styled(Accordion)(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  margin: 0;\n\n  &.Mui-expanded {\n    margin: 0;\n  }\n\n  .MuiAccordionSummary-root {\n    padding: ", ";\n  }\n\n  .MuiAccordionDetails-root {\n    padding: 0px;\n  }\n"], ["\n  margin: 0;\n\n  &.Mui-expanded {\n    margin: 0;\n  }\n\n  .MuiAccordionSummary-root {\n    padding: ", ";\n  }\n\n  .MuiAccordionDetails-root {\n    padding: 0px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "0px ".concat(theme.spacings.xs1);
});
var SummaryContainer = styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  width: 100%;\n  display: grid;\n  margin: 0;\n  grid-template-columns: max-content auto;\n  align-items: center;\n"], ["\n  width: 100%;\n  display: grid;\n  margin: 0;\n  grid-template-columns: max-content auto;\n  align-items: center;\n"])));
var ContentContainer$1 = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  display: grid;\n  align-items: center;\n  gap: ", ";\n  grid-template-columns: 24px auto;\n  padding: ", ";\n"], ["\n  display: grid;\n  align-items: center;\n  gap: ", ";\n  grid-template-columns: 24px auto;\n  padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacings.xs2, " 0px");
});
var ChevronIcon = styled(Icons)(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  transition: 0.3s;\n  border-radius: 100%;\n  transform: rotate(", "deg);\n\n  :hover {\n    background-color: ", ";\n  }\n"], ["\n  transition: 0.3s;\n  border-radius: 100%;\n  transform: rotate(", "deg);\n\n  :hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var expanded = _a.expanded;
    return (expanded ? -180 : 0);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[90];
});
styled(AccordionDetails)(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var templateObject_1$g, templateObject_2$9, templateObject_3$5, templateObject_4$4, templateObject_5$3;

function AccordionBaseRow(props) {
    var rowActions = props.row.getActions();
    var rowQuickActions = props.row.getQuickActions();
    /**
     * TODO: Improves subRows use
     * It is necessary to improve the use of subrows for use as children of the component.
     */
    if (props.row.depth > 0) {
        return null;
    }
    var firstColumn = props.row.getVisibleCells()[0];
    var selectionColumn = firstColumn.column.id === 'selection' ? firstColumn : null;
    var expanded = props.row.getIsExpanded();
    function handleExpanded() {
        props.row.toggleExpanded();
    }
    function handleSelected() {
        var _a;
        (_a = selectionColumn === null || selectionColumn === void 0 ? void 0 : selectionColumn.setSelected) === null || _a === void 0 ? void 0 : _a.call(selectionColumn, props.row);
    }
    return (React__default.createElement(Container$6, { variant: "soft", expanded: expanded, selected: selectionColumn === null || selectionColumn === void 0 ? void 0 : selectionColumn.selected, actions: (rowActions || rowQuickActions) && [
            {
                children: (React__default.createElement(RowActions, { row: props.row, onClickAction: props.onClickAction })),
            },
        ], customHeader: React__default.createElement(SummaryContainer, null,
            selectionColumn && (React__default.createElement(Checkbox, { sx: { marginLeft: '-10px' }, onChange: handleSelected, checked: selectionColumn === null || selectionColumn === void 0 ? void 0 : selectionColumn.selected })),
            React__default.createElement(ContentContainer$1, { onClick: handleExpanded },
                React__default.createElement(ChevronIcon, { name: "IconChevronDown", expanded: expanded, size: 16 }),
                props.summary)) }, props.children));
}

function ListSkeleton(props) {
    var _a;
    return (React__default.createElement(React__default.Fragment, null, Array.from({ length: (_a = props === null || props === void 0 ? void 0 : props.size) !== null && _a !== void 0 ? _a : 10 }, function (_, index) {
        var _a, _b;
        return (React__default.createElement(Skeleton$1, { key: index, height: (_a = props === null || props === void 0 ? void 0 : props.height) !== null && _a !== void 0 ? _a : 80, variant: (_b = props === null || props === void 0 ? void 0 : props.variant) !== null && _b !== void 0 ? _b : 'rounded' }));
    })));
}

var List$1 = styled.ul(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  display: grid;\n  gap: ", ";\n"], ["\n  display: grid;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var templateObject_1$f;

function Root$1(props) {
    var _a;
    if (props.loading) {
        return React__default.createElement(ListSkeleton, { size: props.skeletonSize });
    }
    if (!props.children.length) {
        return React__default.createElement(Empty, __assign({ minHeight: (_a = props.skeletonSize) !== null && _a !== void 0 ? _a : 400 }, props.empty));
    }
    return React__default.createElement(List$1, null, props.children);
}

var List = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AccordionBaseRow: AccordionBaseRow,
    Root: Root$1
});

var Button = styled.button(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  border-radius: 100px;\n  border-style: solid;\n  border-width: 1px;\n\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  flex-direction: row;\n  padding: 8px 16px;\n  text-align: center;\n  white-space: nowrap;\n\n  ", "\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  border-radius: 100px;\n  border-style: solid;\n  border-width: 1px;\n\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  flex-direction: row;\n  padding: 8px 16px;\n  text-align: center;\n  white-space: nowrap;\n\n  ", "\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n"])), function (p) {
    switch (p.status) {
        case 'active':
            return {
                'border-color': p.theme.colors.secondary['95'],
                'background-color': p.theme.colors.secondary['95'],
                color: p.theme.colors.secondary['50'],
            };
        case 'neutral':
            return {
                'border-color': p.theme.colors.neutral['80'],
                'background-color': 'transparent',
                color: p.theme.colors.neutral['40'],
            };
        case 'disabled':
            return {
                'border-color': p.theme.colors.neutral['90'],
                'background-color': p.theme.colors.neutral['90'],
                color: p.theme.colors.neutral['80'],
                cursor: 'default',
            };
    }
}, function (p) { return p.theme.colors.neutral['90']; }, function (p) {
    return p.status === 'disabled'
        ? p.theme.colors.neutral['80']
        : p.theme.colors.neutral['40'];
}, function (p) { return p.theme.colors.neutral['90']; });
var templateObject_1$e;

function TagButton(props) {
    return (React__default.createElement(Button, { status: props.status, onClick: props.status === 'disabled' ? undefined : props.onClick },
        props.leftIcon && React__default.createElement(Icons, { name: props.leftIcon, fill: "transparent" }),
        React__default.createElement(Typography.Body3, { weight: 600 }, props.label),
        props.rightIcon && React__default.createElement(Icons, { name: props.rightIcon, fill: "transparent" })));
}

var MenuItem = styled(MenuItem$4)(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  border-radius: 8px;\n  margin-bottom: 4px;\n  padding: 16px;\n  background-color: ", ";\n"], ["\n  border-radius: 8px;\n  margin-bottom: 4px;\n  padding: 16px;\n  background-color: ", ";\n"])), function (p) {
    return p.selected ? p.theme.colors.secondary[95] : 'transparent';
});
var templateObject_1$d;

function Select(props) {
    var _a, _b;
    var _c = React__default.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var label = (_b = (_a = props.options.find(function (option) { return option.value === props.value; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
    function handleOnClose() {
        setAnchorEl(null);
    }
    function handleSelect(value) {
        props.onChange(value);
        handleOnClose();
    }
    return (React__default.createElement(React__default.Fragment, null,
        props.variant === 'soft' ? (React__default.createElement(PillButton, { size: "small", variant: "default", type: "primary", icon: "IconChevronDown", disabled: props.disabled, onClick: function (e) { return setAnchorEl(e.currentTarget); }, label: label })) : (React__default.createElement(TagButton, { label: label, status: props.disabled ? 'disabled' : 'neutral', rightIcon: "IconChevronDown", onClick: function (e) { return setAnchorEl(e.currentTarget); } })),
        React__default.createElement(Popover, { open: !!anchorEl, anchorEl: anchorEl, onClose: handleOnClose, PaperProps: {
                style: {
                    padding: '12px',
                },
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            } },
            React__default.createElement(MenuList, null, props.options.map(function (item) {
                var selected = item.value === props.value;
                return (React__default.createElement(MenuItem, { selected: selected, key: item.value, onClick: function () { return handleSelect(item.value); } },
                    React__default.createElement(ListItemText, null, item.label)));
            })))));
}

var PaginationContainer = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  .wrapper-select {\n    .select-custom .select-field-custom-theme div.MuiFilledInput-root {\n      border: 0 !important;\n    }\n  }\n\n  @media screen and (max-width: 600px) {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: ", ";\n\n    > nav {\n      width: max-content;\n      margin: 0 auto;\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  .wrapper-select {\n    .select-custom .select-field-custom-theme div.MuiFilledInput-root {\n      border: 0 !important;\n    }\n  }\n\n  @media screen and (max-width: 600px) {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: ", ";\n\n    > nav {\n      width: max-content;\n      margin: 0 auto;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
});
var WrapperSelect = styled.div(function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (__assign({ display: 'flex', alignItems: 'center', gap: theme.spacings['xs2'], '> span': {
            color: theme.colors.neutral[50],
            fontWeight: 600,
        }, '@media screen and (max-width: 600px)': {
            justifyContent: 'space-between',
        } }, (variant === 'soft' && {
        fontFamily: theme.fonts.secondary,
        fontSize: '14px',
        fontWeight: 400,
    })));
});
styled(SelectField)(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  min-width: 143px;\n\n  .data-grid-custom-select {\n    margin-right: 16px;\n    border: 1px solid var(--color-neutral-light2) !important;\n    border-radius: 200px !important;\n    padding-right: 0px !important;\n\n    .select-field-custom-theme {\n      min-width: 143px;\n\n      .MuiFilledInput-root {\n        padding: 9px 39px 9px 8px;\n      }\n    }\n\n    &:before,\n    &:after {\n      content: none !important;\n    }\n\n    &:focus {\n      background-color: transparent !important;\n    }\n\n    .MuiSelect-select {\n      padding: 9px 2px 9px 16px !important;\n      font-family: 'Nunito';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 22px;\n      text-align: center;\n      color: var(--color-neutral-dark4);\n\n      &:focus {\n        background-color: transparent !important;\n      }\n    }\n\n    .select-icon-custom {\n      cursor: pointer !important;\n\n      .icon-container {\n        top: unset !important;\n        position: unset !important;\n        margin-right: 12px;\n      }\n    }\n  }\n"], ["\n  min-width: 143px;\n\n  .data-grid-custom-select {\n    margin-right: 16px;\n    border: 1px solid var(--color-neutral-light2) !important;\n    border-radius: 200px !important;\n    padding-right: 0px !important;\n\n    .select-field-custom-theme {\n      min-width: 143px;\n\n      .MuiFilledInput-root {\n        padding: 9px 39px 9px 8px;\n      }\n    }\n\n    &:before,\n    &:after {\n      content: none !important;\n    }\n\n    &:focus {\n      background-color: transparent !important;\n    }\n\n    .MuiSelect-select {\n      padding: 9px 2px 9px 16px !important;\n      font-family: 'Nunito';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 22px;\n      text-align: center;\n      color: var(--color-neutral-dark4);\n\n      &:focus {\n        background-color: transparent !important;\n      }\n    }\n\n    .select-icon-custom {\n      cursor: pointer !important;\n\n      .icon-container {\n        top: unset !important;\n        position: unset !important;\n        margin-right: 12px;\n      }\n    }\n  }\n"])));
var templateObject_1$c, templateObject_2$8;

function Pagination(_a) {
    var _b;
    var count = _a.count, pagination = _a.pagination, onPaginationChange = _a.onPaginationChange, props = __rest(_a, ["count", "pagination", "onPaginationChange"]);
    var pageNumber = pagination.pageNumber, pageSize = pagination.pageSize;
    var context = useTableContext();
    var itemRange = React__default.useMemo(function () { return calculateItemRange(pagination, count, props.itemRangeLabel); }, [props.itemRangeLabel, pagination, count]);
    return (React__default.createElement(PaginationContainer, __assign({}, props),
        React__default.createElement(WrapperSelect, { variant: context.variant },
            React__default.createElement(Select, { disabled: !count, value: pageSize, variant: context.variant, onChange: function (value) {
                    return onPaginationChange({ pageNumber: 1, pageSize: value });
                }, options: (_b = props.pageSizeOptions) !== null && _b !== void 0 ? _b : defaultPageSizeOptions }),
            props.showItemRange ? itemRange : null),
        React__default.createElement(Pagination$1, { count: Math.ceil(count / pageSize), defaultPage: 1, page: pageNumber, variant: context.variant, onChange: function (_, value) {
                return onPaginationChange(__assign(__assign({}, pagination), { pageNumber: value }));
            }, siblingCount: 1 })));
}
var defaultPageSizeOptions = [
    {
        label: '10 itens',
        value: 10,
    },
    {
        label: '25 itens',
        value: 25,
    },
    {
        label: '50 itens',
        value: 50,
    },
];
function calculateItemRange(pagination, count, itemRangeLabel) {
    if (!count) {
        return null;
    }
    var startIndex = (itemRangeLabel === null || itemRangeLabel === void 0 ? void 0 : itemRangeLabel.startIndex) ||
        (pagination.pageNumber - 1) * pagination.pageSize + 1;
    var endIndex = (itemRangeLabel === null || itemRangeLabel === void 0 ? void 0 : itemRangeLabel.endIndex) ||
        Math.min(startIndex + pagination.pageSize - 1, count);
    var rangeText = "".concat(startIndex, "-").concat(endIndex);
    var prefixText = (itemRangeLabel === null || itemRangeLabel === void 0 ? void 0 : itemRangeLabel.prefix) || 'de';
    var suffixText = (itemRangeLabel === null || itemRangeLabel === void 0 ? void 0 : itemRangeLabel.suffix) || 'itens';
    var fullRangeText = "".concat(rangeText, " ").concat(prefixText, " ").concat(count, " ").concat(suffixText);
    return React__default.createElement("span", null, fullRangeText);
}

var Container$5 = styled.div(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  ", "\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  ", "\n  margin-bottom: ", ";\n"])), function (_a) {
    var theme = _a.theme, gap = _a.gap;
    return "gap: ".concat(theme.spacings[gap], ";");
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.m;
});
var templateObject_1$b;

function Root(props) {
    var _a;
    return (React__default.createElement(TableProvider, { variant: (_a = props.variant) !== null && _a !== void 0 ? _a : 'modest' },
        React__default.createElement(Container$5, __assign({ gap: props.variant === 'soft' ? 'xs3' : 's' }, props), props.children)));
}

function useSearch(callback, initialValue, debounceSettings) {
    var _a, _b;
    if (initialValue === void 0) { initialValue = ''; }
    var _c = useState(initialValue), search = _c[0], setSearch = _c[1];
    var debouncedSearch = debounce(function (data) {
        setSearch(data);
    }, (_a = debounceSettings === null || debounceSettings === void 0 ? void 0 : debounceSettings.wait) !== null && _a !== void 0 ? _a : 1000, { maxWait: (_b = debounceSettings === null || debounceSettings === void 0 ? void 0 : debounceSettings.maxWait) !== null && _b !== void 0 ? _b : 5000 });
    var ref = useRef('');
    useEffect(function () {
        if (ref.current !== search) {
            ref.current = search;
            callback();
        }
    }, [search, callback]);
    return [
        search,
        function (input) {
            debouncedSearch(input);
        },
    ];
}

function useSelectedRows(total, initialValue) {
    var _a;
    var _b = useState((_a = initialValue === null || initialValue === void 0 ? void 0 : initialValue.selected) !== null && _a !== void 0 ? _a : []), selectedRows = _b[0], setSelectedRows = _b[1];
    var _c = useState(!!(initialValue === null || initialValue === void 0 ? void 0 : initialValue.allSelected)), allSelected = _c[0], setAllSelected = _c[1];
    var setAllSelectedRows = function (newAllSelected) {
        setSelectedRows([]);
        setAllSelected(newAllSelected);
        return {
            selected: [],
            allSelected: newAllSelected,
        };
    };
    return [
        { selected: selectedRows, allSelected: allSelected },
        function (selected) {
            var selectedRow = !!selectedRows.find(function (row) { return row.id === selected.id && row.page === selected.page; });
            var newSelectedRows = !selectedRow
                ? __spreadArray(__spreadArray([], selectedRows, true), [selected], false) : selectedRows.filter(function (row) { return row.id !== selected.id || row.page !== selected.page; });
            var allSelectedManually = !!total && newSelectedRows.length === total;
            if (allSelectedManually) {
                return setAllSelectedRows(!allSelected);
            }
            setSelectedRows(newSelectedRows);
            return {
                selected: newSelectedRows,
                allSelected: total ? newSelectedRows.length === total : allSelected,
            };
        },
        setAllSelectedRows,
        function () {
            setSelectedRows([]);
            setAllSelected(false);
        },
        setSelectedRows,
    ];
}

function useTableColumns(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var _r = useSelectedRows((_a = props.total) !== null && _a !== void 0 ? _a : props.data.length, (_b = props.initialState) === null || _b === void 0 ? void 0 : _b.selectedRows), selectedRows = _r[0], setSelectedRow = _r[1], setAllSelected = _r[2], resetSelected = _r[3], setSelectedRows = _r[4];
    var _s = React__default.useState((_d = (_c = props.initialState) === null || _c === void 0 ? void 0 : _c.expandedRows) !== null && _d !== void 0 ? _d : {}), expanded = _s[0], setExpanded = _s[1];
    var _t = React__default.useState(props.pagination), pagination = _t[0], setPagination = _t[1];
    React__default.useEffect(function () {
        if (pagination.pageNumber !== props.pagination.pageNumber) {
            setExpanded({});
        }
        if (pagination.pageNumber !== props.pagination.pageNumber ||
            pagination.pageSize !== props.pagination.pageSize)
            setPagination(props.pagination);
    }, [
        props.pagination,
        props.pagination.pageNumber,
        props.pagination.pageSize,
        pagination.pageNumber,
        pagination.pageSize,
    ]);
    if (((_e = props.options) === null || _e === void 0 ? void 0 : _e.selectable) &&
        !props.columns.some(function (column) { return column.id === 'selection'; })) {
        props.columns.unshift({
            id: 'selection',
            sticky: 'left',
            minSize: 40,
            size: 40,
            maxSize: 40,
        });
    }
    if (((_f = props.options) === null || _f === void 0 ? void 0 : _f.actions) &&
        !props.columns.some(function (column) { return column.id === 'actions'; })) {
        props.columns.push({
            id: 'actions',
            sticky: 'right',
            minSize: 40,
            size: 40,
            maxSize: 40,
        });
    }
    if (((_g = props.options) === null || _g === void 0 ? void 0 : _g.expandable) &&
        !props.columns.some(function (column) { return column.id === 'expander'; })) {
        props.columns.push({
            id: 'expander',
            sticky: 'right',
            minSize: 40,
            size: 40,
            maxSize: 40,
        });
    }
    var table = useReactTable(__assign(__assign({ columns: props.columns, data: props.data }, (typeof ((_h = props.options) === null || _h === void 0 ? void 0 : _h.selectable) === 'function' && {
        getRowId: props.options.selectable,
    })), { getCoreRowModel: getCoreRowModel(), getExpandedRowModel: getExpandedRowModel(), getPaginationRowModel: getPaginationRowModel(), getSubRows: function (row) { return row.subRows; }, onExpandedChange: setExpanded, enableExpanding: (_j = props.options) === null || _j === void 0 ? void 0 : _j.expandable, enableColumnPinning: true, manualPagination: !!props.total, 
        // Buggy behavior when using this props
        // Setting all fields to 0 fix this
        defaultColumn: __assign(__assign({}, props.defaultColumn), { size: (_l = (_k = props.defaultColumn) === null || _k === void 0 ? void 0 : _k.size) !== null && _l !== void 0 ? _l : 0, maxSize: (_o = (_m = props.defaultColumn) === null || _m === void 0 ? void 0 : _m.maxSize) !== null && _o !== void 0 ? _o : 0, minSize: (_q = (_p = props.defaultColumn) === null || _p === void 0 ? void 0 : _p.minSize) !== null && _q !== void 0 ? _q : 0 }), initialState: {
            columnPinning: props.columns.reduce(function (pinnedList, column) {
                if (column.accessorKey || column.id) {
                    if (column.sticky === 'left') {
                        pinnedList.left.push((column.accessorKey || column.id || '').toString());
                    }
                    if (column.sticky === 'right') {
                        pinnedList.right.push((column.accessorKey || column.id || '').toString());
                    }
                }
                return pinnedList;
            }, { left: [], right: [] }),
        }, state: {
            expanded: expanded,
            pagination: {
                pageIndex: pagination.pageNumber - 1,
                pageSize: pagination.pageSize,
            },
        } }));
    var state = table.getState();
    var rows = table.getPaginationRowModel().rows;
    return {
        pagination: {
            pageNumber: state.pagination.pageIndex,
            pageSize: state.pagination.pageSize,
        },
        resetPageIndex: function () {
            props.onPaginationChange(__assign(__assign({}, state.pagination), { pageNumber: 1 }));
        },
        selected: selectedRows,
        resetSelected: resetSelected,
        setSelectedRow: setSelectedRow,
        setAllSelected: setAllSelected,
        selectionHandler: function (callback) {
            return callback(selectedRows);
        },
        setSelectedRows: setSelectedRows,
        rows: rows.map(function (row) {
            return __assign(__assign({}, row), { page: props.pagination.pageNumber, getVisibleCells: function () {
                    return row.getVisibleCells().map(function (cell) {
                        var _a, _b;
                        var finalCell = cell;
                        if (cell.column.id === 'selection') {
                            var selected = selectedRows.selected, allSelected = selectedRows.allSelected;
                            var selectedRow = !!selected.find(function (row) {
                                return row.id === cell.row.id &&
                                    row.page === props.pagination.pageNumber;
                            });
                            finalCell.selected = !allSelected ? selectedRow : !selectedRow;
                            finalCell.setSelected = setSelectedRow;
                        }
                        if (cell.column.id === 'actions' && ((_a = props.options) === null || _a === void 0 ? void 0 : _a.actions)) {
                            finalCell.actions = (_b = props.options) === null || _b === void 0 ? void 0 : _b.actions;
                        }
                        return finalCell;
                    });
                }, getActions: function () { var _a, _b; return (_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.actions) !== null && _b !== void 0 ? _b : []; }, getQuickActions: function () { var _a, _b; return (_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.quickActions) !== null && _b !== void 0 ? _b : []; } });
        }),
        getHeaderGroups: function () {
            return table.getHeaderGroups().map(function (headerGroup) { return (__assign(__assign({}, headerGroup), { headers: headerGroup.headers.map(function (header) {
                    if (header.column.id === 'selection') {
                        header.selected = selectedRows.allSelected;
                        header.setSelected = setAllSelected;
                        header.hasSomeSelected = selectedRows.selected.length > 0;
                    }
                    return header;
                }) })); });
        },
        toggleAllRowsExpanded: function () { return table.toggleAllRowsExpanded(); },
    };
}

var Table = {
    Root: Root,
    Header: Header$1,
    Search: Search,
    Grid: Grid,
    Pagination: Pagination,
    Filters: Filters$1,
    BulkActions: BulkActions,
    Content: Content$1,
    FilterSearch: FilterSearch,
    List: List,
};
var tableControllers = {
    useTableColumns: useTableColumns,
    useSelectedRows: useSelectedRows,
    useSearch: useSearch,
};

var css_248z$1 = ".custom-ql-toolbar{background-color:#f8f6f8;border:1px solid #ebe6e9;border-radius:8px 8px 0 0}.quill .ql-container{border:1px solid #ebe6e9!important;border-radius:0 0 8px 8px;border-top:none!important}.custom-ql-toolbar .custom-arrows{background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon-tabler icon-tabler-arrows-vertical\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"gray\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M0 0h24v24H0z\" stroke=\"none\"/><path d=\"m8 7 4-4 4 4M8 17l4 4 4-4M12 3v18\"/></svg>');background-position:100%;background-repeat:no-repeat;display:inline-block}.custom-ql-toolbar .custom-arrows svg{display:none}.custom-ql-toolbar .ql-formats button{align-items:center;background-color:#f8f6f8;border-radius:50%;color:var(--color-neutral-dark5);display:inline-flex;height:32px;justify-content:center;margin:0 5px;width:32px}.custom-ql-toolbar .ql-formats button svg{height:16px;width:16px}.custom-ql-toolbar .ql-formats button.ql-active,.custom-ql-toolbar .ql-formats button:hover{background-color:var(--color-neutral-light2);color:var(--color-neutral-dark1)}.custom-ql-toolbar .ql-formats .ql-picker-label{color:var(--color-neutral-dark5)}.custom-ql-toolbar .ql-formats .ql-picker-label:hover{color:var(--color-neutral-dark1)}#custom-ql-toolbar .ql-formats .ql-picker-item{color:var(--color-neutral-dark5)}#custom-ql-toolbar .ql-formats .ql-picker-item:hover{color:var(--color-neutral-dark1)}.custom-ql-toolbar .ql-formats{color:var(--color-neutral-dark5);font-family:var(--font-family-secondary);font-size:14px}.quill .ql-container .ql-editor{font-family:var(--font-family-secondary);font-size:16px}.custom-ql-toolbar .ql-picker.ql-size .ql-picker-item[data-value=\"14px\"]:before{font-size:14px}.custom-ql-toolbar .ql-picker.ql-size .ql-picker-item[data-value=\"16px\"]:before{font-size:16px}.custom-ql-toolbar .ql-picker.ql-size .ql-picker-item[data-value=\"24px\"]:before{font-size:24px}.custom-ql-toolbar .ql-picker.ql-size .ql-picker-item[data-value=\"32px\"]:before{font-size:32px}.quill .ql-container .ql-editor .ql-font-nunito{font-family:var(--font-family-secondary)}.quill .ql-container .ql-editor .ql-font-sans-serif{font-family:sans-serif}.quill .ql-container .ql-editor .ql-font-verdana{font-family:verdana}";
styleInject(css_248z$1);

Quill.register(Quill.import('attributors/style/direction'), true);
Quill.register(Quill.import('attributors/style/align'), true);
var Size = Quill.import('attributors/style/size');
Size.whitelist = ['14px', '16px', '24px', '32px'];
Quill.register(Size, true);
var Font = Quill.import('attributors/style/font');
Font.whitelist = ['verdana', 'nunito', 'sans-serif'];
Quill.register(Font, true);
var icons = Quill.import('ui/icons');
icons.bold = null;
icons.italic = null;
icons.underline = null;
icons.strike = null;
icons.background = null;
icons.align = null;
icons.list = null;
var Toolbar = function (_a) {
    var id = _a.id;
    return (React__default.createElement("div", { className: "custom-ql-toolbar", id: "toolbar-".concat(id) },
        React__default.createElement("span", { className: "ql-formats" },
            React__default.createElement("select", { className: "ql-font custom-arrows", defaultValue: "nunito" },
                React__default.createElement("option", { value: "nunito" }, "Nunito Sans"),
                React__default.createElement("option", { value: "sans-serif" }, "Sans-Serif"),
                React__default.createElement("option", { value: "verdana" }, "Verdana")),
            React__default.createElement("select", { className: "ql-size custom-arrows", defaultValue: '16px' },
                React__default.createElement("option", { value: "14px" }, "Small"),
                React__default.createElement("option", { value: "16px" }, "Normal"),
                React__default.createElement("option", { value: "24px" }, "Large"),
                React__default.createElement("option", { value: "32px" }, "Huge"))),
        React__default.createElement("span", { className: "ql-formats" },
            React__default.createElement("button", { className: "ql-bold" },
                React__default.createElement(Icons, { name: "IconBold", fill: "transparent" })),
            React__default.createElement("button", { className: "ql-italic" },
                React__default.createElement(Icons, { name: "IconItalic", fill: "transparent" })),
            React__default.createElement("button", { className: "ql-underline" },
                React__default.createElement(Icons, { name: "IconUnderline", fill: "transparent" })),
            React__default.createElement("button", { className: "ql-strike" },
                React__default.createElement(Icons, { name: "IconStrikethrough", fill: "transparent" }))),
        React__default.createElement("span", { className: "ql-formats" },
            React__default.createElement("button", { className: "ql-background", value: "#f8ff00" },
                React__default.createElement(Icons, { name: "IconHighlight", fill: "transparent" }))),
        React__default.createElement("span", { className: "ql-formats" },
            React__default.createElement("button", { className: "ql-align", value: "" },
                React__default.createElement(Icons, { name: "IconAlignLeft", fill: "transparent" })),
            React__default.createElement("button", { className: "ql-align", value: "center" },
                React__default.createElement(Icons, { name: "IconAlignCenter", fill: "transparent" })),
            React__default.createElement("button", { className: "ql-align", value: "right" },
                React__default.createElement(Icons, { name: "IconAlignRight", fill: "transparent" }))),
        React__default.createElement("span", { className: "ql-formats" },
            React__default.createElement("button", { className: "ql-align", value: "justify" },
                React__default.createElement(Icons, { name: "IconAlignJustified", fill: "transparent" })),
            React__default.createElement("button", { className: "ql-list", value: "bullet" },
                React__default.createElement(Icons, { name: "IconList", fill: "transparent" }))),
        React__default.createElement("span", { className: "ql-formats" },
            React__default.createElement("button", { className: "ql-undo" },
                React__default.createElement(Icons, { name: "IconArrowBackUp", fill: "transparent" })),
            React__default.createElement("button", { className: "ql-redo" },
                React__default.createElement(Icons, { name: "IconArrowForwardUp", fill: "transparent" })))));
};

var Embed = Quill.import('blots/embed');
var TagBlot = /** @class */ (function (_super) {
    __extends(TagBlot, _super);
    function TagBlot(scroll, node) {
        var _this = _super.call(this, scroll, node) || this;
        _this.clickHandler = null;
        _this.hoverHandler = null;
        _this.mounted = false;
        return _this;
    }
    TagBlot.create = function (data) {
        var node = _super.create.call(this);
        var denotationChar = document.createElement('span');
        denotationChar.className = 'ql-mention-denotation-char';
        denotationChar.innerHTML = data.denotationChar;
        denotationChar.setAttribute('contenteditable', 'false');
        node.appendChild(denotationChar);
        node.innerHTML += data.id;
        if (data.denotationChar === '{{') {
            var denotationCharEnd = document.createElement('span');
            denotationCharEnd.className = 'ql-mention-denotation-char';
            denotationCharEnd.innerHTML = '}}';
            denotationCharEnd.setAttribute('contenteditable', 'false');
            node.appendChild(denotationCharEnd);
        }
        var closeElement = document.createElement('span');
        closeElement.className = 'ql-tag-close';
        closeElement.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="12" height="12" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" fill="currentColor" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M18 6l-12 12"></path><path d="M6 6l12 12"></path></svg>';
        closeElement.setAttribute('contenteditable', 'false');
        node.appendChild(closeElement);
        node.setAttribute('contenteditable', 'false');
        return TagBlot.setDataValues(node, data);
    };
    TagBlot.setDataValues = function (element, data) {
        var domNode = element;
        Object.keys(data).forEach(function (key) {
            domNode.dataset[key] = data[key];
        });
        return domNode;
    };
    TagBlot.value = function (domNode) {
        return domNode.dataset;
    };
    TagBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        if (!this.mounted) {
            this.mounted = true;
            this.clickHandler = this.getClickHandler();
            this.hoverHandler = this.getHoverHandler();
            this.domNode.addEventListener('click', this.clickHandler, false);
            this.domNode.addEventListener('mouseenter', this.hoverHandler, false);
        }
    };
    TagBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.mounted = false;
        if (this.clickHandler) {
            this.domNode.removeEventListener('click', this.clickHandler);
            this.clickHandler = null;
        }
    };
    TagBlot.prototype.getClickHandler = function () {
        var _this = this;
        return function (e) {
            var event = _this.buildEvent('mention-clicked', e);
            window.dispatchEvent(event);
            e.preventDefault();
        };
    };
    TagBlot.prototype.getHoverHandler = function () {
        var _this = this;
        return function (e) {
            var event = _this.buildEvent('mention-hovered', e);
            window.dispatchEvent(event);
            e.preventDefault();
        };
    };
    TagBlot.prototype.buildEvent = function (name, e) {
        var event = new Event(name, {
            bubbles: true,
            cancelable: true,
        });
        event.value = Object.assign({}, this.domNode.dataset, {
            domNode: this.domNode,
        });
        event.event = e;
        return event;
    };
    return TagBlot;
}(Embed));
TagBlot.blotName = 'tag';
TagBlot.tagName = 'span';
TagBlot.className = 'ql-tag';
Quill.register(TagBlot);

var css_248z = ".ql-mention-list-container{background-color:#fff;border:1px solid #f0f0f0;border-radius:4px;box-shadow:0 4px 26px 0 rgba(0,0,0,.102);max-height:300px;max-width:296px;overflow-y:scroll;padding:12px;width:100%;z-index:9001}.ql-mention-loading{font-size:16px;line-height:44px;padding:0 20px;vertical-align:middle}.ql-mention-list{list-style:none;margin:0;overflow:hidden;padding:0}.ql-mention-list-item{border-radius:8px;color:#53464f;cursor:pointer;font-family:var(--font-family-secondary);font-size:16px;font-weight:600;line-height:22px;padding:16px;vertical-align:middle;word-break:break-word}.ql-mention-list-item.disabled{cursor:auto}.ql-mention-list-item.selected{background-color:#f8f6f8;text-decoration:none}.ql-tag{background-color:var(--color-secondary-95);border-radius:24px;cursor:pointer;display:inline-flex;margin-right:2px;padding:3px 8px;-webkit-user-select:all;-moz-user-select:all;user-select:all;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ql-tag>span{align-items:center;font-family:var(--font-family-secondary);font-weight:600;line-height:18px}.ql-tag-close,.ql-tag>span{color:var(--color-secondary-10);display:inline-flex;font-size:12px}.ql-tag-close{margin-left:4px;-webkit-user-select:none;-moz-user-select:none;user-select:none}#text-editor .ql-disabled{background:#f8f6f8}#text-editor .ql-disabled p{color:#b9acb4}#helper-text{align-items:center;color:var(--color-neutral-dark5);display:flex;font-weight:600;margin:6px 0 0 16px}";
styleInject(css_248z);

var TextEditor = forwardRef(function (props, forwardedRef) {
    var _a, _b;
    var _c = useState(props.defaultValue || ''), internalValue = _c[0], setInternalValue = _c[1];
    var editorRef = useSyncedRef(forwardedRef);
    var isControlled = typeof props.value != 'undefined';
    var value = isControlled ? props.value : internalValue;
    useEffect(function () {
        var handleListener = function (event) {
            var _a;
            var elementClicked = event === null || event === void 0 ? void 0 : event.value;
            if (!elementClicked)
                return;
            (_a = elementClicked === null || elementClicked === void 0 ? void 0 : elementClicked.domNode) === null || _a === void 0 ? void 0 : _a.remove();
        };
        window.addEventListener('mention-clicked', handleListener, false);
        return function () {
            return window.removeEventListener('mention-clicked', handleListener);
        };
    }, []);
    var handleUndo = function () {
        var _a, _b, _c;
        (_c = (_b = (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.editor) === null || _b === void 0 ? void 0 : _b.history) === null || _c === void 0 ? void 0 : _c.undo();
    };
    var handleRedo = function () {
        var _a, _b, _c;
        (_c = (_b = (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.editor) === null || _b === void 0 ? void 0 : _b.history) === null || _c === void 0 ? void 0 : _c.redo();
    };
    var modules = useMemo(function () {
        return __assign({ toolbar: {
                container: "#toolbar-".concat(props.id),
                handlers: {
                    undo: handleUndo,
                    redo: handleRedo,
                },
            }, history: {
                delay: 500,
                maxStack: 100,
                userOnly: true,
            } }, props.modules);
    }, []);
    var onChangeHandler = useCallback(function (content, delta, source, editor) {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, content, delta, source, editor);
        if (!isControlled)
            setInternalValue(content);
    }, [isControlled]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { id: "text-editor".concat(props.id ? "-".concat(props.id) : ''), style: (_a = props.styles) === null || _a === void 0 ? void 0 : _a.container, className: props.className },
            React__default.createElement(Toolbar, { id: props.id }),
            React__default.createElement(ReactQuill, { id: props.id, ref: editorRef, style: (_b = props.styles) === null || _b === void 0 ? void 0 : _b.editor, theme: props.theme || 'snow', value: value, readOnly: props.readOnly, formats: props.formats, placeholder: props.placeholder, preserveWhitespace: props.preserveWhitespace, modules: modules, onChange: onChangeHandler, onFocus: props.onFocus, onBlur: props.onBlur })),
        React__default.createElement(React__default.Fragment, null, props.onError && props.errorMessage && (React__default.createElement(Typography$1, { id: "helper-text", variant: "caption" },
            React__default.createElement(Icons, { color: "#FEA034", name: "IconInfoCircle", size: 18, fill: "transparent", style: { marginRight: '4px' } }),
            props.errorMessage)))));
});
TextEditor.displayName = 'TextEditor';

var LinkedComponentItemContainer = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n"], ["\n  display: flex;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var LinkedComponentItemIconContainer = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding-top: 36px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding-top: 36px;\n"])));
var LinkedComponentIconWrapper = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  border-radius: 50%;\n  background-color: ", ";\n  padding: 4px;\n  z-index: 1;\n"], ["\n  border-radius: 50%;\n  background-color: ", ";\n  padding: 4px;\n  z-index: 1;\n"])), function (_a) {
    var fill = _a.fill;
    return fill;
});
var LinkedComponentItemDivider = styled.div(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  z-index: 0;\n  height: 100%;\n  width: 1px;\n  background-color: #ebe6e9;\n  position: absolute;\n  left: 50%;\n  transform: translateY(", "px);\n"], ["\n  z-index: 0;\n  height: 100%;\n  width: 1px;\n  background-color: #ebe6e9;\n  position: absolute;\n  left: 50%;\n  transform: translateY(", "px);\n"])), function (_a) {
    var size = _a.size;
    return (size ? size / 2 : '12');
});
var LinkedComponentContainer = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  display: flex;\n  margin: 8px;\n"], ["\n  display: flex;\n  margin: 8px;\n"])));
var templateObject_1$a, templateObject_2$7, templateObject_3$4, templateObject_4$3, templateObject_5$2;

var LinkedComponentList = function (_a) {
    var componentList = _a.componentList;
    return (React__default.createElement("div", null, componentList.map(function (_a, index) {
        var children = _a.children, leftAdornment = _a.leftAdornment;
        return (React__default.createElement(LinkedComponentItemContainer, { key: "linked-component-item-".concat(index) },
            React__default.createElement(LinkedComponentItemIconContainer, null,
                React__default.createElement(LinkedComponentIconWrapper, { name: leftAdornment.name, fill: leftAdornment.fill },
                    React__default.createElement(Icons, __assign({}, leftAdornment))),
                index !== componentList.length - 1 && (React__default.createElement(LinkedComponentItemDivider, { name: leftAdornment.name, size: leftAdornment.size }))),
            React__default.createElement(LinkedComponentContainer, null, children)));
    })));
};

var Container$4 = styled.div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  border: ", ";\n  border-radius: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", "\n  border: ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return !fullWidth && 'width: fit-content;';
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.m;
});
var HeaderContainer = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  border-bottom: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ", ";\n  gap: ", ";\n"], ["\n  border-bottom: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ", ";\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var TitleContainer = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs4;
});
var FooterContainer = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  display: flex;\n  border-top: ", ";\n"], ["\n  display: flex;\n  border-top: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
});
var FooterAction = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  padding: ", ";\n  flex: 1;\n  border-right: ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  padding: ", ";\n  flex: 1;\n  border-right: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
}, function (_a) {
    var theme = _a.theme, lastAction = _a.lastAction;
    return lastAction
        ? 'none'
        : "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90]);
});
var templateObject_1$9, templateObject_2$6, templateObject_3$3, templateObject_4$2, templateObject_5$1;

function SummaryBox(_a) {
    var _b;
    var leftAdornment = _a.leftAdornment, title = _a.title, action = _a.action, children = _a.children, footerActions = _a.footerActions, fullWidth = _a.fullWidth;
    var theme = useTheme();
    return (React__default.createElement(Container$4, { fullWidth: fullWidth !== null && fullWidth !== void 0 ? fullWidth : false },
        React__default.createElement(HeaderContainer, null,
            React__default.createElement(TitleContainer, null,
                React__default.createElement(Icons, { name: leftAdornment, color: theme.colors.neutral[60], size: 16 }),
                typeof title === 'string' ? (React__default.createElement(Typography, { variant: "headline10", variantColor: theme.colors.neutral[50], weight: 700 }, title)) : (title)),
            action && (React__default.createElement(LinkButton, { variant: (_b = action.variant) !== null && _b !== void 0 ? _b : 'default', onClick: function () { return action.onClick(); }, underlined: !!action.underlined },
                action.label,
                ' ',
                action.icon && React__default.createElement(Icons, { name: action.icon, size: 16 })))),
        React__default.createElement(React__default.Fragment, null, children),
        footerActions && (React__default.createElement(FooterContainer, null, footerActions.map(function (action, index) {
            var _a;
            return (React__default.createElement(FooterAction, { lastAction: index === footerActions.length - 1, key: 'summary-box-footer-action-' + index },
                React__default.createElement(LinkButton, { variant: (_a = action.variant) !== null && _a !== void 0 ? _a : 'default', onClick: function () { return action.onClick(); }, underlined: !!action.underlined },
                    action.icon && React__default.createElement(Icons, { name: action.icon, size: 16 }),
                    action.label)));
        })))));
}

var OptionItem = styled.button(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  display: grid;\n  align-items: center;\n  text-align: left;\n  grid-template-columns: max-content auto max-content;\n  width: 100%;\n  gap: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  display: grid;\n  align-items: center;\n  text-align: left;\n  grid-template-columns: max-content auto max-content;\n  width: 100%;\n  gap: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (props) { return props.theme.spacings.xs3; }, function (props) {
    return "".concat(props.theme.spacings.xs4, " ").concat(props.theme.spacings.xs2);
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.s;
}, function (_a) {
    var theme = _a.theme, checked = _a.checked;
    return checked ? theme.colors.secondary[95] : 'transparent';
}, function (_a) {
    var theme = _a.theme, checked = _a.checked;
    return checked ? theme.colors.secondary[40] : theme.colors.neutral[30];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[95];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[30];
});
var templateObject_1$8;

function CheckboxItem(props) {
    var theme = useTheme();
    function renderResultsLabel(total) {
        if (total > 1) {
            return "".concat(total, " resultados");
        }
        return "".concat(total, " resultado");
    }
    return (React__default.createElement("li", { key: props.key },
        React__default.createElement(OptionItem, { checked: props.checked, onClick: function () { return props.onChange(props.value, !props.checked); } },
            React__default.createElement(Checkbox, { checked: props.checked, indeterminate: props.intermediate }),
            React__default.createElement(Typography, { variant: "body3", weight: 600 }, props.label),
            props.total !== undefined && (React__default.createElement(Typography, { variant: "body4", weight: 600, variantColor: props.checked
                    ? theme.colors.secondary[40]
                    : theme.colors.neutral[60] }, renderResultsLabel(props.total))))));
}

var Container$3 = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  display: grid;\n  gap: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n\n  @media screen and (max-width: 480px) {\n    padding: ", ";\n  }\n"], ["\n  display: grid;\n  gap: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n\n  @media screen and (max-width: 480px) {\n    padding: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs2;
}, function (_a) {
    var theme = _a.theme, border = _a.border;
    return border
        ? "".concat(theme.borders.width.xs2, " solid ").concat(theme.colors.neutral[90])
        : 'none';
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius.m;
}, function (_a) {
    var theme = _a.theme, border = _a.border;
    return border ? "".concat(theme.spacings.xs, " ").concat(theme.spacings.m) : 'none';
}, function (_a) {
    var theme = _a.theme, border = _a.border;
    return (border ? theme.spacings.xs : 'none');
});
var OptionsContainer = styled.ul(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  position: relative;\n  list-style: none;\n  display: grid;\n  gap: ", ";\n  max-height: 300px;\n  overflow: auto;\n\n  :has(:nth-child(6)) {\n    -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);\n    mask-image: linear-gradient(to bottom, black 84%, transparent 100%);\n    padding-bottom: ", ";\n  }\n"], ["\n  position: relative;\n  list-style: none;\n  display: grid;\n  gap: ", ";\n  max-height: 300px;\n  overflow: auto;\n\n  :has(:nth-child(6)) {\n    -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);\n    mask-image: linear-gradient(to bottom, black 84%, transparent 100%);\n    padding-bottom: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.m;
});
var templateObject_1$7, templateObject_2$5;

function CheckboxFilter(props) {
    var _a, _b;
    var theme = useTheme();
    var _c = useState(''), search = _c[0], setSearch = _c[1];
    var allChecked = props.onAllSelection
        ? !props.options.some(function (option) { return option.checked === false; })
        : false;
    var options = ((_a = props.options) === null || _a === void 0 ? void 0 : _a.length) > 5 && search.length
        ? props.options.filter(function (item) {
            return item.label.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        })
        : props.options;
    return (React__default.createElement(Container$3, { border: (_b = props.border) !== null && _b !== void 0 ? _b : true },
        React__default.createElement("div", null,
            React__default.createElement(Typography, { variant: "headline8" }, props.title),
            props.subtitle && (React__default.createElement(Typography, { variant: "body4", variantColor: theme.colors.neutral50 }, props.subtitle))),
        props.options.length >= 5 && (React__default.createElement(SearchField, { label: "Buscar", inputSize: "lg", value: search, onChange: function (e) { return setSearch(e.target.value); } })),
        React__default.createElement(OptionsContainer, null,
            props.onAllSelection && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(CheckboxItem, { key: "checkbox-filter-all", label: "Selecionar todos", onChange: function () { var _a; return (_a = props.onAllSelection) === null || _a === void 0 ? void 0 : _a.call(props, !allChecked); }, value: "all", checked: allChecked, intermediate: allChecked }),
                React__default.createElement(Divider, { orientation: "horizontal" }))),
            options.map(function (option, index) { return (React__default.createElement(CheckboxItem, __assign({ key: "checkbox-filter-".concat(index) }, option))); }))));
}

var GroupListContainer = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n"], ["\n  display: flex;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var EmployeeGroups = function (_a) {
    var groups = _a.groups;
    var renderedGroups = groups && (groups === null || groups === void 0 ? void 0 : groups.length) > 3
        ? [
            React__default.createElement(Tag, { variant: "gray", disabled: true, key: 1 }, groups[0].name),
            React__default.createElement(Tag, { variant: "gray", disabled: true, key: 2 }, groups[1].name),
            React__default.createElement(Tag, { variant: "gray", disabled: true, key: 3 }, "+".concat(groups.length - 2)),
        ]
        : groups === null || groups === void 0 ? void 0 : groups.map(function (_a, index) {
            var name = _a.name;
            return (React__default.createElement(Tag, { variant: "gray", disabled: true, key: index }, name));
        });
    return React__default.createElement(GroupListContainer, null, renderedGroups);
};
var templateObject_1$6;

var StatusTag = function (_a) {
    var status = _a.status;
    switch (status) {
        case 'active':
            return (React__default.createElement(Tag, { variant: "success", disabled: true, hasLeftDotIcon: true }, "Ativo"));
        case 'inactive':
            return (React__default.createElement(Tag, { variant: "error", disabled: true, hasLeftDotIcon: true }, "Inativo"));
        case 'inviteScheduled':
            return (React__default.createElement(Tag, { variant: "disabled", disabled: true, hasLeftDotIcon: true }, "Convite agendado"));
        case 'inviteSent':
            return (React__default.createElement(Tag, { variant: "disabled", disabled: true, hasLeftDotIcon: true }, "Convite enviado"));
        case 'inviteExpired':
            return (React__default.createElement(Tag, { variant: "disabled", disabled: true, hasLeftDotIcon: true }, "Convite expirado"));
        case 'invitePending':
            return (React__default.createElement(Tag, { variant: "info", disabled: true, hasLeftDotIcon: true }, "Aguardando convite"));
        default:
            return React__default.createElement(React__default.Fragment, null);
    }
};

styled(DataGrid)(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject([""], [""])));
var EmailIcon = styled(Icons)(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[70];
});
var EmailWrapper$1 = styled.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs5;
});
var EmailText$1 = styled(Typography)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[60];
});
var FirstColumnCell$1 = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var FirstColumnCellData$1 = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  margin-left: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  margin-left: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs3;
});
var templateObject_1$5, templateObject_2$4, templateObject_3$2, templateObject_4$1, templateObject_5, templateObject_6;

var defaultEmployeeColumns = [
    {
        Header: 'Nome',
        accessor: 'name',
        Cell: function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var email = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.cell) === null || _a === void 0 ? void 0 : _a.row) === null || _b === void 0 ? void 0 : _b.original) === null || _c === void 0 ? void 0 : _c.email;
            return (React__default.createElement(FirstColumnCell$1, null,
                React__default.createElement(GenericProfilePicture, { size: 40, name: (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.cell) === null || _d === void 0 ? void 0 : _d.row) === null || _e === void 0 ? void 0 : _e.original) === null || _f === void 0 ? void 0 : _f.name, source: (_k = (_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.cell) === null || _g === void 0 ? void 0 : _g.row) === null || _h === void 0 ? void 0 : _h.original) === null || _j === void 0 ? void 0 : _j.profilePicture) === null || _k === void 0 ? void 0 : _k.source }),
                React__default.createElement(FirstColumnCellData$1, null,
                    React__default.createElement(Typography, { variant: "body4" }, data.value),
                    !!email && (React__default.createElement(EmailWrapper$1, null,
                        React__default.createElement(EmailIcon, { name: "IconMail", size: 16, fill: "transparent" }),
                        React__default.createElement(EmailText$1, { variant: "caption" }, email))))));
        },
    },
    {
        Header: 'Status',
        accessor: 'status',
        Cell: function (data) {
            var _a, _b, _c;
            var status = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.cell) === null || _a === void 0 ? void 0 : _a.row) === null || _b === void 0 ? void 0 : _b.original) === null || _c === void 0 ? void 0 : _c.status;
            return React__default.createElement(StatusTag, { status: status });
        },
    },
    {
        Header: 'CPF',
        accessor: 'cpf',
    },
    {
        Header: 'Telefone',
        accessor: 'phone',
    },
    {
        Header: 'Grupo',
        accessor: 'groups',
        Cell: function (data) {
            var _a, _b, _c;
            var groups = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.cell) === null || _a === void 0 ? void 0 : _a.row) === null || _b === void 0 ? void 0 : _b.original) === null || _c === void 0 ? void 0 : _c.groups;
            return React__default.createElement(EmployeeGroups, __assign({}, groups));
        },
        disableSortBy: true,
    },
];

var EmailWrapper = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n"])));
var EmailText = styled(Typography)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral[60];
});
var FirstColumnCell = styled.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var FirstColumnCellData = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  margin-left: 10px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  margin-left: 10px;\n"])));
var templateObject_1$4, templateObject_2$3, templateObject_3$1, templateObject_4;

var timeAndAttendanceColumns = [
    {
        Header: 'Nome',
        accessor: 'name',
        Cell: function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var registrationNumber = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.cell) === null || _a === void 0 ? void 0 : _a.row) === null || _b === void 0 ? void 0 : _b.original) === null || _c === void 0 ? void 0 : _c.registrationNumber;
            return (React__default.createElement(FirstColumnCell, null,
                React__default.createElement(GenericProfilePicture, { size: 40, name: (_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.cell) === null || _d === void 0 ? void 0 : _d.row) === null || _e === void 0 ? void 0 : _e.original) === null || _f === void 0 ? void 0 : _f.name, source: (_k = (_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.cell) === null || _g === void 0 ? void 0 : _g.row) === null || _h === void 0 ? void 0 : _h.original) === null || _j === void 0 ? void 0 : _j.profilePicture) === null || _k === void 0 ? void 0 : _k.source }),
                React__default.createElement(FirstColumnCellData, null,
                    React__default.createElement(Typography, { variant: "body4" }, data.value),
                    !!registrationNumber && (React__default.createElement(EmailWrapper, null,
                        React__default.createElement(EmailText, { variant: "caption" },
                            "Matr\u00EDcula: ",
                            registrationNumber))))));
        },
    },
    {
        Header: 'Data da marcação',
        accessor: 'clockInDate',
    },
    {
        Header: 'Horário da marcação',
        accessor: 'clockInTime',
    },
    {
        Header: 'Motivo da justificativa',
        accessor: 'clockInMotive',
    },
    {
        Header: 'Cargo',
        accessor: 'role',
    },
    {
        Header: 'Departamento',
        accessor: 'department',
    },
    {
        Header: 'Matrícula',
        accessor: 'registrationNumber',
    },
];

var ContentWrapper = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacings.m, " ").concat(theme.spacings.xs);
});
var ContentContainer = styled.main(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  overflow: hidden scroll;\n  flex: 1;\n"], ["\n  overflow: hidden scroll;\n  flex: 1;\n"])));
var templateObject_1$3, templateObject_2$2;

var Content = function (_a) {
    var children = _a.children, styles = _a.styles;
    return (React__default.createElement(ContentContainer, { style: styles },
        React__default.createElement(ContentWrapper, null, children)));
};

var Container$2 = styled.footer(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  background-color: ", ";\n  min-height: 84px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap-reverse;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ", ";\n  padding: ", ";\n  gap: ", ";\n  border-top: 1px solid ", ";\n  z-index: 2;\n"], ["\n  background-color: ", ";\n  min-height: 84px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap-reverse;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ", ";\n  padding: ", ";\n  gap: ", ";\n  border-top: 1px solid ", ";\n  z-index: 2;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral100;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral100;
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacings.xs2, " ").concat(theme.spacings.xs);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral90;
});
var Wrapper = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacings.xs;
});
var templateObject_1$2, templateObject_2$1;

var Footer = function (_a) {
    var _b = _a.startActions, startActions = _b === void 0 ? [] : _b, _c = _a.endActions, endActions = _c === void 0 ? [] : _c;
    return (React__default.createElement(Container$2, null,
        React__default.createElement(Wrapper, null, startActions.length > 0
            ? startActions.map(function (actionButton) { return actionButton; })
            : null),
        React__default.createElement(Wrapper, null, endActions.length > 0
            ? endActions.map(function (actionButton) { return actionButton; })
            : null)));
};

var Container$1 = styled.header(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n  overflow-x: scroll;\n  scrollbar-width: none;\n\n  @media screen and (max-width: 715px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n  overflow-x: scroll;\n  scrollbar-width: none;\n\n  @media screen and (max-width: 715px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral100;
}, function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacings.xs2, " ").concat(theme.spacings.xs);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral90;
});
var LeftContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var StyledStepper = styled(Stepper)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media screen and (max-width: 715px) {\n    margin-top: 15px;\n    :first-child {\n      margin-left: 55px;\n    }\n  }\n"], ["\n  @media screen and (max-width: 715px) {\n    margin-top: 15px;\n    :first-child {\n      margin-left: 55px;\n    }\n  }\n"])));
var templateObject_1$1, templateObject_2, templateObject_3;

var Header = function (_a) {
    var routes = _a.routes, stepper = _a.stepper;
    var breadCrumbs = useMemo(function () {
        return routes.map(function (_a) {
            var label = _a.label, route = _a.route;
            return (React__default.createElement(LinkButton, { key: label, variant: "neutral", component: Link, to: route }, label));
        });
    }, [routes]);
    return (React__default.createElement(Container$1, null,
        React__default.createElement(LeftContainer, null, breadCrumbs.length > 0 ? (React__default.createElement(Breadcrumbs, { separator: React__default.createElement(Icons, { name: "IconChevronRight", fill: "transparent" }), breadcrumbs: breadCrumbs })) : null),
        (stepper === null || stepper === void 0 ? void 0 : stepper.steps) && (stepper === null || stepper === void 0 ? void 0 : stepper.steps.length) > 0 ? (React__default.createElement(StyledStepper, { setActiveStep: stepper === null || stepper === void 0 ? void 0 : stepper.setActiveStep, steps: (stepper === null || stepper === void 0 ? void 0 : stepper.steps) || [], activeStep: stepper === null || stepper === void 0 ? void 0 : stepper.activeStep, disableClick: (stepper === null || stepper === void 0 ? void 0 : stepper.disableClick) || false })) : null));
};

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"], ["\n  overflow: hidden;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"])));
var Focused = function (_a) {
    var children = _a.children, routes = _a.routes, stepper = _a.stepper, footer = _a.footer, _b = _a.hasHeader, hasHeader = _b === void 0 ? true : _b, navigate = _a.navigate, _c = _a.containerStyle, containerStyle = _c === void 0 ? {} : _c, _d = _a.contentWrapperStyle, contentWrapperStyle = _d === void 0 ? {} : _d;
    return (React__default.createElement(Container, { style: containerStyle },
        hasHeader ? (React__default.createElement(Header, { routes: routes, stepper: stepper, navigate: navigate })) : null,
        React__default.createElement(Content, { styles: contentWrapperStyle }, children),
        React__default.createElement(Footer, { startActions: footer.startActions, endActions: footer.endActions })));
};
var templateObject_1;

export { Accordion, Badge, BigNumber, BoxAdornment, Breadcrumbs, Button$4 as Button, ButtonGroup, Carousel, Checkbox, CheckboxFilter, CircularProgress, Clipboard, Container, Cropper, DataGrid, DatePicker, DateRangeField, DateRangePicker, Divider, DividerExample, Dot, DownloadButton, Dropzone, EOrderBy, EmptyState, ExcelUpload, FLASH_HOLIDAYS, Focused, GenerateXLSXFile, GenericProfilePicture, Grades, IconButton, Icons, LinkButton, LinkedComponentList, Loader, Menu$2 as Menu, MenuOption$2 as MenuOption, Modal, MultiSelect, NotificationCard, OTPField, PDFViewer, PageContainer, PageHeader, Pagination$1 as Pagination, PaginationDots, PasswordField, PillButton, ProgressBar, Radio, RadioButtonCard, RadioVision, RegisterEmployee, SearchField, SelectField, ShapeIcon, Skeleton$1 as Skeleton, SliderField, Spinner, Stepper, SummaryBox, SurveyStore, Tab, Table, Tag, TagCheckboxFilter, TagDateFilter, TagFilter, TagSliderRangeFilter, TextArea, TextEditor, TextField$1 as TextField, ThemeProvider, TimePicker, Toast, Toggle, Tooltip, TransferList, Typography, Unstable, VideoPlayer, Warning, checkErrors, colors, columnIsFirstRightSticky, columnIsLastLeftSticky, defaultEmployeeColumns, deprecatedColors, getCroppedImage, getKeysRecursive, getMarginRight, getStickyValue, getValueFromKey, iconsOptions, isNull, isUndefined, nameInitials, overrideTheme, pxToRem, tableControllers, timeAndAttendanceColumns, updateObjectFromKey, useAnimationFrame, useDisclosure, useMediaQuery, useOutsideClick, useSticky, useSyncedRef, useToasts };
//# sourceMappingURL=hros-web-ui-v2.esm.js.map
